import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { formatDate } from '@angular/common';
import { MatDialog } from "@angular/material/dialog";
import { AngularCsv } from "angular7-csv/dist/Angular-csv";
import { DialogOverviewExampleDialogComponent } from "../../dialog-overview-example-dialog/dialog-overview-example-dialog.component";
import { ConvertDatetimePipe } from "../../../app/convert-datetime.pipe";
import { BackendApiService } from "../../../app/services/backend-api.service";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { ModalService } from "../../../app/_modal";
import { ChangeUsersService } from "../../../app/services/change-users.service";
import * as CanvasJS from "./canvasjs.stock.min";
import * as monitoringChartObject from "./chart-model/monitoring_chart";
import * as predicationChartObject from "./chart-model/prediction_chart";
import * as individualChartObject from "./chart-model/individual_trend_chart";
import * as fftChartObject from "./chart-model/fft_chart";
import * as fft_ultrasound_chart from "./chart-model/fft_ultrasound_chart";
import * as $ from "jquery";
import moment from "moment-timezone";
import { utc } from "moment";
import { cloneDeep } from "lodash";
import { NgbCalendar, NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { collapseTextChangeRangesAcrossMultipleVersions } from "typescript";
import { M } from "@angular/cdk/keycodes";
import * as monitoringVelocityObject from "./chart-model/monitor_velocity";
import { partition } from "rxjs-compat/operator/partition";
import faultsData from "./Faults.js";
import html2canvas from 'html2canvas';
import { WaterfallPlotComponent } from './waterfall-plot/waterfall-plot.component';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { MatMenu } from "@angular/material/menu";
import { CommonModule } from "@angular/common";
import { GaugeChartComponent } from "./gauge-chart-component/gauge-chart-component.component";
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepicker, MatDatepickerModule, MatDatepickerToggle, MatDateRangeInput, MatDateSelectionModel } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltip, MatTooltipModule } from "@angular/material/tooltip";
import { MatIcon } from "@angular/material/icon";
import { ClientSubscriptionService } from "../../../app/client-subscription.service";
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { state } from "@angular/animations";
//import * as kurtosisData2 from './kurtosis.json';
//import * as kurtosisdata from "./data.json"
@Component({
  selector: "app-device-detail-nxt",
  templateUrl: "./device-detail-nxt.component.html",
  styleUrls: ["./device-detail-nxt.component.scss"],
  standalone: true,
  imports: [
    NgbTooltipModule,NgbNavModule,MatMenu,MatInputModule,CommonModule,GaugeChartComponent,MatMenuModule,DialogOverviewExampleDialogComponent,WaterfallPlotComponent,MatNativeDateModule,MatDatepicker,MatDatepickerModule,MatDatepickerToggle, MatButtonModule,MatTooltipModule,MatTooltip,MatIcon]
})
export class DeviceDetailNxtComponent implements OnInit {
  public isMonitoringTabEnabled = true;
  public isDiagnosticsTabEnabled = true;
  public isPredictiveTabEnabled = true;
  public vs_enabled = true;
  public as_enabled = true;
  public us_enabled = true;
  public ms_enabled = true;
  public ba_enabled = true;
  public historicalDataExists:boolean = false;
  // @ViewChild("msglog", { static: true })
  @ViewChild("ctdTabset") ctdTabset;
  @ViewChildren("tooltip")
  tooltips;
  //student:any = kurtosisData();
  displayedColumns: string[] = ["time", "radial", "tangential", "axial"];
  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
  };

  //Add Loading Functionality into Trends charts.
  public AccelartionLoading: boolean;
  public selectedTabId:any=localStorage.getItem('tab') || 'tab-1';
  public innerTab:any='diagSummary';
  public VelocityLoading: boolean;
  public AcousticsLoading: boolean;
  public AudibleLoading: boolean;
  public TemperatureLoading: boolean;
  public globalTempXAxisValueFOrSpectra: Number = 0;
  public chart: any;
  public kurtosisMarkersData: any = [];
  public fftCreateAt: any;
  public tooltipStatus;
  public changeText: boolean;
  public operatingsyncRPM: any = 0;
  public trendsgraph = "Show Trend Graphs";
  public topicname: any;
  public indicesConstValues: any = {};
  public setErrorStateOne: boolean = false;
  public setErrorStateTwo: boolean = false;
  public msg: any;
  public onlineOfflineStatus: string;
  public isConnected: boolean = false;
  public loadingColor: string = "white";
  public msglog!: ElementRef;
  public selectGreen: string = "";
  public selectYellow: string = "";
  public ON_PREM = BaseUrlConstantsService.ON_PREM;
  public deviceStarts: any = 0;
  public deviceStops: any = 0;
  public deviceUtilization: any = 0;
  public deviceAverageRunTime: string = "N/A";
  public assetStarts: any = 0;
  public assetStops: any = 0;
  public assetUtilization: any = 0;
  public assetAverageRunTime: string = "N/A";
  public nLineFrequency: any = 0;
  public listAcousticsData3: any = [];
  public nOpertingLineFrequency: any = 0;
  public ratedLineCurrent: any = 0;
  public faults_info: any = [];
  public fromDate: NgbDate;
  public arclabelforaccleration = ["1", "4"];
  public toDate: NgbDate;
  public activeTabID: number;
  public assetsListUrl = BaseUrlConstantsService.ASSETS_LIST;
  public ErrorLogService = BaseUrlConstantsService.BASE_Error_Log;
  public rtdUrl = BaseUrlConstantsService.ASSET_RTD;
  private getInventoryByIDUrl = BaseUrlConstantsService.GET_INVENTORY_BY_ID;
  public imageBaseV2Url = BaseUrlConstantsService.NEW_IMAGE_RELATIVE_BASE_URL;
  public deviceStatusURL = BaseUrlConstantsService.INVENTORY_URL;
  private assetDeleteUrl = BaseUrlConstantsService.DELETE_ASSETS;
  public imageBaseUrl = BaseUrlConstantsService.IMAGE_RELATIVE_URL + "uploads/";
  public imageAssetUploadUrl = BaseUrlConstantsService.ASSET_IMAGE_UPLOAD;
  public getIndividualFaults = BaseUrlConstantsService.UPDATE_ASSETS;
  public device_report_api = BaseUrlConstantsService.ASSET_REPORT_PDF;
  public monitorDataURL = BaseUrlConstantsService.MONITOR_INFO;
  public anomaly_api=BaseUrlConstantsService.ANOMALY_API;// NEW MONITORING API URL FOR ANOMALY VIBRATION ....
  public checkSensorHistoricalDataExists=BaseUrlConstantsService.CHECK_SENSOR_HISTORICAL_DATA_EXISTS_API;// NEW MONITORING API URL FOR ANOMALY VIBRATION ....
  public machineOperatingParametersAPI = BaseUrlConstantsService.MACHINE_OPERATING_PARAMETERS_API;// NEW MONITORING API URL FOR MACHINE OPERATING PARAMETERS
  public machineHealthIndexAPI = BaseUrlConstantsService.MACHINE_HEALTH_INDEX_API;
  public monitoringSensorAPI = BaseUrlConstantsService.MONITORING_SENSOR_API;
  public monitoringDeviceDetailsAPI = BaseUrlConstantsService.MONITORING_DEVICE_DETAILS_API;
  public monitoringMachineUtilizationAPI = BaseUrlConstantsService.MONITORING_MACHINE_UTILIZATION_API;
  // public diagnosticsRPMValuesAPI = BaseUrlConstantsService.DIAGNOSTICS_RPM_VALUES_API;
  public diagnosticsSummaryAPI = BaseUrlConstantsService.DIAGNOSTICS_SUMMARY_API;
  public diagnosticsFFTListAPI = BaseUrlConstantsService.DIAGNOSTICS_FFT_LIST_API;
  public diagnosticsFFTGraphAPI = BaseUrlConstantsService.DIAGNOSTICS_FFT_GRAPH_API;
  public diagnosticsFFTChartAPI = BaseUrlConstantsService.DIAGNOSTICS_FFT_CHART_API;
  public diagnosticsFFTPredominantFrequencyAPI = BaseUrlConstantsService.DIAGNOSTICS_FFT_PREDOMINANT_API;
  public diagnosticsFFTUltrasoundAPI = BaseUrlConstantsService.DIAGNOSTICS_FFT_ULTRASOUND_CHART_API;
  public diagnosticsFFTMagnetoMeterAPI = BaseUrlConstantsService.DIAGNOSTICS_FFT_MAGNETOMETER_CHART_API;
  public diagnosticsFFTCrestFactorAPI = BaseUrlConstantsService.DIAGNOSTICS_FFT_CREST_FACTOR_API;
  public diagnosticsGearboxCepstrumAPI = BaseUrlConstantsService.DIAGNOSTICS_GEARBOX_CEPSTRUM_API;
  public diagnosticsBearingAnalysisGraphAPI = BaseUrlConstantsService.DIAGNOSTICS_BEARING_ANALYSIS_GRAPH_API;
  public diagnosticsBearingFrequencyAPI = BaseUrlConstantsService.DIAGNOSTICS_BEARING_FREQUENCY_API;
  public diagnosticsEnvelopAnalysisChartAPI = BaseUrlConstantsService.DIAGNOSTICS_ENVELOP_ANALYSIS_CHART_API;
  public lastHours = [8, 13, 24];
  public machineParamUrl = BaseUrlConstantsService.BASE_MIDDLEWARE_SELF;
  public Spectral_Analysis_Data =
    BaseUrlConstantsService.Spectral_Analysis_Data;
  public assetMatricsUrl = BaseUrlConstantsService.ASSET_METRICS;
  public sensorData = BaseUrlConstantsService.Sensor_Data;
  public accelsensorData = BaseUrlConstantsService.Accel_Sensor_Data;
  public bucketsensordata = BaseUrlConstantsService.Bucktet_Sensor_Data;
  public KurtosisData = BaseUrlConstantsService.Kurtosisdata;
  public KurtosisNumberData = BaseUrlConstantsService.Kurtosis_Number;
  public SENSOR_UPDATE_INFO = BaseUrlConstantsService.SENSOR_UPDATE_INFO;
  public Predominent_Freq = BaseUrlConstantsService.PREDOMINENT_FREQ;
  public Predominent_Freq_kurtosis =
    BaseUrlConstantsService.PREDOMINENT_FREQ_KURTOSIS;
  public bearing_url_detail = BaseUrlConstantsService.BEARING_DETAIL;
  // public KurtosisNumberData = BaseUrlConstantsService.Kurtosis_Number;
  public assetServiceUrl = BaseUrlConstantsService.BASE_ASSET_SERVICE;
  public sensorFFTINFO = BaseUrlConstantsService.FFT_SENSOR_URL;
  public new_fft_chart_end = BaseUrlConstantsService.NEW_FFT_CHART;
  public assetsUrlEdit = BaseUrlConstantsService.ASSETS_DATA_EDIT;
  public cepStrumUrlForChart = BaseUrlConstantsService.BASE_CEP_STRUM_URL;
  public cresFactorUrl = BaseUrlConstantsService.BASE_CRES_FACTOR_URL;
  public ultrasoundGauge = BaseUrlConstantsService.ultrasoundforGauge;
  public getBearingFrequency = BaseUrlConstantsService.Get_Bearing_Freq;
  public ElectricalSignaturefft =
    BaseUrlConstantsService.Electrical_Signature_fft;
  public electricalDropDown = BaseUrlConstantsService.Electrical_DropDown;
  public currentSignature = BaseUrlConstantsService.Current_Signature;
  public DiagnosticsSummary = BaseUrlConstantsService.Diagnostics_Summary;
  public baseAssetUrl = BaseUrlConstantsService.BASE_ASSETS_URL;
  public powertrain_delete_one_url = BaseUrlConstantsService.POWERTRAIN_DELETE_ONE_API;
  public base_diagnostics = BaseUrlConstantsService.BASE_DIAGNOSTICS;
  @ViewChild("myDiv") myDiv: ElementRef<HTMLElement>;
  public showTempChartEmpty: boolean;
  public predUltraSoundFrq: any = [];
  public absolutePercentageAcoustics: any;
  public statusAcousticsPredictionValues: boolean;
  public dataAcoustics1: any = [];
  public showPredAcousticsChartEmpty: boolean;
  public dataAcousticsPred1: any = [];
  public listSenVelocityData1: any;
  public maxRatedPower: any = 0;
  public dataOilWhirlChartDoughnut: any;
  public emptyMessageAlert: boolean = true;
  public showUltrasoundChartEmpty_Vibration: boolean;
  public emptyMsgAlert2: boolean = true;
  public emptyMsgAlertKurt2: boolean = true;
  public emptyMessageAlert3: boolean = true;
  public emptyMessageAlert4: boolean = true;
  public showPredictiveKurtChartEmpty: boolean = true;
  public dataOGEDoughnut: any;
  public offlineGaugeData: any = [];
  public listUltraData: any = [];
  public firstTimeChartLoad: boolean;
  public returnMonVelocityObj: any = {};
  public acousticsChart: any;
  public dataEBOGTWDoughnut: any;
  public indicesValues: any = [];
  public firmware_version: string = null;
  public dataIndicesHealth1: any = [];
  public dataIndicesHealth2: any = [];
  public dataIndicesHealth3: any = [];
  public pinionActualForDiagnosticslabel: any = 0;
  public outerActualForDiagnosticslabel: any = 0;
  public dataIndicesHealth4: any = [];
  public predictiveAcousticsChartOn: boolean = true;
  public predictiveAcousticsListOn: boolean;
  public acousticsDataPoints3: any = [];
  public acousticsDataPoints1: any = [];
  public magneticPredFreq: any = [];
  public OperatingSyncRPM: any = 0;
  public outputPower: any = 0;
  public emptyMessageAlertAcoustics: boolean;
  public listPredAcousticsData1: any = [];
  public acousticsDataPoints2: any = [];
  public absolutePercentageDoughnuts: any = 0;
  public absolutePercentageDoughnuts1: any = 0;
  public absolutePercentageDoughnuts2: any = 0;
  public absolutePercentageDoughnuts3: any = 0;
  public absolutePercentageDoughnuts4: any = 0;
  public absolutePercentageDoughnuts5: any = 0;
  public absolutePercentageDoughnuts6: any = 0;
  public absolutePercentageDoughnuts7: any = 0;
  public absolutePercentageDoughnuts9: any = 0;
  public dataCGFDoughnut: any;
  public vibrationNoDataMsg: string;
  public predictionStartTime1: any;
  public dataIndicesHealthPred1: any = [];
  public dataIndicesHealthPred2: any = [];
  public dataIndicesHealthPred3: any = [];
  public dataIndicesHealthPred4: any = [];
  public listMagData1: any = [];
  public listMagData2: any = [];
  public listMagData3: any = [];
  public pinActualRPM: any;
  public ogeChartImageUrl: any;
  public outerRPM: any;
  public cgfImageUrl: any;
  public pinion_gear_rated_rpm: any;
  public visibilityMVChart: boolean;
  public outer_rated_rpm: any;
  public chartOne: any = {};
  public chartTwo: any = {};
  public chartThree: any = {};
  public faultFilterName: string = "Mechanical";
  public listSenVelocityData2: any;
  public listSenVelocityData3: any;
  public hideDownloadBtn: boolean = true;
  public showReportMsg: string = "";
  public showPredictiveChartEmpty: boolean = true;
  public showVibrationChartEmpty: boolean = true;
  public showPredVelocityChartEmpty: boolean = true;
  public showFFTDataChartEmpty: boolean;
  public showFFTDataChartEmpty_Vibration: boolean;
  public returnAcousticsObj: any;
  public maxRPMValue: any = null;
  public minRPMValue: any = null;
  public serviceCategory: any;
  public min_g_imp: any;
  public max_g_imp: any;
  public gmfImageUrl: any;
  public ebogtwImageUrl: any;
  public absolutePercentageDoughnuts11: any = 0;
  public max_y_imp: any;
  public max_r_imp: any;
  public showVelocityChartEmpty: boolean;
  public velocityDataPoints1: any;
  public velocityDataPoints2: any;
  public velocityDataPoints3: any;
  public returnVelocityObj: any;
  public min_g_v: any;
  public max_g_v: any;
  public dataEFCDoughnut: any;
  public dataPMCDoughnut: any;
  public dataLCCDoughnut: any;
  public max_y_v: any;
  public max_r_v: any;
  public tableDataHealthIndices: any = [];
  public velocityChart: any;
  public pgbc0ImageUrl: any;
  public visibilityVAT: boolean;
  public visibilityAcousticsChart: boolean;
  public dtDataForCSVARRAY: any = [];
  public chartLayoutOnVibration: boolean = true;
  public listLayoutOnVibration: boolean;
  public highlightedDiv: number;
  public trend_analysis_acc_new: any = {};
  public rpm_pin: any;
  public actualRPM: any;
  public ogbc0ImageUrl: any;
  public OperatingLineFrequency: any = 0;
  public ratedRPM: any;
  public dtDataForCSVARRAY2: any = [];
  public unblanceImageUrl: any = "";
  public misalignImageUrl: any = "";
  public voltageImageUrl: any = "";
  public loosenessImageUrl: any = "";
  public nonDriveImageUrl: any = "";
  public JBearingImageUrl: any = "";
  public oilwhirlImageUrl: any = "";
  public bentShaftImageUrl: any = "";
  public driveEndImageUrl: any = "";
  public bentRotorImageUrl: any = "";
  public dataRotorRubPredPoints1 = [];
  public dataRotorRubPredPoints3 = [];
  public frequentNewAccChart: any;
  public dataRotorRubPredPoints2 = [];
  public tableVelocityTrendPred: any = [];
  public dataDriveEndBearingPredPoints1 = [];
  public dataDriveEndBearingPredPoints2 = [];
  public dataDriveEndBearingPredPoints3 = [];
  public dataOilWhirlPredPoints1 = [];
  public mySensFFTAcceleration: any = [];
  public dataBentShaftPredPoints1 = [];
  public dataBentShaftPredPoints2 = [];
  public statusVelocityPredictionValues: boolean;
  public statusTempPredictionValues: boolean;
  public statusKurtPredictionValues: boolean;
  public dataPreKurtPointsNew1: any = [];
  public dataPreKurtPointsNew2: any = [];
  public dataPreKurtPointsNew3: any = [];
  public dataNonDrivePredPoints1: any = [];
  public dataNonDrivePredPoints2: any = [];
  public dataNonDrivePredPoints3: any = [];
  public dataPreTempPointsNew1: any = [];
  public dataPreTempPointsNew2: any = [];
  public dataPreTempPointsNew3: any = [];
  public dataLoosenessPoints4: any = [];
  public dataPreVelPointsNew1: any = [];
  public dataPreVelPointsNew2: any = [];
  public dataPreVelPointsNew3: any = [];
  public dataMisalignedPredPoints1: any = [];
  public dataMisalignedPredPoints2: any = [];
  public absolutePercentageTemp: any;
  public absolutePercentageVelocity: any;
  public dataVoltagePredPoints1: any = [];
  public dataVoltagePredPoints2: any = [];
  public dataVoltagePredPoints3: any = [];
  public xaxisFrequency = [];
  public trend_analysis: any = {};
  public velocityTangential: any = {};
  public RPMObj: any = {};
  public trendData = BaseUrlConstantsService.TRENDS_DATA;
  public dsp = BaseUrlConstantsService.DSP_KEY;
  public CG = BaseUrlConstantsService.CG_KEY;
  public production = BaseUrlConstantsService.PRODUCTION_KEY;
  public Fft_List = BaseUrlConstantsService.FFT_LIST;
  public Fft_Force = BaseUrlConstantsService.FFT_FORCE;
  public alert24hrurl = BaseUrlConstantsService.BASE_ALERT_SYSTEM_URL;

  public ErrorPannelService: string = BaseUrlConstantsService.BASE_PANNEL_Log;
  public fftforAdvanceDiag: string = BaseUrlConstantsService.BASE_KURTOSIS_URL;
  public filterType: any;
  public abc = false;
  public showlineChart1: boolean;
  public applicationNme: any;
  public _status: any;
  public _offlineStatus: any;
  public _lastUpdate: any;
  public _observe_value: any = "";
  public VISIBILITY_STATUS: string = "block";
  public _devStaus: any;
  public _orientationX: any;
  public _orientationY: any;
  public tPredictionValue: any = {};
  public _orientationZ: any;
  public _interval: any = 3;
  public _sliderStart: any = undefined;
  public _sliderEnd: any = undefined;
  public _sliderStartTmp: any = undefined;
  public _sliderEndTmp: any = undefined;
  public loader: boolean = false;
  public fday: boolean;
  public fweek: boolean;
  public fmonth: boolean;
  public dataSFCDoughnut: any;
  public dataXBISSUEDChartDoughnut: any;
  public fmonths: boolean;
  public fftUltrsoundChart: any;
  public data: any = [];
  public columnNames: any = [];
  public faults_info_one: any = [];
  public testArr = [];
  public magneticFieldSpecChart: any;
  public dataMagneticFieldPoints1: any = [];
  public dataMagneticFieldPoints2: any = [];
  public dataMagneticFieldPoints3: any = [];
  public showlineChart3: any;
  public errorMSG = "";
  public diagChartType: string = "velocity";
  public loadProgress: any = 0;
  public loaderAddClass: string;
  public returnOrinObj: any;
  public MachineStatus: string = "N/A";
  public RecommendedAction: string = "N/A";
  public showlineChart2: boolean;
  public lineChartLegend = true;
  public lineChartType = "line";
  public SystemName = "MF1";
  public firstCopy = false;
  public canvasWidth = 160;
  public needleValue = 20;
  public centralLabel = "";
  public name = "N/A";
  public bottomLabel = "N/A";
  public Itemsymbol: any;
  public isServiceResponded: boolean;
  public pageRef: any;
  public dataGadge: any;
  public meterShownResult: any = [];
  public meterShowVelocity: any = [];
  public tempratueResults: any = [];
  public orientationData: any = [];
  public rateOfTemp: any = [];
  public rateOfChange: any = [];
  public nameDevice: any;
  public deviceId: any;
  public userId: any;
  public errorStatus: any;
  public deviceStatus: any;
  public dataMUCDoughnut: any;
  public addclass: any;
  public valueSelected: any;
  public _deviceInfo: any;
  public daterangeForm: any;
  public chartBoxVisibility = false;
  public chartBoxVisibility1 = false;
  public pageName: string;
  public devicedata: any;
  public showGraph: any = 0;
  public assetId: any;
  public _lstUpdateDate: any;
  public tabColor = "1day";
  public dayValue = 24;
  public weekValue: number;
  public monthValue: number;
  public valueType: any;
  public selectValue = null;
  public btnColour = "#dedede";
  public btnColor2 = "#ffffff";
  public activeTab = "monitoring";
  public activeTabColor: string = "#dedede";
  public inactiveTabColor: string = "#ffffff";
  public mySensFFTVelocity: any = [];
  public mySensFFTTemperature: any = [];
  public mySensFFTOrientation: any = [];
  public dataNewfrequentPoints1: any = [];
  public dataNewfrequentPoints2: any = [];
  public dataNewfrequentPoints3: any = [];
  public outer_gear_rated_rpm: any;
  public pinion_gear_actual_rpm: any = 0;
  public outer_gear_actual_rpm: any = 0;
  public rpm_pinion_pin: any;
  public rpm_outer_pin: any;
  public dataLoosenessPoints5: any = [];
  public dataLoosenessPredPoints1: any = [];
  public dataLoosenessPredPoints2: any = [];
  public dataLoosenessPredPoints3: any = [];
  public dataLoosenessPredPoints4: any = [];
  public dataLoosenessPredPoints5: any = [];
  public absolutePercentageVibration: any;
  public siteName: any;
  public _spectralLoader: boolean = false;
  public appMacAdd: any;
  public serialNumber: any;
  public _timeOut: any;
  public trendAnalysData: any = [];
  public fftMarkers: any = [];
  public fftMarkersTemp: any = [];
  public fftLists: any = [];
  public newFFTMarkers: any = [];
  public graphType:string ='Hourly';
  public rpmshowgaudge: any = [];
  public rpmLoadingGaudge: any = [];
  public title;
  public type;
  public ddata: any = [];
  public options: any = {};
  public width;
  public height;
  public dataChart = [];
  public velocityArrayValue: any;
  public bearingFaults: any = [];
  public bearingFaultsNds: any = [];
  public datafftUltrasoundfrequentPoints1: any = [];
  public monitorInfo: any = {};
  public showNoRecords: any;
  public showNoRecordsnds: any;
  public tabColor1: any = "active";
  public tabColor2: any;
  public tabColor3: any;
  public tabColor4: any;
  public tabColor5: any;
  public tabColorP1: any = "active";
  public tabColorP2: any;
  public tabColorP3: any;
  public tabColorP4: any;
  public tabColorP5: any;
  public accColor1: any = "active";
  public accColor2: any;
  public accColor3: any;
  public velColor1: any = "active";
  public velColor2: any;
  public velColor3: any;
  public acoColor1: any = "active";
  public acoColor2: any;
  public acoColor3: any;
  public tempColor1: any = "active";
  public tempColor2: any = "";
  public tempColor3: any = "";
  public audiColor1: any = "active";
  public audiColor2: any = "";
  public audiColor3: any = "";
  public kurtColor1: any = "active";
  public kurtColor2: any;
  public kurtColor3: any;
  public tabTwoColor1: string = "active";
  public tabTwoColor2: string = "";
  public tabTwoColor3: string = "";
  public tabTwoColor4: string = "";
  public tabTwoColor5: string = "";
  public tabTwoColor6: string = "";
  public tabTwoColor7: string = "";
  public absolutePercentageDoughnuts10: any = 0;
  public dataPredPoints1: any = [];
  public dataPredPoints2: any = [];
  public dataPredPoints3: any = [];
  public dataPreOPoints1: any = [];
  public dataPreOPoints2: any = [];
  public dataPreOPoints3: any = [];
  public dataPreTPoints1: any = [];
  public dataPreTPoints2: any = [];
  public dataPreTPoints3: any = [];
  public statusVibrationPredictionValues: boolean;
  public unbalanceStatusPredValues: boolean;
  public _driveTemps: any = [];
  public _rmsAccels: any = [];
  public _userData: any = [];
  public _clienId: any;
  public _deviceIds: any;
  public _greenIcon: boolean = false;
  public _yellowIcon: boolean = false;
  public _redIcon: boolean = false;
  public _greenRmsIcon: boolean = false;
  public _yellowRmsIcon: boolean = false;
  public showMagnetFieldChartEmpty: boolean;
  public magnetFieldNoDataMsg: string;
  public _redRmsIcon: boolean = false;
  public dataPreOrienPoints1: any;
  public dataPreOrienPoints2: any;
  public dataPreOrienPoints3: any;
  public predictiveOrienChart: any;
  public sperformedArr: any = [];
  public loadingStatus: string = "Not available";
  public returnPreOrienObj: any;
  public dataGMFDoughnut: any;
  public updateInterval: number = 20000;
  public updateAcousticsInterval: number = 20000;
  public updateInterval2: number = 20000;
  public updateInterval3: number = 20000;
  // public intervalMonitoringUpdate: any;
  // public intervalAcousticsUpdate: any;
  public updateIntervalBool: boolean = false;
  public updateIntervalBool2: boolean = false;
  public updateIntervalBool3: boolean = false;
  public yValue1 = 600;
  public yValue2 = 605;
  public yValue3 = 602;
  public operatingLineCurrent: any = 0;
  public operatingInputPower: any = 0;
  public dataPoints1 = [];
  public dataPoints2 = [];
  public dataPoints3 = [];
  // public chart: any = {};
  public time = new Date();
  public deltaY1;
  public deltaY2;
  public deltaY3;
  public veloTipName1: any;
  public veloTipName2: any;
  public veloTipName3: any;
  public TemperatureUpdateInterval = 18000;
  public yTemperatureValue1 = 600;
  public yTemperatureValue2 = 605;
  public yTemperatureValue3 = 602;
  public dataTemperaturePoints1 = [];
  public dataTemperaturePoints2 = [];
  public dataTemperaturePoints3 = [];
  public temperatureChart;
  public timeTemperature = new Date();
  public deltaYTemperature1;
  public deltaYTemperature2;
  public deltaYTemperature3;
  public lableTwoX: string;
  public lableTwoY: string;
  public lableTwoZ: string;
  public temperatureTipName1: any;
  public temperatureTipName2: any;
  public temperatureTipName3: any;
  public dataJBearingWearPredPoints1 = [];
  public dataJBearingWearPredPoints2 = [];
  public dataJBearingWearPredPoints3 = [];
  public dataJBearingWearPredPoints4 = [];
  public dataJBearingWearPredPoints5 = [];
  public orientationUpdateInterval = 18000;
  public yOrientationValue1 = 600;
  public yOrientationValue2 = 605;
  public yOrientationValue3 = 602;
  public dataOrientationPoints1 = [];
  public dataOrientationPoints2 = [];
  public dataOrientationPoints3 = [];
  public orientationChart;
  public timeOrientation = new Date();
  public deltaYOrientation1;
  public deltaYOrientation2;
  public deltaYOrientation3;
  public orientationTipName1: any;
  public orientationTipName2: any;
  public orientationTipName3: any;
  public dataPreTempPoints1: any;
  public dataPreTempPoints2: any;
  public dataPreTempPoints3: any;
  public dataPreKurtPoints1: any;
  public dataPreKurtPoints2: any;
  public dataPreKurtPoints3: any;
  public absolutePercentageKurt: any;

  public predictiveKurtChart: any;
  public DiagnosticKurtChart: any;
  public predictiveChart: any;
  public returnPreTempObj: any;
  public updateTimeInterval: any;
  public dataPreVelPoints1: any;
  public dataPreVelPoints2: any;
  public dataPreVelPoints3: any;
  public returnPreVelObj: any;
  public predictiveVelocityChart: any;
  public trendTempanalysis: any = {};
  public frequentUpdateInterval = 18000;
  public yfrequentValue1 = 600;
  public yfrequentValue2 = 605;
  public predictiveAcousticsChart: any;
  public yfrequentValue3 = 602;
  public selectedFFTUIDAnomaly: any;
  public selectedFFTAdvance: any;
  public selectedFFTUIDPeriodic: any;
  public datafrequentPoints1 = [];
  public datafrequentPoints2 = [];
  public datafrequentPoints3 = [];
  public frequentChart;
  public timefrequent = new Date();
  public deltaYfrequent1;
  public deltaYfrequent2;
  public deltaYfrequent3;
  public frequentTipName1: any;
  public frequentTipName2: any;
  public frequentTipName3: any;
  public operationObject: any = {};
  public UnbalanceUpdateInterval = 18000;
  public yUnbalanceValue1 = 600;
  public yUnbalanceValue2 = 605;
  public yUnbalanceValue3 = 602;
  public dataUnbalancePredPoints1 = [];
  public dataUnbalancePoints1 = [];
  public dataUnbalancePoints2 = [];
  public dataUnbalancePoints3 = [];
  public UnbalanceChart;
  public timeUnbalance = new Date();
  public deltaYUnbalance1;
  public magneticX: any = 0;
  public magneticY: any = 0;
  public magneticZ: any = 0;
  public ultrasoundValue: any = 0.0;
  public audibleValue: any = 0;
  public deltaYUnbalance2;
  public deltaYUnbalance3;
  public UnbalanceTipName1: any;
  public UnbalanceTipName2: any;
  public UnbalanceTipName3: any;
  public selectedFFTUID: any = undefined;
  public powertrainSelectedFFT_id: any = undefined;
  public fftIdforAdvance: any;
  public p: any;
  public showPredIndicesChartEmpty: boolean;
  public MisalignedUpdateInterval = 18000;
  public yMisalignedValue1 = 600;
  public yMisalignedValue2 = 605;
  public yMisalignedValue3 = 602;
  public dataMisalignedPoints1 = [];
  public dataMisalignedPoints2 = [];
  public dataMisalignedPoints3 = [];
  public MisalignedChart;
  public timeMisaligned = new Date();
  public deltaYMisaligned1;
  public deltaYMisaligned2;
  public deltaYMisaligned3;
  public MisalignedTipName1: any;
  public MisalignedTipName2: any;
  public MisalignedTipName3: any;
  public sensorDataArr: any = [];
  public LoosenessUpdateInterval = 18000;
  public yLoosenessValue1 = 600;
  public yLoosenessValue2 = 605;
  public yLoosenessValue3 = 602;
  public dataLoosenessPoints1 = [];
  public dataLoosenessPoints2 = [];
  public dataLoosenessPoints3 = [];
  public LoosenessChart;
  public acousticsChartOne: any;
  public timeLooseness = new Date();
  public deltaYLooseness1;
  public deltaYLooseness2;
  public deltaYLooseness3;
  public LoosenessTipName1: any;
  public LoosenessTipName2: any;
  public LoosenessTipName3: any;
  public VoltageUpdateInterval = 18000;
  public yVoltageValue1 = 600;
  public yVoltageValue2 = 605;
  public yVoltageValue3 = 602;
  public dataVoltagePoints1 = [];
  public dataVoltagePoints2 = [];
  public dataVoltagePoints3 = [];
  public VoltageChart;
  public timeVoltage = new Date();
  public deltaYVoltage1;
  public deltaYVoltage2;
  public deltaYVoltage3;
  public rtdData: any = [];
  public VoltageTipName1: any;
  public VoltageTipName2: any;
  public VoltageTipName3: any;
  public trend_ori_analy: any = {};
  public min_g: any;
  public max_g: any;
  public max_y: any;
  public max_r: any;
  public kwrating: any;
  public returnTempObj: any;
  public anSensorArray: any = [];
  public predictiveHealthIndicesChart: any;
  public fftLabelValue: string;
  public today: any;
  public overAllService: any;
  public actionRequiredStatus: any;
  public nextServiceDate: any;
  public lastServiceDate: any;
  public servicePerformed: any;
  public returnVibrartionObj: any = {};
  public vibrationUpdateChartStop: boolean;
  public absolutePercentageDoughnuts12: any = 0;
  public _fftDate: any;
  public _rated_rpm: any;
  public _line_frequency: any;
  public _actualrpm: any;
  public _ffteError: any = "";
  public vPredictionValue: any = {};
  // public intervalSensorUpdateAcc: any;
  // public intervalSensorUpdate: any;
  public intervalOrintationUpdate: any;
  public intervalTempUpdate: any;
  public listSenData: any = [];
  public listSenData2: any = [];
  public listSenData3: any = [];
  public listTempData1: any = [];
  public listTempData2: any = [];
  public listTempData3: any = [];
  public listOrienData1: any = [];
  public listOrienData2: any = [];
  public listOrienData3: any = [];
  public dataPreVibrationPointsNew1: any = [];
  public dataPreVibrationPointsNew2: any = [];
  public dataPreVibrationPointsNew3: any = [];
  public dataVibPredPoints1: any = [];
  public dataVibPredPoints2: any = [];
  public dataVibPredPoints3: any = [];
  public mainChartIndiArr: any = [];
  public returnPreVibObj: any;
  public arrObjVibrationPred: any = [];
  public min_g_vib: any;
  public max_g_vib: any;
  public max_y_vib: any;
  public max_r_vib: any;
  public countLatestNValues: any = 25;
  public predictiveVibrationChart: any;
  public arrObjvelocityPred: any = [];
  public listPredSenData1: any = [];
  public listPredSenData2: any = [];
  public listPredSenData3: any = [];
  public listPredVeloData1: any = [];
  public listPredVeloData2: any = [];
  public listPredVeloData3: any = [];
  public listPredTempData1: any = [];
  public listPredTempData2: any = [];
  public listPredTempData3: any = [];
  public listPredKurtData1: any = [];
  public listPredKurtData2: any = [];
  public listPredKurtData3: any = [];
  public listPredTData1: any = [];
  public listPredTData2: any = [];
  public listPredTData3: any = [];
  public listPredOrinData1: any = [];
  public listPredOrinData2: any = [];
  public listPredOrinData3: any = [];
  public listPredOData1: any = [];
  public listPredOData2: any = [];
  public stopLoopForIndi: boolean;
  public listPredOData3: any = [];
  public listFreqData1: any = [];
  public listFreqData2: any = [];
  public listFreqData3: any = [];
  public listAccData1: any = [];
  public listAccData2: any = [];
  public listAccData3: any = [];
  public moreChartsVisible: boolean;
  public showTextOn: string = "more";
  public valueTypeTrend: string = "hour";
  public rpmStopReload: boolean = true;
  public chartLayoutOn: boolean = true;
  public listLayoutOn: boolean;
  public downloadChartDataOn: boolean;
  public predictiveAccOn: boolean = true;
  public preAccListLayoutOn: boolean;
  public predictiveTempOn: boolean = true;
  public predictiveKurtOn: boolean = true;
  public predictiveKurtOff: boolean = false;
  public isMailReceived: boolean = false;
  public preTempListLayoutOn: boolean;
  public preKurtListLayoutOn: boolean;
  public preKurtosisListLayoutOn: boolean;
  public predictiveOrienOn: boolean = true;
  public preOrienListLayoutOn: boolean;
  public rValue: any = 999;
  public returnUpdatedAt: any = "";
  public freqChartViewOn: boolean = true;
  public freqChartViewOff: boolean;
  public accChartViewOff: boolean;
  public accChartViewOn: boolean;
  public ultraChartViewOn: boolean = true;
  public ultraChartViewOff: boolean;
  public magChartViewOff: boolean;
  public magChartViewOn: boolean = true;
  public absolutePercentageIndices: any;
  public statusHealthIndicesPredictionValues: boolean;
  public timeBentShaft = new Date();
  public dataBentShaftPoints1: any = [];
  public dataBentShaftPoints2: any = [];
  public dataBentShaftPoints3: any = [];
  public BentShaftChart;
  public trendAnalysDataPeriodic: any = [];
  public trendAnalysDataAnomaly: any = [];
  public timeRotorRub = new Date();
  public dataRotorRubPoints1: any = [];
  public dataRotorRubPoints2: any = [];
  public dataRotorRubPoints3: any = [];
  public BentRotorRubChart;
  public timeDriveEndBearing = new Date();
  public dataDriveEndBearingPoints1: any = [];
  public dataDriveEndBearingPoints2: any = [];
  public dataDriveEndBearingPoints3: any = [];
  public DriveEndBearingChart;
  public timeNonDrive = new Date();
  public dataNonDrivePoints1: any = [];
  public dataNonDrivePoints2: any = [];
  public dataNonDrivePoints3: any = [];
  public NonDriveChart;
  public assetDataObject: any;
  public timeOilWhirl = new Date();
  public dataOilWhirlPoints1: any = [];
  public dataOilWhirlPoints2: any = [];
  public dataOilWhirlPoints3: any = [];
  public OilWhirlChart;
  public timeJBearingWear = new Date();
  public dataJBearingWearPoints1: any = [];
  public dataJBearingWearPoints2: any = [];
  public dataJBearingWearPoints3: any = [];
  public dataJBearingWearPoints4: any = [];
  public dataJBearingWearPoints5: any = [];
  public JBearingWearChart;
  public syncRPM: any;
  public company_name: string;
  public userID: any;
  public _imgUrl: any;
  public connectivityType: string = "wifi";
  public assetType: string = "MOTOR";
  public dc_motor: boolean = false;
  public driveType: string = "";
  public outer_rpmshowgaudge: any = [];
  public pinionrpmshowgaudge: any = [];
  public dataAMCDoughnut: any;
  public indicesChartOn: boolean = true;
  public indicesTableOn: boolean;
  public lableOneX: string;
  public lableOneY: string;
  public magneticValues: any = [];
  public lableOneZ: string;
  public xaavg: String;
  public yaavg: String;
  public zaavg: String;
  public xaavg_day: String;
  public yaavg_day: String;
  public zaavg_day: String;
  public xaavg_week: String;
  public yaavg_week: String;
  public zaavg_week: String;
  public xvavg: String;
  public yvavg: String;
  public zvavg: String;
  public xvavg_day: String;
  public yvavg_day: String;
  public zvavg_day: String;
  public xvavg_week: String;
  public yvavg_week: String;
  public zvavg_week: String;
  public xauavg: String;
  public xauavg_day: String;
  public xauavg_week: String;
  public xmavg: String;
  public zmavg: String;
  public ymavg: String;
  public xtavg: String;
  public ztavg: String;
  public ytavg: String;
  public xtavg_week: String;
  public ztavg_week: String;
  public ytavg_week: String;
  public xtavg_day: String;
  public ztavg_day: String;
  public ytavg_day: String;
  public bearingFreqVal: any = [];
  public rpmValueClass: String;
  public masterRPM:"";

  public errmsg: any;
  // Velocity threshold values
  public velocityG: any;
  public velocityY: any;
  public velocityR: any;
  public cepListData1: any = [];
  public cepListData2: any = [];
  public cepListData3: any = [];
  public xcf: any;
  public ycf: any;
  public zcf: any;
  public AdvanceDiagFftData: any = [];
  public AdvanceDiagAnalysis: any = [];
  public csvOptions1 = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalseparator: ".",
    showLabels: true,
    showTitle: true,
    title: "Velocity / Vibration / Temperature Data Report",
    useBom: true,
    noDownload: false,
    headers: [
      "Time Stamp",
      "Tangential",
      "Axial",
      "Radial",
      "Tangential",
      "Axial",
      "Radial",
      "DE Bearing",
      "Stator Winding",
      "NDE Bearing",
      "Machine Acoustics (dB)",
    ],
  };
  public csvVibOptions2 = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalseparator: ".",
    showLabels: true,
    showTitle: true,
    title: "Vibration - Acceleration (m/sec2)",
    useBom: true,
    noDownload: false,
    headers: ["Sample Count", "Tangential", "Axial", "Radial"],
  };
  public csvOptions2 = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalseparator: ".",
    showLabels: true,
    showTitle: true,
    title: "Velocity Spectra (mm/s)",
    useBom: true,
    noDownload: false,
    headers: ["Frequency (Hz)", "Tangential", "Axial", "Radial"],
  };
  public magCsvOption = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalseparator: ".",
    showLabels: true,
    showTitle: true,
    title: "Magnetic Field Spectra (Gauss)",
    useBom: true,
    noDownload: false,
    headers: ["Frequency (Hz)", "x", "y", "z"],
  };
  public ultraCsvOption = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalseparator: ".",
    showLabels: true,
    showTitle: true,
    title: "Ultrasonic Spectra (dBV)",
    useBom: true,
    noDownload: false,
    headers: ["Frequency (Hz)", "dBV"],
  };
  public csvoptionskurtosis = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalseparator: ".",
    showLabels: true,
    showTitle: true,
    title: "Kurtosis Spectra (mm/s)",
    useBom: true,
    noDownload: false,
    headers: ["Frequency (Hz)", "Tangential", "Axial", "Radial"],
  };
  public csvOptions3 = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalseparator: ".",
    showLabels: true,
    showTitle: true,
    title: "Acceleration Spectra (m/sec<sup>2</sup>)",
    useBom: true,
    noDownload: false,
    headers: ["Frequency (Hz)", "Tangential", "Axial", "Radial"],
  };
  public cepstrumOptions3 = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalseparator: ".",
    showLabels: true,
    showTitle: true,
    title: "Cepstrum Spectra",
    useBom: true,
    noDownload: false,
    headers: ["Quefrency (sec)", "Tangential", "Axial", "Radial"],
  };
  public kurtosisEnv = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalseparator: ".",
    showLabels: true,
    showTitle: true,
    title: "Kurtosis Envelop",
    useBom: true,
    noDownload: false,
    headers: ["Frequency (Hz)", "X", "Y", "Z"],
  };
  public csvOptions5 = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalseparator: ".",
    showLabels: true,
    showTitle: true,
    title: "Vibration Velocity Trend (mm/sec)",
    useBom: true,
    noDownload: false,
    headers: [
      "Time Stamp",
      "Tangential",
      "Axial",
      "Radial",
      "Prediction X",
      "Prediction Y",
      "Prediction Z",
    ],
  };
  public csvOptionsKurt9 = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalseparator: ".",
    showLabels: true,
    showTitle: true,
    title: "",
    useBom: true,
    noDownload: false,
    headers: ["Time Stamp", "Radial", "Tangential", "Axial"],
  };
  public csvOptions8 = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalseparator: ".",
    showLabels: true,
    showTitle: true,
    title: "Vibration - Acceleration (m/sec<sup>2</sup>)",
    useBom: true,
    noDownload: false,
    headers: [
      "Time Stamp",
      "Tangential",
      "Axial",
      "Radial",
      "Prediction X",
      "Prediction Y",
      "Prediction Z",
    ],
  };
  public csvOptionsIndices = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalseparator: ".",
    showLabels: true,
    showTitle: true,
    title: "Machine Health Indices Trend  (mm/sec)",
    useBom: true,
    noDownload: false,
    headers: [
      "Time Stamp",
      "Mechanical Health",
      "Electrical Health",
      "Bearings Health",
      "Thermal Health",
      "Prediction W",
      "Prediction X",
      "Prediction Y",
      "Prediction Z",
    ],
  };
  public csvOptions51 = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalseparator: ".",
    showLabels: true,
    showTitle: true,
    title: "Vibration Velocity Trend (mm/sec)",
    useBom: true,
    noDownload: false,
    headers: [
      "Time Stamp",
      "DE Bearing",
      "Stator Winding",
      "NDE Bearing",
      "Prediction X",
      "Prediction Y",
      "Prediction Z",
    ],
  };

  public csvOptionsAcr = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalseparator: ".",
    showLabels: true,
    showTitle: true,
    title: "",
    useBom: true,
    noDownload: false,
    headers: ["Time Stamp", "Delta Ultrasound", "Delta Ultrasound Prediction"],
  };
  public csvOptions6 = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalseparator: ".",
    showLabels: true,
    showTitle: true,
    title: "Temperature Trend (°C)",
    useBom: true,
    noDownload: false,
    headers: [
      "Time Stamp",
      "Tangential",
      "Axial",
      "Radial",
      "Prediction X",
      "Prediction Y",
      "Prediction Z",
    ],
  };
  public csvOptions7 = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalseparator: ".",
    showLabels: true,
    showTitle: true,
    title: "Orientation (Degrees)",
    useBom: true,
    noDownload: false,
    headers: [
      "Time Stamp",
      "Tangential",
      "Axial",
      "Radial",
      "Prediction X",
      "Prediction Y",
      "Prediction Z",
    ],
  };
  public electricalCsvOption = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalseparator: ".",
    showLabels: true,
    showTitle: true,
    title: "Electrical Signature Analysis (mA)",
    useBom: true,
    noDownload: false,
    headers: ["Frequency (Hz)", "mA"],
  };
  public electricalCurrentCsvOption = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalseparator: ".",
    showLabels: true,
    showTitle: true,
    title: "Electrical Current",
    useBom: true,
    noDownload: false,
    headers: ["Sample Count", "Tangential", "Axial", "Radial"],
  };
  public rpmGaudgeObj: any = {
    needleValue: "",
    centralLabel: "",
    outerNeedle: false,
    canvasWidth: 550,
    name: "Tangential",
    key: "rpm",
    bottomLabel: "",
    hasneedle: true,
    options: {
      hasNeedle: true,
      needleColor: "black",
      arcColors: ["rgb(255,84,84)", "rgb(255,84,84)", "rgb(255,84,84)"],
      arcDelimiters: [99.99, 99.99],
      rangeLabel: [],
      needleStartValue: 0,
    },
  };
  public breadcrumbsArray: any = [
    {
      page_ref: "device-reports",
      page_title: "All Assets",
    },
    {
      page_ref: "#",
      page_title: "Trend Analysis",
    },
  ];
  public softwareStatusMap:{ [key: string]: boolean }={
    "monitoring": true,
    "diagnostics": true,
    "adv": true,
    "monitoring_tab": true,
    "diagnostics_tab": true,
    "predictive": true,
    "cepstrum": true,
    "kurtosis": true,
    "powertrain": true,
    "waterfall_chart": true
}
  public master_product_type:number=null;
  public greenColor: string = "rgb(212, 237, 218)";
  public yellowColor: string = "rgb(255, 250, 196)";
  public redColor: string = "rgb(255, 230, 230)";
  public emptyIndivisualCharts: boolean;
  public activeMechanicalTab: any;
  public activeElectricalStatorTab: any;
  public activateElectricalRotorTab: any;
  public activateBeltSystemTab: any;
  public activateBearingTab: any;
  public activateGearTab: any;
  public activateJournalTab: any;
  public onoffStatus: any = 2;
  public userRoll: any;
  public deviceSerialNo: any;
  public childCount: any;
  public sensor_mounting_axis_option: any;
  public assetMasterInfo: any = {};
  public datatoprocess: any;
  public deletecheck: boolean;
  public label: any;
  public sensorType: string; // 'Frame','de','nde'
  public serial_no: number;
  public downloadChartLoader = false;
  public startDateTrendChart: string = '';
  public endDateTrendChart: string = '';
  public overallStatus =""
  public showRequestTokenModal: boolean = false;
  public modalTitle: string = "";
  public modalMessage: string = "";
  public sendingRequestToken: boolean = false;
  // public raw_matric_id: any;
  diagKurtOn: boolean;
  datadiagKurtPoints1: any;
  datadiagKurtPoints2: any;
  datadiagKurtPoints3: any;
  diagKurtListLayoutOn: boolean;
  showDiagnosticChartEmpty: boolean;
  diagKurtOff: boolean;
  public mbarChartLabels: string[] = [
    "2012",
    "2013",
    "2014",
    "2015",
    "2016",
    "2017",
    "2018",
  ];
  public barChartType: string = "bar";
  public barChartLegend: boolean = true;

  //Trend Graph Vertical Lines.
  public rmptoggle: boolean = false;
  public rmptoggleEnvelop: boolean = false;
  public bFreqtoggleEnvelop: boolean = false;
  public pFreqtoggleVelocity: boolean = false;
  public bearingFrequencyCheckboxBoolean: boolean = false;
  public gearMeshFrequencyCheckboxBoolean: boolean = false;
  public yChecksMultipleBoolean: boolean = false;
  public bearingFrequencyStripLines: any = [];
  public gearMeshFrequencyStripLines: any = [];
  public preDominantStripLines: any = [];
  public bearingStripLine: any = [];

  //Trend Graph Add marker.
  public markerPoint1: any = [];
  public markerPoint2: any = [];
  public markerPoint3: any = [];
  public DiagnosticsArray: any = [];

  public barChartColors: Array<any> = [
    {
      backgroundColor: "rgba(105,159,177,0.2)",
      borderColor: "rgba(105,159,177,1)",
      pointBackgroundColor: "rgba(105,159,177,1)",
      pointBorderColor: "#fafafa",
      pointHoverBackgroundColor: "#fafafa",
      pointHoverBorderColor: "rgba(105,159,177)",
    },
    {
      backgroundColor: "rgba(77,20,96,0.3)",
      borderColor: "rgba(77,20,96,1)",
      pointBackgroundColor: "rgba(77,20,96,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(77,20,96,1)",
    },
  ];

  public barChartData: any[] = [
    { data: [55, 60, 75, 82, 56, 62, 80], label: "Company A" },
    { data: [58, 55, 60, 79, 66, 57, 90], label: "Company B" },
  ];
  // bartempchart: any;
  //tempbarch: any;
  public anomalyType: string = "periodic";
  temp1: any;
  chartbartemp: any;
  chartbartemp2: any;
  chartbartemp3: any;
  datatoproc: any;
  showEmptyError: string;
  currentdate: Date;
  errordata: any[];
  clientid: string;
  role: string;
  reportDataArr: any;
  checker: boolean;
  TrendzchartOn: boolean = false;
  noalertmessage: any;
  base_middleware_url: string;
  overallhealthindiexnumber: any;
  chartbarmagacc: any;
  spanred: boolean = false;
  spanyellow: boolean = false;
  spangreen: boolean = false;
  maxaccobj: any;
  valll: any;
  cccount: number = 0;
  Optionsss: any;
  gaugedisplay: boolean;
  spanwhite: boolean = false;
  velocityObj: {
    needleValue: any;
    centralLabel: any;
    outerNeedle: boolean;
    canvasWidth: number;
    name: any;
    key: any;
    bottomLabel: string;
    hasneedle: any;
    options: {
      hasNeedle: any;
      needleColor: string;
      needleUpdateSpeed: string;
      arcColors: any;
      arcLabels: any[];
      arcDelimiters: any;
      rangeLabel: any;
      needleStartValue: number;
    };
  };
  magacoustic: {
    needleValue: any;
    centralLabel: any;
    outerNeedle: boolean;
    canvasWidth: number;
    name: any;
    key: any;
    bottomLabel: string;
    hasneedle: any;
    options: {
      hasNeedle: any;
      needleColor: string;
      needleUpdateSpeed: string;
      arcColors: any;
      arcLabels: any[];
      arcDelimiters: any;
      rangeLabel: any;
      needleStartValue: number;
    };
  };
  MonitoringMagacoustic: {
    needleValue: any;
    centralLabel: any;
    outerNeedle: boolean;
    canvasWidth: number;
    name: any;
    key: any;
    bottomLabel: string;
    hasneedle: any;
    options: {
      hasNeedle: any;
      needleColor: string;
      needleUpdateSpeed: string;
      arcColors: any;
      arcLabels: any[];
      arcDelimiters: any;
      rangeLabel: any;
      needleStartValue: number;
    };
  };
  accelerationData: any;
  acousticgaugeLoader: boolean = true;
  displaytempgauge: boolean = false;
  tempgaugeLoader: boolean = true;
  thresholdforvelocity: any;
  stackData: any[];
  stackvelo: boolean = false;
  tabswitchrawid: boolean;
  EstOutputpower: string | number;
  operatingSyncRPM: number;
  mac_address: any;
  rssival: any = "N/A";
  Batterpercentage: any;
  Batteryred: boolean;
  Batteryyellow: boolean;
  Batterygreen: boolean;
  Battery: boolean = false;
  offlinestatustime: string;
  divoff: boolean = true;
  public vibrationVelocityTrendDiv: boolean = true;
  nodataAvailable: string;
  public showCepstrumFieldChartEmpty: boolean;
  dataCepstrumFieldPoints1: any;
  dataCepstrumFieldPoints2: any;
  dataCepstrumFieldPoints3: any;
  cepstrumFieldSpecChart: any;
  cepStrumViewOn: any;
  cepStrumViewOff: boolean;
  public cepStrumPredFreq: any = [];
  cepStrumFieldNoDataMsg: string;
  public cresFactorEmpty: boolean = false;
  public cresFactorValue: any;
  cepstrumProdEmpty: boolean;
  forSAonDemandLabel: string;
  public envelopAnalysisError: string;
  public downloadDisabled: boolean = false;
  public msgDownload: string = "";
  public errorMessage: string = "";
  public advCrestFactor: boolean = true;
  public x_kurtosis: any;
  public y_kurtosis: any;
  public z_kurtosis: any;
  public advuuid: any;
  public time_span: string = "hourly";
  public fftAdvEmpty: boolean = true;
  public valueTypekurt: string = "hour";
  public emptyMsgKurtNum: boolean = true;
  public KurtNumloader: boolean = true;
  public create_at_fft: any = " ";
  public time_fft: any = " ";
  public earlyUpdateAt: any = " ";
  public ballBearingErrorMessage: any = " ";
  public esaUpdateat: any = " ";
  public esamessage: any = " ";

  public elecPredominantError: any = " ";
  public bearingPredominantError: any = " ";
  public bearingObserveableError: any = " ";
  public elecObserveableError: any = " ";
  public mechobserveableError: any = " ";
  public mechFaultPreCondition: any = " ";
  public msgAudibleChart: boolean;
  public audibleChartLoader: boolean;
  public audibleDataPoints1: any = [];
  public audibleChartGraph: any;
  public audibleChart: any;
  public cepsturmError: any = "";
  public audLableX: any;
  public averageTableOff: boolean = true;
  public electricalChartViewOn: boolean = true;
  public electricalChartViewOff: boolean;
  public dataElectricalfrequentPoints1: any = [];
  public electricalMessage: boolean = false;
  public electricalChartLoader: boolean = true;
  public predElectricalFrq: any = [];
  public electricalDropDownList: any = [];
  public device_raw_matric_id: any;
  public currentChartLoader: boolean = true;
  public electricalLabelVal: any = "";
  public currentChartObj: any;
  public listElectricalData: any = [];
  public dataCurrentPoints1: any = [];
  public dataCurrentPoints2: any = [];
  public dataCurrentPoints3: any = [];
  public ESADisabled: boolean = true;
  electricalTooltip: string;
  public AdvanceDiagnosticsDisabled: boolean = true;
  public ElectricalHealthError: string = "";
  public DiagnosticsCondition: string = "";
  public ballBearingOn: boolean = true;
  public sub_type: string = "";
  public mechFaultPreConditionfault: any = null;
  public mechObserveablefault: any = null;
  public elecPredominantFault: any = null;
  public elecObserveableFault: any = null;
  public bearingPredominantFault: any = null;
  public ballBearingEarlyFault: any = null;
  public bearingObserveableFault: any = null;
  public cepsturmFault: any = null;
  public assetErrors: any = [];
  public finalErrors: any = [];
  public greenErrors: any = [];
  public yellowErr: any = [];
  public redErr: any = [];
  public ballBearingErrorFault: any = "";
  public machineVibrationLoading: boolean = true;
  public stackvelocitychartLoader: boolean = true;
  public monitoringLoader: boolean = true;
  public machineHealthLoader: boolean = true;
  public audibleLoader: boolean = true;
  public serviceLoader: boolean = true;
  public machineOperatingLoader: boolean = true;
  public kurt_freq: any;
  public kurt_threshold: any;
  public kurt_anomaly_counter: any;
  public isOutOfService: boolean = false;
  public  outofservicedisable: boolean = false;
  public productTab2: any;
  public productTab3: any;
  public productTab4: any;
  public overall_health_status='N/A';
  public recommened_action='N/A';
  public anomalyLoader:boolean = true;
  public machineOperatngParametersLoader: boolean = true;
  public powertrainSubsystemId: any='';
  public fromPowerTrain: any='';
  public overall_powertrain_live_status:any='';

  public outOfServicedate="";
  // public isJournalBearingWithSyncMotor:boolean=false;
  public opr_rpm: number;
  @ViewChild("myDiv") diagnosticsTab: ElementRef;
  public trendMachineAcousitcsOnOff: boolean = true;
  public predictiveChartContainerOnOff: boolean = true;
  public machineHealthIndicesOnOff: boolean = true;
  public route_path: any;
  public monitoring_operatingLF: any;
  public monitoring_operatingSyncRPM: any;
  public monitoring_actual_rpm: any;
  public monitoring_operating_ph_line_current: any;
  public monitoring_pinion_gear_rpm: any;
  public monitoring_output_gear_rpm: any;
  public monitoring_gear_rated_power: any;
  public monitoring_number_of_stages: any;
  public monitoringIndicesValues: any = [];
  public monitoringOverallHealthIndex: any;
  public monitoringOverallHealthIndexColor: any;
  public monitoringIndicesKeys: string[] = ['Mechanical Health', 'Electrical Health', 'Bearing Health', 'Thermal Health'];
  public monitoringIndicesLoader: any;
  public monitoringMeterShowVelocity: any;
  public monitoringmaxaccobj: any;
  public monitoringTempratueResults: any;
  public monitoringAudibleValue: any;
  public monitoringDeviceDetails: any = 0;
  public monitoringDeviceDetailsLoader: any = 0;
  public serviceStatusLoader: any;
  public showMachineUtilizationLoader: boolean = true;
  public monitoringMachineUtlizationLoader: boolean = true;
  public monitoringMachineUtilization: any;
  public monitoringDeviceStops: any;
  public monitoringAssetStops: any;
  public monitoringDeviceUtilization: any;
  public monitoringAssetUtilization: any;
  public monitoringDeviceAverageRun: any;
  public monitoringAssetAverageRun: any;
  public monitoringDeviceWeeklyRunningStatus: any;
  public diagnosticsSummaryLoader: boolean = true;
  public diagosticsCreateAtFFT: any;
  public diagnosticsMechanicalFaultPredominantError: any;
  public diagnosticsMechanicalFaultObservableError: any;
  public diagnosticsElectricalFaultPredominantError: any;
  public diagnosticsElectricalFaultObservableError: any;
  public diagnosticsBearingFaultPredominantError: any;
  public diagnosticsBearingFaultObservableError: any;
  public diagnosticsEarlyStageBallBearingUpdatedAt: any;
  public diagnosticsBallBearingErrorMessage: any;
  public diagnosticsEsaFaultsUpdatedAt: any;
  public diagnosticsEsaFaultsErrorMessage: any;
  public diagnosticsCepstrumError: any;
  public diagosticsTimeFFT: any;
  public diagnoticsFFTListLoader: boolean = true;
  public isMachineDiagnosticsAnalysisDone: boolean = false;
  public machineDiagnosticsLoader: boolean = true;
  public predominantFrequencyLoader: boolean = true;
  public spectrumAnalysisCase: any;
  public callDiagnosticsSummary: boolean = false;
  public tabName: string
  public gmf_frequency: any;
  public fxMax: any = 0;
  public spectrumResolutionFactor: any = 0;
  public xAxisScaleTypeGlobal: any = 1;
  public rpmData: any;
  orientation: any;
  is_sa_on_demand_done: boolean;
  constructor(
    private cd: ChangeDetectorRef,
    public calendar: NgbCalendar,
    private modalService: ModalService,
    public router: Router,
    public activeRoute: ActivatedRoute,
    public service: BackendApiService,
    public dialog: MatDialog,
    private changeService: ChangeUsersService,
    private clientSubscriptionService: ClientSubscriptionService
  ) {
    this.changeText = false;
    this.userRoll = localStorage.getItem("role");
    //  this.userRoll="USER"
    if (localStorage.getItem("role") === "ACCOUNT_MANAGER") {
      this.userID = localStorage.getItem("admin_client_id");
    } else if (localStorage.getItem("role") === "USER") {
      this.userID = localStorage.getItem("associated_clientid");
    } else if (localStorage.getItem("role") === "ADMIN") {
      this.userID = localStorage.getItem("admin_client_id");
    } else if (localStorage.getItem("role") === "OEM") {
      this.userID = localStorage.getItem("admin_client_id");
    } else {
      this.userID = localStorage.getItem("user_id");
    }
    this.company_name = localStorage.getItem("company_name");
    this.utcTime();
    this.base_middleware_url = BaseUrlConstantsService.BASE_MIDDLEWARE_URL;
    //Route parameters


    activeRoute.queryParams.subscribe(async (params) => {
      console.log(params)
      // if (!params["queryParams"] || typeof params !== 'object') {
      //   console.warn('Query parameters are undefined or null. Exiting function.');
      //   return;
      // }
      // console.log(params)
      this.overallStatus = params["overallStatus"];
      // console.log("Overall Status: ",params["overallStatus"]);
      this.tabName = params["tabName"]
      this.label = params[`label`];
      this.isOutOfService = params['outOfService']=='yes' ? true : false;
      this.deviceId = params[`deviceId`];
      this.assetId = params[`assetid`];
      this.mac_address = params["macaddress"];
      localStorage.setItem("mac_address", this.mac_address);
      localStorage.setItem("assetId", this.assetId);
      this.route_path = params["route_path"];
      this.monitorInfo.motor_serial_number=params["motor_serial_no"];
      this.master_product_type = params["master_type"];
      this.monitorInfo.application_name=localStorage.getItem('ApplicationName')
      // localStorage.setItem("kurt_threshold", this.kurt_threshold);
      // this.kurt_freq = params["kurt_freq"];
      // this.kurt_threshold = params["kurt_threshold"];
      // this.kurt_anomaly_counter = params["kurt_anomaly_counter"];

      this.clientid = localStorage.getItem("user_id");
      this.role = localStorage.getItem("role");
      // let parent = JSON.parse(params["asset_master_info"]);
      // if (
      //   parent.asset_type_s == "JOURNAL_BEARING" &&
      //   parent.template_id == "1_frame_primary" &&
      //   parent.sub_type == "SYNCHRONOUS_MOTOR"
      // ) {
      //   this.isJournalBearingWithSyncMotor = true;
      // }
      this.sensorType = params[`sensorType`];

      this.serial_no = params[`serial_no`];

      this.assetMasterInfo = JSON.parse(params[`asset_master_info`]);
      console.log(this.assetMasterInfo,'assetMasterinfo-----------------');
      this.assetType = params["asset_type"];
      this.sub_type = params["sub_type"];

      this.productTab2=params['tab2'] === "true"? true : false
      this.productTab3=params['tab3']
      this.productTab4=params['tab4']
      if (this.sub_type === "DC_MOTOR") {
        this.dc_motor = true;
      }
      if (parseInt(this.assetMasterInfo.id) === parseInt(this.assetId)) {
        this.deviceSerialNo = 1;
      } else {
        this.deviceSerialNo = 2;
      }
      this.childCount =
        parseInt(this.assetMasterInfo.connected_sensors.length) - 1;
      this.onoffStatus = JSON.parse(params[`assetStatus`]);
      console.log(`CALLING ASSET DAT OBJECT URL WITH ${this.assetsListUrl}/info/detail/v2/${this.userID}/${this.assetId}/${this.mac_address}`)
      this.assetDataObject = await this.service
        .getDataWithQuery(
          `${this.assetsListUrl}/info/detail/v2/${this.userID}/${this.assetId}/${this.mac_address}`
        )
        .then((assetFullInfo) => {
          console.log(assetFullInfo)
          return assetFullInfo;
        });
      this.connectivityType =
        this.assetDataObject.data.body[0] === undefined
          ? "wifi"
          : this.assetDataObject.data.body[0].connectivity_type;
      this.pageName = params[`pageRef`];
      if (this.pageName == "" && localStorage.getItem("role") === "ADMIN") {
        this.pageName = "AdminClientPage";
      }
      if (this.pageName == "" && localStorage.getItem("role") === "OEM") {
        this.pageName = "OEMClientPage";
      }

      this.sensor_mounting_axis_option =
        this.assetDataObject.data.body[0].sensor_mounting_axis_option;
      this.assetType = params[`asset_type`];
      if (this.pageName === "managerAssets") {
        const myObj = {
          page_ref: "manager-client-list",
          page_title: "manager clients",
        };
        this.breadcrumbsArray.unshift(myObj);
      } else if (this.pageName === "AdminClientPage") {
        this.breadcrumbsArray = [
          {
            page_ref: "device-report-new",
            page_title: "All Assets",
          },
          {
            page_ref: "#",
            page_title: "Trend Analysis",
          },
        ];
      } else if (this.pageName === "OEMClientPage") {
        this.breadcrumbsArray = [
          {
            page_ref: "device-report-new",
            page_title: "All Assets",
          },
          {
            page_ref: "#",
            page_title: "Trend Analysis",
          },
        ];
      } else {
        this.breadcrumbsArray = [
          {
            page_ref: "device-reports",
            page_title: "All Assets",
          },
          {
            page_ref: "#",
            page_title: "Trend Analysis",
          },
        ];
      }
      if (this.pageName === "Boiler-device-room") {
        this.breadcrumbsArray = [
          {
            page_ref: "eBoiler-room-devices",
            page_title: "Device Room",
          },
          {
            page_ref: "#",
            page_title: "Trend Analysis",
          },
        ];
      }

      // console.log(params)
      if(params["fromPowerTrain"]){
        this.fromPowerTrain = true;
        this.overall_powertrain_live_status=JSON.parse(params['fromPowerTrain']).overall_status
        this.powertrainSubsystemId=JSON.parse(params["fromPowerTrain"]).subsystemId
      }
      if(params["fromPowerTrain"]){
        this.fromPowerTrain = true;
        if(JSON.parse(params["fromPowerTrain"]).fft_id){
          this.powertrainSelectedFFT_id=JSON.parse(params["fromPowerTrain"]).fft_id
          this.taketopredominantalert('',JSON.parse(params["fromPowerTrain"]).fft_id)
        }
      }
    });
  }

  private async processQueryParams(params: any) {
    this.changeText = false;
    this.userRoll = localStorage.getItem("role");
    //  this.userRoll="USER"
    if (localStorage.getItem("role") === "ACCOUNT_MANAGER") {
      this.userID = localStorage.getItem("admin_client_id");
    } else if (localStorage.getItem("role") === "USER") {
      this.userID = localStorage.getItem("associated_clientid");
    } else if (localStorage.getItem("role") === "ADMIN") {
      this.userID = localStorage.getItem("admin_client_id");
    } else if (localStorage.getItem("role") === "OEM") {
      this.userID = localStorage.getItem("admin_client_id");
    } else {
      this.userID = localStorage.getItem("user_id");
    }
    this.company_name = localStorage.getItem("company_name");
    this.utcTime();
    this.base_middleware_url = BaseUrlConstantsService.BASE_MIDDLEWARE_URL;
        // console.log(params)
        this.label = params[`label`];
        this.isOutOfService = params['outOfService']=='yes' ? true : false;
        this.deviceId = params[`deviceId`];
        this.assetId = params[`assetid`];
        this.mac_address = params["macaddress"];
        localStorage.setItem("mac_address", this.mac_address);
        localStorage.setItem("assetId", this.assetId);
        this.route_path = params["route_path"];
        this.monitorInfo.motor_serial_number=params["motor_serial_no"];
        this.monitorInfo.application_name=localStorage.getItem('ApplicationName')
        // localStorage.setItem("kurt_threshold", this.kurt_threshold);
        // this.kurt_freq = params["kurt_freq"];
        // this.kurt_threshold = params["kurt_threshold"];
        // this.kurt_anomaly_counter = params["kurt_anomaly_counter"];

        this.clientid = localStorage.getItem("user_id");
        this.role = localStorage.getItem("role");
        // let parent = JSON.parse(params["asset_master_info"]);
        // if (
        //   parent.asset_type_s == "JOURNAL_BEARING" &&
        //   parent.template_id == "1_frame_primary" &&
        //   parent.sub_type == "SYNCHRONOUS_MOTOR"
        // ) {
        //   this.isJournalBearingWithSyncMotor = true;
        // }
        this.sensorType = params[`sensorType`];

        this.serial_no = params[`serial_no`];
        this.assetMasterInfo = JSON.parse(params[`asset_master_info`]);
        this.assetType = params["asset_type"];
        this.sub_type = params["sub_type"];
        this.serialNumber = params[`motor_serial_no`];

        this.productTab2=params['tab2']
        this.productTab3=params['tab3']
        this.productTab4=params['tab4']
        if (this.sub_type === "DC_MOTOR") {
          this.dc_motor = true;
        }
        if (parseInt(this.assetMasterInfo.id) === parseInt(this.assetId)) {
          this.deviceSerialNo = 1;
        } else {
          this.deviceSerialNo = 2;
        }
        this.childCount =
          parseInt(this.assetMasterInfo.connected_sensors.length) - 1;
        this.onoffStatus = JSON.parse(params[`assetStatus`]);
        this.assetDataObject = await this.service
          .getDataWithQuery(
            `${this.assetsListUrl}/info/detail/v2/${this.userID}/${this.assetId}/${this.mac_address}`
          )
          .then((assetFullInfo) => {
            return assetFullInfo;
          });
        this.connectivityType =
          this.assetDataObject.data.body[0] === undefined
            ? "wifi"
            : this.assetDataObject.data.body[0].connectivity_type;
        this.pageName = params[`pageRef`];
        if (this.pageName == "" && localStorage.getItem("role") === "ADMIN") {
          this.pageName = "AdminClientPage";
        }
        if (this.pageName == "" && localStorage.getItem("role") === "OEM") {
          this.pageName = "OEMClientPage";
        }

        this.sensor_mounting_axis_option =
          this.assetDataObject.data.body[0].sensor_mounting_axis_option;
        this.assetType = params[`asset_type`];
        if (this.pageName === "managerAssets") {
          const myObj = {
            page_ref: "manager-client-list",
            page_title: "manager clients",
          };
          this.breadcrumbsArray.unshift(myObj);
        } else if (this.pageName === "AdminClientPage") {
          this.breadcrumbsArray = [
            {
              page_ref: "device-report-new",
              page_title: "All Assets",
            },
            {
              page_ref: "#",
              page_title: "Trend Analysis",
            },
          ];
        } else if (this.pageName === "OEMClientPage") {
          this.breadcrumbsArray = [
            {
              page_ref: "device-report-new",
              page_title: "All Assets",
            },
            {
              page_ref: "#",
              page_title: "Trend Analysis",
            },
          ];
        } else {
          this.breadcrumbsArray = [
            {
              page_ref: "device-reports",
              page_title: "All Assets",
            },
            {
              page_ref: "#",
              page_title: "Trend Analysis",
            },
          ];
        }
        if (this.pageName === "Boiler-device-room") {
          this.breadcrumbsArray = [
            {
              page_ref: "eBoiler-room-devices",
              page_title: "Device Room",
            },
            {
              page_ref: "#",
              page_title: "Trend Analysis",
            },
          ];
        }
        if(params["fromPowerTrain"]){
          this.fromPowerTrain = true;
          this.powertrainSubsystemId=JSON.parse(params["fromPowerTrain"]).subsystemId
          this.overall_powertrain_live_status=JSON.parse(params["fromPowerTrain"]).overall_status
        }
        if(params["fromPowerTrain"]){
          this.fromPowerTrain = true;
          if(JSON.parse(params["fromPowerTrain"]).fft_id){
            this.powertrainSelectedFFT_id=JSON.parse(params["fromPowerTrain"]).fft_id
              this.taketopredominantalert('',JSON.parse(params["fromPowerTrain"]).fft_id)
          }
        }

  }

  switchToDiagnostics() {
    // Dispatch click event on the diagnostics tab element
    this.diagnosticsTab.nativeElement.click();
  }

  private waitForMessage(): Promise<void> {
    const assocId = localStorage.getItem('associated_clientid');
    const userId = localStorage.getItem('user_id');
    const adminId = localStorage.getItem('admin_client_id');


    return new Promise((resolve) => {
      if (assocId == '390' || userId == '390' || adminId == '390') {
      // console.log("ids matched waiting for data");
        window.opener?.postMessage({ type: 'ready' }, window.location.origin);

      const messageHandler = (event: MessageEvent) => {
        if (event.origin !== window.location.origin || event.data?.type !== 'init') {
          return;
        }
        const qp = event.data.payload?.data.queryParams;
        // console.log(qp);
        if (qp) {
          this.processQueryParams(qp);
        }
        window.removeEventListener('message', messageHandler);
        clearTimeout(timeoutId);
        resolve();
      };
      const timeoutId = setTimeout(() => {
        window.removeEventListener('message', messageHandler);
        // this.router.navigate(['/home']);
        resolve();
      }, 3500);
      window.addEventListener('message', messageHandler, false);

      }else{
        resolve()
        return
      }
      });
  }



  private navigateBasedOnRole() {
    this.userRoll = localStorage.getItem("role");
    if (this.userRoll === 'CLIENT' || this.userRoll === 'USER') {
      this.router.navigate(['/device-reports']);
    } else if (this.userRoll === 'ADMIN') {
      this.router.navigate(['/device-report-new']);
    }
  }



  async ngOnInit() {
    // localStorage.setItem('Monitoring_window',"false")
    this.loadMailSent();
    this.getSubscriptionService();
    await this.waitForMessage();
    // this.checkSensorDataExitsOnInit();
    this.forBearingAnalysisTab();
    this.getDiagnosticsFFTList();
    this.getGearMeshFrequency();
    // this.getBearingFreq();
    this.getMachineDiagnosticsDone();
    this.getMonitoringDeviceDetails();
    this.getAnomalyStatus()
    this.getMonitoringMachineUtilization()
    // this.tempbarchart();
    this.getMachineOperatingParameters();
    this.getMachineHealthIndexValues();
    this.isOutOfService?this.showOutOfServiceDialogInitially():"";
    this.masterRPMCheck()
    this.fftForAdvanceDiagnostics();
    this.getIndicesCondition();
    this.getGaugeDataByID();
    this.monitoringGaugeData();

    this.service.getIndicesConstants().then((indValue) => {
      this.indicesConstValues = indValue;
    });
    this.getalertsummmary();
    this.rtdData = await this.service
      .getDataWithQuery(
        this.rtdUrl + "rtd/" + parseInt(this.assetId) + "/" + this.mac_address
      )
      .then((rtdRes) => {
        return rtdRes;
      });
    this.offlineGaugeData = await this.service
      .getOfflineData()
      .then((offDataRes) => {
        return offDataRes;
      });
    this.againStartUpdate();
    this.getElectricalDropDown();
    this.firstTimeChartLoad = true;
    localStorage.setItem("dataInterval", null);
    this.siteName = localStorage.getItem("siteName");
    this.appMacAdd = localStorage.getItem("appMacAdd");
    this.assetId = localStorage.getItem("assetId");
    this.assetDataObject = await this.service
      .getDataWithQuery(
        `${this.assetsListUrl}/info/detail/v2/${this.userID}/${this.assetId}/${this.mac_address}`
      )
      .then((assetFullInfo) => {
        return assetFullInfo;
      });
    this.serialNumber = localStorage.getItem("serialNumber");
    this.applicationNme = localStorage.getItem("applicationName");
    // this.checkOutOfServiceStatus();
    // this.getFftList();
    // this.getDiagnosticsFFTList();
    this.getAssetServiceData();
    this.getMonitoringInfo();
    this.getAssetImage();
    this.loadMetrics();
    this.fetchRPMDetails();

    /*************Monitoring chart methods******************* */
    // this.getSensorCharts();
    // this.getVelocityChart();
    // this.getSensorTempCharts();
    // this.getMachineAcousticsChart();
    // this.getAudibleChart();
    // this.ForcedSpectralAnalysis();//so we could get latest values of line freq, operating freq, etc shown on diagnostics screen below machine diagnostics frequency chart
    //this.stackchartvelocity();
    // setTimeout(() => {
      // this.stackchartvelocity();
    // }, 7000);
    setTimeout(() => {
      this.getrssiandbatterystatus();
    }, 1000);


    Promise.all([
      this.service.getDataV2(`${this.base_middleware_url}get-software-products?client_id=${this.userID}`),
      this.service.getDataV2(`${this.base_middleware_url}get-software-products`),
      this.service.getDataV2(`${this.deviceStatusURL}inventory/v2/get_master_type_by_mac/${this.mac_address}`),
    ])
    .then(([resWithClient, resWithoutClient,productTypeRes]: any[]) => {
      let client_software=[],allSoftware=[];
      if (resWithClient.data.code == '200' && resWithClient.data.status == 'success') {
        client_software = resWithClient.data.body.selected_ids;
      }

      if (resWithoutClient.data.code == '200' && resWithoutClient.data.status == 'success') {
        allSoftware = resWithoutClient.data.body.body;
      }
      const subscribedKeys = new Set(client_software.map(s => s));
      if(client_software.length && this.role!='ADMIN'){
        this.softwareStatusMap = allSoftware.reduce((acc, s) => {
          acc[s.key] = subscribedKeys.has(s.id);
          return acc;
        }, {} as { [key: string]: boolean });
      }else{
        console.log(`ROLE IS ${this.role} OR NO CLIENT SOFTWARE SUBSCRIPTION ENABLED`)
        console.log("No client_software subs. enabled all")
      }
      if(productTypeRes.data.code==200){
        this.master_product_type=productTypeRes.data.body.master_type;
        localStorage.setItem('masterType', String(this.master_product_type))
        if(this.master_product_type!=null && this.master_product_type!=3){
            this.monitoringTempratueResults=this.monitoringTempratueResults.filter(temp=>temp.key=="Bearing_Temperature")
          }
      }
    })
    .catch(err => {
      console.log('Error in one of the requests:', err);
    });

  }

  async fetchRPMDetails () {
    console.log(this.assetMasterInfo.asset_status , this.is_sa_on_demand_done,'assetMasterInfo.asset_status === 1 &&  this.is_sa_on_demand_done');
    let selected_asset_id;
    if(this.assetMasterInfo.asset_status === 1 &&  !this.is_sa_on_demand_done){
      selected_asset_id = this.assetMasterInfo.id;
    } else{
      selected_asset_id = this.assetId;
    }
    try {
      const response: any = await this.service.getDataV2(BaseUrlConstantsService.GET_RPM_DETAILS + `/${this.assetId}/${selected_asset_id}?userId=${this.userID}&assetType=${this.assetType}`)
      console.log(response)
      if(response.success === true) {
        this.rpmData = response.data;
      }
    }
    catch (error) {
        console.error('Error fetching RPM details:', error);
        throw error;
      }
  }

  onCheckTabClick(event: MouseEvent, type: 'diagnostics' | 'predictive') {
  if (this.role === 'USER' && !this.softwareStatusMap[type]) {
    // stop NgbNav from changing tab
    event.preventDefault();
    event.stopImmediatePropagation();
    return;
  }
  this.checkSubscriptionController(event, type);
}

  async loadMailSent() {
      try {
        const response: any = await this.service.postData(BaseUrlConstantsService.GET_MAIL_SENT, { clientId: this.userID });
        if(response.status === 'success') {
          this.isMailReceived = response.status === "success" && response.mail_received === 1;
        } else {
          this.isMailReceived = false;
        }
      }
      catch (error) {
        console.error('Error fetching mail sent status:', error);
        throw error;
      }
    }

  getSubscriptionService() {
    this.clientSubscriptionService.getSubscriptionService(this.userID).subscribe({
      next: (response: any) => {
        const tabs = response?.data?.body?.body[0]?.tabs || [];
        const parentTabs = tabs.filter((tab: any) => !tab.parentTabId);
        this.isMonitoringTabEnabled = parentTabs.some((item: any) => item.id === 1 && item.status === 'Active');
        this.isDiagnosticsTabEnabled = parentTabs.some((item: any) => item.id === 2 && item.status === 'Active');
        this.isPredictiveTabEnabled = parentTabs.some((item: any) => item.id === 3 && item.status === 'Active');
        if(this.isDiagnosticsTabEnabled){
          parentTabs.forEach(pt => {
            if(pt.id==2){
              pt.children && pt.children.map(child=>{
                // if(child.id==5)this.vs_enabled=true;
                // if(child.id==6) this.as_enabled=true;
                // if(child.id==7) this.us_enabled=true;
                // if(child.id==8) this.ms_enabled=true;
                // if(child.id==9) this.ba_enabled=true;
              })
            }
          });
        }
      },
      error: (err) => {
        console.error('Failed to fetch subscription status:', err);
        this.isMonitoringTabEnabled = true;
        this.isDiagnosticsTabEnabled = true;
        this.isPredictiveTabEnabled = true;
      }
    })
  }


  setFaults() {
    const data: any = faultsData;
    const asset = this.assetType;
    let subtype = null;
    if (asset == "MOTOR") subtype = this.sub_type;
    this.mechObserveablefault = "";
    this.mechFaultPreConditionfault = "";
    this.elecPredominantFault = "";
    this.elecObserveableFault = "";
    this.bearingPredominantFault = "";
    this.bearingObserveableFault = "";
    this.cepsturmFault = "";
    this.ballBearingErrorFault = "";
    this.ballBearingEarlyFault = "";
    this.assetErrors = [];
    this.finalErrors = [];
    this.yellowErr = [];
    this.redErr = [];
    this.greenErrors = [];

    data.forEach((fault) => {
      if (subtype != null) {
        if (fault.assets.includes(subtype)) {
          this.assetErrors.push(fault);
        }
      } else {
        if (fault.assets.includes(asset)) {
          this.assetErrors.push(fault);
        }
      }
    });
    this.mechObserveablefault = this.diagnosticsMechanicalFaultObservableError.split(",");
    this.mechObserveablefault = this.mechObserveablefault.flatMap((err) => {
      let arr1 = [];
      let arr2 = err.split("or");
      arr1 = arr2.flatMap((item) => item.trim());
      return arr1;
    });
    this.elecObserveableFault = this.diagnosticsElectricalFaultObservableError.split(",");
    this.elecObserveableFault = this.elecObserveableFault.flatMap((err) => {
      let arr1 = [];
      let arr2 = err.split("or");
      arr1 = arr2.flatMap((item) => item.trim());
      return arr1;
    });
    this.bearingObserveableFault = this.diagnosticsBearingFaultObservableError.split(",");
    this.bearingObserveableFault = this.bearingObserveableFault.flatMap(
      (err) => {
        let arr1 = [];
        let arr2 = err.split("or");
        arr1 = arr2.flatMap((item) => item.trim());
        return arr1;
      }
    );
    // console.log("Cepstrum Error::" + this.cepsturmError);
    this.cepsturmFault = this.diagnosticsCepstrumError.split(",");
    this.cepsturmFault = this.cepsturmFault.flatMap((err) => {
      let arr1 = [];
      let arr2 = err.split("or");
      arr1 = arr2.flatMap((item) => item.trim());
      return arr1;
    });

    // got all observalbe errors splitted them by  "," and "or"
    let finalObservalbeErrors = new Array(
      ...new Set([
        ...this.mechObserveablefault,
        ...this.elecObserveableFault,
        ...this.bearingObserveableFault,
        ...this.cepsturmFault,
      ])
    );

    //from all errors of particular asset we push only those errors which matched finalobservalbeError array to yellowErr array
    this.assetErrors.forEach((err, i) => {
      // console.log(err.key,finalObservalbeErrors,finalObservalbeErrors.includes(err.key));
      for (let j = 0; j < finalObservalbeErrors.length; j++) {
        if (
          finalObservalbeErrors[j].includes(this.assetErrors[i].key) &&
          finalObservalbeErrors[j] != ""
        ) {
          this.yellowErr.push({
            fault: err.key,
            error: err.faults,
            group: err.faultGroup,
            color: "yellow_color_bg_new",
          });
        }
      }
      // if (finalObservalbeErrors.includes(err.key)) {
      //   this.yellowErr.push({
      //     fault: err.key,
      //     error:err.faults,
      //     group: err.faultGroup,
      //     color: "yellow_color_bg",
      //   });
      // }
    });

    //TO separate uncoom error ie get green errors
    let arr1 = this.assetErrors.map((err) => err.key);
    let uncommon = arr1
      .filter((value) => !finalObservalbeErrors.includes(value))
      .concat(finalObservalbeErrors.filter((value) => !arr1.includes(value)));
    // this line below should be at last to get all errors  green errors should done at last after finding red errors

    //store only green errors
    this.assetErrors.forEach((err) => {
      if (uncommon.includes(err.key)) {
        this.greenErrors.push({
          fault: err.key,
          error: err.faults,
          group: err.faultGroup,
          color: "green_color_bg_new",
        });
      }
    });
    /* -----------------------------------------RED ERROR STARTS-------------------------- */
    this.mechFaultPreConditionfault = this.diagnosticsMechanicalFaultPredominantError.split(",");
    this.mechFaultPreConditionfault = this.mechFaultPreConditionfault.flatMap(
      (err) => {
        let arr1 = [];
        let arr2 = err.split("or");
        arr1 = arr2.flatMap((item) => item.trim());
        return arr1;
      }
    );
    this.elecPredominantFault = this.diagnosticsElectricalFaultPredominantError.split(",");
    this.elecPredominantFault = this.elecPredominantFault.flatMap((err) => {
      let arr1 = [];
      let arr2 = err.split("or");
      arr1 = arr2.flatMap((item) => item.trim());
      return arr1;
    });
    this.bearingPredominantFault = this.diagnosticsBearingFaultPredominantError.split(",");
    this.bearingPredominantFault = this.bearingPredominantFault.flatMap(
      (err) => {
        let arr1 = [];
        let arr2 = err.split("or");
        arr1 = arr2.flatMap((item) => item.trim());
        return arr1;
      }
    );
    this.ballBearingEarlyFault = this.diagnosticsBallBearingErrorMessage.split(",");
    this.ballBearingEarlyFault = this.ballBearingEarlyFault.flatMap((err) => {
      let arr1 = [];
      let arr2 = err.split("or");
      arr1 = arr2.flatMap((item) => item.trim());
      return arr1;
    });
    let finalDominatErrors = new Array(
      ...new Set([
        ...this.mechFaultPreConditionfault,
        ...this.elecPredominantFault,
        ...this.bearingPredominantFault,
        ...this.ballBearingEarlyFault,
      ])
    );
    this.assetErrors.forEach((err, i) => {
      // console.log(err.key,finalDominatErrors,finalDominatErrors.includes(err.key));
      for (let j = 0; j < finalDominatErrors.length; j++) {
        if (
          finalDominatErrors[j].includes(this.assetErrors[i].key) &&
          finalDominatErrors[j] != ""
        ) {
          this.redErr.push({
            fault: err.key,
            error: err.faults,
            group: err.faultGroup,
            color: "red_color_bg_new",
          });
        }
      }
    });

    arr1 = [];
    uncommon = [];
    this.finalErrors = [...this.yellowErr, ...this.redErr];
    let xyz = this.finalErrors.map((err) => err.fault);
    arr1 = this.assetErrors.map((err) => err.key);
    uncommon = arr1
      .filter((value) => !xyz.includes(value))
      .concat(xyz.filter((value) => !arr1.includes(value)));

    this.greenErrors = [];
    this.assetErrors.forEach((err) => {
      if (uncommon.includes(err.key)) {
        this.greenErrors.push({
          fault: err.key,
          error: err.faults,
          group: err.faultGroup,
          color: "green_color_bg_new",
        });
      }
    });
    this.finalErrors = [];
    this.finalErrors = [...this.redErr, ...this.yellowErr, ...this.greenErrors];

    let beltErrros = [...this.finalErrors];
    if (this.driveType == "DIRECT") {
      // console.log("Drive type: " + this.driveType);
      // this.finalErrors = beltErrros.map((err) => {
      //   console.log(err.group, err.group != "Belt System");
      //   if (err.group != "Belt System") {
      //     console.log("Pushing err");
      //     return err;
      //   }
      // });
      this.finalErrors = this.finalErrors.filter(
        (err) => err.group != "Belt System"
      );
      // console.log(this.finalErrors);
    } else {
      this.finalErrors = beltErrros;
    }
  }

  toggleTooltips(val) {}

  getMoreInformation(): string {
    return "- Assumes the connectivity is intact at 100%. \n  - Asset utilization and run time metrics will be impacted if connectivity is not 100%.";
  }

  ultraChartLayout() {
    this.getUltrasoundFFTChart(this.selectedFFTUID);
    this.ultraChartViewOff = false;
    this.ultraChartViewOn = true;
  }

  public randomize(): void {
    let data = [
      Math.round(Math.random() * 100),
      Math.round(Math.random() * 100),
      Math.round(Math.random() * 100),
      Math.random() * 100,
      Math.round(Math.random() * 100),
      Math.random() * 100,
      Math.round(Math.random() * 100),
    ];
    let clone = JSON.parse(JSON.stringify(this.barChartData));
    clone[0].data = data;
    this.barChartData = clone;
  }

  ultralistLayout() {
    this.ultraChartViewOff = true;
    this.ultraChartViewOn = false;
    this.listUltraData = [];
    this.listUltraData = this.datafftUltrasoundfrequentPoints1.map(function (
      val,
      index
    ) {
      return { key: index, x: val.x, y: val.y };
    });
  }

  downloadUltraChartData() {}

  magChartLayout() {
    this.getMagnetiFieldSpectraChart(this.selectedFFTUID);
    this.magChartViewOff = false;
    this.magChartViewOn = true;
  }

  //for cepstrum funtionality

  cepChartLayout() {
    this.getCepStrumChart(this.selectedFFTUID);
    this.cepStrumViewOff = false;
    this.cepStrumViewOn = true;
  }
  getCepStrumChart(fftId) {
    this.cepstrumProdEmpty = false;
    let cepArray = [];
    this.service
      .getDataWithQuery(
        // this.cepStrumUrlForChart + "/" + fftId + "/" + this.assetId
        this.diagnosticsGearboxCepstrumAPI + fftId + "/" + this.assetId
      )
      .then((res) => {
        if (JSON.parse(JSON.stringify(res)).status === "fail") {
          this.showCepstrumFieldChartEmpty = true;
        } else if (JSON.parse(JSON.stringify(res)).status == "success") {
          if (
            JSON.parse(JSON.stringify(res)).body.result.chartXAxisData.length !=
            0
          ) {
            //this.cepsturmError = JSON.parse(JSON.stringify(res)).body.result.error;
            let valueOne = JSON.parse(
              JSON.stringify(res)
            ).body.result.chartXAxisData.find(
              (item) =>
                item.y ===
                Math.max.apply(
                  Math,
                  JSON.parse(
                    JSON.stringify(res)
                  ).body.result.chartXAxisData.map(function (o) {
                    return o.y;
                  })
                )
            );
            let valueTwo = JSON.parse(
              JSON.stringify(res)
            ).body.result.chartYAxisData.find(
              (item) =>
                item.y ===
                Math.max.apply(
                  Math,
                  JSON.parse(
                    JSON.stringify(res)
                  ).body.result.chartYAxisData.map(function (o) {
                    return o.y;
                  })
                )
            );
            let valueThree = JSON.parse(
              JSON.stringify(res)
            ).body.result.chartZAxisData.find(
              (item) =>
                item.y ===
                Math.max.apply(
                  Math,
                  JSON.parse(
                    JSON.stringify(res)
                  ).body.result.chartZAxisData.map(function (o) {
                    return o.y;
                  })
                )
            );

            cepArray.push(valueOne);
            cepArray.push(valueTwo);
            cepArray.push(valueThree);
            let valueHigh = cepArray.find(
              (item) =>
                item.y ===
                Math.max.apply(
                  Math,
                  cepArray.map(function (o) {
                    return o.y;
                  })
                )
            );
            this.showCepstrumFieldChartEmpty = false;
            let lableFreqX = JSON.parse(JSON.stringify(res)).body.result.xLabel;
            let lableFreqY = JSON.parse(JSON.stringify(res)).body.result.yLabel;
            let lableFreqZ = JSON.parse(JSON.stringify(res)).body.result.zLabel;
            this.cepStrumPredFreq = JSON.parse(
              JSON.stringify(res)
            ).body.result.predominantData.map(function (value, index) {
              if (!isNaN(value.frequency)) {
                value["freq"] = value.frequency.toFixed(6);
              }
              if (!isNaN(value.x)) {
                value["X"] = value.x.toFixed(2);
              }
              if (!isNaN(value.y)) {
                value["Y"] = value.y.toFixed(2);
              }
              if (!isNaN(value.z)) {
                value["Z"] = value.z.toFixed(2);
              }
              return value;
            });
            this.dataCepstrumFieldPoints1 = JSON.parse(
              JSON.stringify(res)
            ).body.result.chartXAxisData;
            this.dataCepstrumFieldPoints2 = JSON.parse(
              JSON.stringify(res)
            ).body.result.chartYAxisData;
            this.dataCepstrumFieldPoints3 = JSON.parse(
              JSON.stringify(res)
            ).body.result.chartZAxisData;
            if (document.getElementById("cepstrumChartId") !== null) {
              let fftChartObj = cloneDeep(fftChartObject);
              let feedDataToArray = [];
              feedDataToArray.push({
                data: this.dataCepstrumFieldPoints1,
                lineDashType: "",
                label: lableFreqX,
                legendMarkerType: "none",
              });
              feedDataToArray.push({
                data: this.dataCepstrumFieldPoints2,
                lineDashType: "",
                label: lableFreqY,
                legendMarkerType: "none",
              });
              feedDataToArray.push({
                data: this.dataCepstrumFieldPoints3,
                lineDashType: "",
                label: lableFreqZ,
                legendMarkerType: "none",
              });
              fftChartObj.charts[0].axisX.interval = 500;
              fftChartObj.charts[0].axisY["minimum"] = 0;
              fftChartObj.charts[0].axisX["title"] = "Quefrency (Sec)";
              fftChartObj.charts[0].data = [];
              fftChartObj.charts[0].unit = "";
              fftChartObj.charts[0].myValue = "cepstrum";
              fftChartObj.charts[0].data =
                this.makeFFTDataForChart(feedDataToArray);
              fftChartObj.navigator.data =
                this.makeFFTDataForChart(feedDataToArray);
              this.cepstrumFieldSpecChart = new CanvasJS.StockChart(
                "cepstrumChartId",
                fftChartObj
              );
              setTimeout(() => {
                this.cepstrumFieldSpecChart.render();
              }, 500);

            }
          } else {
            this.showCepstrumFieldChartEmpty = true;
            this.cepstrumProdEmpty = true;
            this.cepStrumFieldNoDataMsg = JSON.parse(
              JSON.stringify(res)
            ).body.result.error;
            //this.cepsturmError=JSON.parse(JSON.stringify(res)).body.result.error;
          }
        } else {
          this.showCepstrumFieldChartEmpty = true;
          this.cepStrumFieldNoDataMsg = "404 Error while fetching data.";
        }
      });
  }
  cepstrumListLayout() {
    this.cepStrumViewOff = true;
    this.cepStrumViewOn = false;
    this.cepListData1 = [];
    this.cepListData2 = [];
    this.cepListData3 = [];
    this.cepListData1 = this.dataCepstrumFieldPoints1.map(function (
      val,
      index
    ) {
      return { key: index, x: val.x.toFixed(6), y: val.y };
    });
    this.cepListData2 = this.dataCepstrumFieldPoints2.map(function (
      val,
      index
    ) {
      return { key: index, x: val.x.toFixed(6), y: val.y.toFixed(6) };
    });
    this.cepListData3 = this.dataCepstrumFieldPoints3.map(function (
      val,
      index
    ) {
      return { key: index, x: val.x.toFixed(6), y: val.y.toFixed(6) };
    });
  }
  //for cres factor
  getCresFactor(fftId) {
    if (fftId === "undefined") {
      this.cresFactorEmpty = true;
    } else {
      this.service.getDataWithQuery(
        // this.cresFactorUrl + fftId
        this.diagnosticsFFTCrestFactorAPI + fftId
      ).then((res) => {
        if (JSON.parse(JSON.stringify(res)).status === "fail") {
          this.cresFactorEmpty = true;
        } else if (JSON.parse(JSON.stringify(res)).status === "success") {
          this.cresFactorEmpty = false;
          if (
            JSON.parse(JSON.stringify(res)).body.message ==
            "No Flies were found for the given params"
          ) {
            this.cresFactorEmpty = true;
          } else if (JSON.parse(JSON.stringify(res)).body.result != null) {
            this.cresFactorEmpty = false;
            this.cresFactorValue = JSON.parse(JSON.stringify(res)).body.result;
            this.xcf = this.cresFactorValue.xcf.toFixed(2);
            this.ycf = this.cresFactorValue.ycf.toFixed(2);
            this.zcf = this.cresFactorValue.zcf.toFixed(2);
          }
        }
      });
    }
  }

  //end cepstrum
  maglistLayout() {
    this.magChartViewOff = true;
    this.magChartViewOn = false;
    this.listMagData1 = [];
    this.listMagData2 = [];
    this.listMagData3 = [];
    this.listMagData1 = this.dataMagneticFieldPoints1.map(function (
      val,
      index
    ) {
      return { key: index, x: val.x.toFixed(1), y: val.y };
    });
    this.listMagData2 = this.dataMagneticFieldPoints2.map(function (
      val,
      index
    ) {
      return { key: index, x: val.x, y: val.y };
    });
    this.listMagData3 = this.dataMagneticFieldPoints3.map(function (
      val,
      index
    ) {
      return { key: index, x: val.x, y: val.y };
    });
  }

  downloadMagChartData() {}

  async ngOnDestroy() {
    clearInterval(this._timeOut);
    // clearInterval(this.intervalSensorUpdateAcc);
    // clearInterval(this.intervalSensorUpdate);
    // clearInterval(this.intervalMonitoringUpdate);
    // clearInterval(this.intervalAcousticsUpdate);
    clearInterval(this.intervalTempUpdate);
    localStorage.removeItem("max_g_imp");
    localStorage.removeItem("min_g_imp");
    localStorage.removeItem("max_y_imp");
    localStorage.removeItem("max_r_imp");
    this.stopLoopForIndi = false;
  }

  checkArray(my_arr) {
    for (var i = 0; i < my_arr.length; i++) {
      if (my_arr[i] === "") return false;
    }
    return true;
  }

  getMonitoringInfo() {
    this.monitoringLoader = true;
    this.service
      .getDataWithQuery(
        this.monitorDataURL +
          "/" +
          parseInt(this.assetId) +
          "/" +
          this.mac_address +
          "?userid=" +
          this.userID +
          "&asset_type=" +
          this.assetType
      )
      .then((res) => {
        if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
          const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
          this.service.showError(msgErr);
          this.monitoringLoader = false;
        } else if (JSON.parse(JSON.stringify(res)).data.status === "success") {
          this.monitorInfo = JSON.parse(JSON.stringify(res)).data.body[0];
          localStorage.setItem(
            "AssetSerialNumber",
            this.monitorInfo.motor_serial_number
          );

          this.kwrating = JSON.parse(
            JSON.stringify(res)
          ).data.body[0].kwrating.toFixed(0);
          this.sperformedArr = JSON.parse(
            JSON.stringify(res)
          ).data.body[0].service.service_performed.split(",");
          if (!this.checkArray(this.sperformedArr)) {
            this.sperformedArr = [];
          }
          // this.servicePerformed = JSON.parse(
          //   JSON.stringify(res)
          // ).data.body[0].service.service_performed;

          // this.serviceCategory = JSON.parse(
          //   JSON.stringify(res)
          // ).data.body[0].service.service_category;

          // const monthNames = [
          //   "January",
          //   "February",
          //   "March",
          //   "April",
          //   "May",
          //   "June",
          //   "July",
          //   "August",
          //   "September",
          //   "October",
          //   "November",
          //   "December",
          // ];
          // if (
          //   JSON.parse(JSON.stringify(res)).data.body[0].service
          //     .last_service_date != ""
          // ) {
          //   let lastDate = new Date(
          //     JSON.parse(
          //       JSON.stringify(res)
          //     ).data.body[0].service.last_service_date
          //   );
          //   // const day = lastDate.getDate();
          //   // const monthIndex = lastDate.getMonth();
          //   // const year = lastDate.getFullYear();
          //   // this.lastServiceDate = `${day} ${monthNames[monthIndex]} ${year}`;
          //   this.lastServiceDate = new ConvertDatetimePipe().convertDateTime(
          //     lastDate
          //   );

          //   let dateandtime = this.lastServiceDate.split(" ");
          //   this.lastServiceDate = dateandtime[0].toString();
          // }
          // if (
          //   JSON.parse(JSON.stringify(res)).data.body[0].service
          //     .next_service_date != ""
          // ) {
          //   let nextDate = new Date(
          //     JSON.parse(
          //       JSON.stringify(res)
          //     ).data.body[0].service.next_service_date
          //   );
          //   // const day = nextDate.getDate();
          //   // const monthIndex = nextDate.getMonth();
          //   // const year = nextDate.getFullYear();
          //   //this.nextServiceDate = `${day} ${monthNames[monthIndex]} ${year}`;
          //   this.nextServiceDate = new ConvertDatetimePipe().convertDateTime(
          //     nextDate
          //   );

          //   let dateandtime = this.nextServiceDate.split(" ");
          //   this.nextServiceDate = dateandtime[0].toString();
          // }

          if (
            JSON.parse(JSON.stringify(res)).data.body[0].overall_health
              .updated_at !== ""
          ) {
            let testDateUtc = moment.utc(
              JSON.parse(JSON.stringify(res)).data.body[0].overall_health
                .updated_at
            );

            let localDate = testDateUtc.local();

            let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(
              localDate
            );

            // this.overAllService = timeUpdatedAt;
            this.monitoringLoader = false;
          } else {
            // this.overAllService = "N/A";
          }
          this.operationObject = JSON.parse(
            JSON.stringify(res)
          ).data.body[0].operational;
          // this.serviceLoader = false;
        }
      });
  }

  getAssetServiceData(){
    this.serviceLoader = true;
    this.service
      .getDataWithQuery(
        this.assetServiceUrl +
          "/" +
          parseInt(this.assetId) +
          "/" +
          this.mac_address +
          "?userid=" +
          this.userID +
          "&asset_type=" +
          this.assetType
      ).then(res=>{
        if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
          const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
          this.service.showError(msgErr);
          this.monitoringLoader = false;
        } else if (JSON.parse(JSON.stringify(res)).data.status === "success") {
          this.serviceLoader = false;
          let serviceData = JSON.parse(JSON.stringify(res)).data.body;

          this.servicePerformed = serviceData.last_service_performed

          this.serviceCategory = serviceData.service_category;


          if (serviceData.last_service_date != ""
          ) {
            let lastDate = new Date(serviceData.last_service_date);
            this.lastServiceDate = new ConvertDatetimePipe().convertDateTime(
              lastDate
            );

            let dateandtime = this.lastServiceDate.split(" ");
            this.lastServiceDate = dateandtime[0].toString();
          }
          if (
            serviceData.next_service_date != ""
          ) {
            let nextDate = new Date(
              serviceData.next_service_date
            );
            // const day = nextDate.getDate();
            // const monthIndex = nextDate.getMonth();
            // const year = nextDate.getFullYear();
            //this.nextServiceDate = `${day} ${monthNames[monthIndex]} ${year}`;
            this.nextServiceDate = new ConvertDatetimePipe().convertDateTime(
              nextDate
            );

            let dateandtime = this.nextServiceDate.split(" ");
            this.nextServiceDate = dateandtime[0].toString();
          }
        }
      })
      .catch(err=>{
        console.log(err)
        // this.service.showError("Error getting asset service data")
      })
  }

  utcTime() {
    setInterval(() => {
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }

  onTabClick() {}

  selectItem(value) {
    localStorage.setItem("dataInterval", value);
    switch (value) {
      case "hour":
        this.selectValue = 24;
        this.valueTypeTrend = "hour";
        this.loadAllGraphs();
        this.valueType = "hour";
        this.tabColor5 = "";
        this.tabColor2 = "";
        this.tabColor3 = "";
        this.tabColor4 = "";
        this.tabColor1 = "active";
        break;
      case "day":
        this.selectValue = 24;
        this.valueTypeTrend = "day";
        this.loadAllGraphs();
        this.valueType = "day";
        this.tabColor1 = "";
        this.tabColor2 = "active";
        this.tabColor3 = "";
        this.tabColor4 = "";
        this.tabColor5 = "";
        break;
      case "week":
        this.selectValue = 24;
        this.valueTypeTrend = "week";
        this.valueType = "week";
        this.tabColor2 = "";
        this.tabColor1 = "";
        this.tabColor3 = "active";
        this.tabColor4 = "";
        this.tabColor5 = "";
        break;
      case "month":
        this.selectValue = 24;
        this.valueTypeTrend = "month";
        this.valueType = "month";
        this.tabColor2 = "";
        this.tabColor1 = "";
        this.tabColor3 = "";
        this.tabColor4 = "active";
        this.tabColor5 = "";
        break;
      case "quarterly":
        this.selectValue = 24;
        this.valueTypeTrend = "quaterly";
        this.valueType = "quaterly";
        this.tabColor4 = "";
        this.tabColor2 = "";
        this.tabColor3 = "";
        this.tabColor1 = "";
        this.tabColor5 = "active";
        break;
    }
  }

  selectFilter(value) {
    localStorage.setItem('graphType',value);
    this.graphType = value;
    document.getElementById("chartContainer").innerHTML = "";
    document.getElementById("chartContainer").style.height = "0px";
    document.getElementById("monitoringVelocityChartContainer").innerHTML = "";
    document.getElementById("monitoringVelocityChartContainer").style.height =
      "0px";
    document.getElementById("monitoringMachineAcousticsChart").innerHTML = "";
    document.getElementById("monitoringMachineAcousticsChart").style.height =
      "0px";
    document.getElementById("audibleChartId").innerHTML = "";
    document.getElementById("audibleChartId").style.height = "0px";
    document.getElementById("tempChartContainer").innerHTML = "";
    document.getElementById("tempChartContainer").style.height = "0px";

    this.selectFilterAccelartion(value);
    this.selectItemFilterForvelocity(value);
    this.selectFilterAcoustics(value);
    this.selectFileterAudible(value);
    this.selectFileterTemperature(value);
  }

  selectFilterAccelartion(value) {
    localStorage.setItem("dataInterval", value);
    switch (value) {
      case "Hourly":
        this.selectValue = 24;
        //this.valueTypeTrend = "hour";
        this.valueType = "hour";
        this.time_span = "hour";
        this.getSensorCharts();
        this.accColor1 = "active";
        this.accColor2 = "";
        this.accColor3 = "";
        break;
      case "Daily":
        this.selectValue = 24;
        //this.valueTypeTrend = "day";
        this.valueType = "day";
        this.time_span = "day";
        this.getSensorCharts();
        this.accColor1 = "";
        this.accColor2 = "active";
        this.accColor3 = "";
        break;
      case "Weekly":
        this.selectValue = 24;
        //this.valueTypeTrend = "week";
        this.valueType = "week";
        this.time_span = "week";
        this.getSensorCharts();
        this.accColor2 = "";
        this.accColor1 = "";
        this.accColor3 = "active";
        break;
    }
  }
  selectItemFilterForvelocity(value) {
    localStorage.setItem("dataInterval", value);
    switch (value) {
      case "Hourly":
        this.selectValue = 24;
        //this.valueTypeTrend = "hour";
        this.valueType = "hour";
        this.time_span = "hour";
        this.getVelocityChart();
        this.velColor1 = "active";
        this.velColor2 = "";
        this.velColor3 = "";
        break;
      case "Daily":
        this.selectValue = 24;
        //this.valueTypeTrend = "day";
        this.valueType = "day";
        this.time_span = "day";
        this.getVelocityChart();
        this.velColor1 = "";
        this.velColor2 = "active";
        this.velColor3 = "";
        break;
      case "Weekly":
        this.selectValue = 24;
        //this.valueTypeTrend = "week";
        this.valueType = "week";
        this.time_span = "week";
        this.getVelocityChart();
        this.velColor2 = "";
        this.velColor1 = "";
        this.velColor3 = "active";
        break;
    }
  }
  selectFilterAcoustics(value) {
    switch (value) {
      case "Hourly":
        this.selectValue = 24;
        //this.valueTypeTrend = "hour";
        this.valueType = "hour";
        this.time_span = "hourly";
        if([2,3].includes(this.master_product_type))
          this.getMachineAcousticsChart();
        this.acoColor1 = "active";
        this.acoColor2 = "";
        this.acoColor3 = "";
        break;
      case "Daily":
        this.selectValue = 24;
        //this.valueTypeTrend = "day";
        this.valueType = "day";
        this.time_span = "daily";
        if([2,3].includes(this.master_product_type))
          this.getMachineAcousticsChart();
        this.acoColor1 = "";
        this.acoColor2 = "active";
        this.acoColor3 = "";
        break;
      case "Weekly":
        this.selectValue = 24;
        //this.valueTypeTrend = "week";
        this.valueType = "week";
        this.time_span = "weekly";
        if([2,3].includes(this.master_product_type))
          this.getMachineAcousticsChart();
        this.acoColor2 = "";
        this.acoColor1 = "";
        this.acoColor3 = "active";
        break;
    }
  }

  selectFileterAudible(value) {
    localStorage.setItem("dataInterval", value);
    switch (value) {
      case "Hourly":
        this.selectValue = 24;
        //this.valueTypeTrend = "hour";
        this.valueType = "hour";
        this.time_span = "hour";
        if([2,3].includes(this.master_product_type)){
          this.getAudibleChart();
        }
        this.audiColor1 = "active";
        this.audiColor2 = "";
        this.audiColor3 = "";
        break;
      case "Daily":
        this.selectValue = 24;
        //this.valueTypeTrend = "day";
        this.valueType = "day";
        this.time_span = "day";
        if([2,3].includes(this.master_product_type)){
          this.getAudibleChart();
        }
        this.audiColor1 = "";
        this.audiColor2 = "active";
        this.audiColor3 = "";
        break;
      case "Weekly":
        this.selectValue = 24;
        //this.valueTypeTrend = "week";
        this.valueType = "week";
        this.time_span = "week";
        if([2,3].includes(this.master_product_type)){
          this.getAudibleChart();
        }
        this.audiColor1 = "";
        this.audiColor2 = "";
        this.audiColor3 = "active";
        break;
    }
  }

  selectFileterTemperature(value) {
    localStorage.setItem("dataInterval", value);
    switch (value) {
      case "Hourly":
        this.selectValue = 24;
        //this.valueTypeTrend = "hour";
        this.valueType = "hour";
        this.time_span = "hour";
        this.getSensorTempCharts();
        this.tempColor1 = "active";
        this.tempColor2 = "";
        this.tempColor3 = "";
        break;
      case "Daily":
        this.selectValue = 24;
        //this.valueTypeTrend = "day";
        this.valueType = "day";
        this.time_span = "day";
        this.getSensorTempCharts();
        this.tempColor1 = "";
        this.tempColor2 = "active";
        this.tempColor3 = "";
        break;
      case "Weekly":
        this.selectValue = 24;
        //this.valueTypeTrend = "week";
        this.valueType = "week";
        this.time_span = "week";
        this.getSensorTempCharts();
        this.tempColor2 = "";
        this.tempColor1 = "";
        this.tempColor3 = "active";
        break;
    }
  }

  //bearing fault
fftForAdvanceDiagnostics() {
  this.service
    .getDataWithQuery(
      this.fftforAdvanceDiag +
        "v1" +
        "/" +
        "kurtosis" +
        "/" +
        "drop-down" +
        "/" +
        this.userID +
        "/" +
        this.assetId +
        "/" +
        this.mac_address
    )
    .then((res) => {
      let response = JSON.parse(JSON.stringify(res)).data;
      if (response.status == "fail") {
        this.fftAdvEmpty = true;
      } else if (response.status == "success") {
        if (
          response.message == "Kurtosis Runner service is under development"
        ) {
          this.fftAdvEmpty = true;
          this.getdiagKurtChart(this.fftIdforAdvance);
          this.predominentFreq(this.deviceId, this.fftIdforAdvance);
        } else if (response.body.length != 0) {
          this.fftAdvEmpty = false;
          let self = this;
          self.AdvanceDiagFftData = [];
          this.AdvanceDiagAnalysis = response.body.map(function (val, index) {
            const fftDateTime = moment.utc(val.created_at).local();
            const fftTime = new ConvertDatetimePipe().convertDateTime(
              fftDateTime
            );
            const obj = {
              key: index,
              label: fftTime,
              value: val.fft_id,
              uuid: val.uuid,
            };
            self.AdvanceDiagFftData.push(obj);
          });
          this.kurtosisMarkersData = self.AdvanceDiagFftData;
          this.selectedFFTAdvance = self.AdvanceDiagFftData[0].label;
          this.fftIdforAdvance = self.AdvanceDiagFftData[0].value;
          this.advuuid = self.AdvanceDiagFftData[0].uuid;
          this.diagKurtOn = true;
          this.getdiagKurtChart(this.fftIdforAdvance);

          // this.predominentFreq(this.deviceId, this.fftIdforAdvance);
          // this.kurtosisNumAdvanceDiagnostics(this.advuuid);
        } else {
          this.getdiagKurtChart(this.fftIdforAdvance);
          // this.predominentFreq(this.deviceId, this.fftIdforAdvance);
          // this.service.showError("Fft value is not there");
        }
      }
    });
}
  selectKurtosisNumber(value) {
    localStorage.setItem("dataInterval", value);
    document.getElementById('predictiveKurtChartContainer').innerHTML = null;
    switch (value) {
      case "Hourly":
        this.KurtNumloader = true;
        this.selectValue = 24;
        this.valueTypekurt = "hour";
        this.getPredictiveKurtChart();
        this.kurtColor1 = "active";
        this.kurtColor2 = "";
        this.kurtColor3 = "";
        break;
      case "Daily":
        this.KurtNumloader = true;
        this.selectValue = 24;
        this.valueTypekurt = "day";
        this.getPredictiveKurtChart();
        this.kurtColor1 = "";
        this.kurtColor2 = "active";
        this.kurtColor3 = "";
        break;
      case "Weekly":
        this.KurtNumloader = true;
        this.selectValue = 24;
        this.valueTypekurt = "week";
        this.getPredictiveKurtChart();
        this.kurtColor2 = "";
        this.kurtColor1 = "";
        this.kurtColor3 = "active";
        break;
    }
  }
  selectItemFilter(value) {
    // localStorage.setItem("dataInterval", value);
    switch (value) {
      case "Hourly":
        this.selectValue = 24;
        this.valueTypeTrend = "hour";
        this.valueType = "hour";
        this.loadAllGraphs();
        this.getPredictiveMachineAcousticsChart();
        this.tabColorP1 = "active";
        this.tabColorP2 = "";
        this.tabColorP3 = "";
        this.tabColorP4 = "";
        this.tabColorP5 = "";
        break;
      case "Daily":
        this.selectValue = 24;
        this.valueTypeTrend = "day";
        this.valueType = "day";
        this.loadAllGraphs();
        this.getPredictiveMachineAcousticsChart();
        this.tabColorP1 = "";
        this.tabColorP2 = "active";
        this.tabColorP3 = "";
        this.tabColorP4 = "";
        this.tabColorP5 = "";
        break;
      case "Weekly":
        this.selectValue = 24;
        this.valueTypeTrend = "week";
        this.valueType = "week";
        this.loadAllGraphs();
        this.getPredictiveMachineAcousticsChart();
        this.tabColorP2 = "";
        this.tabColorP1 = "";
        this.tabColorP3 = "active";
        this.tabColorP4 = "";
        this.tabColorP5 = "";
        break;
      case "Monthly":
        this.selectValue = 24;
        this.valueTypeTrend = "month";
        this.valueType = "month";
        this.loadAllGraphs();
        this.getPredictiveMachineAcousticsChart();
        this.tabColorP3 = "";
        this.tabColorP2 = "";
        this.tabColorP1 = "";
        this.tabColorP4 = "active";
        this.tabColorP5 = "";
        break;
      case "Quaterly":
        this.selectValue = 24;
        this.valueTypeTrend = "quaterly";
        this.valueType = "quaterly";
        this.loadAllGraphs();
        this.getPredictiveMachineAcousticsChart();
        this.tabColorP4 = "";
        this.tabColorP2 = "";
        this.tabColorP3 = "";
        this.tabColorP1 = "";
        this.tabColorP5 = "active";
        break;
    }
  }

  loadAllGraphs() {
    this.getPredictiveVelocityChart();
    this.getVibrationNewTrendChart();
    this.getPredictiveTempChart();
    this.getIndicesTrendChart();
    //this.selectIndividualFilter(this.faultFilterName);
  }

  loadMetrics() {
    const body = {
      user_id:
        Math.floor(Math.random() * 90 + 10) +
        this.userID +
        Math.floor(Math.random() * 9000 + 1000),
      asset_id: parseInt(this.assetId),
    };
    this.service.postData(this.assetMatricsUrl, body).then((res) => {
      let resp = JSON.parse(JSON.stringify(res)).data;
      if (resp.status === "success") {
        this.kurt_freq = resp.body[0].kurt_freq;
        this.kurt_threshold = resp.body[0].kurt_threshold;
        this.kurt_anomaly_counter = resp.body[0].kurt_anomaly_counter;
        localStorage.setItem("mac_address", this.mac_address);
        localStorage.setItem("assetId", this.assetId);
        localStorage.setItem("kurt_threshold", this.kurt_threshold);
      }
    });
  }

  //Diagnostics Summary
  // diagnosticsSummary(fftId, fftIdforAdvance, fetchFaults) {
  //   if (this.anomalyType === "periodic" || this.anomalyType === "") {
  //     this.service
  //       .getData(
  //         this.DiagnosticsSummary +
  //           "/" +
  //           this.userID +
  //           "/" +
  //           this.deviceId +
  //           "/" +
  //           this.assetId +
  //           "?type=" +
  //           this.assetType +
  //           "&fft_id=" +
  //           fftId +
  //           "&bearing_id=" +
  //           fftIdforAdvance
  //       )
  //       .then((res1) => {
  //         let fftres = JSON.parse(JSON.stringify(res1)).data;
  //         if (fftres.status === "success") {
  //           this.time_fft = new ConvertDatetimePipe().convertDateTime(
  //             moment.utc(fftres.body.vibrationfaults.updated_at).toDate()
  //           );
  //         }
  //       });
  //     fftId = "undefined";
  //   }
  //   this.service
  //     .getData(
  //       this.DiagnosticsSummary +
  //         "/" +
  //         this.userID +
  //         "/" +
  //         this.deviceId +
  //         "/" +
  //         this.assetId +
  //         "?type=" +
  //         this.assetType +
  //         "&fft_id=" +
  //         fftId +
  //         "&bearing_id=" +
  //         fftIdforAdvance
  //     )
  //     .then((res) => {
  //       let response = JSON.parse(JSON.stringify(res)).data;
  //       if (response.status === "success") {
  //         setTimeout(() => {
  //           this.loader = false;
  //         }, 400);
  //         // moment.utc(sensorChartDataY[i].x).toDate();
  //         // let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
  //         this.create_at_fft = new ConvertDatetimePipe().convertDateTime(
  //           moment.utc(response.body.vibrationfaults.updated_at).toDate()
  //         );
  //         // this.create_at_fft =response.body.vibrationfaults.updated_at;
  //         if (fftId != "undefined") {
  //           this.time_fft = new ConvertDatetimePipe().convertDateTime(
  //             moment.utc(response.body.vibrationfaults.updated_at).toDate()
  //           );
  //         }
  //         // this.time_fft = new ConvertDatetimePipe().convertDateTime(moment.utc(response.body.vibrationfaults.updated_at).toDate());
  //         this.mechFaultPreCondition =
  //           response.body.vibrationfaults.mechanicalFaults.predominantError;
  //         this.mechobserveableError =
  //           response.body.vibrationfaults.mechanicalFaults.observeableError;
  //         this.elecPredominantError =
  //           response.body.vibrationfaults.electricalFaults.predominantError;
  //         this.elecObserveableError =
  //           response.body.vibrationfaults.electricalFaults.observeableError;
  //         this.bearingPredominantError =
  //           response.body.vibrationfaults.bearingFaults.predominantError;
  //         this.bearingObserveableError =
  //           response.body.vibrationfaults.bearingFaults.observeableError;
  //         this.cepsturmError = response.body.vibrationfaults.cepstrum_mssg;
  //         // this.fftLabelValue = new ConvertDatetimePipe().convertDateTime(moment.utc(response.body.machineDiagnostic.device_matric_time).toDate());
  //         this.earlyUpdateAt = new ConvertDatetimePipe().convertDateTime(
  //           moment.utc(response.body.earlyStageBallBearing.updated_at).toDate()
  //         );

  //         this.ballBearingErrorMessage =
  //           response.body.earlyStageBallBearing.ballBearingErrorMessage;
  //         if (fetchFaults) {
  //           this.setFaults();
  //         }
  //         if (!response.body.esaFaults.updated_at.includes("Not Applicable")) {
  //           this.esaUpdateat = new ConvertDatetimePipe().convertDateTime(
  //             moment.utc(response.body.esaFaults.updated_at).toDate()
  //           );
  //           this.esamessage = response.body.esaFaults.esaMessage;
  //         } else {
  //           this.esaUpdateat = response.body.esaFaults.updated_at;
  //           this.esamessage = response.body.esaFaults.esaMessage;
  //         }
  //       } else {
  //         this.loader = false;
  //       }
  //     });
  // }

  //Diagnostics Summary end





  insideTabChange(event) {
    // console.log(event);
    this.innerTab=event;
    localStorage.setItem("innertab", event)
    switch (event) {
      case "diagSummary":
        // this.diagnosticsSummary(
        //   this.selectedFFTUID,
        //   this.fftIdforAdvance,
        //   false
        // );
        this.getDiagnosticsSummary(
          this.selectedFFTUID,
          this.fftIdforAdvance,
          false
        );
        this.getCresFactor(this.selectedFFTUID);
        break;
      case "innertab-1":
        this.activeTabID = 1;
        this.diagChartType = "velocity";
        this.predominentFreq(this.deviceId, this.selectedFFTUID);
        this.getFrequentDetail(this.selectedFFTUID);
        this.getCresFactor(this.selectedFFTUID);
        // if(this.frequentChart){
        //   setTimeout(() => {
        //     this.frequentChart.render();
        //   }, 500);
        // }
        break;
      case "innertab-2":
        this.rmptoggle = false;
        this.activeTabID = 2;
        this.diagChartType = "fft";
        this.getFrequentDetail(this.selectedFFTUID);
        this.predominentFreq(this.deviceId, this.selectedFFTUID);
        this.getCresFactor(this.selectedFFTUID);
        this.diagChartType = "fft";
        this.cd.detectChanges();
        // if(this.frequentChart){
        //   setTimeout(() => {
        //     this.frequentChart.render();
        //   }, 500);
        // }
        // console.log("we moved to new tab");
        break;
      case "innertab-3":
        this.activeTabID = 3;
        this.diagChartType = "velocity";
        this.predominentFreq(this.deviceId, this.selectedFFTUID);
        this.getUltrasoundFFTChart(this.selectedFFTUID);
        this.getCresFactor(this.selectedFFTUID);
        // if(this.fftUltrsoundChart){
        //   setTimeout(() => {
        //     this.fftUltrsoundChart.render();
        //   }, 500);
        // }
        break;
      case "innertab-4":
        this.activeTabID = 4;
        this.diagChartType = "velocity";
        this.predominentFreq(this.deviceId, this.selectedFFTUID);
        this.getMagnetiFieldSpectraChart(this.selectedFFTUID);
        this.getCresFactor(this.selectedFFTUID);
        // if(this.magneticFieldSpecChart){
        //   setTimeout(() => {
        //     this.magneticFieldSpecChart.render();
        //   }, 500);
        // }
        break;
      // case "innertab-5":
      //   this.activeTabID = 5;
      //   this.diagChartType = "kurtosis";
      //   this.predominentFreq(this.deviceId, this.selectedFFTUID);
      //   this.diagKurtOn = true;
      //   this.getdiagKurtChart(this.selectedFFTUID);
      //   break;
      case "innertab-6":
        this.activeTabID = 6;
        this.diagChartType = "cepstrum";
        // this.predominentFreq(this.deviceId, this.selectedFFTUID);
        this.getCepStrumChart(this.selectedFFTUID);
        // this.cepChartLayout();
        this.getCresFactor(this.selectedFFTUID);

        // if(this.cepstrumFieldSpecChart){
        //   setTimeout(() => {
        //     this.cepstrumFieldSpecChart.render();
        //   }, 500);
        // }
        break;

      case "innertab-7":
        this.activeTabID = 7;
        this.diagChartType = "kurtosis";
        this.getPredictiveKurtChart();
        this.getBearingFreq();
        this.getdiagKurtChart(this.fftIdforAdvance);
        // this.kurtosisNumAdvanceDiagnostics(this.advuuid);
        this.diagKurtOn = true;
        // if(this.predictiveKurtChart){
        //   setTimeout(() => {
        //     this.predictiveKurtChart.render();
        //   }, 500);
        // }
        break;
      case "innertab-8":
        this.activeTabID = 8;
        this.electricalChartViewOff = false;
        this.getElectricalDropDown();
    }
  }

  pageReload() {
    this.loaderAddClass = "refresh_move";
    this.ForcedSpectralAnalysis();
  }

  public conditionDetails(): void {
    this.service.getFaultSummary().then((res) => {
      let firstArray = JSON.parse(JSON.stringify(res));
      const faultsArrFirst = this._ffteError.split(",").map(function (item) {
        return item.trim();
      });
      let tempArrFirst = [];
      for (let k = 0; k < firstArray.length; k++) {
        for (let l = 0; l < faultsArrFirst.length; l++) {
          let sub_str1 = firstArray[k].tag;
          let main_str2 = faultsArrFirst[l];
          let result2 = main_str2.includes(sub_str1);
          if (result2) {
            tempArrFirst.push(firstArray[k]);
          }
        }
      }
      this.faults_info_one = tempArrFirst;
      if (tempArrFirst.length === 0) {
        this.setErrorStateOne = true;
      } else {
        this.setErrorStateOne = false;
      }
    });
  }

  public faultDetails(): void {
    this.service.getFaultSummary().then((res) => {
      const faultsArr = this._observe_value.split(",").map(function (item) {
        return item.trim();
      });
      let firstArray = JSON.parse(JSON.stringify(res));
      let secondArray = faultsArr;
      let tempArr = [];
      for (let i = 0; i < firstArray.length; i++) {
        for (let j = 0; j < secondArray.length; j++) {
          let sub_str = firstArray[i].tag;
          let main_str = secondArray[j];
          let result = main_str.includes(sub_str);
          if (result) {
            tempArr.push(firstArray[i]);
          }
        }
      }
      this.faults_info = tempArr;
      if (tempArr.length === 0) {
        this.setErrorStateTwo = true;
      } else {
        this.setErrorStateTwo = false;
      }
    });
  }

  public beforeChange($event) {
    this.selectedTabId=$event.nextId;
    localStorage.setItem('tab', this.selectedTabId);
    localStorage.setItem("innertab", 'diagSummary')
    this.innerTab='diagSummary';
    switch ($event.nextId) {
      case "tab-1":
        this.moreChartsVisible = false;
        this.stopLoopForIndi = false;
        this.showTextOn = "more";
        localStorage.removeItem("max_g_imp");
        localStorage.removeItem("min_g_imp");
        localStorage.removeItem("max_y_imp");
        localStorage.removeItem("max_r_imp");
        this.againStartUpdate();
        /*************Monitoring charts methods*************** */
        this.getSensorCharts();
        this.getSensorTempCharts();
        this.getVelocityChart();
        if([2,3].includes(this.master_product_type)){
          this.getMachineAcousticsChart();
          this.getAudibleChart();
        }
        this.getalertsummmary();
        // setTimeout(() => {
          this.stackchartvelocity();
          // }, 1000);
          this.forBearingAnalysisTab();
        break;
      case "tab-2":
        this.fftForAdvanceDiagnostics();
        // console.log("YEYEE TAB TWO CLICK DIAGNOSTICS");
        this.stopLoopForIndi = false;
        this.firstTimeChartLoad = true;
        localStorage.removeItem("max_g_imp");
        localStorage.removeItem("min_g_imp");
        localStorage.removeItem("max_y_imp");
        localStorage.removeItem("max_r_imp");
        clearInterval(this._timeOut);
        this.forBearingAnalysisTab();

        // clearInterval(this.intervalSensorUpdateAcc);
        // clearInterval(this.intervalSensorUpdate);
        clearInterval(this.intervalOrintationUpdate);
        clearInterval(this.intervalTempUpdate);
        // clearInterval(this.intervalMonitoringUpdate);
        // clearInterval(this.intervalAcousticsUpdate);
        this.diagChartType = "velocity";
        // setTimeout(() =>{this.diagnosticsSummary(
        //   this.selectedFFTUID,
        //   this.fftIdforAdvance,
        //   true
        // )},3000);
        this.getDiagnosticsSummary(this.selectedFFTUID, this.fftIdforAdvance, true)
        //this.predominentFreq(this.deviceId, this.selectedFFTUID);
        //this.getFrequentDetail(this.selectedFFTUID);
        //this.getBearingFreq();
        this.freqChartViewOn = true;
        this.freqChartViewOff = false;
        this.ultraChartViewOn = true;
        this.ultraChartViewOff = false;
        this.magChartViewOff = false;
        this.magChartViewOn = true;
        this.cepStrumViewOff = false;
        this.cepStrumViewOn = true;
        this.diagChartType = "velocity";
        this.moreChartsVisible = false;
        this.showTextOn = "more";
        //this.getMagnetiFieldSpectraChart(this.selectedFFTUID);
        //this.faultDetails();
        //this.conditionDetails();
        this.cd.detectChanges();
        break;
      case "tab-3":
        this.stopLoopForIndi = true;
        this.firstTimeChartLoad = true;
        clearInterval(this._timeOut);
        // clearInterval(this.intervalSensorUpdateAcc);
        // clearInterval(this.intervalSensorUpdate);
        clearInterval(this.intervalOrintationUpdate);
        clearInterval(this.intervalTempUpdate);
        // clearInterval(this.intervalMonitoringUpdate);
        // clearInterval(this.intervalAcousticsUpdate);
        this.getPredictiveVelocityChart();
        this.getVibrationNewTrendChart();
        this.getPredictiveTempChart();
        this.getIndicesTrendChart();
        this.getPredictiveMachineAcousticsChart();
        this.selectIndividualFilter(this.faultFilterName);
        if (this.assetType === "GEAR") {
          this.activeMechanicalTab = "active";
          this.activeElectricalStatorTab = "";
          this.activateElectricalRotorTab = "";
          this.activateBeltSystemTab = "";
          this.activateBearingTab = "active";
          this.activateGearTab = "active";
          this.activateJournalTab = "";
        } else if (this.assetType === "MOTOR") {
          this.activeMechanicalTab = "active";
          this.activeElectricalStatorTab = "active";
          this.activateElectricalRotorTab = "active";
          this.activateBeltSystemTab = "";
          this.activateBearingTab = "active";
          this.activateGearTab = "";
          this.activateJournalTab = "";
        } else if (this.assetType === "PUMP") {
          this.activeMechanicalTab = "active";
          this.activeElectricalStatorTab = "";
          this.activateElectricalRotorTab = "";
          this.activateBeltSystemTab = "active";
          this.activateBearingTab = "active";
          this.activateGearTab = "";
          this.activateJournalTab = "";
        } else if (this.assetType === "FAN_BLOWER") {
          this.activeMechanicalTab = "active";
          this.activeElectricalStatorTab = "";
          this.activateElectricalRotorTab = "";
          this.activateBeltSystemTab = "active";
          this.activateBearingTab = "";
          this.activateGearTab = "";
          this.activateJournalTab = "";
        } else if (this.assetType === "JOURNAL_BEARING") {
          this.activeMechanicalTab = "active";
          this.activeElectricalStatorTab = "";
          this.activateElectricalRotorTab = "";
          this.activateBeltSystemTab = "";
          this.activateBearingTab = "";
          this.activateGearTab = "";
          this.activateJournalTab = "active";
        } else if (this.assetType === "COMPRESSOR") {
          this.activeMechanicalTab = "active";
          this.activeElectricalStatorTab = "";
          this.activateElectricalRotorTab = "";
          this.activateBeltSystemTab = "active";
          this.activateBearingTab = "active";
          this.activateGearTab = "";
          this.activateJournalTab = "";
        }
        break;
    }
  }

  pregridLayout(val: string) {
    if (val === "one") {
      this.getPredictiveVelocityChart();
      this.predictiveAccOn = true;
      this.preAccListLayoutOn = false;
    } else {
      this.getVibrationNewTrendChart();
      this.chartLayoutOnVibration = true;
      this.listLayoutOnVibration = false;
    }
  }

  prelistLayout(val: string) {
    if (val === "one") {
      this.predictiveAccOn = false;
      this.preAccListLayoutOn = true;
    } else {
      this.chartLayoutOnVibration = false;
      this.listLayoutOnVibration = true;
    }
  }
  imposeRtdKurtOrdering(dataSet: any) {
    const rtd1 = this.rtdData[0]?.rtd_one;
    const rtd2 = this.rtdData[0]?.rtd_two;
    const rtd3 = this.rtdData[0]?.rtd_three;
    if (rtd1 === "MS") {
      dataSet[0].name = "Radial (Horizontal)";
    } else if (rtd1 === "DE") {
      dataSet[0].name = "Tangential";
    } else if (rtd1 === "NDE") {
      dataSet[0].name = "Axial";
    }
    if (rtd2 === "MS") {
      dataSet[1].name = "Radial";
    } else if (rtd2 === "DE") {
      dataSet[1].name = "Tangential (Vertical)";
    } else if (rtd2 === "NDE") {
      dataSet[1].name = "Axial";
    }
    if (rtd3 === "MS") {
      dataSet[2].name = "Radial";
    } else if (rtd3 === "DE") {
      dataSet[2].name = "Tangential";
    } else if (rtd3 === "NDE") {
      dataSet[2].name = "Axial";
    }
    return dataSet;
  }
  imposeRtdOrdering(dataSet: any) {
    const rtd1 = this.rtdData[0]?.rtd_one;
    const rtd2 = this.rtdData[0]?.rtd_two;
    const rtd3 = this.rtdData[0]?.rtd_three;
    if (rtd1 === "MS") {
      dataSet[0].name = "Machine Skin";
    } else if (rtd1 === "DE") {
      dataSet[0].name = "DE Bearing";
    } else if (rtd1 === "NDE") {
      dataSet[0].name = "NDE Bearing";
    }
    if (rtd2 === "MS") {
      dataSet[1].name = "Machine Skin";
    } else if (rtd2 === "DE") {
      dataSet[1].name = "DE Bearing";
    } else if (rtd2 === "NDE") {
      dataSet[1].name = "NDE Bearing";
    }else{
      dataSet[1].name = "NA"
    }
    if (rtd3 === "MS") {
      dataSet[2].name = "Machine Skinn";
    } else if (rtd3 === "DE") {
      dataSet[2].name = "DE Bearing";
    } else if (rtd3 === "NDE") {
      dataSet[2].name = "NDE Bearing";
    }else{
      dataSet[2].name = "NA";
    }
    return dataSet;
  }

  changeOrder(orderBy, list) {
    return list.sort((x, y) => orderBy.indexOf(x.key) - orderBy.indexOf(y.key));
  }

  changeOrderPred(orderBy, list) {
    let tempArrOne = [];
    let tempArrTwo = [];
    for (let i = 0; i < list.length; i++) {
      if (list[i].lineDashType === "") {
        tempArrOne.push(list[i]);
      } else {
        tempArrTwo.push(list[i]);
      }
    }
    tempArrOne.sort((x, y) => orderBy.indexOf(x.key) - orderBy.indexOf(y.key));
    tempArrTwo.sort((x, y) => orderBy.indexOf(x.key) - orderBy.indexOf(y.key));
    return [...tempArrOne, ...tempArrTwo];
  }

  async showMachineUtilization(mac_address, user_id, interval) {
    this.showMachineUtilizationLoader = true;
    await this.service
      .getDataWithQuery(
        this.machineParamUrl +
          "machine/utilization/" +
          mac_address +
          "/" +
          user_id +
          "/" +
          interval
      )
      .then((machineUtilRes) => {
        this.showMachineUtilizationLoader = false;
        const machineUtil = JSON.parse(JSON.stringify(machineUtilRes)).data
          .body;
        this.deviceStarts = machineUtil.device.no_of_starts;
        this.deviceStops = machineUtil.device.no_of_stops;
        this.deviceUtilization =
          typeof machineUtil.device.device_utilization === "string"
            ? 0
            : machineUtil.device.device_utilization.toFixed(2);
        this.deviceAverageRunTime = machineUtil.device.avg_run;
        this.assetStarts = machineUtil.asset.no_of_starts;
        this.assetStops = machineUtil.asset.no_of_stops;
        this.assetUtilization =
          typeof machineUtil.asset.asset_utilization === "string"
            ? 0
            : machineUtil.asset.asset_utilization.toFixed(2);
        this.assetAverageRunTime = machineUtil.asset.avg_run;
      })
      .catch((error) => {
        this.showMachineUtilizationLoader = false;
      });
  }

  getIndicesCondition(): string {
    return `Red: Less than ${this.indicesConstValues["first_condition_val"]} %.  \n Yellow: Between ${this.indicesConstValues["fourth_condition_val"]} - ${this.indicesConstValues["fifth_condition_val"]} %. \n Green: Between ${this.indicesConstValues["second_condition_val"]} - ${this.indicesConstValues["third_condition_val"]} %.`;
  }
  public async monitoringGaugeData(machineVibReload=true,tempReload=true,acousticReload=true) {
    this.machineVibrationLoading=machineVibReload;
    this.tempgaugeLoader=tempReload;
    this.acousticgaugeLoader=acousticReload;
    this.cccount = 0;
    let sensorRes = await this.service
      .getDataWithQuery(
        this.monitoringSensorAPI +
          parseInt(this.assetId) +
          "/" +
          parseInt(this.deviceId) +
          "?userId=" +
          this.userID
      )
      .then((sRes) => {
        return JSON.parse(JSON.stringify(sRes)).data;
      });
    if(sensorRes.body.sensor.length > 0) {
      this.machineVibrationLoading = false;
      let response = sensorRes.body;
      this.meterShownResult = [];
      this.monitoringMeterShowVelocity = [];
      this.dataGadge = response.sensor.filter(
        (item, i, arr) => arr.findIndex((t) => t.key === item.key) === i
      );
      let ultrasoundResponse = response.ultrasoundData;
      let bottomLab = "0.00";
      if (this.dataGadge.length !== 0) {
        let tempArr = [];
        for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
          console.log('this.dataGadge[mCount].value',this.dataGadge[mCount].name)
          if(this.dataGadge[mCount].name === "DE Bearing"){
            this.dataGadge[mCount].name = "Surface Temp";
          }
          if(JSON.parse(this.dataGadge[mCount].value) === 0.00 &&  this.dataGadge[mCount]['key'].includes('Temperature')){
            bottomLab = "N/A";  
            console.log(this.dataGadge[mCount].key,'ffaaafafaafasf')
          }
          else if (
            JSON.parse(this.dataGadge[mCount].value) === 0 &&
            this.dataGadge[mCount].needle === false
          ) {
            // console.log(this.dataGadge[mCount].key,'inside if')
            bottomLab = "N/A";
          }else {
            bottomLab =
              JSON.parse(this.dataGadge[mCount].value) <= 0
                ? `0.00 ${this.dataGadge[mCount].icon}`
                : this.dataGadge[mCount].symbol === "C"
                ? JSON.parse(this.dataGadge[mCount].value) +
                  " °" +
                  this.dataGadge[mCount].icon
                : JSON.parse(this.dataGadge[mCount].value) +
                  " " +
                  this.dataGadge[mCount].icon;
          }
          this.Itemsymbol = this.dataGadge[mCount].symbol;
          let needleValueRes;
          if (this.dataGadge[mCount].symbol === "m/sec²") {
            needleValueRes =
              (JSON.parse(this.dataGadge[mCount].value) * 100) /
              parseFloat(this.dataGadge[mCount].rangelabel[1]);
          } else if (this.dataGadge[mCount].symbol === "mm/sec") {
            needleValueRes =
              (JSON.parse(this.dataGadge[mCount].value) );
          } else if (this.dataGadge[mCount].symbol === "deg") {
            needleValueRes = JSON.parse(this.dataGadge[mCount].value);
          } else {
            needleValueRes = JSON.parse(this.dataGadge[mCount].value);
          }
          let centerLab =
            JSON.parse(this.dataGadge[mCount].value) < 0
              ? "N/A"
              : JSON.parse(this.dataGadge[mCount].value);
          let arc_colors =
            this.dataGadge[mCount].needle === true
              ? this.dataGadge[mCount].arcColors
              : ["transparent", "transparent", "transparent"];
          let range_label =
            this.dataGadge[mCount].needle === true
              ? this.dataGadge[mCount].rangelabel
              : [];
          let arc_Delimiters =
            this.dataGadge[mCount].needle === true
              ? this.dataGadge[mCount].arcDelimiters
              : [];
          let value =
            JSON.parse(this.dataGadge[mCount].value) < 0
              ? "N/A"
              : JSON.parse(this.dataGadge[mCount].value);

          this.accelerationData = {
            // value:value,
            needleValue: needleValueRes,
            centralLabel: centerLab,
            outerNeedle: false,
            canvasWidth: 150,
            name: this.dataGadge[mCount].name,
            key: this.dataGadge[mCount].key,
            bottomLabel: bottomLab,
            hasneedle: this.dataGadge[mCount].needle,
            options: {
              hasNeedle: this.dataGadge[mCount].needle,
              needleColor: "black",
              needleUpdateSpeed: "",
              arcColors: arc_colors,
              arcLabels: [],
              arcDelimiters: this.dataGadge[mCount].arcDelimiters,
              rangeLabel: range_label,
              needleStartValue: 0,
            },
          };
          if (
            this.accelerationData.key === "x_velocity" ||
            this.accelerationData.key === "y_velocity" ||
            this.accelerationData.key === "z_velocity"
          ) {
            // if(arc_Delimiters[0])  [arcdelimiter[0],arcelimiter[1]]
            //code to set label by Deepak'
            if (
              arc_Delimiters[0] < 100 &&
              arc_Delimiters[0] > 0 &&
              arc_Delimiters[1] > 0 &&
              arc_Delimiters[0] < arc_Delimiters[1] &&
              arc_Delimiters[1] < 100
            ) {
              let max = range_label[1] != null ? range_label[1] : 0;
              // let a = arc_Delimiters[0] / 100;
              // let b = arc_Delimiters[1] / 100;
              // let k = (a * max).toFixed(1);
              // let l = (b * max).toFixed(1);
              // let r = k.toFixed(0);
              // let s = l.toFixed(0);\
              this.accelerationData.options.arcLabels[0] =
                sensorRes.body.rangeLabels.green;
                this.accelerationData.options.arcLabels[1] =
                sensorRes.body.rangeLabels.yellow;
              this.velocityG = sensorRes.body.rangeLabels.green;
              this.velocityY = sensorRes.body.rangeLabels.yellow;
              this.velocityR = max;
              this.accelerationData.options.arcColors[0] = "#72FF13";
              this.accelerationData.options.arcColors[1] = "#FAA700";
              this.accelerationData.options.arcColors[2] = "#ff2a1b";
              // if(this.velocity)
              // console.log("THIS VELOCITY G"+this.velocityG)
              if (
                this.accelerationData.centralLabel <=
                this.accelerationData.options.arcLabels[0]
              ) {
                // accelerationData.options.centralLabel=
                this.accelerationData.options.needleColor = "#72FF13";
              } else if (
                this.accelerationData.centralLabel >
                  this.accelerationData.options.arcLabels[0] &&
                this.accelerationData.centralLabel <=
                  this.accelerationData.options.arcLabels[1]
              ) {
                this.accelerationData.options.needleColor = "#FAA700";
              } else {
                this.accelerationData.options.needleColor = "#ff2a1b";
              }
              this.monitoringMeterShowVelocity.push(this.accelerationData);
              this.machineVibrationLoading = false;
            } else {
              arc_Delimiters[0] = 20;
              arc_Delimiters[1] = 70;
              let max = range_label[1] != null ? range_label[1] : 0;
              // let a = arc_Delimiters[0] / 100;
              // let b = arc_Delimiters[1] / 100;
              // let k = (a * max).toFixed(1);
              // let l = (b * max).toFixed(1);
              // let r = k.toFixed(0);
              // let s = l.toFixed(0);
              this.accelerationData.options.arcLabels[0] =
                sensorRes.body.rangeLabels.green;
              this.accelerationData.options.arcLabels[1] =
                sensorRes.body.rangeLabels.yellow;
              this.velocityG = sensorRes.body.rangeLabels.green;
              this.velocityY = sensorRes.body.rangeLabels.yellow;
              this.velocityR = max;
              this.accelerationData.options.arcColors[0] = "#72FF13";
              this.accelerationData.options.arcColors[1] = "#FAA700";
              this.accelerationData.options.arcColors[2] = "#ff2a1b";
              // console.log("THIS VELOCITY G"+this.velocityG)
              if (
                this.accelerationData.centralLabel <=
                this.accelerationData.options.arcLabels[0]
              ) {
                // accelerationData.options.centralLabel=
                this.accelerationData.options.needleColor = "#72FF13";
              } else if (
                this.accelerationData.centralLabel >
                  this.accelerationData.options.arcLabels[0] &&
                this.accelerationData.centralLabel <=
                  this.accelerationData.options.arcLabels[1]
              ) {
                this.accelerationData.options.needleColor = "#FAA700";
              } else {
                this.accelerationData.options.needleColor = "#ff2a1b";
              }

              this.monitoringMeterShowVelocity.push(this.accelerationData);
              this.machineVibrationLoading = false;
            }

            if (this.monitoringMeterShowVelocity.length > 0) {
              this.machineVibrationLoading = false;
            }
          }

          this.changeOrder(
            ["z_velocity", "y_velocity", "x_velocity"],
            this.monitoringMeterShowVelocity
          );
          if (this.dataGadge[mCount].symbol === "C") {
            this.accelerationData.needleValue > 150
              ? (this.accelerationData.bottomLabel = "N/A")
              : this.accelerationData.needleValue;
          }
          if (this.accelerationData.key === "RMS_Accel_1_X_Axis") {
            if (
              arc_Delimiters[0] < 100 &&
              arc_Delimiters[0] > 0 &&
              arc_Delimiters[1] > 0 &&
              arc_Delimiters[0] < arc_Delimiters[1] &&
              arc_Delimiters[1] < 100
            ) {
              let max = range_label[1] != null ? range_label[1] : 0;
              let a = arc_Delimiters[0] / 100;
              let b = arc_Delimiters[1] / 100;
              let k = a * max;
              let l = b * max;
              let r = k.toFixed(1);
              let s = l.toFixed(1);
              this.accelerationData.options.arcLabels[0] = r;
              this.accelerationData.options.arcLabels[1] = s;
              this.accelerationData.options.arcColors[0] = "#72FF13";
              this.accelerationData.options.arcColors[1] = "#FAA700";
              this.accelerationData.options.arcColors[2] = "#ff2a1b";
              this.meterShownResult.splice(0, 0, this.accelerationData);
            } else {
              arc_Delimiters[0] = 20;
              arc_Delimiters[1] = 70;
              let max = range_label[1] != null ? range_label[1] : 0;
              let a = arc_Delimiters[0] / 100;
              let b = arc_Delimiters[1] / 100;
              let k = a * max;
              let l = b * max;
              let r = k.toFixed(1);
              let s = l.toFixed(1);
              this.accelerationData.options.arcLabels[0] = r;
              this.accelerationData.options.arcLabels[1] = s;
              this.accelerationData.options.arcColors[0] = "#72FF13";
              this.accelerationData.options.arcColors[1] = "#FAA700";
              this.accelerationData.options.arcColors[2] = "#ff2a1b";
              this.meterShownResult.splice(0, 0, this.accelerationData);
            }
          }
          if (this.accelerationData.key === "RMS_Accel_1_Y_Axis") {
            let max = range_label[1];
            let a = arc_Delimiters[0] / 100;
            let b = arc_Delimiters[1] / 100;
            let k = a * max;
            let l = b * max;
            let r = k.toFixed(1);
            let s = l.toFixed(1);
            this.accelerationData.options.arcLabels[0] = r;
            this.accelerationData.options.arcLabels[1] = s;
            this.accelerationData.options.arcColors[0] = "#72FF13";
            this.accelerationData.options.arcColors[1] = "#FAA700";
            this.accelerationData.options.arcColors[2] = "#ff2a1b";
            this.meterShownResult.splice(1, 0, this.accelerationData);
          }
          if (this.accelerationData.key === "RMS_Accel_1_Z_Axis") {
            let max = range_label[1];
            let a = arc_Delimiters[0] / 100;
            let b = arc_Delimiters[1] / 100;
            let k = a * max;
            let l = b * max;
            let r = k.toFixed(1);
            let s = l.toFixed(1);
            this.accelerationData.options.arcLabels[0] = r;
            this.accelerationData.options.arcLabels[1] = s;
            this.accelerationData.options.arcColors[0] = "#72FF13";
            this.accelerationData.options.arcColors[1] = "#FAA700";
            this.accelerationData.options.arcColors[2] = "#ff2a1b";
            this.meterShownResult.splice(2, 0, this.accelerationData);
          }

          //code to find out max of aacclaration
          if (this.meterShownResult.length == 3) {
            let temparr = [];

            this.meterShownResult.forEach((i) => {
              temparr.push(Math.sqrt(2) * parseFloat(i.centralLabel));
            });
            temparr.sort(function (a, b) {
              return a - b;
            });
            // accelerationData.needleValue=  (temparr[temparr.length - 1]* 100) /
            //   parseFloat(accelerationData.options.rangeLabel[1]);
            if (this.cccount < 1) {
              this.valll = temparr[temparr.length - 1];
              this.monitoringmaxaccobj = this.accelerationData;
              let needleRes =
                (this.valll)
              this.monitoringmaxaccobj.needleValue = needleRes;
              this.monitoringmaxaccobj.name = "Peak Acceleration";
              if (this.valll < this.monitoringmaxaccobj.options.arcLabels[0]) {
                this.monitoringmaxaccobj.options.needleColor = "#72FF13";
              } else if (
                this.valll > this.monitoringmaxaccobj.options.arcLabels[0] &&
                this.valll < this.monitoringmaxaccobj.options.arcLabels[1]
              ) {
                this.monitoringmaxaccobj.options.needleColor = "#FAA700";
              } else {
                this.monitoringmaxaccobj.options.needleColor = "#ff2a1b";
              }
              this.Optionsss = this.monitoringmaxaccobj.options;
              this.monitoringmaxaccobj.centralLabel = this.valll.toFixed(2);
              this.monitoringmaxaccobj.bottomLabel =
                this.monitoringmaxaccobj.centralLabel.toString() + " m/sec²";
              if (this.monitoringmaxaccobj != undefined) {
                this.gaugedisplay = true;
              }

              this.cccount++;
            }
          }

          if (
            this.accelerationData.key !== "RMS_Accel_1_X_Axis" &&
            this.accelerationData.key !== "RMS_Accel_1_Y_Axis" &&
            this.accelerationData.key !== "RMS_Accel_1_Z_Axis" &&
            this.accelerationData.key !== "Rate of change of orientation" &&
            this.accelerationData.key !== "Pitch" &&
            this.accelerationData.key !== "Roll" &&
            this.accelerationData.key !== "Yaw" &&
            this.accelerationData.key !== "x_mag" &&
            this.accelerationData.key !== "y_mag" &&
            this.accelerationData.key !== "z_mag" &&
            this.accelerationData.key !== "ultrasound" &&
            this.accelerationData.key !== "audible" &&
            this.accelerationData.key !== "x_velocity" &&
            this.accelerationData.key !== "y_velocity" &&
            this.accelerationData.key !== "z_velocity" &&
            this.accelerationData.key !== "Bearing_Temperature" &&
            this.accelerationData.key !== "Winding_Temperature" &&
            this.accelerationData.key !== "Ambient_Temperature" &&
            this.accelerationData.key !== "Rate of change of useful life left"
          ) {
            //code to set label by Deepak
          }
          this.changeOrder(
            ["RMS_Accel_1_Z_Axis", "RMS_Accel_1_Y_Axis", "RMS_Accel_1_X_Axis"],
            this.meterShownResult
          );
          if (
            this.accelerationData.key === "Bearing_Temperature" ||
            this.accelerationData.key === "Winding_Temperature" ||
            this.accelerationData.key === "Ambient_Temperature"
          ) {
            if (
              this.assetType === "MOTOR" ||
              this.assetType === "FAN_BLOWER" ||
              this.assetType === "PUMP" ||
              this.assetType === "COMPRESSOR" ||
              this.assetType === "JOURNAL_BEARING"
            ) {
              range_label[0] = "0";
              range_label[1] = "100";

              let max = range_label[1];
              this.accelerationData.options.hasNeedle = true;

              this.accelerationData.options.arcColors[0] = "#72FF13";
              this.accelerationData.options.arcColors[1] = "#FAA700";
              this.accelerationData.options.arcColors[2] = "#ff2a1b";

              let a = this.accelerationData.options.arcDelimiters[0] / 100;
              let b = this.accelerationData.options.arcDelimiters[1] / 100;
              let k = a * max;
              let l = b * max;
              let r = k.toFixed(0);
              let s = l.toFixed(0);
              this.accelerationData.options.arcLabels[0] = r;
              this.accelerationData.options.arcLabels[1] = s;
              if (this.accelerationData.bottomLabel == "N/A") {
                this.accelerationData.needleValue = 0;
                this.accelerationData.canvasWidth = 0;
              }

              if (
                this.accelerationData.needleValue <
                this.accelerationData.options.arcLabels[0]
              ) {
                this.accelerationData.options.needleColor = "#72FF13";
              } else if (
                this.accelerationData.needleValue >
                  this.accelerationData.options.arcLabels[0] &&
                this.accelerationData.needleValue <
                  this.accelerationData.options.arcLabels[1]
              ) {
                this.accelerationData.options.needleColor = "#FAA700";
              } else {
                this.accelerationData.options.needleColor = "#ff2a1b";
              }
              tempArr.push(this.accelerationData);
              if (tempArr.length >= 3) {
                this.monitoringTempratueResults = this.imposeRtdOrdering(tempArr);

                if (this.monitoringTempratueResults) {
                  this.displaytempgauge = true;
                  this.tempgaugeLoader = false;
                }
              }
            } else {
              range_label[0] = "0";
              range_label[1] = "100";
              let max = range_label[1];
              this.accelerationData.options.hasNeedle = true;

              this.accelerationData.options.arcColors[0] = "#72FF13";
              this.accelerationData.options.arcColors[1] = "#FAA700";
              this.accelerationData.options.arcColors[2] = "#ff2a1b";

              let a = this.accelerationData.options.arcDelimiters[0] / 100;
              let b = this.accelerationData.options.arcDelimiters[1] / 100;
              let k = a * max;
              let l = b * max;
              let r = k.toFixed(0);
              let s = l.toFixed(0);
              this.accelerationData.options.arcLabels[0] = r;
              this.accelerationData.options.arcLabels[1] = s;
              if (this.accelerationData.bottomLabel == "N/A") {
                this.accelerationData.needleValue = 0;
                this.accelerationData.canvasWidth = 0;
              }

              if (
                this.accelerationData.needleValue <
                this.accelerationData.options.arcLabels[0]
              ) {
                this.accelerationData.options.needleColor = "#72FF13";
              } else if (
                this.accelerationData.needleValue >
                  this.accelerationData.options.arcLabels[0] &&
                this.accelerationData.needleValue <
                  this.accelerationData.options.arcLabels[1]
              ) {
                this.accelerationData.options.needleColor = "#FAA700";
              } else {
                this.accelerationData.options.needleColor = "#ff2a1b";
              }
              tempArr.push(this.accelerationData);
              if (tempArr.length >= 3) {
                this.monitoringTempratueResults = this.imposeRtdOrdering(tempArr);
                if (this.monitoringTempratueResults) {
                  this.displaytempgauge = true;
                  this.tempgaugeLoader = false;
                }
              }
            }
          }
          if (this.accelerationData.key === "x_mag") {
            this.magneticX = this.accelerationData.needleValue.toFixed(2);
          }
          if (this.accelerationData.key === "y_mag") {
            this.magneticY = this.accelerationData.needleValue.toFixed(2);
          }
          if (this.accelerationData.key === "z_mag") {
            this.magneticZ = this.accelerationData.needleValue.toFixed(2);
          }

          if (this.accelerationData.key === "ultrasound") {
            let max = range_label[1];
            let a = arc_Delimiters[0] / 100;
            let b = arc_Delimiters[1] / 100;
            let k = a * max;
            let l = b * max;
            let r = k.toFixed(1);
            let s = l.toFixed(1);
            this.accelerationData.options.arcLabels[0] = r;
            this.accelerationData.options.arcLabels[1] = s;
            this.accelerationData.options.arcColors[0] = "#72FF13";
            this.accelerationData.options.arcColors[1] = "#FAA700";
            this.accelerationData.options.arcColors[2] = "#ff2a1b";
            this.accelerationData.bottomLabel = "0.0dB";
            this.accelerationData.needleValue = 0;
            this.MonitoringMagacoustic = this.accelerationData;
            this.MonitoringMagacoustic.options.arcLabels[0] = (+this.MonitoringMagacoustic.options
              .arcLabels[0]).toFixed(0);
            this.MonitoringMagacoustic.options.arcLabels[1] = (+this.MonitoringMagacoustic.options
              .arcLabels[1]).toFixed(0);
            // this.service
            //   .getDataWithQuery(
            //     this.ultrasoundGauge +
            //       "data/" +
            //       parseInt(this.deviceId) +
            //       "/" +
            //       parseInt(this.assetId) +
            //       "/" +
            //       this.userID
            //   )
              // .then((res) => {
                // let ultrasoundResponse = response.ultrasoundData;
                let response = JSON.parse(JSON.stringify(ultrasoundResponse));
                // if (response.status === "fail" || response.status === "error") {
                //   this.MonitoringMagacoustic.bottomLabel = "0.0 dB";
                //   this.MonitoringMagacoustic.needleValue = 0;
                //   if (this.MonitoringMagacoustic) {
                //     this.acousticgaugeLoader = false;
                //   }
                //   if (
                //     this.ultrasoundValue >= 0.0 &&
                //     this.ultrasoundValue < this.MonitoringMagacoustic.options.arcLabels[0]
                //   ) {
                //     this.MonitoringMagacoustic.options.needleColor = "#72FF13";
                //   } else if (
                //     this.ultrasoundValue >
                //       this.MonitoringMagacoustic.options.arcLabels[0] &&
                //     this.ultrasoundValue < this.MonitoringMagacoustic.options.arcLabels[1]
                //   ) {
                //     this.MonitoringMagacoustic.options.needleColor = "#FAA700";
                //   } else {
                //     this.MonitoringMagacoustic.options.needleColor = "#ff2a1b";
                //   }
                // } else {
                  // this.magacoustic.bottomLabel = "0.0 dB";
                  // this.magacoustic.needleValue = 0;
                  let predictedNumber = new Number(response.predicted);
                  this.MonitoringMagacoustic.bottomLabel =
                    predictedNumber.toFixed(1) + "dB";
                  this.MonitoringMagacoustic.needleValue =
                    (parseFloat(predictedNumber.toFixed(2)));
                  this.ultrasoundValue = parseFloat(predictedNumber.toFixed(2));
                  if (this.MonitoringMagacoustic) {
                    this.acousticgaugeLoader = false;
                  }
                  if (
                    this.ultrasoundValue >= 0.0 &&
                    this.ultrasoundValue < this.MonitoringMagacoustic.options.arcLabels[0]
                  ) {
                    this.MonitoringMagacoustic.options.needleColor = "#72FF13";
                  } else if (
                    this.ultrasoundValue >
                      this.MonitoringMagacoustic.options.arcLabels[0] &&
                    this.ultrasoundValue < this.MonitoringMagacoustic.options.arcLabels[1]
                  ) {
                    this.MonitoringMagacoustic.options.needleColor = "#FAA700";
                  } else {
                    this.MonitoringMagacoustic.options.needleColor = "#ff2a1b";
                  }
                // }
              // });
            // this.service
            //   .getDataWithQuery(
            //     this.ultrasoundGauge +
            //       "data/" +
            //       parseInt(this.deviceId) +
            //       "/" +
            //       parseInt(this.assetId) +
            //       "/" +
            //       this.userID
            //   )
            //   .then((res) => {
            //     let response = JSON.parse(JSON.stringify(res));
            //     if (response.status === "fail" || response.status === "error") {
            //       this.MonitoringMagacoustic.bottomLabel = "0.0 dB";
            //       this.MonitoringMagacoustic.needleValue = 0;
            //       if (this.MonitoringMagacoustic) {
            //         this.acousticgaugeLoader = false;
            //       }
            //       if (
            //         this.ultrasoundValue >= 0.0 &&
            //         this.ultrasoundValue < this.MonitoringMagacoustic.options.arcLabels[0]
            //       ) {
            //         this.MonitoringMagacoustic.options.needleColor = "#72FF13";
            //       } else if (
            //         this.ultrasoundValue >
            //           this.MonitoringMagacoustic.options.arcLabels[0] &&
            //         this.ultrasoundValue < this.MonitoringMagacoustic.options.arcLabels[1]
            //       ) {
            //         this.MonitoringMagacoustic.options.needleColor = "#FAA700";
            //       } else {
            //         this.MonitoringMagacoustic.options.needleColor = "#ff2a1b";
            //       }
            //     } else {
            //       // this.magacoustic.bottomLabel = "0.0 dB";
            //       // this.magacoustic.needleValue = 0;
            //       let predictedNumber = new Number(response.data.predicted);
            //       this.MonitoringMagacoustic.bottomLabel =
            //         predictedNumber.toFixed(1) + "dB";
            //       this.MonitoringMagacoustic.needleValue =
            //         (parseFloat(predictedNumber.toFixed(2)) * 100) /
            //         this.MonitoringMagacoustic.options.rangeLabel[1];
            //       this.ultrasoundValue = parseFloat(predictedNumber.toFixed(2));
            //       if (this.MonitoringMagacoustic) {
            //         this.acousticgaugeLoader = false;
            //       }
            //       if (
            //         this.ultrasoundValue >= 0.0 &&
            //         this.ultrasoundValue < this.MonitoringMagacoustic.options.arcLabels[0]
            //       ) {
            //         this.MonitoringMagacoustic.options.needleColor = "#72FF13";
            //       } else if (
            //         this.ultrasoundValue >
            //           this.MonitoringMagacoustic.options.arcLabels[0] &&
            //         this.ultrasoundValue < this.MonitoringMagacoustic.options.arcLabels[1]
            //       ) {
            //         this.MonitoringMagacoustic.options.needleColor = "#FAA700";
            //       } else {
            //         this.MonitoringMagacoustic.options.needleColor = "#ff2a1b";
            //       }
            //     }
            //   });
          }
          if (this.accelerationData.key === "audible") {
            this.monitoringAudibleValue = this.accelerationData.needleValue.toFixed(1);
            this.audibleLoader = false;
          }
          if (this.accelerationData.key === "Rate of change of useful life left") {
            this.rateOfChange.push(this.accelerationData);
          }
          if (this.accelerationData.key === "Pitch") {
            this._orientationX = this.accelerationData.needleValue.toFixed(3);
          }
          if (this.accelerationData.key === "Roll") {
            this._orientationY = this.accelerationData.needleValue.toFixed(3);
          }
          if (this.accelerationData.key === "Yaw") {
            this._orientationZ = this.accelerationData.needleValue.toFixed(3);
          }
        }
        console.log("MASTER PRODUCT TYPE:"+this.master_product_type)
        if(this.master_product_type!=null && this.master_product_type!=3){
          console.log("GOING IN HERE")
            this.monitoringTempratueResults=this.monitoringTempratueResults.filter(temp=>temp.key=="Bearing_Temperature")
          }
      }
    }
    this.machineVibrationLoading = false;
    // this.stackchartvelocity();
  }

  public async getGaugeDataByID(machineVibReload=true,tempReload=true,acousticReload=true) {
    this.machineVibrationLoading=machineVibReload;
    this.tempgaugeLoader=tempReload;
    this.acousticgaugeLoader=acousticReload;
    //this.tempbarchart();
    this.cccount = 0;
    const getMacAddress = await this.service
      .getDataWithQuery(
        this.getInventoryByIDUrl +
          "/" +
          "v2" +
          "/" +
          this.mac_address +
          "/" +
          this.assetId +
          "/" +
          this.userID
      )
      .then((mRes) => {
        return JSON.parse(JSON.stringify(mRes));
      });
    this.firmware_version = getMacAddress[0]?.installed_firmware_version;
    this.mac_address = getMacAddress[0]?.mac_address;
    let machineData;
    if (this.deviceSerialNo != 1) {
      machineData = await this.service
        .getDataWithQuery(
          this.machineParamUrl +
            "machine/parameters/" +
            this.assetMasterInfo.inventory_id +
            "/" +
            this.assetMasterInfo.id +
            "/" +
            this.userID
        )
        .then((mRes) => {
          return JSON.parse(JSON.stringify(mRes));
        });
    } else {
      machineData = await this.service
        .getDataWithQuery(
          this.machineParamUrl +
            "machine/parameters/" +
            this.deviceId +
            "/" +
            parseInt(this.assetId) +
            "/" +
            this.userID
        )
        .then((mRes) => {
          return JSON.parse(JSON.stringify(mRes));
        });
    }
    const machineResData = machineData.data.body[0];
    let deviceStatus;

    // if (getMacAddress.length != 0) {

    //   deviceStatus = await this.service
    //     .getDataWithQuery(
    //       this.deviceStatusURL + "device/status/" + getMacAddress[0].mac_address
    //     )
    //     .then((statusRes) => {

    //       return JSON.parse(JSON.stringify(statusRes)).data.body;
    //     });
    //   if (deviceStatus != null)
    //   {this.onoffStatus = deviceStatus.asset_status;}

    // }
    // let sensorRes = await this.service
    //   .getDataWithQuery(
    //     this.monitoringSensorAPI +
    //       parseInt(this.assetId) +
    //       "/" +
    //       parseInt(this.deviceId) +
    //       "?userId=" +
    //       this.userID
    //   )
    //   .then((sRes) => {
    //     return JSON.parse(JSON.stringify(sRes)).data;
    //   });
    let sensorRes = await this.service
      .getDataWithQuery(
        this.sensorData +
          "/" +
          parseInt(this.deviceId) +
          "/" +
          parseInt(this.assetId) +
          "?userid=" +
          this.userID
      )
      .then((sRes) => {
        return JSON.parse(JSON.stringify(sRes)).data;
      });

    if (sensorRes.status === "fail") {
      this.service.showError(sensorRes.body.message);
      this.machineVibrationLoading = false;
    }
    if (
      sensorRes.msgResponder == "no sensor data available." ||
      sensorRes.body.length == 0
    ) {
      // this.service.showError("No sensor data available");
      this.machineVibrationLoading = false;
      this.acousticgaugeLoader = false;
      this.audibleLoader = false;
      this.monitoringLoader = false;
      this.machineHealthLoader = false;
      this.tempgaugeLoader = false;
      this.serviceLoader = false;
      this.stackvelocitychartLoader = false;
    }
    if (this.deviceSerialNo != 1) {
      this.showMachineUtilization(
        this.assetMasterInfo.mac_address,
        this.userID,
        1
      );
    } else {
      this.showMachineUtilization(getMacAddress[0].mac_address, this.userID, 1);
    }
    if (sensorRes.body.length != 0) {
      this.machineVibrationLoading = false;
      let response = sensorRes.body;
      this.driveType = response.drive_type;
      this.filterType = "day";
      this.selectItem(
        response.issue === undefined ? "day" : response.issue.filterType
      );
      this.rValue = response.rVal;
      this.returnUpdatedAt = response.updated_at;
      this.rateOfChange = [];
      //this.tempratueResults = [];
      this.meterShownResult = [];
      this.meterShowVelocity = [];

      // if (response.indices !== undefined) {
      //   if (response.indices.length != 0) {
      //     //this.showoverallhealthindices=true;

      //     this.indicesValues = response.indices;

      //     for (let i = 0; i < this.indicesValues.length; i++) {
      //       if (this.indicesValues[i].value == "N/A") {
      //         this.indicesValues[i].rvalue = 0;
      //       } else {
      //         this.indicesValues[i].rvalue = this.indicesValues[i].value;
      //       }
      //     }

      //     //Code to calculate overall Health indices by deepak

      //     let endpoint =
      //       this.base_middleware_url +
      //       "machine/indices/" +
      //       this.assetId +
      //       "/" +
      //       this.mac_address;
      //     this.service.gethealthindicesbyassetid(endpoint).then((res) => {
      //       if (JSON.parse(JSON.stringify(res)).data.status === "success") {
      //         if (JSON.parse(JSON.stringify(res)).data.body.length != 0) {
      //           for (let i = 0; i < this.indicesValues.length; i++) {
      //             if (this.indicesValues[i].label == "Mechanical Health") {
      //               var aa =
      //                 (JSON.parse(JSON.stringify(res)).data.body[0]
      //                   .mechanical_health /
      //                   100) *
      //                 this.indicesValues[i].rvalue;
      //             }
      //             if (this.indicesValues[i].label == "Electrical Health") {
      //               var bb =
      //                 (JSON.parse(JSON.stringify(res)).data.body[0]
      //                   .electrical_health /
      //                   100) *
      //                 this.indicesValues[i].rvalue;
      //             }
      //             if (this.indicesValues[i].label == "Bearings Health") {
      //               var cc =
      //                 (JSON.parse(JSON.stringify(res)).data.body[0]
      //                   .bearing_health /
      //                   100) *
      //                 this.indicesValues[i].rvalue;
      //             }
      //             if (this.indicesValues[i].label == "Thermal Health") {
      //               var dd =
      //                 (JSON.parse(JSON.stringify(res)).data.body[0]
      //                   .thermal_health /
      //                   100) *
      //                 this.indicesValues[i].rvalue;
      //             }
      //           }
      //           this.overallhealthindiexnumber = (aa + bb + cc + dd).toFixed(0);

      //           if (this.overallhealthindiexnumber == 0) {
      //             this.overallhealthindiexnumber = "N/A";
      //             this.spanwhite = true;
      //           }
      //           this.machineHealthLoader = false;
      //           //condition for colouring span of overall Health Indice number
      //           const col = this.overallhealthindiexnumber;
      //           if (!this.spanwhite) {
      //             if (col <= 59.9 && col > 0) {
      //               this.spanred = true;
      //             } else if (col > 59.9 && col <= 84.9) {
      //               this.spanyellow = true;
      //             } else {
      //               this.spangreen = true;
      //             }
      //           }
      //         } else {
      //           this.overallhealthindiexnumber == 0;
      //           this.overallhealthindiexnumber = "N/A";
      //           this.spanwhite = true;
      //         }
      //       }
      //     });
      //   }
      // }
      // //code By deepak
      // else {
      //   this.indicesValues.push({
      //     label: "Mechanical Health",
      //     color: "#FFFFFF",
      //     value: "N/A",
      //   });
      // }
      // this.onlineOfflineStatus = response.issue.status;

      //Check

      this.dataGadge = response.sensor.filter(
        (item, i, arr) => arr.findIndex((t) => t.key === item.key) === i
      );

      let bottomLab = "N/A";

      if (this.dataGadge.length !== 0) {
        let tempArr = [];
        for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
          // if (
          //   JSON.parse(this.dataGadge[mCount].value) === 0 &&
          //   this.dataGadge[mCount].needle === false
          // ) {
          //   bottomLab = "N/A";
          // } else {
          //   bottomLab =
          //     JSON.parse(this.dataGadge[mCount].value) <= 0
          //       ? "N/A"
          //       : this.dataGadge[mCount].symbol === "C"
          //       ? JSON.parse(this.dataGadge[mCount].value) +
          //         " °" +
          //         this.dataGadge[mCount].icon
          //       : JSON.parse(this.dataGadge[mCount].value) +
          //         " " +
          //         this.dataGadge[mCount].icon;
          // }
          // this.Itemsymbol = this.dataGadge[mCount].symbol;
          // let needleValueRes;
          // if (this.dataGadge[mCount].symbol === "m/sec²") {
          //   needleValueRes =
          //     (JSON.parse(this.dataGadge[mCount].value) * 100) /
          //     parseFloat(this.dataGadge[mCount].rangelabel[1]);
          // } else if (this.dataGadge[mCount].symbol === "mm/sec") {
          //   needleValueRes =
          //     (JSON.parse(this.dataGadge[mCount].value) * 100) /
          //     parseFloat(this.dataGadge[mCount].rangelabel[1]);
          // } else if (this.dataGadge[mCount].symbol === "deg") {
          //   needleValueRes = JSON.parse(this.dataGadge[mCount].value);
          // } else {
          //   needleValueRes = JSON.parse(this.dataGadge[mCount].value);
          // }
          // let centerLab =
          //   JSON.parse(this.dataGadge[mCount].value) < 0
          //     ? "N/A"
          //     : JSON.parse(this.dataGadge[mCount].value);
          // let arc_colors =
          //   this.dataGadge[mCount].needle === true
          //     ? this.dataGadge[mCount].arcColors
          //     : ["transparent", "transparent", "transparent"];
          // let range_label =
          //   this.dataGadge[mCount].needle === true
          //     ? this.dataGadge[mCount].rangelabel
          //     : [];
          // let arc_Delimiters =
          //   this.dataGadge[mCount].needle === true
          //     ? this.dataGadge[mCount].arcDelimiters
          //     : [];
          // let value =
          //   JSON.parse(this.dataGadge[mCount].value) < 0
          //     ? "N/A"
          //     : JSON.parse(this.dataGadge[mCount].value);

          // const accelerationData = {
          //   // value:value,
          //   needleValue: needleValueRes,
          //   centralLabel: centerLab,
          //   outerNeedle: false,
          //   canvasWidth: 150,
          //   name: this.dataGadge[mCount].name,
          //   key: this.dataGadge[mCount].key,
          //   bottomLabel: bottomLab,
          //   hasneedle: this.dataGadge[mCount].needle,
          //   options: {
          //     hasNeedle: this.dataGadge[mCount].needle,
          //     needleColor: "black",
          //     needleUpdateSpeed: "",
          //     arcColors: arc_colors,
          //     arcLabels: [],
          //     arcDelimiters: this.dataGadge[mCount].arcDelimiters,
          //     rangeLabel: range_label,
          //     needleStartValue: 0,
          //   },
          // };
          // if (
          //   accelerationData.key === "x_velocity" ||
          //   accelerationData.key === "y_velocity" ||
          //   accelerationData.key === "z_velocity"
          // ) {
          //   // if(arc_Delimiters[0])  [arcdelimiter[0],arcelimiter[1]]
          //   //code to set label by Deepak'
          //   if (
          //     arc_Delimiters[0] < 100 &&
          //     arc_Delimiters[0] > 0 &&
          //     arc_Delimiters[1] > 0 &&
          //     arc_Delimiters[0] < arc_Delimiters[1] &&
          //     arc_Delimiters[1] < 100
          //   ) {
          //     let max = range_label[1] != null ? range_label[1] : 0;
          //     // let a = arc_Delimiters[0] / 100;
          //     // let b = arc_Delimiters[1] / 100;
          //     // let k = (a * max).toFixed(1);
          //     // let l = (b * max).toFixed(1);
          //     // let r = k.toFixed(0);
          //     // let s = l.toFixed(0);\
          //     accelerationData.options.arcLabels[0] =
          //       sensorRes.body.rangeLabels.green;
          //     accelerationData.options.arcLabels[1] =
          //       sensorRes.body.rangeLabels.yellow;
          //     this.velocityG = sensorRes.body.rangeLabels.green;
          //     this.velocityY = sensorRes.body.rangeLabels.yellow;
          //     this.velocityR = max;
          //     accelerationData.options.arcColors[0] = "#72FF13";
          //     accelerationData.options.arcColors[1] = "#FAA700";
          //     accelerationData.options.arcColors[2] = "#ff2a1b";
          //     // if(this.velocity)
          //     // console.log("THIS VELOCITY G"+this.velocityG)
          //     if (
          //       accelerationData.centralLabel <=
          //       accelerationData.options.arcLabels[0]
          //     ) {
          //       // accelerationData.options.centralLabel=
          //       accelerationData.options.needleColor = "#72FF13";
          //     } else if (
          //       accelerationData.centralLabel >
          //         accelerationData.options.arcLabels[0] &&
          //       accelerationData.centralLabel <=
          //         accelerationData.options.arcLabels[1]
          //     ) {
          //       accelerationData.options.needleColor = "#FAA700";
          //     } else {
          //       accelerationData.options.needleColor = "#ff2a1b";
          //     }
          //     this.meterShowVelocity.push(accelerationData);
          //     this.machineVibrationLoading = false;
          //   } else {
          //     arc_Delimiters[0] = 20;
          //     arc_Delimiters[1] = 70;
          //     let max = range_label[1] != null ? range_label[1] : 0;
          //     // let a = arc_Delimiters[0] / 100;
          //     // let b = arc_Delimiters[1] / 100;
          //     // let k = (a * max).toFixed(1);
          //     // let l = (b * max).toFixed(1);
          //     // let r = k.toFixed(0);
          //     // let s = l.toFixed(0);
          //     accelerationData.options.arcLabels[0] =
          //       sensorRes.body.rangeLabels.green;
          //     accelerationData.options.arcLabels[1] =
          //       sensorRes.body.rangeLabels.yellow;
          //     this.velocityG = sensorRes.body.rangeLabels.green;
          //     this.velocityY = sensorRes.body.rangeLabels.yellow;
          //     this.velocityR = max;
          //     accelerationData.options.arcColors[0] = "#72FF13";
          //     accelerationData.options.arcColors[1] = "#FAA700";
          //     accelerationData.options.arcColors[2] = "#ff2a1b";
          //     // console.log("THIS VELOCITY G"+this.velocityG)
          //     if (
          //       accelerationData.centralLabel <=
          //       accelerationData.options.arcLabels[0]
          //     ) {
          //       // accelerationData.options.centralLabel=
          //       accelerationData.options.needleColor = "#72FF13";
          //     } else if (
          //       accelerationData.centralLabel >
          //         accelerationData.options.arcLabels[0] &&
          //       accelerationData.centralLabel <=
          //         accelerationData.options.arcLabels[1]
          //     ) {
          //       accelerationData.options.needleColor = "#FAA700";
          //     } else {
          //       accelerationData.options.needleColor = "#ff2a1b";
          //     }

          //     this.meterShowVelocity.push(accelerationData);
          //     this.machineVibrationLoading = false;
          //   }

          //   if (this.meterShowVelocity.length > 0) {
          //     this.machineVibrationLoading = false;
          //   }
          // }

          // this.changeOrder(
          //   ["z_velocity", "y_velocity", "x_velocity"],
          //   this.meterShowVelocity
          // );
          // if (this.dataGadge[mCount].symbol === "C") {
          //   accelerationData.needleValue > 150
          //     ? (accelerationData.bottomLabel = "N/A")
          //     : accelerationData.needleValue;
          // }
          // if (accelerationData.key === "RMS_Accel_1_X_Axis") {
          //   if (
          //     arc_Delimiters[0] < 100 &&
          //     arc_Delimiters[0] > 0 &&
          //     arc_Delimiters[1] > 0 &&
          //     arc_Delimiters[0] < arc_Delimiters[1] &&
          //     arc_Delimiters[1] < 100
          //   ) {
          //     let max = range_label[1] != null ? range_label[1] : 0;
          //     let a = arc_Delimiters[0] / 100;
          //     let b = arc_Delimiters[1] / 100;
          //     let k = a * max;
          //     let l = b * max;
          //     let r = k.toFixed(1);
          //     let s = l.toFixed(1);
          //     accelerationData.options.arcLabels[0] = r;
          //     accelerationData.options.arcLabels[1] = s;
          //     accelerationData.options.arcColors[0] = "#72FF13";
          //     accelerationData.options.arcColors[1] = "#FAA700";
          //     accelerationData.options.arcColors[2] = "#ff2a1b";
          //     this.meterShownResult.splice(0, 0, accelerationData);
          //   } else {
          //     arc_Delimiters[0] = 20;
          //     arc_Delimiters[1] = 70;
          //     let max = range_label[1] != null ? range_label[1] : 0;
          //     let a = arc_Delimiters[0] / 100;
          //     let b = arc_Delimiters[1] / 100;
          //     let k = a * max;
          //     let l = b * max;
          //     let r = k.toFixed(1);
          //     let s = l.toFixed(1);
          //     accelerationData.options.arcLabels[0] = r;
          //     accelerationData.options.arcLabels[1] = s;
          //     accelerationData.options.arcColors[0] = "#72FF13";
          //     accelerationData.options.arcColors[1] = "#FAA700";
          //     accelerationData.options.arcColors[2] = "#ff2a1b";
          //     this.meterShownResult.splice(0, 0, accelerationData);
          //   }
          // }
          // if (accelerationData.key === "RMS_Accel_1_Y_Axis") {
          //   let max = range_label[1];
          //   let a = arc_Delimiters[0] / 100;
          //   let b = arc_Delimiters[1] / 100;
          //   let k = a * max;
          //   let l = b * max;
          //   let r = k.toFixed(1);
          //   let s = l.toFixed(1);
          //   accelerationData.options.arcLabels[0] = r;
          //   accelerationData.options.arcLabels[1] = s;
          //   accelerationData.options.arcColors[0] = "#72FF13";
          //   accelerationData.options.arcColors[1] = "#FAA700";
          //   accelerationData.options.arcColors[2] = "#ff2a1b";
          //   this.meterShownResult.splice(1, 0, accelerationData);
          // }
          // if (accelerationData.key === "RMS_Accel_1_Z_Axis") {
          //   let max = range_label[1];
          //   let a = arc_Delimiters[0] / 100;
          //   let b = arc_Delimiters[1] / 100;
          //   let k = a * max;
          //   let l = b * max;
          //   let r = k.toFixed(1);
          //   let s = l.toFixed(1);
          //   accelerationData.options.arcLabels[0] = r;
          //   accelerationData.options.arcLabels[1] = s;
          //   accelerationData.options.arcColors[0] = "#72FF13";
          //   accelerationData.options.arcColors[1] = "#FAA700";
          //   accelerationData.options.arcColors[2] = "#ff2a1b";
          //   this.meterShownResult.splice(2, 0, accelerationData);
          // }

          // //code to find out max of aacclaration
          // if (this.meterShownResult.length == 3) {
          //   let temparr = [];

          //   this.meterShownResult.forEach((i) => {
          //     temparr.push(Math.sqrt(2) * parseFloat(i.centralLabel));
          //   });
          //   temparr.sort(function (a, b) {
          //     return a - b;
          //   });
          //   // accelerationData.needleValue=  (temparr[temparr.length - 1]* 100) /
          //   //   parseFloat(accelerationData.options.rangeLabel[1]);

          //   if (this.cccount < 1) {
          //     this.valll = temparr[temparr.length - 1];
          //     this.maxaccobj = accelerationData;
          //     let needleRes =
          //       (this.valll * 100) /
          //       parseFloat(this.maxaccobj.options.rangeLabel[1]);
          //     this.maxaccobj.needleValue = needleRes;
          //     this.maxaccobj.name = "Peak Acceleration";
          //     if (this.valll < this.maxaccobj.options.arcLabels[0]) {
          //       this.maxaccobj.options.needleColor = "#72FF13";
          //     } else if (
          //       this.valll > this.maxaccobj.options.arcLabels[0] &&
          //       this.valll < this.maxaccobj.options.arcLabels[1]
          //     ) {
          //       this.maxaccobj.options.needleColor = "#FAA700";
          //     } else {
          //       this.maxaccobj.options.needleColor = "#ff2a1b";
          //     }
          //     this.Optionsss = this.maxaccobj.options;
          //     this.maxaccobj.centralLabel = this.valll.toFixed(2);
          //     this.maxaccobj.bottomLabel =
          //       this.maxaccobj.centralLabel.toString() + " m/sec²";
          //     if (this.maxaccobj != undefined) {
          //       this.gaugedisplay = true;
          //     }

          //     this.cccount++;
          //   }
          // }

          // if (
          //   this.accelerationData.key !== "RMS_Accel_1_X_Axis" &&
          //   this.accelerationData.key !== "RMS_Accel_1_Y_Axis" &&
          //   this.accelerationData.key !== "RMS_Accel_1_Z_Axis" &&
          //   this.accelerationData.key !== "Rate of change of orientation" &&
          //   this.accelerationData.key !== "Pitch" &&
          //   this.accelerationData.key !== "Roll" &&
          //   this.accelerationData.key !== "Yaw" &&
          //   this.accelerationData.key !== "x_mag" &&
          //   this.accelerationData.key !== "y_mag" &&
          //   this.accelerationData.key !== "z_mag" &&
          //   this.accelerationData.key !== "ultrasound" &&
          //   this.accelerationData.key !== "audible" &&
          //   this.accelerationData.key !== "x_velocity" &&
          //   this.accelerationData.key !== "y_velocity" &&
          //   this.accelerationData.key !== "z_velocity" &&
          //   this.accelerationData.key !== "Bearing_Temperature" &&
          //   this.accelerationData.key !== "Winding_Temperature" &&
          //   this.accelerationData.key !== "Ambient_Temperature" &&
          //   this.accelerationData.key !== "Rate of change of useful life left"
          // ) {
          //   //code to set label by Deepak
          // }
          // this.changeOrder(
          //   ["RMS_Accel_1_Z_Axis", "RMS_Accel_1_Y_Axis", "RMS_Accel_1_X_Axis"],
          //   this.meterShownResult
          // );
          // if (
          //   accelerationData.key === "Bearing_Temperature" ||
          //   accelerationData.key === "Winding_Temperature" ||
          //   accelerationData.key === "Ambient_Temperature"
          // ) {
          //   if (
          //     this.assetType === "MOTOR" ||
          //     this.assetType === "FAN_BLOWER" ||
          //     this.assetType === "PUMP" ||
          //     this.assetType === "COMPRESSOR" ||
          //     this.assetType === "JOURNAL_BEARING"
          //   ) {
          //     range_label[0] = "0";
          //     range_label[1] = "100";

          //     let max = range_label[1];
          //     accelerationData.options.hasNeedle = true;

          //     accelerationData.options.arcColors[0] = "#72FF13";
          //     accelerationData.options.arcColors[1] = "#FAA700";
          //     accelerationData.options.arcColors[2] = "#ff2a1b";

          //     let a = accelerationData.options.arcDelimiters[0] / 100;
          //     let b = accelerationData.options.arcDelimiters[1] / 100;
          //     let k = a * max;
          //     let l = b * max;
          //     let r = k.toFixed(0);
          //     let s = l.toFixed(0);
          //     accelerationData.options.arcLabels[0] = r;
          //     accelerationData.options.arcLabels[1] = s;
          //     if (accelerationData.bottomLabel == "N/A") {
          //       accelerationData.needleValue = 0;
          //       accelerationData.canvasWidth = 0;
          //     }

          //     if (
          //       accelerationData.needleValue <
          //       accelerationData.options.arcLabels[0]
          //     ) {
          //       accelerationData.options.needleColor = "#72FF13";
          //     } else if (
          //       accelerationData.needleValue >
          //         accelerationData.options.arcLabels[0] &&
          //       accelerationData.needleValue <
          //         accelerationData.options.arcLabels[1]
          //     ) {
          //       accelerationData.options.needleColor = "#FAA700";
          //     } else {
          //       accelerationData.options.needleColor = "#ff2a1b";
          //     }
          //     tempArr.push(accelerationData);
          //     if (tempArr.length >= 3) {
          //       this.tempratueResults = this.imposeRtdOrdering(tempArr);

          //       if (this.tempratueResults) {
          //         this.displaytempgauge = true;
          //         this.tempgaugeLoader = false;
          //       }
          //     }
          //   } else {
          //     range_label[0] = "0";
          //     range_label[1] = "100";
          //     let max = range_label[1];
          //     accelerationData.options.hasNeedle = true;

          //     accelerationData.options.arcColors[0] = "#72FF13";
          //     accelerationData.options.arcColors[1] = "#FAA700";
          //     accelerationData.options.arcColors[2] = "#ff2a1b";

          //     let a = accelerationData.options.arcDelimiters[0] / 100;
          //     let b = accelerationData.options.arcDelimiters[1] / 100;
          //     let k = a * max;
          //     let l = b * max;
          //     let r = k.toFixed(0);
          //     let s = l.toFixed(0);
          //     accelerationData.options.arcLabels[0] = r;
          //     accelerationData.options.arcLabels[1] = s;
          //     if (accelerationData.bottomLabel == "N/A") {
          //       accelerationData.needleValue = 0;
          //       accelerationData.canvasWidth = 0;
          //     }

          //     if (
          //       accelerationData.needleValue <
          //       accelerationData.options.arcLabels[0]
          //     ) {
          //       accelerationData.options.needleColor = "#72FF13";
          //     } else if (
          //       accelerationData.needleValue >
          //         accelerationData.options.arcLabels[0] &&
          //       accelerationData.needleValue <
          //         accelerationData.options.arcLabels[1]
          //     ) {
          //       accelerationData.options.needleColor = "#FAA700";
          //     } else {
          //       accelerationData.options.needleColor = "#ff2a1b";
          //     }
          //     tempArr.push(accelerationData);
          //     if (tempArr.length >= 3) {
          //       this.tempratueResults = this.imposeRtdOrdering(tempArr);
          //       if (this.tempratueResults) {
          //         this.displaytempgauge = true;
          //         this.tempgaugeLoader = false;
          //       }
          //     }
          //   }

          // }
          // if (accelerationData.key === "x_mag") {
          //   this.magneticX = accelerationData.needleValue.toFixed(2);
          // }
          // if (accelerationData.key === "y_mag") {
          //   this.magneticY = accelerationData.needleValue.toFixed(2);
          // }
          // if (accelerationData.key === "z_mag") {
          //   this.magneticZ = accelerationData.needleValue.toFixed(2);
          // }
          // if (accelerationData.key === "ultrasound") {
          //   let max = range_label[1];
          //   let a = arc_Delimiters[0] / 100;
          //   let b = arc_Delimiters[1] / 100;
          //   let k = a * max;
          //   let l = b * max;
          //   let r = k.toFixed(1);
          //   let s = l.toFixed(1);
          //   accelerationData.options.arcLabels[0] = r;
          //   accelerationData.options.arcLabels[1] = s;
          //   accelerationData.options.arcColors[0] = "#72FF13";
          //   accelerationData.options.arcColors[1] = "#FAA700";
          //   accelerationData.options.arcColors[2] = "#ff2a1b";
          //   accelerationData.bottomLabel = "0.0dB";
          //   accelerationData.needleValue = 0;
          //   this.magacoustic = accelerationData;
          //   this.magacoustic.options.arcLabels[0] = (+this.magacoustic.options
          //     .arcLabels[0]).toFixed(0);
          //   this.magacoustic.options.arcLabels[1] = (+this.magacoustic.options
          //     .arcLabels[1]).toFixed(0);
          //   this.service
          //     .getDataWithQuery(
          //       this.ultrasoundGauge +
          //         "data/" +
          //         parseInt(this.deviceId) +
          //         "/" +
          //         parseInt(this.assetId) +
          //         "/" +
          //         this.userID
          //     )
          //     .then((res) => {
          //       let response = JSON.parse(JSON.stringify(res));
          //       if (response.status === "fail" || response.status === "error") {
          //         this.magacoustic.bottomLabel = "0.0 dB";
          //         this.magacoustic.needleValue = 0;
          //         if (this.magacoustic) {
          //           this.acousticgaugeLoader = false;
          //         }
          //         if (
          //           this.ultrasoundValue >= 0.0 &&
          //           this.ultrasoundValue < this.magacoustic.options.arcLabels[0]
          //         ) {
          //           this.magacoustic.options.needleColor = "#72FF13";
          //         } else if (
          //           this.ultrasoundValue >
          //             this.magacoustic.options.arcLabels[0] &&
          //           this.ultrasoundValue < this.magacoustic.options.arcLabels[1]
          //         ) {
          //           this.magacoustic.options.needleColor = "#FAA700";
          //         } else {
          //           this.magacoustic.options.needleColor = "#ff2a1b";
          //         }
          //       } else {
          //         // this.magacoustic.bottomLabel = "0.0 dB";
          //         // this.magacoustic.needleValue = 0;
          //         let predictedNumber = new Number(response.data.predicted);
          //         this.magacoustic.bottomLabel =
          //           predictedNumber.toFixed(1) + "dB";
          //         this.magacoustic.needleValue =
          //           (parseFloat(predictedNumber.toFixed(2)) * 100) /
          //           this.magacoustic.options.rangeLabel[1];
          //         this.ultrasoundValue = parseFloat(predictedNumber.toFixed(2));
          //         if (this.magacoustic) {
          //           this.acousticgaugeLoader = false;
          //         }
          //         if (
          //           this.ultrasoundValue >= 0.0 &&
          //           this.ultrasoundValue < this.magacoustic.options.arcLabels[0]
          //         ) {
          //           this.magacoustic.options.needleColor = "#72FF13";
          //         } else if (
          //           this.ultrasoundValue >
          //             this.magacoustic.options.arcLabels[0] &&
          //           this.ultrasoundValue < this.magacoustic.options.arcLabels[1]
          //         ) {
          //           this.magacoustic.options.needleColor = "#FAA700";
          //         } else {
          //           this.magacoustic.options.needleColor = "#ff2a1b";
          //         }
          //       }
          //     });
          // }
          // if (accelerationData.key === "audible") {
          //   this.audibleValue = accelerationData.needleValue.toFixed(1);
          //   this.audibleLoader = false;
          // }
          // if (accelerationData.key === "Rate of change of useful life left") {
          //   this.rateOfChange.push(accelerationData);
          // }
          // if (accelerationData.key === "Pitch") {
          //   this._orientationX = accelerationData.needleValue.toFixed(3);
          // }
          // if (accelerationData.key === "Roll") {
          //   this._orientationY = accelerationData.needleValue.toFixed(3);
          // }
          // if (accelerationData.key === "Yaw") {
          //   this._orientationZ = accelerationData.needleValue.toFixed(3);
          // }
        }
        if (response.rpm !== undefined) {
          this.RPMObj = response.rpm;
        }
        if (
          this.assetType === "MOTOR" ||
          this.assetType === "FAN_BLOWER" ||
          this.assetType === "PUMP" ||
          this.assetType === "COMPRESSOR" ||
          this.assetType === "JOURNAL_BEARING"
        ) {
          if (machineResData != undefined) {
            // this.service
            // .getData(
            //   this.assetsUrlEdit + "/" + this.assetId + "/" + this.mac_address
            // )
            // .then(async (result) => {
            //   if (
            //     JSON.parse(JSON.stringify(result)).data.status === "success"
            //   ) {
            //     const {
            //       poles,
            //       sub_type,
            //       asset_marker,
            //       asset_type,
            //       template_id,
            //     } = JSON.parse(JSON.stringify(result)).data.body;
            //     // console.log(asset_type,this.deviceSerialNo,sub_type,template_id,machineResData)
            //     if (asset_type == "JOURNAL_BEARING" && this.deviceSerialNo!=1 && this.isJournalBearingWithSyncMotor) {
            //       // console.log(first)
            //       this.opr_rpm =
            //         (machineResData.operatingLF / machineResData.line_freq) *
            //         machineResData.rated_rpm;
            //         this.opr_rpm=Number(this.opr_rpm.toFixed(1))
            //     } else if (
            //       poles == 0 &&
            //       asset_type == "MOTOR" &&
            //       sub_type == "SYNCHRONOUS_MOTOR"
            //       // template_id.split("_")[1] == "frame"
            //     ) {
            //       this.opr_rpm =
            //         (machineResData.operatingLF / machineResData.line_freq) *
            //         machineResData.rated_rpm;
            //         this.opr_rpm=Number(this.opr_rpm.toFixed(1))
            //     }
            //   }
            //   console.log(machineResData)
            //   console.log(this.opr_rpm,this._actualrpm,this._line_frequency)
            // });
            this.opr_rpm = machineResData.actual_rpm;
            this.opr_rpm = Number(this.opr_rpm.toFixed(1));
            let OperatingSyncRPM =
              (machineResData.operatingLF * machineResData.syncRPM) /
              machineResData.line_freq;

            let EstOutputPower: any =
              machineResData.input_power *
              machineResData.actual_rpm *
              (OperatingSyncRPM - machineResData.actual_rpm);

            EstOutputPower = parseInt(EstOutputPower);

            if (EstOutputPower <= 0 || EstOutputPower == undefined) {
              EstOutputPower = 0;
            }
            this.outputPower =
              machineResData.power_output === undefined
                ? 0
                : machineResData.power_output.toFixed(0);
            this.nLineFrequency =
              machineResData.line_freq === null
                ? "N/A"
                : machineResData.line_freq.toFixed(1);
            this.syncRPM =
              machineResData.syncRPM === 0 ? 0 : ~~machineResData.syncRPM;
            this.ratedRPM =
              machineResData.rated_rpm === 0 ? 0 : ~~machineResData.rated_rpm;
            this.ratedLineCurrent =
              machineResData.ph_line_current === 0
                ? 0
                : machineResData.ph_line_current.toFixed(2);
            if (this.onoffStatus === 1) {
              this.EstOutputpower =
                EstOutputPower === 0 ? "N/A" : EstOutputPower;
              //this.operatingSyncRPM =
              this.maxRatedPower = EstOutputPower;

              this.actualRPM =
                machineResData.actual_rpm === 0
                  ? 0
                  : ~~machineResData.actual_rpm.toFixed(1);
              this.operatingSyncRPM =
                machineResData.operatingSyncRPM === 0
                  ? 0
                  : ~~machineResData.operatingSyncRPM;
              this.nOpertingLineFrequency =
                machineResData.operatingLF === 0
                  ? 0
                  : machineResData.operatingLF.toFixed(1);
              this.operatingLineCurrent =
                machineResData.operating_ph_line_current === 0
                  ? 0
                  : machineResData.operating_ph_line_current.toFixed(2);
              this.operatingInputPower =
                machineResData.operating_input_power === 0
                  ? 0
                  : machineResData.operating_input_power.toFixed(2);
              this.loadProgress = ~~(
                (this.outputPower / this.maxRatedPower) *
                100
              );
            } else {
              this.EstOutputpower =
                EstOutputPower === 0 ? "N/A" : EstOutputPower;
            }
            if (JSON.parse(this.outputPower) > JSON.parse(this.maxRatedPower)) {
              this.outputPower = JSON.parse(this.maxRatedPower).toFixed(0);
            }
            if (this.loadProgress > 80 && this.loadProgress < 95) {
              this.loadingColor = "p_bar";
              this.loadingStatus = `Between 80-95% (Normal Loaded)`;
            } else if (this.loadProgress > 1 && this.loadProgress < 80) {
              this.loadingColor = "p_bar2";
              this.loadingStatus = `Below 80% (Under loaded)`;
            } else if (this.loadProgress > 95) {
              this.loadingColor = "p_bar3";
              this.loadingStatus = `Above 95% (Over loaded)`;
            } else {
              this.loadingStatus = "Not available";
              this.loadProgress = 0;
            }
          } else {
            this.rpm_pin = 0;
            this.operatingSyncRPM = 0;
            this.nOpertingLineFrequency = 0;
            this.operatingLineCurrent = 0;
            this.operatingInputPower = 0;
            this.loadProgress = 0;
            this.outputPower = 0;
            this.actualRPM = 0;
            this.maxRatedPower = 0;
            this.EstOutputpower = "N/A";
          }
          this.machineOperatingLoader = false;
          if (
            this.RPMObj.rpm_toggle === null ||
            this.RPMObj.rpm_toggle === "fixed"
          ) {
            this.maxRPMValue = null;
          } else {
            this.maxRPMValue = this.RPMObj.max_rated_rpm.toFixed(0);
          }
          this.minRPMValue = this.RPMObj.min_rated_rpm;
          if (
            JSON.parse(this.onoffStatus) === 0 ||
            JSON.parse(this.onoffStatus) === 2
          ) {
            this.rpm_pin = 0;
            this.operatingSyncRPM = 0;
            this.nOpertingLineFrequency = 0;
            this.operatingLineCurrent = 0;
            this.operatingInputPower = 0;
            this.loadProgress = 0;
            this.outputPower = 0;
            this.actualRPM = 0;
          } else {
            this.rpm_pin =
              this.actualRPM === 0 ? 0 : (this.actualRPM / 4000) * 100;
          }
          if (this.rpmLoadingGaudge.length == 0) {
            let loadingRPMOBJ = Object.assign({}, this.rpmGaudgeObj);
            loadingRPMOBJ["needleValue"] = this.loadProgress;
            this.rpmLoadingGaudge.push(loadingRPMOBJ);
          } else {
            this.rpmLoadingGaudge[0]["needleValue"] = this.loadProgress;
          }
          this.rpmStopReload = false;
        } else {
          //need to discuss
          this.pinion_gear_actual_rpm = response.rpm_pinion[0].actual_rpm;
          this.pinion_gear_actual_rpm = parseInt(
            this.pinion_gear_actual_rpm
          ).toFixed(0);
          this.outer_gear_actual_rpm = parseInt(
            response.rpm.actual_rpm
          ).toFixed(0);

          //Need to check RMP value if less then 400 then 1X Otherwise 10X for both charts.
          // Code Start.

          this.rpmValueClass = "";
          if (
            this.pinion_gear_actual_rpm != undefined &&
            this.pinion_gear_actual_rpm <= 400 &&
            this.pinion_gear_actual_rpm > 0 &&
            this.outer_gear_actual_rpm != undefined &&
            this.outer_gear_actual_rpm <= 400 &&
            this.outer_gear_actual_rpm > 0
          ) {
            this.rpmValueClass = "1x";
          } else if (
            this.pinion_gear_actual_rpm != undefined &&
            this.pinion_gear_actual_rpm > 400 &&
            this.outer_gear_actual_rpm != undefined &&
            this.outer_gear_actual_rpm > 400
          ) {
            this.rpmValueClass = "10x";
          } else {
            this.rpmValueClass = "1x";
          }

          // Code End.

          this.rpm_pinion_pin =
            response.rpm_pinion[0].actual_rpm === 0
              ? 0
              : (response.rpm_pinion[0].actual_rpm / 4000) * 100;
          this.rpm_outer_pin =
            response.rpm.actual_rpm === 0
              ? 0
              : (response.rpm.actual_rpm / 4000) * 100;
          if (
            JSON.parse(this.onoffStatus) === 0 ||
            JSON.parse(this.onoffStatus) === 2
          ) {
            this.rpm_pinion_pin = 0;
            this.rpm_outer_pin = 0;
            this.pinion_gear_actual_rpm = -1;
            this.outer_gear_actual_rpm = -1;
          }
          /***************PINION RPM DIAL******************* */
          if (this.pinionrpmshowgaudge.length == 0) {
            let pinionRPMOBJ = Object.assign({}, this.rpmGaudgeObj);
            pinionRPMOBJ["needleValue"] = this.rpm_pinion_pin;
            this.pinionrpmshowgaudge.push(pinionRPMOBJ);
          } else {
            this.pinionrpmshowgaudge[0]["needleValue"] = this.rpm_pinion_pin;
          }
          /***************OUTER RPM DIAL******************* */
          if (this.outer_rpmshowgaudge.length == 0) {
            let outerRPMOBJ = Object.assign({}, this.rpmGaudgeObj);
            outerRPMOBJ["needleValue"] = this.rpm_outer_pin;
            this.outer_rpmshowgaudge.push(outerRPMOBJ);
          } else {
            this.outer_rpmshowgaudge[0]["needleValue"] = this.rpm_outer_pin;
          }
          this.rpmStopReload = false;
        }
      }
      this.machineVibrationLoading = false;
    }
    this.machineVibrationLoading = false;
    this.stackchartvelocity();
  }

  findNextBigVal(mapValues, num) {
    let ans;
    for (let i = 0; i < mapValues.length; i++) {
      if (mapValues[i] > num) {
        ans = mapValues[i];
      }
    }
    return ans;
  }

  async goToPageLink(name: string) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pageRef: "managerAssets" === this.pageName ? "managerAssets" : "",
        tab1:true,
        tab2:this.productTab2,
        tab3:this.productTab3,
        tab4:this.productTab4,
        tabName:this.tabName
      },
    };
    localStorage.removeItem('tab')
    localStorage.removeItem('innertab')
    this.router.navigate([name], navigationExtras);
  }

  againStartUpdate() {
    let dataFreq = 600000;
    let self = this;
    self._timeOut = setInterval(function () {
      self.getGaugeDataByID();
      self.monitoringGaugeData();
      self.getMonitoringInfo();
      self.getAnomalyStatus();
    }, dataFreq);
  }
  //for bearing analysis tab
  forBearingAnalysisTab(){
    this.service.getData(this.baseAssetUrl + "assets/bearing_analysis/" + this.assetId)
      .then(res => {
        let response = JSON.parse(JSON.stringify(res)).data;
        console.log(response)
        if(response.status == "success"){
          if(response.body.bearing_analysis_key){
            this.AdvanceDiagnosticsDisabled = false;
          }else{
            this.AdvanceDiagnosticsDisabled = true;
          }
        }else{
          this.AdvanceDiagnosticsDisabled = true;
        }
      });
  }
  goToImageLink(url: string) {
    if (url !== undefined) {
      window.open(url, "_blank");
    }
  }

  checkOutOfServiceStatus(){
    this.service
    .getData(
      this.assetServiceUrl + `/under-service/${this.assetId}`
    ).then(res=>{
      if(JSON.parse(JSON.stringify(res)).data.status === "success"){
        if(JSON.parse(JSON.stringify(res)).data.body){
          this.isOutOfService = JSON.parse(JSON.stringify(res)).data.body.out_of_service =='yes'?true:false;
          this.outofservicedisable= JSON.parse(JSON.stringify(res)).data.body.out_of_service =='yes'?true:false;
          this.outOfServicedate = JSON.parse(JSON.stringify(res)).data.body.updated_at;
          this.outOfServicedate = new ConvertDatetimePipe().convertDateTime(
            this.outOfServicedate
          );
        }else{
          this.service.showError("Failed to fetch out for service status")
        }
      }
    }).catch(err=>{
      this.service.showError("Failed to fetch out for service status")
      console.log(err)
    })
  }
  onOutOfServiceChange(event){
    const isChecked = (event.target as HTMLInputElement).checked;
    (event.target as HTMLInputElement).checked = !(event.target as HTMLInputElement).checked;
    // this.isOutOfService=isChecked;
    this.fromDate = this.calendar.getToday();
    this.toDate = this.calendar.getNext(
      this.calendar.getToday(),
      "d",
      360
    );
    let lastServiceDate=`${(new Date()).getFullYear()}-${(new Date()).getMonth()}-${(new Date()).getDate()}`
    let nextServiceDate=`${(new Date()).getFullYear()+1}-${(new Date()).getMonth()}-${(new Date()).getDate()}`
   let reqObj={
    outOfServiceData:{
      asset_id: this.assetId,
      inventory_id: this.deviceId,
      last_service_date: lastServiceDate,
      next_service_date: nextServiceDate,
      service_detail: "OUT FOR SERVICE",
      last_service_performed: "OUT FOR SERVICE",
      service_performed_by: localStorage.getItem("user_name"),
      user_id: this.userID,
      service_category: "Planned Repair/Service",
      group_id: this.assetMasterInfo.group_id,
      new_out_of_service:isChecked==true?'yes':'no',
      db_out_of_service:this.isOutOfService,
      out_of_service:isChecked==true?'yes':'no'
    },
    auditData:{
      application:this.monitorInfo.application_name,
      site:this.monitorInfo.site_name,
      mac_address:this.mac_address,
      serial_number:this.serialNumber,
      doneBy:localStorage.getItem("user_name")
    }
   }
  //  console.log(reqObj)
   const dialogRef=this.dialog.open(DialogOverviewExampleDialogComponent, {
    width: "800px",
    maxWidth: "55vw",
    data: {
      type: "outOfServiceConfirmation",
      data:reqObj
    },
  });
  dialogRef.afterClosed().subscribe(result=>{
    if(result.isCancelled){
      this.isOutOfService=this.isOutOfService;
      (event.target as HTMLInputElement).checked = (event.target as HTMLInputElement).checked;
    }
    else if(result.newOutOfService) {
      this.isOutOfService=result.newOutOfService=='yes'?true:false;
      (event.target as HTMLInputElement).checked = result.newOutOfService=='yes'?true:false;
    }
  })
    /*
    SAMPLE OBJ TO SEND
    {
  "asset_id": "91",
  "inventory_id": "31",
  "last_service_date": "2024-10-16",
  "next_service_date": "2025-10-11",
  "service_detail": "Testingsfs",
  "last_service_performed": "Machine NDE Bearing repaired,Machine DE Bearing repaired,Electrical Unbalance Corrected",
  "service_performed_by": "sarthak",
  "user_id": "2",
  "service_category": "Planned Repair/Service",
  "group_id": "a4fd9595-037f-4a5d-bbb7-2f1202296541",
  "out_of_service": "no"
}
    */

  }
  masterRPMCheck(){
    // console.log(this.assetMasterInfo)
    let master =this.assetMasterInfo.connected_sensors[0]
    // console.log(master.id,master.inventory_id)
    this.service
      .getDataWithQuery(
        this.Fft_List +
          "/" +
          master.inventory_id +
          "/" +
          master.id +
          "?userid=" +
          this.userID +
          "&role=" +
          localStorage.getItem("role") +
          "&asset_type=" +
          master.asset_type
      ).then(async res=>{
        let response = JSON.parse(JSON.stringify(res)).data;
        if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
        }else if (response.status === "success") {

          if (response.body.length !== 0) {
            // console.log("In if case")
            let self = this;
           this.masterRPM=response?.body[0]?.actual_rpm.toFixed(0);
           this._line_frequency=response?.body[0]?.line_freq.toFixed(0);

            //Add this line for DiagnosticsArray without date format.
            // console.log( response.body);
          }else{
            // console.log("In else case")
           let  machineData = await this.service
              .getDataWithQuery(
                this.machineParamUrl +
                  "machine/parameters/" +
                  this.assetMasterInfo.inventory_id +
                  "/" +
                  this.assetMasterInfo.id +
                  "/" +
                  this.userID
                )
                .then((mRes) => {
                  return JSON.parse(JSON.stringify(mRes));
                });
                // console.log(machineData)
                // this.masterRPM=machineData.data.body[0].master_rpm.toFixed(0);
                this.masterRPM=machineData?.data?.body[0]?.actual_rpm.toFixed(0);
                this._line_frequency=machineData?.data?.body[0]?.line_freq.toFixed(0);
          }
        }
      })
  }
  showOutOfServiceDialogInitially(){
    const dialogRef=this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: "800px",
      maxWidth: "55vw",
      data: {
        type: "showOutOfServiceDialogInitially",
        serialNumber:this.monitorInfo.motor_serial_number
      },
    });

  }
  getAssetImage() {
    this.service
      .getData(
        this.imageAssetUploadUrl + "/" + this.assetId + "/" + this.mac_address
      )
      .then((response) => {
        if (JSON.parse(JSON.stringify(response)).data.body.length !== 0) {
          this._imgUrl = JSON.parse(
            JSON.stringify(response)
          ).data.body[0].relative_url;
        }
      });
  }

  gridLayout() {
    this.averageTableOff = true;
    this.getSensorCharts();
    this.getSensorTempCharts();
    this.getVelocityChart();
    if([2,3].includes(this.master_product_type))
      {
          this.getMachineAcousticsChart();
          this.getAudibleChart();
      }
        this.chartLayoutOn = true;
    this.listLayoutOn = false;
    this.downloadChartDataOn = false;
  }

  downloadChartData5() {
    this.tableListVelocityTrend(
      this.dataPreVelPoints1,
      this.dataPreVelPoints2,
      this.dataPreVelPoints3,
      this.dataPreVelPointsNew1,
      this.dataPreVelPointsNew2,
      this.dataPreVelPointsNew3
    );
    let csvArray = [];
    for (let time of this.tableVelocityTrendPred) {
      let obj = {
        time: time.d,
        Tangential: time.c1 === undefined ? "-" : time.c1,
        Axial: time.c2 === undefined ? "-" : time.c2,
        Radial: time.c3 === undefined ? "-" : time.c3,
        PredictionX: time.c4 === undefined ? "-" : time.c4,
        PredictionY: time.c5 === undefined ? "-" : time.c5,
        PredictionZ: time.c6 === undefined ? "-" : time.c6,
      };
      csvArray.push(obj);
    }
    new AngularCsv(
      csvArray,
      this.mac_address + "-VibrationTrendData",
      this.csvOptions5
    );
  }

  downloadChartData8() {
    this.listSensorVibrationNewChartData(
      this.dataVibPredPoints1,
      this.dataVibPredPoints2,
      this.dataVibPredPoints3,
      this.dataPreVibrationPointsNew1,
      this.dataPreVibrationPointsNew2,
      this.dataPreVibrationPointsNew3
    );
    let csvArray = [];
    for (let time of this.arrObjVibrationPred) {
      let obj = {
        time: time.d,
        Tangential: time.c1 === undefined ? "-" : time.c1,
        Axial: time.c2 === undefined ? "-" : time.c2,
        Radial: time.c3 === undefined ? "-" : time.c3,
        PredictionX: time.c4 === undefined ? "-" : time.c4,
        PredictionY: time.c5 === undefined ? "-" : time.c5,
        PredictionZ: time.c6 === undefined ? "-" : time.c6,
      };
      csvArray.push(obj);
    }
    new AngularCsv(
      csvArray,
      this.mac_address + "-VibrationTrendData",
      this.csvOptions8
    );
  }

  downloadAcousticsChartData() {
    this.listPreAcousticsChartData(
      this.dataAcoustics1,
      this.dataAcousticsPred1,
      [],
      [],
      [],
      []
    );
    const csvArray = [];
    for (let time of this.listPredAcousticsData1) {
      let obj = {
        time: time.d,
        "Delta Ultrasound": time.c1 === undefined ? "-" : time.c1,
        "Delta Ultrasound Prediction": time.c4 === undefined ? "-" : time.c4,
      };
      csvArray.push(obj);
    }
    new AngularCsv(
      csvArray,
      this.mac_address + "-MachineAcousticsTrendData",
      this.csvOptionsAcr
    );
  }

  async getalertsummmary() {
    this.currentdate = new Date();
    let currentdate = this.currentdate.toISOString();
    this.currentdate.setDate(this.currentdate.getDate() - 30);
    let old_date = this.currentdate.toISOString();
    let url = "";

    this.clientid = localStorage.getItem("user_id");
    this.role = localStorage.getItem("role");

    // if (this.role == "ADMIN") {
    //   url = `${this.ErrorLogService}/${old_date}/${currentdate}`;
    // } else {
    //   url =
    //     `${this.ErrorLogService}/${old_date}/${currentdate}` +
    //     "?clientid=" +
    //     this.clientid;
    // }
    // await this.service.loadnewData(url).then(async (response) => {
    //   let res = JSON.parse(JSON.stringify(response)).data.body;
    //   let data = JSON.parse(res);

    //   if (JSON.parse(JSON.stringify(response)).data.body == "[]") {
    //     this.showEmptyError = "No Reports Available for week!";
    //     this.checker = true;
    //   } else {
    //     this.checker = false;
    //     this.showEmptyError = "";
    //     this.reportDataArr = data;
    //   }
    // });
    let endpoint = this.alert24hrurl + "alert/errors/";
    this.errordata = [];
    await this.service
      .loadPannelData(
        `${endpoint}${this.userID}/${this.deviceId}/${this.assetId}/${this.mac_address}`
      )
      .then((response) => {
        let res = JSON.parse(JSON.stringify(response)).data.body.errors;

        if (res.length === 0) {
          this.noalertmessage = "No Alerts in last 24 hours";
        } else {
          this.errordata = res;
          for (let i = 0; i < this.errordata.length; i++) {
            let testDateUtc = moment.utc(this.errordata[i].time);

            let localDate = testDateUtc.local();
            let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(
              `${this.errordata[i].time}`
            );
            this.errordata[i].time = timeUpdatedAt;
            if (this.errordata[i].ack_time != "") {
              let ackDateUtc = moment.utc(this.errordata[i].ask_time);
              let localDate = ackDateUtc.local();
              let timeAckUpdate = new ConvertDatetimePipe().convertDateTime(
                ` ${this.errordata[i].ack_time}`
              );
              this.errordata[i].ack_time = timeAckUpdate;
            }
          }
          this.noalertmessage = "";
        }
      });
  }

  downloadChartData6() {
    this.listPreTempChartData(
      this.dataPreTempPoints1,
      this.dataPreTempPoints2,
      this.dataPreTempPoints3,
      this.dataPreTempPointsNew1,
      this.dataPreTempPointsNew2,
      this.dataPreTempPointsNew3
    );
    let csvArray = [];
    for (let time of this.listPredTempData1) {
      let obj = {
        time: time.d,
        Tangential: time.c1 === undefined ? "-" : time.c1,
        Axial: time.c2 === undefined ? "-" : time.c2,
        Radial: time.c3 === undefined ? "-" : time.c3,
        PredictionX: time.c4 === undefined ? "-" : time.c4,
        PredictionY: time.c5 === undefined ? "-" : time.c5,
        PredictionZ: time.c6 === undefined ? "-" : time.c6,
      };
      csvArray.push(obj);
    }
    new AngularCsv(
      csvArray,
      this.mac_address + "-TemperatureTrendData",
      this.csvOptions51
    );
  }

  downloadMachineSum() {
    let csvOptions = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalseparator: ".",
      showLabels: true,
      showTitle: true,
      title: "Machine Diagnostics Summary Report",
      useBom: true,
      noDownload: false,
      headers: [
        "",
        "",
        "Machine Parameter",
        "Value",
        "Parameter",
        "Acceptable Limits",
      ],
    };
    let array25 = [
      ...this.mySensFFTVelocity,
      ...this.mySensFFTTemperature,
      ...this.mySensFFTOrientation,
    ];
    new AngularCsv(
      array25,
      this.mac_address + "-Machine Diagnostics Summary",
      csvOptions
    );
  }

  listLayout() {
    this.averageTableOff = false;
    this.listSensorChartData();
    this.listLayoutOn = true;
    this.chartLayoutOn = false;
    this.downloadChartDataOn = false;
  }
  async listPreKurtChartData(
    data1,
    data2,
    data3
    // predData1,
    // predData2,
    // predData3
  ) {
    let self = this;
    var f_arr3;
    let f_arr = await Promise.all(
      data1.map(async function (f, fx) {
        let chartTime = self.getTimeOnly(f);
        return {
          d: chartTime,
          c1: f.y === null ? "" : f.y.toFixed(2),
          c2: data2[fx].y === null ? "" : data2[fx].y.toFixed(2),
          c3: data3[fx].y === null ? "" : data3[fx].y.toFixed(2),
        };
      })
    );

    // if (predData1 !== null) {
    //   let f_arr1 = await Promise.all(
    //     predData1.map(async function (f, fx) {
    //       let chartTime = self.getTimeOnly(f);
    //       return {
    //         d: chartTime,
    //         c4: f.y === null ? "" : f.y.toFixed(2),
    //         c5: predData2[fx].y === null ? "" : predData2[fx].y.toFixed(2),
    //         c6: predData3[fx].y === null ? "" : predData3[fx].y.toFixed(2),
    //       };
    //     })
    //   );
    //   f_arr3 = [...f_arr, ...f_arr1];
    // } else {
    //   f_arr3 = [...f_arr];
    // }
    this.listPredKurtData1 = this.mergeArrayTemp(f_arr, "d");
  }

  listKurtosisChartData() {}
  downloadChartData1() {
    this.listSensorChartData();
    for (let table1 = 0; table1 < this.listSenData.length; table1++) {
      if (this.listSenVelocityData1[table1] != undefined) {
        let obj = {
          Time_Stamp: this.listSenData === 0 ? "" : this.listSenData[table1].x,
          x: this.listSenData === 0 ? "" : this.listSenVelocityData1[table1].y,
          y: this.listSenData2 === 0 ? "" : this.listSenVelocityData2[table1].y,
          z: this.listSenData3 === 0 ? "" : this.listSenVelocityData3[table1].y,
          tangential: this.listSenData === 0 ? "" : this.listSenData[table1].y,
          axial: this.listSenData2 === 0 ? "" : this.listSenData2[table1].y,
          Radial: this.listSenData3 === 0 ? "" : this.listSenData3[table1].y,
          DE_Bearing:
            this.listTempData1 === 0 ? "" : this.listTempData1[table1].y,
          "Machine Skin":
            this.listTempData2 === 0 ? "" : this.listTempData2[table1].y,
          "NDE Bearing":
            this.listTempData3 === 0 ? "" : this.listTempData3[table1].y,
          dB:
            this.acousticsDataPoints1[table1] === undefined
              ? ""
              : this.acousticsDataPoints1[table1].y,
        };
        this.dtDataForCSVARRAY.push(obj);
      }
    }
    new AngularCsv(
      this.dtDataForCSVARRAY,
      this.mac_address + "-Monitoring",
      this.csvOptions1
    );
  }

  showMoreChart(selVal) {
    if (selVal === "more") {
      this.moreChartsVisible = true;
      this.showTextOn = "less";
    } else {
      this.moreChartsVisible = false;
      this.showTextOn = "more";
    }
  }

  listSensorChartData() {
    let self = this;
    this.listSenVelocityData1 = this.velocityDataPoints1.map(function (
      val,
      index
    ) {
      let dTime = self.getTimeOnly(val);
      return {
        key: index,
        x: dTime,
        y: val.y === null ? "-" : val.y.toFixed(2),
      };
    });
    this.listSenVelocityData2 = this.velocityDataPoints2.map(function (
      val,
      index
    ) {
      return { key: index, y: val.y === null ? "-" : val.y.toFixed(2) };
    });
    this.listSenVelocityData3 = this.velocityDataPoints3.map(function (
      val,
      index
    ) {
      return { key: index, y: val.y === null ? "-" : val.y.toFixed(2) };
    });
    this.listSenData = this.dataPoints1.map(function (val, index) {
      let dTime = self.getTimeOnly(val);
      return {
        key: index,
        x: dTime,
        y: val.y === null ? "-" : val.y.toFixed(2),
      };
    });
    this.listSenData2 = this.dataPoints2.map(function (val, index) {
      return { key: index, y: val.y === null ? "-" : val.y.toFixed(2) };
    });
    this.listSenData3 = this.dataPoints3.map(function (val, index) {
      return { key: index, y: val.y === null ? "-" : val.y.toFixed(2) };
    });
    this.listTempData1 = this.dataTemperaturePoints1.map(function (val, index) {
      return { key: index, y: val.y === null ? "-" : val.y.toFixed(2) };
    });
    this.listTempData2 = this.dataTemperaturePoints2.map(function (val, index) {
      return { key: index, y: val.y === null ? "-" : val.y.toFixed(2) };
    });
    this.listTempData3 = this.dataTemperaturePoints3.map(function (val, index) {
      return { key: index, y: val.y === null ? "-" : val.y.toFixed(2) };
    });
    this.listOrienData1 = this.dataOrientationPoints1.map(function (
      val,
      index
    ) {
      return { key: index, y: val.y === null ? "-" : val.y.toFixed(2) };
    });
    this.listOrienData2 = this.dataOrientationPoints2.map(function (
      val,
      index
    ) {
      return { key: index, y: val.y === null ? "-" : val.y.toFixed(2) };
    });
    this.listOrienData3 = this.dataOrientationPoints3.map(function (
      val,
      index
    ) {
      return { key: index, y: val.y === null ? "-" : val.y.toFixed(2) };
    });
    this.listAcousticsData3 = this.acousticsDataPoints1.map(function (
      val,
      index
    ) {
      return { key: index, y: val.y === null ? "-" : val.y.toFixed(2) };
    });
  }

  preMachineAcousticsGridLayout() {
    this.getPredictiveMachineAcousticsChart();
    this.predictiveAcousticsChartOn = true;
    this.predictiveAcousticsListOn = false;
  }

  preMachineAcousticsListLayout() {
    this.listPreAcousticsChartData(
      this.dataAcoustics1,
      this.dataAcousticsPred1,
      [],
      [],
      [],
      []
    );
    this.predictiveAcousticsChartOn = false;
    this.predictiveAcousticsListOn = true;
  }

  preTempgridLayout() {
    this.getPredictiveTempChart();
    this.predictiveTempOn = true;
    this.preTempListLayoutOn = false;
  }

  preTemplistLayout() {
    this.listPreTempChartData(
      this.dataPreTempPoints1,
      this.dataPreTempPoints2,
      this.dataPreTempPoints3,
      this.dataPreTempPointsNew1,
      this.dataPreTempPointsNew2,
      this.dataPreTempPointsNew3
    );
    this.predictiveTempOn = false;
    this.preTempListLayoutOn = true;
  }

  async listPreTempChartData(
    data1,
    data2,
    data3,
    predData1,
    predData2,
    predData3
  ) {
    let self = this;
    var f_arr3;
    let f_arr = await Promise.all(
      data1.map(async function (f, fx) {
        let chartTime = self.getTimeOnly(f);
        return {
          d: chartTime,
          c1: f.y === null ? "" : f.y.toFixed(2),
          c2: data2[fx].y === null ? "" : data2[fx].y.toFixed(2),
          c3: data3[fx].y === null ? "" : data3[fx].y.toFixed(2),
        };
      })
    );
    if (predData1 !== null) {
      let f_arr1 = await Promise.all(
        predData1.map(async function (f, fx) {
          let chartTime = self.getTimeOnly(f);
          return {
            d: chartTime,
            c4: f.y === null ? "" : f.y.toFixed(2),
            c5: predData2[fx].y === null ? "" : predData2[fx].y.toFixed(2),
            c6: predData3[fx].y === null ? "" : predData3[fx].y.toFixed(2),
          };
        })
      );
      f_arr3 = [...f_arr, ...f_arr1];
    } else {
      f_arr3 = [...f_arr];
    }
    this.listPredTempData1 = this.mergeArrayTemp(f_arr3, "d");
  }
  async listPreAcousticsChartData(
    data1,
    data2,
    data3,
    predData1,
    predData2,
    predData3
  ) {
    let self = this;
    var f_arr3;
    let f_arr = await Promise.all(
      data1.map(async function (f, fx) {
        let chartTime = self.getTimeOnly(f);
        return {
          d: chartTime,
          c1: f.y === null ? "" : f.y.toFixed(2),
          c2: "",
          c3: "",
        };
      })
    );
    if (data2 !== null) {
      let f_arr1 = await Promise.all(
        data2.map(async function (f, fx) {
          let chartTime = self.getTimeOnly(f);
          return {
            d: chartTime,
            c4: f.y === null ? "" : f.y.toFixed(2),
            c5: "",
            c6: "",
          };
        })
      );
      f_arr3 = [...f_arr, ...f_arr1];
    } else {
      f_arr3 = [...f_arr];
    }
    this.listPredAcousticsData1 = this.mergeArrayTemp(f_arr3, "d");
  }

  async listdiagKurtChartData(
    data1,
    data2,
    data3,
    predData1,
    predData2,
    predData3
  ) {
    let self = this;
    var f_arr3;
    let f_arr = await Promise.all(
      data1.map(async function (f, fx) {
        let chartTime = self.getTimeOnly(f);
        return {
          d: chartTime,
          c1: f.y === null ? "" : f.y.toFixed(2),
          c2: data2[fx].y === null ? "" : data2[fx].y.toFixed(2),
          c3: data3[fx].y === null ? "" : data3[fx].y.toFixed(2),
        };
      })
    );
    if (predData1 !== null) {
      let f_arr1 = await Promise.all(
        predData1.map(async function (f, fx) {
          let chartTime = self.getTimeOnly(f);
          return {
            d: chartTime,
            c4: f.y === null ? "" : f.y.toFixed(2),
            c5: predData2[fx].y === null ? "" : predData2[fx].y.toFixed(2),
            c6: predData3[fx].y === null ? "" : predData3[fx].y.toFixed(2),
          };
        })
      );
      f_arr3 = [...f_arr, ...f_arr1];
    } else {
      f_arr3 = [...f_arr];
    }
    //this.listPredKurtData1 = this.mergeArrayTemp(f_arr3, "d");
  }

  preKurtosisLayout() {
    this.getPredictiveKurtChart();
    this.predictiveKurtOn = true;
    this.preKurtosisListLayoutOn = false;
  }

  preKurtlistLayout() {
    this.listPreKurtChartData(
      this.dataPreKurtPoints1,
      this.dataPreKurtPoints2,
      this.dataPreKurtPoints3
      // this.dataPreKurtPointsNew1,
      // this.dataPreKurtPointsNew2,
      // this.dataPreKurtPointsNew3
    );

    this.predictiveKurtOn = false;
    this.preKurtosisListLayoutOn = true;
  }

  OnClickAlert(report) {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: "400px",
      maxWidth: "85vw",
      data: {
        type: "AlertBookOpen",
        data: {
          assetid: this.assetId,
          clientid: this.clientid,
          report: report,
        },
      },
    });
  }
  //For kurtosis Diagnostic
  KurtosisLayout() {
    this.getdiagKurtChart(this.fftIdforAdvance);
    this.diagKurtOn = true;
    this.diagKurtOff = false;
    //this.diagKurtListLayoutOn = false;
  }
  KurtosislistLayout() {
    this.diagKurtListLayoutOn = true;
    this.diagKurtOff = true;
    this.diagKurtOn = false;

    this.listdiagKurtChartData(
      this.datadiagKurtPoints1,
      this.datadiagKurtPoints2,
      this.datadiagKurtPoints3,
      this.dataPreKurtPointsNew1,
      this.dataPreKurtPointsNew2,
      this.dataPreKurtPointsNew3
    );
  }

  downloadChartData7() {
    this.listPreKurtChartData(
      this.dataPreKurtPoints1,
      this.dataPreKurtPoints2,
      this.dataPreKurtPoints3
      // this.dataPreKurtPointsNew1,
      // this.dataPreKurtPointsNew2,
      // this.dataPreKurtPointsNew3
    );

    let csvArray = [];

    for (let time of this.listPredKurtData1) {
      let obj = {
        time: time.d,
        Radial: time.c1 === undefined ? "-" : time.c1,
        Tangential: time.c2 === undefined ? "-" : time.c2,
        Axial: time.c3 === undefined ? "-" : time.c3,
      };
      csvArray.push(obj);
    }
    new AngularCsv(
      csvArray,
      this.mac_address + "-KurtosisNumberData",
      this.csvOptionsKurt9
    );
  }

  getPredictiveKurtChart() {
    this.KurtNumloader = true;
    this.service
      .getDataV2(
        // this.KurtosisNumberData +
        //   parseInt(this.userID) +
        //   "/" +
        //   parseInt(this.deviceId) +
        //   "/" +
        //   parseInt(this.assetId) +
        //   "/" +
        //   this.valueTypekurt
        this.diagnosticsBearingAnalysisGraphAPI +
          parseInt(this.userID) +
          "/" +
          parseInt(this.deviceId) +
          "/" +
          parseInt(this.assetId) +
          "/" +
          this.valueTypekurt
          // "day"
      )
      .then((res) => {
        let newData = JSON.parse(JSON.stringify(res));

        if (newData.data == undefined) {
          newData.data = newData.body;
          delete newData.body;
        }
        this.emptyMsgKurtNum = false;
        if (JSON.parse(JSON.stringify(res)).status === "fail") {
          this.KurtNumloader = false;
          this.emptyMsgKurtNum = false;
          this.advCrestFactor = true;
        }
        if (newData.status === "success") {
          if (newData.message == "No Data Available for given params") {
            this.KurtNumloader = false;
            this.emptyMsgKurtNum = false;
            this.advCrestFactor = true;
          } else if (newData.data.chartXData !== null) {
            this.emptyMsgKurtNum = true;
            this.KurtNumloader = false;
            let tempArr = [];
            tempArr.push({ name: newData.data.labelx });
            tempArr.push({ name: newData.data.labely });
            tempArr.push({ name: newData.data.labelz });
            let labels = this.imposeRtdKurtOrdering(tempArr);
            let lablePreKurtX = labels[0].name;
            let lablePreKurtY = labels[1].name;
            let lablePreKurtZ = labels[2].name;
            this.advCrestFactor = false;

            this.dataPreKurtPoints1 = JSON.parse(
              JSON.stringify(res)
            ).body.chartXData.map(function (val, index) {
              let arr1: any = val.x.split(/[- :]/);
              let time1A = new Date(
                arr1[0],
                arr1[1] - 1,
                arr1[2],
                arr1[3],
                arr1[4],
                arr1[5]
              );
              let x = time1A;
              let y = val.y;
              return { x, y };
            });

            this.dataPreKurtPoints2 = newData.data.chartYData.map(function (
              val,
              index
            ) {
              let arr1: any = val.x.split(/[- :]/);
              let time2A = new Date(
                arr1[0],
                arr1[1] - 1,
                arr1[2],
                arr1[3],
                arr1[4],
                arr1[5]
              );
              let x = time2A;
              let y = val.y;
              return { x, y };
            });

            this.dataPreKurtPoints3 = newData.data.chartZData.map(function (
              val,
              index
            ) {
              let arr1: any = val.x.split(/[- :]/);
              let time3A = new Date(
                arr1[0],
                arr1[1] - 1,
                arr1[2],
                arr1[3],
                arr1[4],
                arr1[5]
              );
              let x = time3A;
              let y = val.y;
              return { x, y };
            });
            this.x_kurtosis = this.dataPreKurtPoints1[this.dataPreKurtPoints1.length-1].y.toFixed(2);
            this.y_kurtosis = this.dataPreKurtPoints2[this.dataPreKurtPoints2.length-1].y.toFixed(2);
            this.z_kurtosis = this.dataPreKurtPoints3[this.dataPreKurtPoints3.length-1].y.toFixed(2);
            this.min_g = newData.data.min || 0;
            this.max_g = localStorage.getItem("kurt_threshold")
              ? Number(localStorage.getItem("kurt_threshold"))
              : 4;
            this.max_y = newData.data.yellow;
            this.max_r = (this.max_g+(this.max_g*0.5)).toFixed(1);
            // this.max_y = parseFloat((this.max_g+(this.max_g*0.5)).toFixed(2));
            // this.max_r = parseFloat((this.max_g+(this.max_g*0.5)).toFixed(2))
            this.listPreKurtChartData(
              this.dataPreKurtPoints1,
              this.dataPreKurtPoints2,
              this.dataPreKurtPoints3
              // this.dataPreKurtPointsNew1,
              // this.dataPreKurtPointsNew2,
              // this.dataPreKurtPointsNew3
            );
            let fftLineData = this.kurtosisMarkersData.map(function (
              val,
              index
            ) {
              let arr1: any = val.label.split(/[- :]/);
              let time1A = new Date(
                arr1[0],
                arr1[1] - 1,
                arr1[2],
                arr1[3],
                arr1[4],
                arr1[5]
              );
              let x = time1A;
              let y = 3;
              return {
                x,
                y,
                fftId: val.value,
                indexLabel: "FFT",
                markerType: "triangle",
                markerColor: "tomato",
                markerSize: 28,
                click: (e) => {
                  self.takeselectedEnvelopAnalysis("", val.value);
                },
              };
            });

            let kurt_fft_marker=[]
            let startDate=this.dataPreKurtPoints1[0].x;
            let endDate=this.dataPreKurtPoints1[this.dataPreKurtPoints1.length-1].x;
            fftLineData.forEach(val=>{
              if(new Date(val.x) > new Date(startDate) && new Date(val.x) < new Date(endDate)){
                kurt_fft_marker.push(val)
              }else{
                console.log("FFT MARKER NOT FOUND");
              }
            })
            let self = this;
            if (
              document.getElementById("predictiveKurtChartContainer") !== null
            ) {
              let feedDataToArray = [];
              feedDataToArray.push({
                data: this.dataPreKurtPoints1,
                lineDashType: "",
                label: lablePreKurtX,
                legendMarkerType: "none",
                key: lablePreKurtX.trim(),
              });
              feedDataToArray.push({
                data: this.dataPreKurtPoints2,
                lineDashType: "",
                label: lablePreKurtY,
                legendMarkerType: "none",
                key: lablePreKurtY.trim(),
              });
              feedDataToArray.push({
                data: this.dataPreKurtPoints3,
                lineDashType: "",
                label: lablePreKurtZ,
                legendMarkerType: "none",
                key: lablePreKurtZ.trim(),
              });
              feedDataToArray.push({
                data: kurt_fft_marker,
                lineDashType: "",
                label: "Envelop Analysis",
                legendMarkerType: "none",
                key: lablePreKurtZ.trim(),
              });
              // this.changeOrder(
              //   ["Radial (Horizontal)", "Tangential (Vertical)", "Axial"],
              //   feedDataToArray
              // );
              let dataAd = this.makeDataForChart(feedDataToArray);
              let predChartFour = cloneDeep(monitoringVelocityObject);
              predChartFour.data = [];
              predChartFour.charts[0].axisY.maximum = this.max_r;
              predChartFour.charts[0].axisY.minimum = 0;
              predChartFour.charts[0].data = dataAd;
              predChartFour.navigator.data = dataAd;
              // predChartFour.unit = " ";
              // predChartFour.myValue = this.statusKurtPredictionValues;
              predChartFour.data = this.makeDataForChart(feedDataToArray);
              this.predictiveKurtChart = new CanvasJS.StockChart(
                "predictiveKurtChartContainer",
                predChartFour
              );
              setTimeout(() => {
                this.predictiveKurtChart.render();
                this.predictiveKurtChart.charts[0].axisY[0].addTo("stripLines", {
                  value: this.max_g,
                  label: this.max_g,
                  color: this.greenColor,
                  labelFontColor: "#000000",
                });

                //Change color green
                this.predictiveKurtChart.charts[0].axisY[0].addTo(
                  "stripLines",
                  this.addBackgroundColor(this.min_g, this.max_g, this.greenColor)
                );

                this.predictiveKurtChart.charts[0].axisY[0].addTo("stripLines", {
                  value: this.max_g,
                  label: this.max_g,
                  color: this.greenColor,
                  labelFontColor: "#000000",
                });
                //Change yellow
                this.predictiveKurtChart.charts[0].axisY[0].addTo("stripLines", {
                  value: this.max_y,
                  label: this.max_y,
                  color: this.yellowColor,
                  labelFontColor: "#000000",
                });

                //Change color yellow
                this.predictiveKurtChart.charts[0].axisY[0].addTo(
                  "stripLines",
                  this.addBackgroundColor(
                    this.max_g,
                    this.max_y,
                    this.yellowColor
                  )
                );
                //Change red
                this.predictiveKurtChart.charts[0].axisY[0].addTo("stripLines", {
                  value: this.max_r,
                  label: this.max_r,
                  color: this.yellowColor,
                  labelFontColor: "#000000",
                });

                //Change red
                this.predictiveKurtChart.charts[0].axisY[0].addTo(
                  "stripLines",
                  this.addBackgroundColor(
                    this.max_y,
                    this.max_r,
                    this.yellowColor
                  )
                );
              }, 500);

              // this.predictiveKurtChart.axisY[0].addTo(
              //   "stripLines",
              //   this.addBackgroundColor(this.min_g, this.max_g, this.greenColor)
              // );
              //Change yellow
              // console.log("predictiveKurtChart", this.predictiveKurtChart);
              // console.log("predictiveKurtChart", this.predictiveKurtChart.charts[0]);
              // console.log("predictiveKurtChart", this.predictiveKurtChart.charts[0].axisY[0]);
            }
          } else {
            this.KurtNumloader = false;
            this.emptyMsgKurtNum = false;
          }
        } else {
          this.KurtNumloader = false;
          this.emptyMsgKurtNum = false;
        }
      });
  }
  //Predictive kurtosis ends
  Showtrendsgraph() {
    if (this.TrendzchartOn == true) {
      this.TrendzchartOn = false;
      this.listLayoutOn = false;
      this.trendsgraph = "Show Trend Chart";
    } else {
      this.TrendzchartOn = true;
      this.trendsgraph = "Hide Trend Chart";
      this.gridLayout();
      // this.getSensorCharts();
      // this.getSensorTempCharts();
      // this.getVelocityChart();
      // this.getMachineAcousticsChart();
      // this.getAudibleChart();
    }
  }
  getdiagKurtChart(fftUUID) {
    this.emptyMsgAlertKurt2 = true;
    if (fftUUID !== undefined) {
      try {
        this.showDiagnosticChartEmpty = true;
        this.service
          .getDataWithQuery(
            // this.KurtosisData + "/" + fftUUID
            this.diagnosticsEnvelopAnalysisChartAPI +  fftUUID
          )
          .then((res) => {
            this.emptyMsgAlertKurt2 = false;
            if (JSON.parse(JSON.stringify(res)).status === "fail") {
              this.showDiagnosticChartEmpty = false;
              this.emptyMsgAlertKurt2 = true;
              this.envelopAnalysisError =
                "Bearings are healthy based on advance bearing health analysis.";
            } else if (JSON.parse(JSON.stringify(res)).status === "success") {
              if (
                JSON.parse(JSON.stringify(res)).message ==
                "No Data Available for given raw matric id"
              ) {
                this.showDiagnosticChartEmpty = false;
                this.emptyMsgAlertKurt2 = true;
                this.envelopAnalysisError =
                  "Bearings are healthy based on advance bearing health analysis.";
              } else {
                this.fftCreateAt = moment.utc(
                  JSON.parse(JSON.stringify(res)).data.create_at
                );
                let localDate = this.fftCreateAt.local();

                this.fftCreateAt = new ConvertDatetimePipe().convertDateTime(
                  localDate
                );
                this.create_at_fft = new ConvertDatetimePipe().convertDateTime(
                  this.fftCreateAt
                );
                // this.create_at_fft = new ConvertDatetimePipe().convertDateTime(fftCreateAt);
                //this.errorMessage = JSON.parse(JSON.stringify(res)).data.errorMessage;
                this.showDiagnosticChartEmpty = false;
                this.emptyMsgAlertKurt2 = false;

                let lablediagKurtX = JSON.parse(JSON.stringify(res)).data
                  .plottingData.labelx;
                let lablediagKurtY = JSON.parse(JSON.stringify(res)).data
                  .plottingData.labely;
                let lablediagKurtZ = JSON.parse(JSON.stringify(res)).data
                  .plottingData.labelz;

                this.dataPreKurtPointsNew1 = null;
                this.dataPreKurtPointsNew2 = null;
                this.dataPreKurtPointsNew3 = null;

                this.datadiagKurtPoints1 = JSON.parse(
                  JSON.stringify(res)
                ).data.plottingData.chartXData;
                this.datadiagKurtPoints2 = JSON.parse(
                  JSON.stringify(res)
                ).data.plottingData.chartYData;
                this.datadiagKurtPoints3 = JSON.parse(
                  JSON.stringify(res)
                ).data.plottingData.chartZData;

                // .map(function (val, index) {
                //   let x=val.x
                //   let y = val.y;
                //   return { x, y };
                // });
                //to be discussed
                this.min_g =
                  JSON.parse(JSON.stringify(res)).data.plottingData.min || 0;
                this.max_g = JSON.parse(JSON.stringify(res)).data.plottingData
                  .green
                  ? JSON.parse(JSON.stringify(res)).data.plottingData.green
                  : 3;
                this.max_y = JSON.parse(JSON.stringify(res)).data.plottingData
                  .yellow
                  ? JSON.parse(JSON.stringify(res)).data.plottingData.yellow
                  : 5;
                this.max_r = JSON.parse(JSON.stringify(res)).data.plottingData
                  .red
                  ? JSON.parse(JSON.stringify(res)).data.plottingData.red
                  : 7;

                this.listdiagKurtChartData(
                  this.datadiagKurtPoints1,
                  this.datadiagKurtPoints2,
                  this.datadiagKurtPoints3,
                  this.dataPreKurtPointsNew1,
                  this.dataPreKurtPointsNew2,
                  this.dataPreKurtPointsNew3
                );
                this.showOverAllStatusSummary();
                if (
                  document.getElementById("KurtosisSpectraChartContainer") !==
                  null
                ) {
                  let fftChartObj = cloneDeep(fftChartObject);
                  let feedDataToArray = [];
                  let rpmvalue: any = "";
                  let RPMGraphValueUpto8x: any = [];
                  if (this.assetType == "GEAR") {
                    if (
                      this.pinion_gear_actual_rpm != undefined &&
                      this.pinion_gear_actual_rpm > 0
                    ) {
                      //rpmvalue = this.pinionrpmshowgaudge[0].needleValue;
                      rpmvalue = this.pinion_gear_actual_rpm;
                    }
                  } else {
                    rpmvalue = this._actualrpm;
                  }
                  // console.log(rpmvalue,typeof rpmvalue)
                  if (rpmvalue != undefined && rpmvalue >= 0) {
                    RPMGraphValueUpto8x[0] = rpmvalue / 60;
                  }
                  if (RPMGraphValueUpto8x[0] != undefined) {
                    RPMGraphValueUpto8x[1] =
                      RPMGraphValueUpto8x[0].toFixed(2) * 2;
                    RPMGraphValueUpto8x[2] =
                      RPMGraphValueUpto8x[0].toFixed(2) * 3;
                    RPMGraphValueUpto8x[3] =
                      RPMGraphValueUpto8x[0].toFixed(2) * 4;
                    RPMGraphValueUpto8x[4] =
                      RPMGraphValueUpto8x[0].toFixed(2) * 5;
                    RPMGraphValueUpto8x[5] =
                      RPMGraphValueUpto8x[0].toFixed(2) * 6;
                    RPMGraphValueUpto8x[6] =
                      RPMGraphValueUpto8x[0].toFixed(2) * 7;
                  }
                  let bearingFreqValLines = [];
                  if (this.bearingFreqVal.length > 0) {
                    bearingFreqValLines = this.bearingFreqVal.flatMap(
                      (obj) => obj.values
                    );
                  }
                  feedDataToArray.push({
                    data: this.datadiagKurtPoints1,
                    lineDashType: "",
                    label: "Radial(Horizontal)",
                    legendMarkerType: "none",
                  });
                  feedDataToArray.push({
                    data: this.datadiagKurtPoints2,
                    lineDashType: "",
                    label: "Tangential(Vertical)",
                    legendMarkerType: "none",
                  });
                  feedDataToArray.push({
                    data: this.datadiagKurtPoints3,
                    lineDashType: "",
                    label: "Axial",
                    legendMarkerType: "none",
                  });
                  fftChartObj.charts[0].axisX.interval = 100;
                  fftChartObj.charts[0].axisY["minimum"] = 0;
                  fftChartObj.charts[0].axisX["title"] = "Frequency (Hz)";
                  fftChartObj.charts[0].data = [];
                  fftChartObj.charts[0].unit = "";
                  fftChartObj.charts[0].myValue = "kurtosis";
                  fftChartObj.charts[0].data =
                    this.makeFFTDataForChart(feedDataToArray);
                  fftChartObj.navigator.data =
                    this.makeFFTDataForChart(feedDataToArray);

                  /* Strip lines upto 8x array */
                  let stripLines8x = [
                    {
                      value: RPMGraphValueUpto8x[0],
                      color: "red",
                      thickness: 1,
                      label: RPMGraphValueUpto8x[0].toFixed(2) + " (1x)",
                    },
                    {
                      value: RPMGraphValueUpto8x[1],
                      color: "yellow",
                      thickness: 1,
                      label: RPMGraphValueUpto8x[1].toFixed(2) + " (2x)",
                    },
                    {
                      value: RPMGraphValueUpto8x[2],
                      color: "green",
                      thickness: 1,
                      label: RPMGraphValueUpto8x[2].toFixed(2) + " (3x)",
                    },
                    {
                      value: RPMGraphValueUpto8x[3],
                      color: "orange",
                      thickness: 1,
                      label: RPMGraphValueUpto8x[3].toFixed(2) + " (4x)",
                    },
                    {
                      value: RPMGraphValueUpto8x[4],
                      color: "gray",
                      thickness: 1,
                      label: RPMGraphValueUpto8x[4].toFixed(2) + " (5x)",
                    },
                    {
                      value: RPMGraphValueUpto8x[5],
                      color: "black",
                      thickness: 1,
                      label: RPMGraphValueUpto8x[5].toFixed(2) + " (6x)",
                    },
                    {
                      value: RPMGraphValueUpto8x[6],
                      color: "red",
                      thickness: 1,
                      label: RPMGraphValueUpto8x[6].toFixed(2) + " (7x)",
                    },
                  ];
                  let bearingStripLine = [];
                  if (bearingFreqValLines.length) {
                    this.bearingStripLine = bearingFreqValLines.map(
                      (val, i) => {
                        return {
                          value: bearingFreqValLines[i],
                          color: "black",
                          thickness: 2,
                          label: bearingFreqValLines[i],
                        };
                      }
                    );
                  }
                  /* If 1x is only selected show frequencies upto 8x */
                  if (
                    RPMGraphValueUpto8x.length > 0 &&
                    this.rmptoggleEnvelop == true &&
                    this.bFreqtoggleEnvelop == false
                  ) {
                    fftChartObj.charts[0].axisX.stripLines = stripLines8x;
                  } else if (
                    /* If only Bearing frequency is selected */
                    bearingFreqValLines.length > 0 &&
                    this.bFreqtoggleEnvelop == true &&
                    this.rmptoggleEnvelop == false
                  ) {
                    fftChartObj.charts[0].axisX.stripLines =
                      this.bearingStripLine;
                  } else if (
                    /* If both are selected */
                    bearingFreqValLines.length > 0 &&
                    RPMGraphValueUpto8x.length > 0 &&
                    this.bFreqtoggleEnvelop == true &&
                    this.rmptoggleEnvelop == true
                  ) {
                    fftChartObj.charts[0].axisX.stripLines = [
                      ...stripLines8x,
                      ...this.bearingStripLine,
                    ];
                  } else {
                    fftChartObj.charts[0].axisX.stripLines = [];
                  }
                  this.magneticFieldSpecChart = new CanvasJS.StockChart(
                    "KurtosisSpectraChartContainer",
                    fftChartObj
                  );
                  setTimeout(() => {
                    this.magneticFieldSpecChart.render();
                  }, 1000);

                }
              }
            } else {
              this.magnetFieldNoDataMsg = "No data available.";
              this.showDiagnosticChartEmpty = true;
            }
          })
          .catch((err) => {
            // console.log("ERRRRRORRRR");
            // console.log(err);
          });
      } catch (err) {}
    } else {
      this.emptyMsgAlertKurt2 = true;
      this.envelopAnalysisError =
        "Bearings are healthy based on advance bearing health analysis";
    }
  }


  loadFftAdvanceDiag(value) {
    this.fftIdforAdvance = value;
    //this.selectedFFTAdvance=this.AdvanceDiagFftData;
    this.advuuid = this.AdvanceDiagFftData.filter(
      (id) => id.value == value
    )[0].uuid;
    this.diagChartType = "kurtosis";
    this.getdiagKurtChart(this.fftIdforAdvance);
    // this.diagnosticsSummary(this.selectedFFTUID, this.fftIdforAdvance, true);
    this.getDiagnosticsSummary(this.selectedFFTUID, this.fftIdforAdvance, true);
    // this.kurtosisNumAdvanceDiagnostics(this.advuuid);
  }

  // kurtosisNumAdvanceDiagnostics(val) {
  //   if (val !== undefined) {
  //     this.service
  //       .getDataWithQuery(`${this.fftforAdvanceDiag}v1/kurtosis-numbers/${val}`)
  //       .then((res) => {
  //         if (JSON.parse(JSON.stringify(res)).status == "fail") {
  //           this.advCrestFactor = true;
  //         } else if (JSON.parse(JSON.stringify(res)).status == "success") {
  //           let response = JSON.parse(JSON.stringify(res)).body;
  //           if (JSON.parse(JSON.stringify(res)).body.length != 0) {
  //             this.advCrestFactor = false;
  //             this.x_kurtosis = response.x_kurtosis;
  //             this.y_kurtosis = response.y_kurtosis;
  //             this.z_kurtosis = response.z_kurtosis;
  //           } else {
  //             this.advCrestFactor = true;
  //           }
  //         }
  //       });
  //   }
  // }
  //end diagnostic kurtosis

  mergeArrayTemp(array, property) {
    const newArray = new Map();
    array.forEach((item) => {
      const propertyValue = item[property];
      newArray.has(propertyValue)
        ? newArray.set(propertyValue, {
            ...item,
            ...newArray.get(propertyValue),
          })
        : newArray.set(propertyValue, item);
    });

    return Array.from(newArray.values());
  }

  freqChartLayout() {
    this.getFrequentChart(this.selectedFFTUID, this.xAxisScaleTypeGlobal);
    this.freqChartViewOn = true;
    this.freqChartViewOff = false;
  }

  frqlistLayout() {
    this.listFrequencyChartData();
    this.freqChartViewOff = true;
    this.freqChartViewOn = false;
  }
  public aalertSettings(): void {
    const alertDialogRef = this.dialog.open(
      DialogOverviewExampleDialogComponent,
      {
        width: "1220px",
        maxWidth: "100%",
        disableClose: false,
        data: {
          sitename: this.siteName,
          appplicationname: this.applicationNme,
          assetId: this.assetId,
          type: "AlertSettingsforasset",
          clientId: localStorage.getItem("user_id"),
        },
      }
    );
  }
  listFrequencyChartData() {
    let self = this;
    this.listFreqData1 = [];
    this.listFreqData2 = [];
    this.listFreqData3 = [];
    this.listFreqData1 = this.datafrequentPoints1.map(function (val, index) {
      return { key: index, x: val.x.toFixed(1), y: val.y };
    });

    this.listFreqData2 = this.datafrequentPoints2.map(function (val, index) {
      return { key: index, y: val.y };
    });

    this.listFreqData3 = this.datafrequentPoints3.map(function (val, index) {
      return { key: index, y: val.y };
    });
  }

  //for Diagnostics vibration -acceleration chart
  accChartLayout() {
    this.getNewAccFrequentChart(this.selectedFFTUID);
    this.accChartViewOn = true;
    this.accChartViewOff = false;
  }
  acclistLayout() {
    this.listAccelerationChartData();
    this.accChartViewOff = true;
    this.accChartViewOn = false;
  }
  listAccelerationChartData() {
    let self = this;
    this.listAccData1 = [];
    this.listAccData2 = [];
    this.listAccData3 = [];
    this.listAccData1 = this.dataNewfrequentPoints1.map(function (val, index) {
      return { key: index, x: val.x, y: val.y };
    });

    this.listAccData2 = this.dataNewfrequentPoints2.map(function (val, index) {
      return { key: index, y: val.y };
    });

    this.listAccData3 = this.dataNewfrequentPoints3.map(function (val, index) {
      return { key: index, y: val.y };
    });
  }
  mergeArrayOrient(array, property) {
    const newArray = new Map();
    array.forEach((item) => {
      const propertyValue = item[property];
      newArray.has(propertyValue)
        ? newArray.set(propertyValue, {
            ...item,
            ...newArray.get(propertyValue),
          })
        : newArray.set(propertyValue, item);
    });
    return Array.from(newArray.values());
  }

  async tableListVelocityTrend(
    dataPoint1,
    dataPoint2,
    dataPoint3,
    dataPointPred1,
    dataPointPred2,
    dataPointPred3
  ) {
    let self = this;
    var f_arr3;
    let f_arr = await Promise.all(
      dataPoint1.map(async function (f, fx) {
        let chartTime = self.getTimeOnly(f);
        return {
          d: chartTime,
          c1: f.y === null ? "-" : f.y.toFixed(2),
          c2: dataPoint2[fx].y === null ? "-" : dataPoint2[fx].y.toFixed(2),
          c3: dataPoint3[fx].y === null ? "-" : dataPoint3[fx].y.toFixed(2),
        };
      })
    );
    if (dataPointPred1 !== null) {
      let f_arr1 = await Promise.all(
        dataPointPred1.map(async function (f, fx) {
          let chartTime = self.getTimeOnly(f);
          return {
            d: chartTime,
            c4: f.y === null ? "-" : f.y.toFixed(2),
            c5:
              dataPointPred2[fx].y === null
                ? "-"
                : dataPointPred2[fx].y.toFixed(2),
            c6:
              dataPointPred3[fx].y === null
                ? "-"
                : dataPointPred3[fx].y.toFixed(2),
          };
        })
      );
      f_arr3 = [...f_arr, ...f_arr1];
    } else {
      f_arr3 = [...f_arr];
    }
    this.tableVelocityTrendPred = this.mergeArray(f_arr3, "d");
  }

  async listSensorVibrationNewChartData(
    dataPoint1,
    dataPoint2,
    dataPoint3,
    dataPointPred1,
    dataPointPred2,
    dataPointPred3
  ) {
    let self = this;
    var f_arr3;
    let f_arr = await Promise.all(
      dataPoint1.map(async function (f, fx) {
        let chartTime = self.getTimeOnly(f);
        return {
          d: chartTime,
          c1: f.y === null ? "-" : f.y.toFixed(2),
          c2: dataPoint2[fx].y === null ? "-" : dataPoint2[fx].y.toFixed(2),
          c3: dataPoint3[fx].y === null ? "-" : dataPoint3[fx].y.toFixed(2),
        };
      })
    );
    if (dataPointPred1 !== null) {
      let f_arr1 = await Promise.all(
        dataPointPred1.map(async function (f, fx) {
          let chartTime = self.getTimeOnly(f);
          return {
            d: chartTime,
            c4: f.y === null ? "-" : f.y.toFixed(2),
            c5:
              dataPointPred2[fx].y === null
                ? "-"
                : dataPointPred2[fx].y.toFixed(2),
            c6:
              dataPointPred3[fx].y === null
                ? "-"
                : dataPointPred3[fx].y.toFixed(2),
          };
        })
      );
      f_arr3 = [...f_arr, ...f_arr1];
    } else {
      f_arr3 = [...f_arr];
    }
    this.arrObjVibrationPred = this.mergeArray(f_arr3, "d");
  }

  mergeArray(array, property) {
    const newArray = new Map();
    array.forEach((item) => {
      const propertyValue = item[property];
      newArray.has(propertyValue)
        ? newArray.set(propertyValue, {
            ...item,
            ...newArray.get(propertyValue),
          })
        : newArray.set(propertyValue, item);
    });
    return Array.from(newArray.values());
  }

  getTimeOnly(val) {
    let timeVal = new Date(val.x);
    timeVal.setMinutes(timeVal.getMinutes());
    let format1 = "YYYY-MM-DD HH:mm:ss";
    let addedDate = new Date(timeVal);
    let newDateBe = moment(addedDate).format(format1);
    let hours = timeVal.getHours();
    let minutes: any = timeVal.getMinutes();
    let ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    let strTime = hours + ":" + minutes + " " + ampm;
    return newDateBe;
  }
  /********************************************
   * Vibration - Acceleration Trend (m/sec<sup>2</sup>)
   ********************************************/
  async getSensorCharts() {
    let self = this;
    this.AccelartionLoading = true;
    if (this.firstTimeChartLoad) {
      this.service
        .getDataWithQuery(
          this.accelsensorData +
            "/v2" +
            "/" +
            parseInt(this.deviceId) +
            "/" +
            parseInt(this.assetId) +
            "/" +
            [6, 7, 8] +
            "/" +
            this.time_span +
            "?type=" +
            0 +
            "&userid=" +
            this.userID +
            "&asset_type=" +
            this.assetType +
            "&start_date=" + this.startDateTrendChart + "&end_date=" + this.endDateTrendChart
        )
        .then((res) => {
          if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
            if (
              JSON.parse(JSON.stringify(res)).data.body.chartXdata.length === 0
            ) {
              this.visibilityVAT = true;
              this.AccelartionLoading = false;
            }
          } else if (
            JSON.parse(JSON.stringify(res)).data.status === "success"
          ) {
            if (JSON.parse(JSON.stringify(res)).data.body.length !== 0) {
              if (
                JSON.parse(JSON.stringify(res)).data.body.chartXdata.length != 0
              ) {
                this.visibilityVAT = false;
                this.AccelartionLoading = false;
                let chartOneResponse = JSON.parse(JSON.stringify(res));
                this.lableOneX = chartOneResponse.data.body.labelx;
                this.lableOneY = chartOneResponse.data.body.labely;
                this.lableOneZ = chartOneResponse.data.body.labelz;
                this.xaavg =
                  chartOneResponse.data.body.movingAvg.x_hour === null
                    ? "N/A"
                    : chartOneResponse.data.body.movingAvg.x_hour.toFixed(2);
                this.yaavg =
                  chartOneResponse.data.body.movingAvg.y_hour === null
                    ? "N/A"
                    : chartOneResponse.data.body.movingAvg.y_hour.toFixed(2);
                this.zaavg =
                  chartOneResponse.data.body.movingAvg.z_hour === null
                    ? "N/A"
                    : chartOneResponse.data.body.movingAvg.z_hour.toFixed(2);
                this.xaavg_day =
                  chartOneResponse.data.body.movingAvg.x_day === null
                    ? "N/A"
                    : chartOneResponse.data.body.movingAvg.x_day.toFixed(2);
                this.yaavg_day =
                  chartOneResponse.data.body.movingAvg.y_day === null
                    ? "N/A"
                    : chartOneResponse.data.body.movingAvg.y_day.toFixed(2);
                this.zaavg_day =
                  chartOneResponse.data.body.movingAvg.z_day === null
                    ? "N/A"
                    : chartOneResponse.data.body.movingAvg.z_day.toFixed(2);
                this.xaavg_week =
                  chartOneResponse.data.body.movingAvg.x_week === null
                    ? "N/A"
                    : parseFloat(
                        chartOneResponse.data.body.movingAvg.x_week
                      ).toFixed(2);
                this.yaavg_week =
                  chartOneResponse.data.body.movingAvg.y_week === null
                    ? "N/A"
                    : parseFloat(
                        chartOneResponse.data.body.movingAvg.y_week
                      ).toFixed(2);
                this.zaavg_week =
                  chartOneResponse.data.body.movingAvg.z_week === null
                    ? "N/A"
                    : chartOneResponse.data.body.movingAvg.z_week.toFixed(2);

                let sensorChartDataX = [];
                let sensorChartDataY = [];
                let sensorChartDataZ = [];

                sensorChartDataX = chartOneResponse.data.body.chartXdata;
                // for (let i = 0; i < sensorChartDataX.length; i++) {
                //   let testDateUtc = moment.utc(sensorChartDataX[i].x).toDate();
                //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
                //   sensorChartDataX[i].x = timeUpdatedAt;
                // }
                sensorChartDataY = chartOneResponse.data.body.chartYdata;
                // for (let i = 0; i < sensorChartDataY.length; i++) {
                //   let testDateUtc = moment.utc(sensorChartDataY[i].x).toDate();
                //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
                //   sensorChartDataY[i].x = timeUpdatedAt;
                // }
                sensorChartDataZ = chartOneResponse.data.body.chartZdata;
                // for (let i = 0; i < sensorChartDataZ.length; i++) {
                //   let testDateUtc = moment.utc(sensorChartDataZ[i].x).toDate();
                //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
                //   sensorChartDataZ[i].x = timeUpdatedAt;
                // }
                let lastChartTime: any = new Date(
                  new Date(sensorChartDataX[sensorChartDataX.length - 1]["x"])
                );
                lastChartTime.setMinutes(lastChartTime.getMinutes() + 30);
                let format1 = "YYYY-MM-DD HH:mm:ss";
                let addedDate = new Date(lastChartTime);
                let newDateBe = moment(addedDate).format(format1);
                sensorChartDataX.push({ x: newDateBe, y: null });
                sensorChartDataY.push({ x: newDateBe, y: null });
                sensorChartDataZ.push({ x: newDateBe, y: null });

                this.dataPoints1 = [];
                this.dataPoints2 = [];
                this.dataPoints3 = [];

                this.dataPoints1 = sensorChartDataX.map(function (val, index) {
                  let arr1: any = val.x.split(/[- :]/);
                  let time1A = new Date(
                    arr1[0],
                    arr1[1] - 1,
                    arr1[2],
                    arr1[3],
                    arr1[4],
                    arr1[5]
                  );
                  let x = time1A;
                  let y = val.y;
                  return { x, y };
                });
                this.dataPoints2 = sensorChartDataY.map(function (val, index) {
                  let arr1: any = val.x.split(/[- :]/);
                  let time1A = new Date(
                    arr1[0],
                    arr1[1] - 1,
                    arr1[2],
                    arr1[3],
                    arr1[4],
                    arr1[5]
                  );
                  let x = time1A;
                  let y = val.y;
                  return { x, y };
                });
                this.dataPoints3 = sensorChartDataZ.map(function (val, index) {
                  let arr1: any = val.x.split(/[- :]/);
                  let time1A = new Date(
                    arr1[0],
                    arr1[1] - 1,
                    arr1[2],
                    arr1[3],
                    arr1[4],
                    arr1[5]
                  );
                  let x = time1A;
                  let y = val.y;
                  return { x, y };
                });
                this.returnVibrartionObj = JSON.parse(
                  JSON.stringify(res)
                ).data.body.returnobj;
                this.min_g = chartOneResponse.data.body.min || 0;
                this.max_g = chartOneResponse.data.body.green;
                this.max_y = chartOneResponse.data.body.yellow;
                this.max_r = chartOneResponse.data.body.red;

                if (this.AccelartionLoading == false) {
                  if (document.getElementById("chartContainer") !== null) {
                    /****************RANGE SELECTOR PART************ */
                    let rangeChanged = function (e) {
                      if (e.index == 0) {
                        this.time_span = "hour";
                      } else if (e.index == 1) {
                        this.time_span = "day";
                      } else {
                        this.time_span = "week";
                      }

                      let minDate = new Date(e.minimum);
                      let maxDate = new Date(e.maximum);
                      let startDate = minDate.toISOString();
                      let endDate = maxDate.toISOString();
                      let c_no = e.stockChart.options.chartNumber;
                      if (
                        e.source != "navigator" &&
                        e.source != "chart" &&
                        e.source != "buttons"
                      ) {
                        var url = `${e.stockChart.options.url}/${e.stockChart.options.device_id}/${e.stockChart.options.asset_id}/${e.stockChart.options.type_array}/${e.stockChart.options.role}?type=0&userid=${e.stockChart.options.user_id}&asset_type=${e.stockChart.options.asset_id}&start_date=${startDate}&end_date=${endDate}`;
                        $.ajaxSetup({
                          headers: {
                            Authorization: e.stockChart.options.token,
                            timezone: e.stockChart.options.timezone,
                          },
                        });
                        $.getJSON(url, function (res) {
                          if (
                            JSON.parse(JSON.stringify(res)).data.status ===
                            "fail"
                          ) {
                          } else if (
                            JSON.parse(JSON.stringify(res)).data.status ===
                            "success"
                          ) {
                            if (
                              JSON.parse(JSON.stringify(res)).data.body
                                .length !== 0
                            ) {
                              if (
                                JSON.parse(JSON.stringify(res)).data.body
                                  .chartXdata !== null
                              ) {
                                let finalResponse = JSON.parse(
                                  JSON.stringify(res)
                                );
                                let sensorChartDataX =
                                  finalResponse.data.body.chartXdata;
                                let sensorChartDataY =
                                  finalResponse.data.body.chartYdata;
                                let sensorChartDataZ =
                                  finalResponse.data.body.chartZdata;
                                let pointVibration1 = sensorChartDataX.map(
                                  function (val, index) {
                                    let arr1: any = val.x.split(/[- :]/);
                                    let time1A = new Date(
                                      arr1[0],
                                      arr1[1] - 1,
                                      arr1[2],
                                      arr1[3],
                                      arr1[4],
                                      arr1[5]
                                    );
                                    let x = time1A;
                                    let y = val.y;
                                    return { x, y };
                                  }
                                );
                                let pointVibration2 = sensorChartDataY.map(
                                  function (val, index) {
                                    let arr1: any = val.x.split(/[- :]/);
                                    let time1A = new Date(
                                      arr1[0],
                                      arr1[1] - 1,
                                      arr1[2],
                                      arr1[3],
                                      arr1[4],
                                      arr1[5]
                                    );
                                    let x = time1A;
                                    let y = val.y;
                                    return { x, y };
                                  }
                                );
                                let pointVibration3 = sensorChartDataZ.map(
                                  function (val, index) {
                                    let arr1: any = val.x.split(/[- :]/);
                                    let time1A = new Date(
                                      arr1[0],
                                      arr1[1] - 1,
                                      arr1[2],
                                      arr1[3],
                                      arr1[4],
                                      arr1[5]
                                    );
                                    let x = time1A;
                                    let y = val.y;
                                    return { x, y };
                                  }
                                );
                                addData(
                                  pointVibration1,
                                  pointVibration2,
                                  pointVibration3,
                                  c_no
                                );
                              }
                            }
                          }
                        });
                      }
                    };

                    let addData = function (data1, data2, data3, cn) {
                      self.chart.options.charts[0].data[0].dataPoints = [];
                      self.chart.options.charts[0].data[1].dataPoints = [];
                      self.chart.options.charts[0].data[2].dataPoints = [];
                      self.chart.options.charts[0].data[0].dataPoints.push(
                        ...data1
                      );
                      self.chart.options.charts[0].data[1].dataPoints.push(
                        ...data2
                      );
                      self.chart.options.charts[0].data[2].dataPoints.push(
                        ...data3
                      );
                      self.chart.render();
                    };
                    /************************************************** */
                    this.chartOne = cloneDeep(monitoringVelocityObject);
                    let feedDataToArray = [];
                    feedDataToArray.push({
                      data: this.dataPoints1,
                      lineDashType: "",
                      label: this.lableOneX,
                      legendMarkerType: "none",
                      key: this.lableOneX.trim(),
                    });
                    feedDataToArray.push({
                      data: this.dataPoints2,
                      lineDashType: "",
                      label: this.lableOneY,
                      legendMarkerType: "none",
                      key: this.lableOneY.trim(),
                    });
                    feedDataToArray.push({
                      data: this.dataPoints3,
                      lineDashType: "",
                      label: this.lableOneZ,
                      legendMarkerType: "none",
                      key: this.lableOneZ.trim(),
                    });
                    this.changeOrder(
                      ["Radial (Horizontal)", "Tangential (Vertical)", "Axial"],
                      feedDataToArray
                    );
                    let dataAd = this.makeDataForChart(feedDataToArray);
                    this.chartOne = cloneDeep(monitoringVelocityObject);
                    /**INFO PASSED TO SERVICE  */
                    this.chartOne.url = this.accelsensorData;
                    this.chartOne.device_id = parseInt(this.deviceId);
                    this.chartOne.asset_id = parseInt(this.assetId);
                    this.chartOne.type_array = [6, 7, 8];
                    this.chartOne.role = "range";
                    this.chartOne.type = 0;
                    this.chartOne.user_id = this.userID;
                    this.chartOne.asset_type = this.assetType;
                    this.chartOne.token = localStorage.getItem("token");
                    this.chartOne.timezone =
                      localStorage.getItem("clientTimeZone");
                    this.chartOne.chartNumber = 0;
                    /*****************************/

                    this.chartOne.charts[0].axisY.maximum = this.max_r;
                    this.chartOne.charts[0].axisY.minimum = 0;
                    this.chartOne.charts[0].unit = "m/sec<sup>2</sup>";
                    this.chartOne.charts[0].data = dataAd;
                    this.chartOne.navigator.data = dataAd;
                    this.chartOne.rangeChanging = rangeChanged;

                    //this.chart.render();
                    document.getElementById("chartContainer").style.height =
                      "370px";
                    this.chart = new CanvasJS.StockChart(
                      "chartContainer",
                      this.chartOne
                    );
                    this.chart.render();

                    //Change yellow
                    this.chart.charts[0].axisY[0].addTo("stripLines", {
                      value: this.max_g,
                      label: this.max_g,
                      color: this.greenColor,
                      labelFontColor: "#000000",
                    });

                    //Change color green
                    this.chart.charts[0].axisY[0].addTo(
                      "stripLines",
                      this.addBackgroundColor(
                        this.min_g,
                        this.max_g,
                        this.greenColor
                      )
                    );

                    this.chart.charts[0].axisY[0].addTo("stripLines", {
                      value: this.max_g,
                      label: this.max_g,
                      color: this.greenColor,
                      labelFontColor: "#000000",
                    });
                    //Change yellow
                    this.chart.charts[0].axisY[0].addTo("stripLines", {
                      value: this.max_y,
                      label: this.max_y,
                      color: this.yellowColor,
                      labelFontColor: "#000000",
                    });

                    //Change color yellow
                    this.chart.charts[0].axisY[0].addTo(
                      "stripLines",
                      this.addBackgroundColor(
                        this.max_g,
                        this.max_y,
                        this.yellowColor
                      )
                    );
                    //Change red
                    this.chart.charts[0].axisY[0].addTo("stripLines", {
                      value: this.max_r,
                      label: this.max_r,
                      color: this.redColor,
                      labelFontColor: "#000000",
                    });

                    //Change red
                    this.chart.charts[0].axisY[0].addTo(
                      "stripLines",
                      this.addBackgroundColor(
                        this.max_y,
                        this.max_r,
                        this.redColor
                      )
                    );

                    // this.intervalSensorUpdateAcc = setInterval(() => {
                    //   self.updateVibrationChart();
                    // }, self.updateInterval);
                  }
                } else {
                  console.log(
                    "loading is still true...",
                    this.AccelartionLoading
                  );
                }
              } else {
                this.visibilityVAT = true;
                this.AccelartionLoading = false;
              }
            } else {
              this.visibilityVAT = true;
              this.AccelartionLoading = false;
            }
          } else {
            this.visibilityVAT = true;
            this.AccelartionLoading = false;
          }
        });
    } else {
      const slideOneInterval = setInterval(() => {
        if (document.getElementById("chartContainer") !== null) {
          this.chartOne.height = 300;
          this.chartOne.width = 1160;
          if (Object.keys(this.chartOne).length != 0) {
            this.chart = new CanvasJS.StockChart(
              "chartContainer",
              this.chartOne
            );
            this.chart.render();
            let self = this;
            // self.intervalSensorUpdateAcc = setInterval(() => {
            //   self.updateVibrationChart();
            // }, self.updateInterval);
          } else {
            this.firstTimeChartLoad = true;
            this.getSensorCharts();
          }
        }
        clearInterval(slideOneInterval);
      }, 1000);
    }
  }

  /********************************************
   * Vibration - Velocity Trend (mm/sec)
   ********************************************/
  getVelocityChart() {
    this.VelocityLoading = true;
    if (this.firstTimeChartLoad) {
      this.service
        .getDataWithQuery(
          this.accelsensorData +
            "/v2" +
            "/" +
            parseInt(this.deviceId) +
            "/" +
            parseInt(this.assetId) +
            "/" +
            [29, 30, 31] +
            "/" +
            this.time_span +
            "?type=" +
            0 +
            "&userid=" +
            this.userID +
            "&asset_type=" +
            this.assetType +
            "&start_date=" + this.startDateTrendChart + "&end_date=" + this.endDateTrendChart
        )
        .then((res) => {
          if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
            if (
              JSON.parse(JSON.stringify(res)).data.body.chartXdata.length === 0
            ) {
              this.visibilityMVChart = true;
              this.VelocityLoading = false;
            }
          } else if (
            JSON.parse(JSON.stringify(res)).data.status === "success"
          ) {
            // this.thresholdforvelocity = JSON.parse(
            //   JSON.stringify(res)
            // ).data.body.returnobj.thresholds.velocity;

            if (JSON.parse(JSON.stringify(res)).data.body.length !== 0) {
              if (
                JSON.parse(JSON.stringify(res)).data.body.chartXdata.length != 0
              ) {
                this.visibilityMVChart = false;
                this.VelocityLoading = false;
                let chartTwoResponse = JSON.parse(JSON.stringify(res));
                this.lableTwoX = chartTwoResponse.data.body.labelx;
                this.lableTwoY = chartTwoResponse.data.body.labely;
                this.lableTwoZ = chartTwoResponse.data.body.labelz;
                this.xvavg =
                  chartTwoResponse.data.body.movingAvg.x_hour === null
                    ? "N/A"
                    : chartTwoResponse.data.body.movingAvg.x_hour.toFixed(2);
                this.yvavg =
                  chartTwoResponse.data.body.movingAvg.y_hour === null
                    ? "N/A"
                    : chartTwoResponse.data.body.movingAvg.y_hour.toFixed(2);
                this.zvavg =
                  chartTwoResponse.data.body.movingAvg.z_hour === null
                    ? "N/A"
                    : chartTwoResponse.data.body.movingAvg.z_hour.toFixed(2);
                this.xvavg_day =
                  chartTwoResponse.data.body.movingAvg.x_day === null
                    ? "N/A"
                    : chartTwoResponse.data.body.movingAvg.x_day.toFixed(2);
                this.yvavg_day =
                  chartTwoResponse.data.body.movingAvg.y_day === null
                    ? "N/A"
                    : chartTwoResponse.data.body.movingAvg.y_day.toFixed(2);
                this.zvavg_day =
                  chartTwoResponse.data.body.movingAvg.z_day === null
                    ? "N/A"
                    : chartTwoResponse.data.body.movingAvg.z_day.toFixed(2);
                this.xvavg_week =
                  chartTwoResponse.data.body.movingAvg.x_week === null
                    ? "N/A"
                    : chartTwoResponse.data.body.movingAvg.x_week.toFixed(2);
                this.yvavg_week =
                  chartTwoResponse.data.body.movingAvg.y_week === null
                    ? "N/A"
                    : chartTwoResponse.data.body.movingAvg.y_week.toFixed(2);
                this.zvavg_week =
                  chartTwoResponse.data.body.movingAvg.z_week === null
                    ? "N/A"
                    : chartTwoResponse.data.body.movingAvg.z_week.toFixed(2);
                let sensorChartDataX = chartTwoResponse.data.body.chartXdata;
                // for (let i = 0; i < sensorChartDataX.length; i++) {
                //   let testDateUtc = moment.utc(sensorChartDataX[i].x).toDate();
                //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
                //   sensorChartDataX[i].x = timeUpdatedAt;
                // }
                let sensorChartDataY = chartTwoResponse.data.body.chartYdata;
                // for (let i = 0; i < sensorChartDataY.length; i++) {
                //   let testDateUtc = moment.utc(sensorChartDataY[i].x).toDate();
                //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
                //   sensorChartDataY[i].x = timeUpdatedAt;
                // }
                let sensorChartDataZ = chartTwoResponse.data.body.chartZdata;
                // for (let i = 0; i < sensorChartDataZ.length; i++) {
                //   let testDateUtc = moment.utc(sensorChartDataZ[i].x).toDate();
                //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
                //   sensorChartDataZ[i].x = timeUpdatedAt;
                // }
                let lastChartTime: any = new Date(
                  new Date(sensorChartDataX[sensorChartDataX.length - 1]["x"])
                );
                lastChartTime.setMinutes(lastChartTime.getMinutes() + 30);
                let format1 = "YYYY-MM-DD HH:mm:ss";
                let addedDate = new Date(lastChartTime);
                let newDateBe = moment(addedDate).format(format1);
                sensorChartDataX.push({ x: newDateBe, y: null });
                sensorChartDataY.push({ x: newDateBe, y: null });
                sensorChartDataZ.push({ x: newDateBe, y: null });

                this.velocityDataPoints1 = sensorChartDataX.map(function (
                  val,
                  index
                ) {
                  let arr1: any = val.x.split(/[- :]/);
                  let time1A = new Date(
                    arr1[0],
                    arr1[1] - 1,
                    arr1[2],
                    arr1[3],
                    arr1[4],
                    arr1[5]
                  );
                  let x = time1A;
                  let y = val.y;
                  return { x, y };
                });
                this.velocityDataPoints2 = sensorChartDataY.map(function (
                  val,
                  index
                ) {
                  let arr1: any = val.x.split(/[- :]/);
                  let time1A = new Date(
                    arr1[0],
                    arr1[1] - 1,
                    arr1[2],
                    arr1[3],
                    arr1[4],
                    arr1[5]
                  );
                  let x = time1A;
                  let y = val.y;
                  return { x, y };
                });
                this.velocityDataPoints3 = sensorChartDataZ.map(function (
                  val,
                  index
                ) {
                  let arr1: any = val.x.split(/[- :]/);
                  let time1A = new Date(
                    arr1[0],
                    arr1[1] - 1,
                    arr1[2],
                    arr1[3],
                    arr1[4],
                    arr1[5]
                  );
                  let x = time1A;
                  let y = val.y;
                  return { x, y };
                });

                // console.log(this.fftMarkers,sensorChartDataX[0].x,sensorChartDataX[sensorChartDataX.length-1].x);
                // console.log(new Date(this.fftMarkers[0]),new Date(sensorChartDataX[0].x),new Date(sensorChartDataX[sensorChartDataX.length-1].x));

                let fftTimeArr = [];
                /*
                  Functionality: We are filtering the data for fftmarkers based on graphType (Hourly, Daily, Weekly) etc
                                  because current this.fftMarkers API fetching all the data but we need to show only hourly, daily & weekly

                  Date: 8th Aug 2024
                  Commented by:
                */
               this.fftMarkers = this.fftMarkersTemp;
                if(this.fftMarkers.length >0){


                    //const storedGraphType = localStorage.getItem('graphType');
                    //this.graphType = storedGraphType !== null ? storedGraphType : 'Hourly';

                    // Assume this.graphType is a string that can be "Hourly", "Daily", or "Weekly"
                    switch (this.graphType) {
                      case "Hourly":
                        const todayHourly = new Date();
                        const startDateHourly = new Date(todayHourly);
                        startDateHourly.setDate(todayHourly.getDate() - 3);
                        startDateHourly.setHours(0, 0, 0, 0);

                        this.newFFTMarkers = this.fftMarkers.filter(item => {
                          const itemDate = new Date(item.fft_time);
                          return itemDate >= startDateHourly && itemDate <= todayHourly;
                        });
                        break;

                      case "Daily":
                        const todayDaily = new Date();
                        const startDateDaily = new Date(todayDaily);
                        startDateDaily.setDate(todayDaily.getDate() - 14);
                        startDateDaily.setHours(0, 0, 0, 0);

                        this.newFFTMarkers = this.fftMarkers.filter(item => {
                          const itemDate = new Date(item.fft_time);
                          return itemDate >= startDateDaily && itemDate <= todayDaily;
                        });
                        break;

                      case "Weekly":
                        const todayWeekly = new Date();
                        const startDateWeekly = new Date(todayWeekly);
                        startDateWeekly.setDate(todayWeekly.getDate() - 90);
                        startDateWeekly.setHours(0, 0, 0, 0);

                        this.newFFTMarkers = this.fftMarkers.filter(item => {
                          const itemDate = new Date(item.fft_time);
                          return itemDate >= startDateWeekly && itemDate <= todayWeekly;
                        });
                        break;

                      default:
                        // Default case can be the same as "Hourly" if needed
                        const todayDefault = new Date();
                        const startDateDefault = new Date(todayDefault);
                        startDateDefault.setDate(todayDefault.getDate() - 3);
                        startDateDefault.setHours(0, 0, 0, 0);

                        this.newFFTMarkers = this.fftMarkers.filter(item => {
                          const itemDate = new Date(item.fft_time);
                          return itemDate >= startDateDefault && itemDate <= todayDefault;
                        });
                        break;
                    }
                    this.fftMarkers = this.newFFTMarkers;
                }

                this.fftMarkers.forEach((val) => {
                  // console.log(val);
                  // console.log(
                  //   new Date(val.fft_time),
                  //   new Date(sensorChartDataX[0].x),
                  //   new Date(sensorChartDataX[sensorChartDataX.length - 1].x)
                  // );
                  // console.log(
                  //   "Val >= x[0]" +
                  //     (new Date(val.fft_time) > new Date(sensorChartDataX[0].x))
                  // );
                  // console.log(
                  //   "Val <= x[n-1]" +
                  //     (new Date(val.fft_time) <
                  //       new Date(
                  //         sensorChartDataX[sensorChartDataX.length - 1].x
                  //       ))
                  // );
                  // if (
                  //   new Date(val.fft_time) >= new Date(sensorChartDataX[0].x) &&
                  //   new Date(val.fft_time) <=
                  //     new Date(sensorChartDataX[sensorChartDataX.length - 1].x)
                  // ) {
                  fftTimeArr.push(val);
                  // }
                });
                let self = this;
                let fftLineData = [];
                let periodicLineData = [];
                let onDemandLineData = [];
                let anomalyLineData = [];
                // if (fftTimeArr != undefined) {
                //   fftLineData = fftTimeArr.map(function (val, index) {
                //     let arr1: any = val.fft_time.split(/[- :]/);
                //     let time1A = new Date(
                //       arr1[0],
                //       arr1[1] - 1,
                //       arr1[2],
                //       arr1[3],
                //       arr1[4],
                //       arr1[5]
                //     );
                //     let x = time1A;
                //     let y = 3;
                //     return {
                //       x,
                //       y,
                //       fftId: val.value,
                //       indexLabel: "FFT",
                //       markerType: "triangle",
                //       markerColor:
                //         val.label === "Anomaly SA : " ? "tomato" : val.label === "On-Demand SA : " ? "green" : "#53bab4",
                //       markerSize: 28,
                //       click: (e) => {
                //         self.taketopredominantalert("", val.fftId);
                //       }
                //     };
                //   });
                // }
                let periodicArray: any = [];
                let onDemandArray: any = [];
                let anomalyArray: any = [];
                if (fftTimeArr != undefined) {
                  fftLineData = fftTimeArr.map(function (val, index) {
                    switch(val.label) {
                      case "Anomaly SA : ":
                        anomalyArray.push(val);
                        break;
                      case "On-Demand SA : ":
                        onDemandArray.push(val);
                        break;
                      case "Periodic SA : ":
                        periodicArray.push(val);
                        break;
                    }
                    let arr1: any = val.fft_time.split(/[- :]/);
                    let time1A = new Date(arr1[0], arr1[1] - 1, arr1[2], arr1[3], arr1[4], arr1[5]);
                    let x = time1A;
                    let y = 3;
                    const currentTime = new Date();
                    const twentyFourHoursAgo = new Date(currentTime.getTime() - 24 * 60 * 60 * 1000);
                    const isWithinLast24Hours = time1A >= twentyFourHoursAgo;
                    let markerData: any = {
                      x,
                      y,
                      fftId: val.fftId,
                      indexLabel: "FFT",
                      markerType: "triangle",
                      markerColor: !isWithinLast24Hours ? "#8A8A8A" :
                        val.label === "Anomaly SA : " ? "tomato"
                      : val.label === "On-Demand SA : " ? "green"
                      : "#53bab4",
                      markerSize: 28,
                    };

                    // Add click function only if it's NOT Periodic SA
                    if (isWithinLast24Hours) {
                      markerData.click = (e) => {
                        self.taketopredominantalert("", val.fftId);
                      };
                    }

                    return markerData;
                  });
                }
                // if(periodicArray.length > 0) {
                //   let latestNValues = periodicArray.slice(0, this.countLatestNValues - 1);
                //   periodicLineData = periodicArray.map(function (val, index) {
                //     let isInLatestNValues = latestNValues.includes(val);
                //     let arr1: any = val.fft_time.split(/[- :]/);
                //     let time1A = new Date(arr1[0], arr1[1] - 1, arr1[2], arr1[3], arr1[4], arr1[5]);
                //     let x = time1A;
                //     let y = 3;
                //     let markerData: any = {
                //       x,
                //       y,
                //       fftId: val.fftId,
                //       indexLabel: "Periodic SA",
                //       markerType: "triangle",
                //       markerColor: !isInLatestNValues ? "#8A8A8A" : "#53bab4",
                //       markerSize: 28,
                //     };
                //     if (isInLatestNValues) {
                //       markerData.click = (e) => {
                //         self.taketopredominantalert("", val.fftId);
                //       };
                //     }
                //     return markerData;
                //   })
                // }
                // if(onDemandArray.length > 0) {
                //   let latestNValues = onDemandArray.slice(0, this.countLatestNValues - 1);
                //   onDemandLineData = onDemandArray.map(function (val, index) {
                //     let isInLatestNValues = latestNValues.includes(val);
                //     let arr1: any = val.fft_time.split(/[- :]/);
                //     let time1A = new Date(arr1[0], arr1[1] - 1, arr1[2], arr1[3], arr1[4], arr1[5]);
                //     let x = time1A;
                //     let y = 3;
                //     let markerData: any = {
                //       x,
                //       y,
                //       fftId: val.fftId,
                //       indexLabel: "SA On Demand",
                //       markerType: "triangle",
                //       markerColor: !isInLatestNValues ? "#8A8A8A" : "green",
                //       markerSize: 28,
                //     };
                //     if (isInLatestNValues) {
                //       markerData.click = (e) => {
                //         self.taketopredominantalert("", val.fftId);
                //       };
                //     }
                //     return markerData;
                //   })
                // }
                // if(anomalyArray.length > 0) {
                //   let latestNValues = anomalyArray.slice(0, this.countLatestNValues - 1);
                //   anomalyLineData = anomalyArray.map(function (val, index) {
                //     let isInLatestNValues = latestNValues.includes(val);
                //     let arr1: any = val.fft_time.split(/[- :]/);
                //     let time1A = new Date(arr1[0], arr1[1] - 1, arr1[2], arr1[3], arr1[4], arr1[5]);
                //     let x = time1A;
                //     let y = 3;
                //     let markerData: any = {
                //       x,
                //       y,
                //       fftId: val.fftId,
                //       indexLabel: "Anomaly SA",
                //       markerType: "triangle",
                //       markerColor: !isInLatestNValues ? "#8A8A8A" : "tomato",
                //       markerSize: 28,
                //     };
                //     if (isInLatestNValues) {
                //       markerData.click = (e) => {
                //         self.taketopredominantalert("", val.fftId);
                //       };
                //     }
                //     return markerData;
                //   })
                // }
                if (periodicArray.length > 0 || onDemandArray.length > 0 || anomalyArray.length > 0) {
                  // Combine all data and sort by fft_time
                  let combinedArray = [...periodicArray, ...onDemandArray, ...anomalyArray].sort((a, b) => {
                    let timeA = new Date(a.fft_time).getTime();
                    let timeB = new Date(b.fft_time).getTime();
                    return timeB - timeA; // Sort in descending order (latest first)
                  });

                  // Get the latest N values from the combined array
                  let latestNValues = combinedArray.slice(0, this.countLatestNValues - 1);

                  function processArray(dataArray, label, color) {
                    return dataArray.map((val) => {
                      let isInLatestNValues = latestNValues.includes(val);
                      let arr1: any = val.fft_time.split(/[- :]/);
                      let time1A = new Date(arr1[0], arr1[1] - 1, arr1[2], arr1[3], arr1[4], arr1[5]);
                      return {
                        x: time1A,
                        y: 3,
                        fftId: val.fftId,
                        indexLabel: label,
                        markerType: "triangle",
                        markerColor: isInLatestNValues ? color : "#8A8A8A",
                        markerSize: 28,
                        ...(isInLatestNValues && { click: (e) => self.taketopredominantalert("", val.fftId) }),
                      };
                    });
                  }

                  periodicLineData = processArray(periodicArray, "Periodic SA", "#53bab4");
                  onDemandLineData = processArray(onDemandArray, "SA On Demand", "green");
                  anomalyLineData = processArray(anomalyArray, "Anomaly SA", "tomato");
                }
                // console.log("Periodic Array: ", periodicArray);
                // console.log("On-Demand Array: ", onDemandArray);
                // console.log("Anomaly Array: ", anomalyArray);
                // console.log("Periodic Line: ", periodicLineData);
                // console.log("On-Demand Line: ", onDemandLineData);
                // console.log("Anomaly Line: ", anomalyLineData);
                // console.log("FFT Line data: ", fftLineData)
                // console.log("fftTimeArr: ", fftTimeArr)
                // fftLineData.push({ x: new Date(sensorChartDataX[0].x), y: 0 })
                // fftLineData.push({ x: new Date(sensorChartDataX[sensorChartDataX.length - 1].x), y: 0 })
                this.returnMonVelocityObj =
                  chartTwoResponse.data.body.returnobj;
                this.min_g_v = chartTwoResponse.data.body.min || 0;
                this.max_g_v = chartTwoResponse.data.body.green;
                this.max_y_v = chartTwoResponse.data.body.yellow;
                this.max_r_v = chartTwoResponse.data.body.red;
                if (
                  document.getElementById(
                    "monitoringVelocityChartContainer"
                  ) !== null
                ) {
                  /**************RANGE SELECTOR PART****************** */

                  let rangeChanged = function (e) {
                    let minDate = new Date(e.minimum);
                    let maxDate = new Date(e.maximum);
                    let startDate = minDate.toISOString();
                    let endDate = maxDate.toISOString();
                    let c_no = e.stockChart.options.chartNumber;
                    // Above date object is converted
                    // into a string using toISOString() function.
                    if (
                      e.source != "navigator" &&
                      e.source != "chart" &&
                      e.source != "buttons"
                    ) {
                      var url = `${e.stockChart.options.url}/${e.stockChart.options.device_id}/${e.stockChart.options.asset_id}/${e.stockChart.options.type_array}/${e.stockChart.options.role}?type=0&userid=${e.stockChart.options.user_id}&asset_type=${e.stockChart.options.asset_id}&start_date=${startDate}&end_date=${endDate}`;
                      $.ajaxSetup({
                        headers: {
                          Authorization: e.stockChart.options.token,
                          timezone: e.stockChart.options.timezone,
                        },
                      });
                      $.getJSON(url, function (res) {
                        if (
                          JSON.parse(JSON.stringify(res)).data.status === "fail"
                        ) {
                        } else if (
                          JSON.parse(JSON.stringify(res)).data.status ===
                          "success"
                        ) {
                          if (
                            JSON.parse(JSON.stringify(res)).data.body.length !==
                            0
                          ) {
                            if (
                              JSON.parse(JSON.stringify(res)).data.body
                                .chartXdata !== null
                            ) {
                              let finalResponse = JSON.parse(
                                JSON.stringify(res)
                              );
                              let sensorChartDataX =
                                finalResponse.data.body.chartXdata;
                              let sensorChartDataY =
                                finalResponse.data.body.chartYdata;
                              let sensorChartDataZ =
                                finalResponse.data.body.chartZdata;
                              let pointVibration1 = sensorChartDataX.map(
                                function (val, index) {
                                  let arr1: any = val.x.split(/[- :]/);
                                  let time1A = new Date(
                                    arr1[0],
                                    arr1[1] - 1,
                                    arr1[2],
                                    arr1[3],
                                    arr1[4],
                                    arr1[5]
                                  );
                                  let x = time1A;
                                  let y = val.y;
                                  return { x, y };
                                }
                              );
                              let pointVibration2 = sensorChartDataY.map(
                                function (val, index) {
                                  let arr1: any = val.x.split(/[- :]/);
                                  let time1A = new Date(
                                    arr1[0],
                                    arr1[1] - 1,
                                    arr1[2],
                                    arr1[3],
                                    arr1[4],
                                    arr1[5]
                                  );
                                  let x = time1A;
                                  let y = val.y;
                                  return { x, y };
                                }
                              );
                              let pointVibration3 = sensorChartDataZ.map(
                                function (val, index) {
                                  let arr1: any = val.x.split(/[- :]/);
                                  let time1A = new Date(
                                    arr1[0],
                                    arr1[1] - 1,
                                    arr1[2],
                                    arr1[3],
                                    arr1[4],
                                    arr1[5]
                                  );
                                  let x = time1A;
                                  let y = val.y;
                                  return { x, y };
                                }
                              );
                              addData(
                                pointVibration1,
                                pointVibration2,
                                pointVibration3,
                                c_no
                              );
                            }
                          }
                        }
                      });
                    }
                  };

                  let addData = function (data1, data2, data3, cn) {
                    self.velocityChart.options.charts[0].data[0].dataPoints =
                      [];
                    self.velocityChart.options.charts[0].data[1].dataPoints =
                      [];
                    self.velocityChart.options.charts[0].data[2].dataPoints =
                      [];
                    self.velocityChart.options.charts[0].data[3].dataPoints =
                      [];
                    self.velocityChart.options.charts[0].data[0].dataPoints.push(
                      ...data1
                    );
                    self.velocityChart.options.charts[0].data[1].dataPoints.push(
                      ...data2
                    );
                    self.velocityChart.options.charts[0].data[2].dataPoints.push(
                      ...data3
                    );
                    // self.velocityChart.options.charts[0].data[2].dataPoints.push(
                    //   ...fftLineData
                    // );
                    self.velocityChart.options.charts[0].data[2].dataPoints.push(
                      ...periodicLineData
                    );
                    self.velocityChart.options.charts[0].data[2].dataPoints.push(
                      ...onDemandLineData
                    );
                    self.velocityChart.options.charts[0].data[2].dataPoints.push(
                      ...anomalyLineData
                    );
                    self.velocityChart.render();
                  };

                  /*********************************************** */

                  this.chartTwo = cloneDeep(monitoringVelocityObject);
                  /**INFO PASSED TO SERVICE  */
                  this.chartTwo.url = `${this.sensorData}/velocity`;
                  this.chartTwo.device_id = parseInt(this.deviceId);
                  this.chartTwo.asset_id = parseInt(this.assetId);
                  this.chartTwo.type_array = [29, 30, 31];
                  this.chartTwo.role = "range";
                  this.chartTwo.type = 0;
                  this.chartTwo.user_id = this.userID;
                  this.chartTwo.asset_type = this.assetType;
                  this.chartTwo.token = localStorage.getItem("token");
                  this.chartOne.timezone =
                    localStorage.getItem("clientTimeZone");
                  this.chartTwo.chartNumber = 1;
                  /*****************************/
                  let feedDataToArray = [];
                  feedDataToArray.push({
                    data: this.velocityDataPoints1,
                    lineDashType: "",
                    label: this.lableTwoX,
                    legendMarkerType: "none",
                    key: this.lableTwoX.trim(),
                  });
                  feedDataToArray.push({
                    data: this.velocityDataPoints2,
                    lineDashType: "",
                    label: this.lableTwoY,
                    legendMarkerType: "none",
                    key: this.lableTwoY.trim(),
                  });
                  feedDataToArray.push({
                    data: this.velocityDataPoints3,
                    lineDashType: "",
                    label: this.lableTwoZ,
                    legendMarkerType: "none",
                    key: this.lableTwoZ.trim(),
                  });

                  // Add SA data types if available
                  if (periodicArray.length > 0) {
                    feedDataToArray.push({
                      data: periodicLineData,
                      lineDashType: "",
                      label: "Periodic SA",
                      legendMarkerType: "none",
                      key: "Periodic SA",
                    });
                  }

                  if (anomalyArray.length > 0) {
                    feedDataToArray.push({
                      data: anomalyLineData,
                      lineDashType: "",
                      label: "Anomaly SA",
                      legendMarkerType: "none",
                      key: "Anomaly SA",
                    });
                  }

                  if (onDemandArray.length > 0) {
                    feedDataToArray.push({
                      data: onDemandLineData,
                      lineDashType: "",
                      label: "On-Demand SA",
                      legendMarkerType: "none",
                      key: "On-Demand SA",
                    });
                  }

                  // Define the correct order for display
                  const order = ["Radial (Horizontal)", "Tangential (Vertical)", "Axial"];
                  if (periodicArray.length > 0) order.push("Periodic SA");
                  if (anomalyArray.length > 0) order.push("Anomaly SA");
                  if (onDemandArray.length > 0) order.push("On-Demand SA");

                  // Ensure correct ordering
                  this.changeOrder(order, feedDataToArray);
                  /*
                    - If we found a fft time between SensorxData 0 and last index only then push this line on graph
                    - To show Triangles
                    - Commented by Sarthak on 29-feb-2024
                  */
                  // if (fftTimeArr != undefined) {
                  //   feedDataToArray.push({
                  //     data: fftLineData,
                  //     lineDashType: "",
                  //     label: "FFT ",
                  //     legendMarkerType: "none",
                  //     key: "FFT",
                  //   });
                  //   this.changeOrder(
                  //     [
                  //       "Radial (Horizontal)",
                  //       "Tangential (Vertical)",
                  //       "Axial",
                  //       "FFT",
                  //     ],
                  //     feedDataToArray
                  //   );
                  // } else {
                  //   this.changeOrder(
                  //     ["Radial (Horizontal)", "Tangential (Vertical)", "Axial"],
                  //     feedDataToArray
                  //   );
                  // }
                  // if(periodicArray.length > 0) {
                  //   feedDataToArray.push({
                  //     data: periodicLineData,
                  //     lineDashType: "",
                  //     label: "Periodic SA",
                  //     legendMarkerType: "none",
                  //     key: "Periodic SA",
                  //   })
                  //   this.changeOrder(["Radial (Horizontal)", "Tangential (Vertical)", "Axial", "Periodic SA"], feedDataToArray)
                  // }
                  // else if(anomalyArray.length > 0) {
                  //   feedDataToArray.push({
                  //     data: anomalyLineData,
                  //     lineDashType: "",
                  //     label: "Anomaly SA",
                  //     legendMarkerType: "none",
                  //     key: "Anomaly SA",
                  //   })
                  //   this.changeOrder(["Radial (Horizontal)", "Tangential (Vertical)", "Axial", "Anomaly SA"], feedDataToArray)
                  // }
                  // else if(onDemandArray.length > 0) {
                  //   feedDataToArray.push({
                  //     data: onDemandLineData,
                  //     lineDashType: "",
                  //     label: "On-Demand SA",
                  //     legendMarkerType: "none",
                  //     key: "On-Demand SA",
                  //   })
                  //   this.changeOrder(["Radial (Horizontal)", "Tangential (Vertical)", "Axial", "On-Demand SA"], feedDataToArray)
                  // }


                  let dataAd = this.makeDataForChart(feedDataToArray);
                  this.chartTwo.charts[0].axisY.maximum = this.max_r_v;
                  this.chartTwo.charts[0].axisY.minimum = 0;
                  this.chartTwo.charts[0].unit = "mm/sec";
                  this.chartTwo.charts[0].data = dataAd;
                  this.chartTwo.navigator.data = dataAd;
                  this.chartTwo.rangeChanging = rangeChanged;

                  console.log(this.chartTwo);
                  document.getElementById(
                    "monitoringVelocityChartContainer"
                  ).style.height = "370px";
                  this.velocityChart = new CanvasJS.StockChart(
                    "monitoringVelocityChartContainer",
                    this.chartTwo
                  );
                  this.velocityChart.render();
                  //Change color green`
                  this.velocityChart.charts[0].axisY[0].addTo(
                    "stripLines",
                    this.addBackgroundColor(
                      this.min_g_v,
                      this.max_g_v,
                      this.greenColor
                    )
                  );

                  this.velocityChart.charts[0].axisY[0].addTo("stripLines", {
                    value: this.max_g_v,
                    label: this.max_g_v,
                    color: this.greenColor,
                    labelFontColor: "#000000",
                  });
                  //Change color yellow
                  this.velocityChart.charts[0].axisY[0].addTo(
                    "stripLines",
                    this.addBackgroundColor(
                      this.max_g_v,
                      this.max_y_v,
                      this.yellowColor
                    )
                  );
                  this.velocityChart.charts[0].axisY[0].addTo("stripLines", {
                    value: this.max_y_v,
                    label: this.max_y_v,
                    color: this.yellowColor,
                    labelFontColor: "#000000",
                  });
                  //Change red
                  this.velocityChart.charts[0].axisY[0].addTo(
                    "stripLines",
                    this.addBackgroundColor(
                      this.max_y_v,
                      this.max_r_v,
                      this.redColor
                    )
                  );
                  this.velocityChart.charts[0].axisY[0].addTo("stripLines", {
                    value: this.max_r_v,
                    label: this.max_r_v,
                    color: this.yellowColor,
                    labelFontColor: "#000000",
                  });
                  let self = this;
                  // this.intervalMonitoringUpdate = setInterval(() => {
                  //   self.updateMonitoringVelocityChart();
                  // }, self.updateInterval);
                }
              } else {
                this.visibilityMVChart = true;
                this.VelocityLoading = false;
              }
            } else {
              this.visibilityMVChart = true;
              this.VelocityLoading = false;
            }
          } else {
            this.visibilityMVChart = true;
            this.VelocityLoading = false;
          }
        });
    } else {
      const slideTwoInterval = setInterval(() => {
        if (
          document.getElementById("monitoringVelocityChartContainer") !== null
        ) {
          if (Object.keys(this.chartTwo).length != 0) {
            this.chartTwo.height = 300;
            this.chartTwo.width = 1160;
            this.velocityChart = new CanvasJS.StockChart(
              "monitoringVelocityChartContainer",
              this.chartTwo
            );
            this.velocityChart.render();
            let self = this;
            // self.intervalMonitoringUpdate = setInterval(() => {
            //   self.updateMonitoringVelocityChart();
            // }, self.updateInterval);
          } else {
            this.firstTimeChartLoad = true;
            this.getVelocityChart();
          }
        }
        clearInterval(slideTwoInterval);
      }, 1000);
    }
  }
  /********************************************
   * Machine Acoustics (dB)
   ********************************************/
  getMachineAcousticsChart() {
    console.log("IM BEING CALLEDDD")
    this.AcousticsLoading = true;
    this.service
      .getDataWithQuery(
        this.ultrasoundGauge +
          "historical/" +
          parseInt(this.deviceId) +
          "/" +
          parseInt(this.assetId) +
          "/" +
          this.userID +
          "?filter=" +
          this.time_span +
          "&start_date=" + this.startDateTrendChart + "&end_date=" + this.endDateTrendChart
      )
      .then((res) => {
        if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
        } else if (JSON.parse(JSON.stringify(res)).data.status === "error") {
          this.visibilityAcousticsChart = true;
          this.AcousticsLoading = false;
        } else if (JSON.parse(JSON.stringify(res)).data.status === "success") {
          if (
            JSON.parse(JSON.stringify(res)).data.body.chartXdata.length !== 0
          ) {
            if (JSON.parse(JSON.stringify(res)).data.body.chartXdata !== null) {
              this.visibilityAcousticsChart = false;
              this.AcousticsLoading = false;
              let chartTwoResponse = JSON.parse(JSON.stringify(res));
              this.lableTwoX = chartTwoResponse.data.body.labelx;
              chartTwoResponse.data.body.chartXdata.shift();
              let sensorChartDataX = chartTwoResponse.data.body.chartXdata;
              //  this.xmavg = chartTwoResponse.data.body.x_avg.toFixed(2);
              // for (let i = 0; i < sensorChartDataX.length; i++) {
              //   let testDateUtc = moment.utc(sensorChartDataX[i].x).toDate();
              //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
              //   sensorChartDataX[i].x = timeUpdatedAt;
              // }
              let lastChartTime: any = new Date(
                new Date(sensorChartDataX[sensorChartDataX.length - 1]["x"])
              );
              lastChartTime.setMinutes(lastChartTime.getMinutes() + 30);
              let format1 = "YYYY-MM-DD HH:mm:ss";
              let addedDate = new Date(lastChartTime);
              let newDateBe = moment(addedDate).format(format1);
              sensorChartDataX.push({ x: newDateBe, y: null });
              this.acousticsDataPoints1 = sensorChartDataX.map(function (
                val,
                index
              ) {
                let arr1: any = val.x.split(/[- :]/);
                let time1A = new Date(
                  arr1[0],
                  arr1[1] - 1,
                  arr1[2],
                  arr1[3],
                  arr1[4],
                  arr1[5]
                );
                let x = time1A;
                let y = val.y;
                return { x, y };
              });

              this.returnAcousticsObj = chartTwoResponse.data.body.returnobj;
              let min_g_v = chartTwoResponse.data.body.min || 0;
              let max_g_v = chartTwoResponse.data.body.green;
              let max_y_v = chartTwoResponse.data.body.yellow;
              let max_r_v = chartTwoResponse.data.body.red;
              if (
                document.getElementById("monitoringMachineAcousticsChart") !==
                null
              ) {
                /**************RANGE SELECTOR PART****************** */

                let rangeChanged = function (e) {
                  let minDate = new Date(e.minimum);
                  let maxDate = new Date(e.maximum);

                  let startDate = minDate.toISOString();
                  let endDate = maxDate.toISOString();
                  let c_no = e.stockChart.options.chartNumber;
                  if (
                    e.source != "navigator" &&
                    e.source != "chart" &&
                    e.source != "buttons"
                  ) {
                    var url = `${e.stockChart.options.url}/${e.stockChart.options.device_id}/${e.stockChart.options.asset_id}/${e.stockChart.options.type_array}/${e.stockChart.options.role}?type=0&userid=${e.stockChart.options.user_id}&asset_type=${e.stockChart.options.asset_id}&start_date=${startDate}&end_date=${endDate}`;
                    $.ajaxSetup({
                      headers: {
                        Authorization: e.stockChart.options.token,
                        timezone: e.stockChart.options.timezone,
                      },
                    });
                    $.getJSON(url, function (res) {
                      if (
                        JSON.parse(JSON.stringify(res)).data.status === "fail"
                      ) {
                      } else if (
                        JSON.parse(JSON.stringify(res)).data.status ===
                        "success"
                      ) {
                        if (
                          JSON.parse(JSON.stringify(res)).data.body.length !== 0
                        ) {
                          if (
                            JSON.parse(JSON.stringify(res)).data.body
                              .chartXdata !== null
                          ) {
                            let finalResponse = JSON.parse(JSON.stringify(res));
                            let sensorChartDataX =
                              finalResponse.data.body.chartXdata;
                            let pointVibration1 = sensorChartDataX.map(
                              function (val, index) {
                                let arr1: any = val.x.split(/[- :]/);
                                let time1A = new Date(
                                  arr1[0],
                                  arr1[1] - 1,
                                  arr1[2],
                                  arr1[3],
                                  arr1[4],
                                  arr1[5]
                                );
                                let x = time1A;
                                let y = val.y;
                                return { x, y };
                              }
                            );
                            addData(pointVibration1, c_no);
                          }
                        }
                      }
                    });
                  }
                };

                let addData = function (data1, cn) {
                  self.acousticsChart.options.charts[0].data[0].dataPoints = [];
                  self.acousticsChart.options.charts[0].data[0].dataPoints.push(
                    ...data1
                  );
                  self.acousticsChart.render();
                };

                /*********************************************** */

                this.acousticsChartOne = cloneDeep(monitoringVelocityObject);

                /**INFO PASSED TO SERVICE  */
                this.acousticsChartOne.url = `${this.sensorData}/detail`;
                // this.acousticsChartOne.height = 300;
                //this.acousticsChartOne.width = 300;
                this.acousticsChartOne.device_id = parseInt(this.deviceId);
                this.acousticsChartOne.asset_id = parseInt(this.assetId);
                this.acousticsChartOne.type_array = [35];
                this.acousticsChartOne.role = "range";
                this.acousticsChartOne.type = 0;
                this.acousticsChartOne.user_id = this.userID;
                this.acousticsChartOne.asset_type = this.assetType;
                this.acousticsChartOne.token = localStorage.getItem("token");
                this.acousticsChartOne.timezone =
                  localStorage.getItem("clientTimeZone");
                this.acousticsChartOne.chartNumber = 1;
                /*****************************/

                let feedDataToArray = [];
                feedDataToArray.push({
                  data: this.acousticsDataPoints1,
                  lineDashType: "",
                  label: this.lableTwoX,
                  legendMarkerType: "none",
                });
                let dataAd = this.makeDataForChart(feedDataToArray);
                this.acousticsChartOne.charts[0].axisY.maximum = max_r_v;
                this.acousticsChartOne.charts[0].axisY.minimum = 0;
                this.acousticsChartOne.charts[0].unit = "dB";
                this.acousticsChartOne.charts[0].data = dataAd;
                this.acousticsChartOne.navigator.data = dataAd;
                this.acousticsChartOne.rangeChanging = rangeChanged;
                document.getElementById(
                  "monitoringMachineAcousticsChart"
                ).style.height = "370px";
                this.acousticsChart = new CanvasJS.StockChart(
                  "monitoringMachineAcousticsChart",
                  this.acousticsChartOne
                );
                this.acousticsChart.render();
                // console.log(this.acousticsChart);
                // console.log(this.acousticsChart.charts[0].axisY[0]);
                //Change color green`
                this.acousticsChart.charts[0].axisY[0].addTo(
                  "stripLines",
                  this.addBackgroundColor(min_g_v, max_g_v, this.greenColor)
                );
                this.acousticsChart.charts[0].axisY[0].addTo("stripLines", {
                  value: max_g_v,
                  label: max_g_v,
                  color: this.greenColor,
                  labelFontColor: "#000000",
                });
                //Change color yellow
                this.acousticsChart.charts[0].axisY[0].addTo(
                  "stripLines",
                  this.addBackgroundColor(max_g_v, max_y_v, this.yellowColor)
                );
                this.acousticsChart.charts[0].axisY[0].addTo("stripLines", {
                  value: max_y_v,
                  label: max_y_v,
                  color: this.yellowColor,
                  labelFontColor: "#000000",
                });
                //Change red
                this.acousticsChart.charts[0].axisY[0].addTo(
                  "stripLines",
                  this.addBackgroundColor(max_y_v, max_r_v, this.redColor)
                );
                this.acousticsChart.charts[0].axisY[0].addTo("stripLines", {
                  value: max_r_v,
                  label: max_r_v,
                  color: this.redColor,
                  labelFontColor: "#000000",
                });
                let self = this;
                // self.intervalAcousticsUpdate = setInterval(() => {
                //   self.updateMachineAcousticsChart();
                // }, self.updateAcousticsInterval);
              }
            } else {
              this.visibilityAcousticsChart = true;
              this.AcousticsLoading = false;
            }
          } else {
            this.visibilityAcousticsChart = true;
            this.AcousticsLoading = false;
          }
        } else {
          this.visibilityAcousticsChart = true;
          this.AcousticsLoading = false;
        }
      })
      .catch((error) => {
        this.visibilityAcousticsChart = true;
        this.AcousticsLoading = false;
      });
  }

  /****************Audible Chart**************************** */
  getAudibleChart() {
    this.AudibleLoading = true;
    this.audibleChartLoader = true;

    this.service
      .getDataWithQuery(
        this.sensorData +
          "/detail/" +
          "v2/" +
          parseInt(this.deviceId) +
          "/" +
          parseInt(this.assetId) +
          "/" +
          [36] +
          "/" +
          this.time_span +
          "?userid=" +
          this.userID +
          "&asset_type=" +
          this.assetType +
          "&start_date=" + this.startDateTrendChart + "&end_date=" + this.endDateTrendChart
      )
      .then((res) => {
        let autdibleRes = JSON.parse(JSON.stringify(res)).data;

        if (autdibleRes.status === "fail") {
          this.audibleChartLoader = false;
          this.msgAudibleChart = true;
          this.AudibleLoading = false;
        } else if (autdibleRes.status === "success") {
          if (autdibleRes.body.chartXdata.length != 0) {
            if (
              autdibleRes.body.chartXdata !== null &&
              autdibleRes.body.chartXdata !== undefined
            ) {
              this.audibleChartLoader = false;
              this.msgAudibleChart = false;
              this.AudibleLoading = false;
              let chartTwoResponse = JSON.parse(JSON.stringify(res));
              this.audLableX = autdibleRes.body.labelx;
              let audibleChartDataX = autdibleRes.body.chartXdata;
              this.xauavg =
                chartTwoResponse.data.body.movingAvg.x_hour.toFixed(2);
              this.xauavg_day =
                chartTwoResponse.data.body.movingAvg.x_day.toFixed(2);
              this.xauavg_week =
                chartTwoResponse.data.body.movingAvg.x_week.toFixed(2);
              // lastChartTime.setMinutes(lastChartTime.getMinutes() + 30);
              // let format1 = "YYYY-MM-DD HH:mm:ss";
              // let addedDate = new Date(lastChartTime);
              // let newDateBe = moment(addedDate).format(format1);
              this.audibleDataPoints1 = audibleChartDataX.map(function (
                val,
                index
              ) {
                let arr1: any = val.x.split(/[- :]/);
                let time1A = new Date(
                  arr1[0],
                  arr1[1] - 1,
                  arr1[2],
                  arr1[3],
                  arr1[4],
                  arr1[5]
                );
                let x = time1A;
                let y = val.y;
                return { x, y };
              });
              let min_g = autdibleRes.body.min || 0;
              let max_g = autdibleRes.body.green;
              let max_y = autdibleRes.body.yellow;
              let max_r = autdibleRes.body.red;
              if (document.getElementById("audibleChartId") !== null) {
                this.audibleChartGraph = cloneDeep(monitoringVelocityObject);
                this.audibleChartGraph.type = 0;
                this.audibleChartGraph.chartNumber = 1;
                let feedDataToArray = [];
                feedDataToArray.push({
                  data: this.audibleDataPoints1,
                  lineDashType: "",
                  label: this.audLableX,
                  legendMarkerType: "none",
                });
                let dataAd = this.makeDataForChart(feedDataToArray);
                this.audibleChartGraph.charts[0].axisY.maximum = max_r;
                this.audibleChartGraph.charts[0].axisY.minimum = 0;
                this.audibleChartGraph.charts[0].data = dataAd;
                this.audibleChartGraph.navigator.data = dataAd;
                document.getElementById("audibleChartId").style.height =
                  "370px";
                this.audibleChart = new CanvasJS.StockChart(
                  "audibleChartId",
                  this.audibleChartGraph
                );
                this.audibleChart.render();
                //Change color green`
                this.audibleChart.charts[0].axisY[0].addTo(
                  "stripLines",
                  this.addBackgroundColor(min_g, max_g, this.greenColor)
                );
                this.audibleChart.charts[0].axisY[0].addTo("stripLines", {
                  value: max_g,
                  label: max_g,
                  color: this.greenColor,
                  labelFontColor: "#000000",
                });
                //Change color yellow
                this.audibleChart.charts[0].axisY[0].addTo(
                  "stripLines",
                  this.addBackgroundColor(max_g, max_y, this.yellowColor)
                );
                this.audibleChart.charts[0].axisY[0].addTo("stripLines", {
                  value: max_y,
                  label: max_y,
                  color: this.yellowColor,
                  labelFontColor: "#000000",
                });
                //Change red
                this.audibleChart.charts[0].axisY[0].addTo(
                  "stripLines",
                  this.addBackgroundColor(max_y, max_r, this.redColor)
                );
                this.audibleChart.charts[0].axisY[0].addTo("stripLines", {
                  value: max_r,
                  label: max_r,
                  color: this.redColor,
                  labelFontColor: "#000000",
                });
              }
            } else {
              this.audibleChartLoader = false;
              this.msgAudibleChart = true;
              this.AudibleLoading = false;
            }
          } else {
            this.audibleChartLoader = false;
            this.msgAudibleChart = true;
            this.AudibleLoading = false;
          }
        }
      });
  }
  /****************Audible Chart end*******************************************/
  /********************************************
   * Temperature Trend (°C)
   ********************************************/
  getSensorTempCharts() {
    this.TemperatureLoading = true;
    if (this.firstTimeChartLoad) {
      this.service
        .getDataWithQuery(
          this.accelsensorData +
            "/v2" +
            "/" +
            parseInt(this.deviceId) +
            "/" +
            parseInt(this.assetId) +
            "/" +
            [1, 2, 3] +
            "/" +
            this.time_span +
            "?type=" +
            0 +
            "&userid=" +
            this.userID +
            "&asset_type=" +
            this.assetType +
            "&start_date=" + this.startDateTrendChart + "&end_date=" + this.endDateTrendChart
        )
        .then((res) => {
          if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
            if (
              JSON.parse(JSON.stringify(res)).data.body.chartXdata.length === 0
            ) {
              this.showTempChartEmpty = true;
              this.TemperatureLoading = false;
            }
          } else if (
            JSON.parse(JSON.stringify(res)).data.status === "success"
          ) {
            if (
              JSON.parse(JSON.stringify(res)).data.body.chartXdata.length !== 0
            ) {
              if (
                JSON.parse(JSON.stringify(res)).data.body.chartXdata !== null &&
                JSON.parse(JSON.stringify(res)).data.body.chartXdata !==
                  undefined
              ) {
                let tempArr = [];
                this.showTempChartEmpty = false;
                this.TemperatureLoading = false;
                let chartThreeResponse = JSON.parse(JSON.stringify(res));
                tempArr.push({ name: chartThreeResponse.data.body.labelx });
                tempArr.push({ name: chartThreeResponse.data.body.labely });
                tempArr.push({ name: chartThreeResponse.data.body.labelz });
                let labels = this.imposeRtdOrdering(tempArr);
                let lableTempX = labels[0].name;
                let lableTempY = labels[1].name;
                let lableTempZ = labels[2].name;
                let tempChartDataX = chartThreeResponse.data.body.chartXdata;
                // for (let i = 0; i < tempChartDataX.length; i++) {
                //   let testDateUtc = moment.utc(tempChartDataX[i].x).toDate();
                //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
                //   tempChartDataX[i].x = timeUpdatedAt;
                // }
                let tempChartDataY = chartThreeResponse.data.body.chartYdata;
                // for (let i = 0; i < tempChartDataY.length; i++) {
                //   let testDateUtc = moment.utc(tempChartDataY[i].x).toDate();
                //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
                //   tempChartDataY[i].x = timeUpdatedAt;
                // }
                let tempChartDataZ = chartThreeResponse.data.body.chartZdata;
                if (chartThreeResponse.data.body.x_avg == null)
                  chartThreeResponse.data.body.x_avg = 0;
                if (chartThreeResponse.data.body.y_avg == null)
                  chartThreeResponse.data.body.y_avg = 0;
                if (chartThreeResponse.data.body.z_avg == null)
                  chartThreeResponse.data.body.z_avg = 0;
                this.xtavg =
                  chartThreeResponse.data.body.movingAvg.x_hour === null
                    ? "N/A"
                    : chartThreeResponse.data.body.movingAvg.x_hour.toFixed(2);
                this.ytavg =
                  chartThreeResponse.data.body.movingAvg.y_hour === null
                    ? "N/A"
                    : chartThreeResponse.data.body.movingAvg.y_hour.toFixed(2);
                this.ztavg =
                  chartThreeResponse.data.body.movingAvg.z_hour === null
                    ? "N/A"
                    : chartThreeResponse.data.body.movingAvg.z_hour.toFixed(2);
                this.xtavg_day =
                  chartThreeResponse.data.body.movingAvg.x_day === null
                    ? "N/A"
                    : chartThreeResponse.data.body.movingAvg.x_day.toFixed(2);
                this.ytavg_day =
                  chartThreeResponse.data.body.movingAvg.y_day === null
                    ? "N/A"
                    : chartThreeResponse.data.body.movingAvg.y_day.toFixed(2);
                this.ztavg_day =
                  chartThreeResponse.data.body.movingAvg.z_day === null
                    ? "N/A"
                    : chartThreeResponse.data.body.movingAvg.z_day.toFixed(2);
                this.xtavg_week =
                  chartThreeResponse.data.body.movingAvg.x_week === null
                    ? "N/A"
                    : chartThreeResponse.data.body.movingAvg.x_week.toFixed(2);
                this.ytavg_week =
                  chartThreeResponse.data.body.movingAvg.y_week === null
                    ? "N/A"
                    : chartThreeResponse.data.body.movingAvg.y_week.toFixed(2);
                this.ztavg_week =
                  chartThreeResponse.data.body.movingAvg.z_week === null
                    ? "N/A"
                    : chartThreeResponse.data.body.movingAvg.z_week.toFixed(2);
                // for (let i = 0; i < tempChartDataZ.length; i++) {
                //   let testDateUtc = moment.utc(tempChartDataZ[i].x).toDate();
                //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
                //   tempChartDataZ[i].x = timeUpdatedAt;
                // }
                let lastChartTime: any = new Date(
                  new Date(tempChartDataX[tempChartDataX.length - 1]["x"])
                );
                lastChartTime.setMinutes(lastChartTime.getMinutes() + 30);
                let format1 = "YYYY-MM-DD HH:mm:ss";
                let addedDate = new Date(lastChartTime);
                let newDateBe = moment(addedDate).format(format1);
                tempChartDataX.push({ x: newDateBe, y: null });
                tempChartDataY.push({ x: newDateBe, y: null });
                tempChartDataZ.push({ x: newDateBe, y: null });
                this.dataTemperaturePoints1 = tempChartDataX.map(function (
                  val,
                  index
                ) {
                  let arr1: any = val.x.split(/[- :]/);
                  let time1A = new Date(
                    arr1[0],
                    arr1[1] - 1,
                    arr1[2],
                    arr1[3],
                    arr1[4],
                    arr1[5]
                  );
                  let x = time1A;
                  let y = val.y;
                  return { x, y };
                });
                this.dataTemperaturePoints2 = tempChartDataY.map(function (
                  val,
                  index
                ) {
                  let arr1: any = val.x.split(/[- :]/);
                  let time1A = new Date(
                    arr1[0],
                    arr1[1] - 1,
                    arr1[2],
                    arr1[3],
                    arr1[4],
                    arr1[5]
                  );
                  let x = time1A;
                  let y = val.y;
                  return { x, y };
                });
                this.dataTemperaturePoints3 = tempChartDataZ.map(function (
                  val,
                  index
                ) {
                  let arr1: any = val.x.split(/[- :]/);
                  let time1A = new Date(
                    arr1[0],
                    arr1[1] - 1,
                    arr1[2],
                    arr1[3],
                    arr1[4],
                    arr1[5]
                  );
                  let x = time1A;
                  let y = val.y;
                  return { x, y };
                });
                this.returnTempObj = JSON.parse(
                  JSON.stringify(res)
                ).data.body.returnobj;
                let minTemp_g = chartThreeResponse.data.body.min || 0;
                let maxTemp_g = chartThreeResponse.data.body.green;
                let maxTemp_y = chartThreeResponse.data.body.yellow;
                let maxTemp_r = chartThreeResponse.data.body.red;

                if (document.getElementById("tempChartContainer") !== null) {
                  /************RANGE SELECTOR PART***************** */
                  let rangeChanged = function (e) {
                    let minDate = new Date(e.minimum);
                    let maxDate = new Date(e.maximum);
                    let startDate = minDate.toISOString();
                    let endDate = maxDate.toISOString();
                    let c_no = e.stockChart.options.chartNumber;
                    // Above date object is converted
                    // into a string using toISOString() function.
                    if (
                      e.source != "navigator" &&
                      e.source != "chart" &&
                      e.source != "buttons"
                    ) {
                      var url = `${e.stockChart.options.url}/${e.stockChart.options.device_id}/${e.stockChart.options.asset_id}/${e.stockChart.options.type_array}/${e.stockChart.options.role}?type=0&userid=${e.stockChart.options.user_id}&asset_type=${e.stockChart.options.asset_id}&start_date=${startDate}&end_date=${endDate}`;
                      $.ajaxSetup({
                        headers: {
                          Authorization: e.stockChart.options.token,
                          timezone: e.stockChart.options.timezone,
                        },
                      });
                      $.getJSON(url, function (res) {
                        if (
                          JSON.parse(JSON.stringify(res)).data.status === "fail"
                        ) {
                        } else if (
                          JSON.parse(JSON.stringify(res)).data.status ===
                          "success"
                        ) {
                          if (
                            JSON.parse(JSON.stringify(res)).data.body.length !==
                            0
                          ) {
                            if (
                              JSON.parse(JSON.stringify(res)).data.body
                                .chartXdata !== null
                            ) {
                              let finalResponse = JSON.parse(
                                JSON.stringify(res)
                              );
                              let sensorChartDataX =
                                finalResponse.data.body.chartXdata;
                              let sensorChartDataY =
                                finalResponse.data.body.chartYdata;
                              let sensorChartDataZ =
                                finalResponse.data.body.chartZdata;
                              let pointVibration1 = sensorChartDataX.map(
                                function (val, index) {
                                  let arr1: any = val.x.split(/[- :]/);
                                  let time1A = new Date(
                                    arr1[0],
                                    arr1[1] - 1,
                                    arr1[2],
                                    arr1[3],
                                    arr1[4],
                                    arr1[5]
                                  );
                                  let x = time1A;
                                  let y = val.y;
                                  return { x, y };
                                }
                              );
                              let pointVibration2 = sensorChartDataY.map(
                                function (val, index) {
                                  let arr1: any = val.x.split(/[- :]/);
                                  let time1A = new Date(
                                    arr1[0],
                                    arr1[1] - 1,
                                    arr1[2],
                                    arr1[3],
                                    arr1[4],
                                    arr1[5]
                                  );
                                  let x = time1A;
                                  let y = val.y;
                                  return { x, y };
                                }
                              );
                              let pointVibration3 = sensorChartDataZ.map(
                                function (val, index) {
                                  let arr1: any = val.x.split(/[- :]/);
                                  let time1A = new Date(
                                    arr1[0],
                                    arr1[1] - 1,
                                    arr1[2],
                                    arr1[3],
                                    arr1[4],
                                    arr1[5]
                                  );
                                  let x = time1A;
                                  let y = val.y;
                                  return { x, y };
                                }
                              );
                              addData(
                                pointVibration1,
                                pointVibration2,
                                pointVibration3,
                                c_no
                              );
                            }
                          }
                        }
                      });
                    }
                  };

                  let addData = function (data1, data2, data3, cn) {
                    self.temperatureChart.options.charts[0].data[0].dataPoints =
                      [];
                    self.temperatureChart.options.charts[0].data[1].dataPoints =
                      [];
                    self.temperatureChart.options.charts[0].data[2].dataPoints =
                      [];
                    self.temperatureChart.options.charts[0].data[0].dataPoints.push(
                      ...data1
                    );
                    self.temperatureChart.options.charts[0].data[1].dataPoints.push(
                      ...data2
                    );
                    self.temperatureChart.options.charts[0].data[2].dataPoints.push(
                      ...data3
                    );
                    self.temperatureChart.render();
                  };
                  /********************************************* */

                  this.chartThree = cloneDeep(monitoringVelocityObject);
                  let feedDataToArray = [];
                  feedDataToArray.push({
                    data: this.dataTemperaturePoints1,
                    lineDashType: "",
                    label: lableTempX,
                    legendMarkerType: "none",
                  });
                  feedDataToArray.push({
                    data: this.dataTemperaturePoints2,
                    lineDashType: "",
                    label: lableTempY,
                    legendMarkerType: "none",
                  });
                  feedDataToArray.push({
                    data: this.dataTemperaturePoints3,
                    lineDashType: "",
                    label: lableTempZ,
                    legendMarkerType: "none",
                  });
                  /**INFO PASSED TO SERVICE  */
                  this.chartThree.url = this.accelsensorData;
                  this.chartThree.device_id = parseInt(this.deviceId);
                  this.chartThree.asset_id = parseInt(this.assetId);

                  this.chartThree.type_array = [1, 2, 3];
                  this.chartThree.role = "range";
                  this.chartThree.type = 0;
                  this.chartThree.user_id = this.userID;
                  this.chartThree.asset_type = this.assetType;
                  this.chartThree.token = localStorage.getItem("token");
                  this.chartOne.timezone =
                    localStorage.getItem("clientTimeZone");
                  this.chartThree.chartNumber = 2;
                  /*****************************/
                  let dataAd = this.makeDataForChart(feedDataToArray);
                  this.chartThree.charts[0].axisY.maximum = maxTemp_r;
                  this.chartThree.charts[0].axisY.minimum = 0;
                  this.chartThree.charts[0].unit = "°C";
                  this.chartThree.charts[0].data = dataAd;
                  this.chartThree.navigator.data = dataAd;
                  this.chartThree.rangeChanging = rangeChanged;
                  document.getElementById("tempChartContainer").style.height =
                    "370px";
                  this.temperatureChart = new CanvasJS.StockChart(
                    "tempChartContainer",
                    this.chartThree
                  );
                  this.temperatureChart.render();
                  //Change color green`
                  this.temperatureChart.charts[0].axisY[0].addTo(
                    "stripLines",
                    this.addBackgroundColor(
                      minTemp_g,
                      maxTemp_g,
                      this.greenColor
                    )
                  );

                  this.temperatureChart.charts[0].axisY[0].addTo("stripLines", {
                    value: maxTemp_g,
                    label: maxTemp_g,
                    color: this.greenColor,
                    labelFontColor: "#000000",
                  });
                  //Change color yellow
                  this.temperatureChart.charts[0].axisY[0].addTo(
                    "stripLines",
                    this.addBackgroundColor(
                      maxTemp_g,
                      maxTemp_y,
                      this.yellowColor
                    )
                  );
                  this.temperatureChart.charts[0].axisY[0].addTo("stripLines", {
                    value: maxTemp_y,
                    label: maxTemp_y,
                    color: this.yellowColor,
                    labelFontColor: "#000000",
                  });
                  //Change red
                  this.temperatureChart.charts[0].axisY[0].addTo(
                    "stripLines",
                    this.addBackgroundColor(maxTemp_y, maxTemp_r, this.redColor)
                  );
                  this.temperatureChart.charts[0].axisY[0].addTo("stripLines", {
                    value: maxTemp_r,
                    label: maxTemp_r,
                    color: this.redColor,
                    labelFontColor: "#000000",
                  });
                  let self = this;
                  // this.intervalSensorUpdate = setInterval(() => {
                  //   self.updateTemperatureChart();
                  // }, self.updateInterval);
                }
              } else {
                this.showTempChartEmpty = true;
                this.TemperatureLoading = false;
              }
            } else {
              this.showTempChartEmpty = true;
              this.TemperatureLoading = false;
            }
          } else {
            this.showTempChartEmpty = true;
            this.TemperatureLoading = false;
          }
        });
    } else {
      const slideThreeInterval = setInterval(() => {
        if (document.getElementById("tempChartContainer") !== null) {
          this.chartThree.width = 1550;
          this.chartThree.height = 300;
          if (Object.keys(this.chartThree).length != 0) {
            this.temperatureChart = new CanvasJS.StockChart(
              "tempChartContainer",
              this.chartThree
            );
            this.temperatureChart.render();
            let self = this;
            // self.intervalSensorUpdate = setInterval(() => {
            //   self.updateTemperatureChart();
            // }, self.updateInterval);
          } else {
            this.firstTimeChartLoad = true;
            this.getSensorTempCharts();
          }
        }
        clearInterval(slideThreeInterval);
      }, 1000);
    }
  }
  getrssiandbatterystatus() {
    let endpoint =
      this.deviceStatusURL + "inventory/rssi/" + `${this.mac_address}`;

    this.service
      .getDataWithQuery(endpoint)
      .then((res) => {
        if (JSON.parse(JSON.stringify(res)).length == 0) {
          this.rssival = "N/A";
        } else {
          const Response = JSON.parse(JSON.stringify(res));

          this.rssival = Response[0].rssi_value;
        }
      })
      .catch((err) => {
        this.rssival = "N/A";
      });

    let endpointforbatterystatus =
      this.deviceStatusURL + "device/batterystatus/" + `${this.mac_address}`;
    // this.service
    //   .getDataWithQuery(endpointforbatterystatus)
    //   .then((res) => {
    //     const Response = JSON.parse(JSON.stringify(res));
    //     if (Response.data.body != null) {
    //       this.Battery = true;
    //       this.Batterpercentage = Response.data.body.battery_percentage;
    //       if (this.Batterpercentage <= 20) {
    //         this.Batteryred = true;
    //       } else if (
    //         this.Batterpercentage > 20 &&
    //         this.Batterpercentage <= 50
    //       ) {
    //         this.Batteryyellow = true;
    //       } else {
    //         this.Batterygreen = true;
    //       }
    //     } else {
    //       this.Battery = false;
    //     }
    //   })
    //   .catch((err) => {});
  }
  itemtooltiptext() {
    return `Battery status : ${this.Batterpercentage}%`;
  }
  // updateMachineAcousticsChart() {
  //   if (this.updateIntervalBool2 === false) {
  //     this.updateIntervalBool2 = true;
  //     this.service
  //       .postData(this.SENSOR_UPDATE_INFO, this.returnAcousticsObj)
  //       .then((res) => {
  //         if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
  //         } else if (
  //           JSON.parse(JSON.stringify(res)).data.status === "success"
  //         ) {
  //           if (
  //             JSON.parse(JSON.stringify(res)).data.body.chartXdata !== null &&
  //             JSON.parse(JSON.stringify(res)).data.body.chartXdata !== undefined
  //           ) {
  //             this.acousticsDataPoints1.pop();
  //             let updateSensorChartDataX = JSON.parse(JSON.stringify(res)).data
  //               .body.chartXdata;
  //             let lastChartTime: any = new Date(
  //               new Date(
  //                 updateSensorChartDataX[updateSensorChartDataX.length - 1]["x"]
  //               )
  //             );
  //             lastChartTime.setMinutes(lastChartTime.getMinutes() + 30);
  //             let format1 = "YYYY-MM-DD HH:mm:ss";
  //             let addedDate = new Date(lastChartTime);
  //             let newDateBe = moment(addedDate).format(format1);
  //             updateSensorChartDataX.push({ x: newDateBe, y: null });
  //             let pointVibration1 = updateSensorChartDataX.map(function (
  //               val,
  //               index
  //             )
  //              {
  //               let arr1: any = val.x.split(/[- :]/);
  //               let time1A = new Date(
  //                 arr1[0],
  //                 arr1[1] - 1,
  //                 arr1[2],
  //                 arr1[3],
  //                 arr1[4],
  //                 arr1[5]
  //               );
  //               let x = time1A;
  //               let y = val.y;
  //               return { x, y };
  //             });
  //             let lastUpdatedTime: any = new Date(
  //               new Date(this.dataPoints1[this.dataPoints1.length - 1]["x"])
  //             );
  //             let newUpdatedTime: any = new Date(
  //               new Date(pointVibration1[pointVibration1.length - 1]["x"])
  //             );
  //             if (lastUpdatedTime < newUpdatedTime) {
  //               this.acousticsDataPoints1.push(...pointVibration1);
  //               this.acousticsChart.render();
  //               this.returnAcousticsObj = JSON.parse(
  //                 JSON.stringify(res)
  //               ).data.body.returnobj;
  //             } else {

  //             }
  //           } else {

  //           }
  //         } else {
  //         }
  //       });
  //     this.updateIntervalBool2 = false;
  //   }
  // }

  /********************************************
   * Update - Vibration Acceleration Trend (m/sec<sup>2</sup>)
   ********************************************/
  // updateVibrationChart() {
  //   if (this.updateIntervalBool2 === false) {
  //     this.updateIntervalBool2 = true;
  //     this.service
  //       .postData(this.SENSOR_UPDATE_INFO, this.returnVibrartionObj)
  //       .then((res) => {
  //         if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
  //         } else if (
  //           JSON.parse(JSON.stringify(res)).data.status === "success"
  //         ) {
  //           if (
  //             JSON.parse(JSON.stringify(res)).data.body.chartXdata !== null &&
  //             JSON.parse(JSON.stringify(res)).data.body.chartXdata !== undefined
  //           ) {
  //             console.log( this.dataPoints1,'before pop')
  //             this.dataPoints1.pop();
  //             console.log( this.dataPoints1,'after pop')
  //             this.dataPoints2.pop();
  //             this.dataPoints3.pop();
  //             let updateSensorChartDataX = JSON.parse(JSON.stringify(res)).data
  //               .body.chartXdata;
  //             let updateSensorChartDataY = JSON.parse(JSON.stringify(res)).data
  //               .body.chartYdata;
  //             let updateSensorChartDataZ = JSON.parse(JSON.stringify(res)).data
  //               .body.chartZdata;
  //             let lastChartTime: any = new Date(
  //               new Date(
  //                 updateSensorChartDataX[updateSensorChartDataX.length - 1]["x"]
  //               )
  //             );
  //             lastChartTime.setMinutes(lastChartTime.getMinutes() + 30);
  //             let format1 = "YYYY-MM-DD HH:mm:ss";
  //             let addedDate = new Date(lastChartTime);
  //             let newDateBe = moment(addedDate).format(format1);
  //             updateSensorChartDataX.push({ x: newDateBe, y: null });
  //             updateSensorChartDataY.push({ x: newDateBe, y: null });
  //             updateSensorChartDataZ.push({ x: newDateBe, y: null });
  //             let pointVibration1 = updateSensorChartDataX.map(function (
  //               val,
  //               index
  //             ) {
  //               let arr1: any = val.x.split(/[- :]/);
  //               let time1A = new Date(
  //                 arr1[0],
  //                 arr1[1] - 1,
  //                 arr1[2],
  //                 arr1[3],
  //                 arr1[4],
  //                 arr1[5]
  //               );
  //               let x = time1A;
  //               let y = val.y;
  //               return { x, y };
  //             });
  //             let pointVibration2 = updateSensorChartDataY.map(function (
  //               val,
  //               index
  //             ) {
  //               let arr1: any = val.x.split(/[- :]/);
  //               let time1A = new Date(
  //                 arr1[0],
  //                 arr1[1] - 1,
  //                 arr1[2],
  //                 arr1[3],
  //                 arr1[4],
  //                 arr1[5]
  //               );
  //               let x = time1A;
  //               let y = val.y;
  //               return { x, y };
  //             });
  //             let pointVibration3 = updateSensorChartDataZ.map(function (
  //               val,
  //               index
  //             ) {
  //               let arr1: any = val.x.split(/[- :]/);
  //               let time1A = new Date(
  //                 arr1[0],
  //                 arr1[1] - 1,
  //                 arr1[2],
  //                 arr1[3],
  //                 arr1[4],
  //                 arr1[5]
  //               );
  //               let x = time1A;
  //               let y = val.y;
  //               return { x, y };
  //             });
  //             let lastUpdatedTime: any = new Date(
  //               new Date(this.dataPoints1[this.dataPoints1.length - 1]["x"])
  //             );
  //             let newUpdatedTime: any = new Date(
  //               new Date(pointVibration1[pointVibration1.length - 1]["x"])
  //             );
  //             if (lastUpdatedTime < newUpdatedTime) {
  //               console.log('lastupdatedate')
  //               this.dataPoints1.push(...pointVibration1);
  //               this.dataPoints2.push(...pointVibration2);
  //               this.dataPoints3.push(...pointVibration3);
  //               this.chart.render();
  //               this.returnVibrartionObj = JSON.parse(
  //                 JSON.stringify(res)
  //               ).data.body.returnobj;
  //             } else {
  //             }
  //           } else {

  //           }
  //         } else {
  //         }
  //       });
  //     this.updateIntervalBool2 = false;
  //   }
  // }

  /********************************************
   * Update Vibration Velocity Trend (mm/sec)
   ********************************************/
  UpdateMAchinealertSettingsforasset() {
    //Code to impement machine alert Sunmary settings

    this.aalertSettings();
  }

  // updateMonitoringVelocityChart() {
  //   if (this.updateIntervalBool2 === false) {
  //     this.updateIntervalBool2 = true;
  //     this.service
  //       .postData(this.SENSOR_UPDATE_INFO, this.returnMonVelocityObj)
  //       .then((res) => {
  //         if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
  //         } else if (
  //           JSON.parse(JSON.stringify(res)).data.status === "success"
  //         ) {
  //           if (
  //             JSON.parse(JSON.stringify(res)).data.body.chartXdata !== null &&
  //             JSON.parse(JSON.stringify(res)).data.body.chartXdata !== undefined
  //           ) {
  //             this.velocityDataPoints1.pop();
  //             this.velocityDataPoints2.pop();
  //             this.velocityDataPoints3.pop();
  //             let updateSensorChartDataX = JSON.parse(JSON.stringify(res)).data
  //               .body.chartXdata;
  //             let updateSensorChartDataY = JSON.parse(JSON.stringify(res)).data
  //               .body.chartYdata;
  //             let updateSensorChartDataZ = JSON.parse(JSON.stringify(res)).data
  //               .body.chartZdata;
  //             let lastChartTime: any = new Date(
  //               new Date(
  //                 updateSensorChartDataX[updateSensorChartDataX.length - 1]["x"]
  //               )
  //             );
  //             lastChartTime.setMinutes(lastChartTime.getMinutes() + 30);
  //             let format1 = "YYYY-MM-DD HH:mm:ss";
  //             let addedDate = new Date(lastChartTime);
  //             let newDateBe = moment(addedDate).format(format1);
  //             updateSensorChartDataX.push({ x: newDateBe, y: null });
  //             updateSensorChartDataY.push({ x: newDateBe, y: null });
  //             updateSensorChartDataZ.push({ x: newDateBe, y: null });
  //             let pointVibration1 = updateSensorChartDataX.map(function (
  //               val,
  //               index
  //             ) {
  //               let arr1: any = val.x.split(/[- :]/);
  //               let time1A = new Date(
  //                 arr1[0],
  //                 arr1[1] - 1,
  //                 arr1[2],
  //                 arr1[3],
  //                 arr1[4],
  //                 arr1[5]
  //               );
  //               let x = time1A;
  //               let y = val.y;
  //               return { x, y };
  //             });
  //             let pointVibration2 = updateSensorChartDataY.map(function (
  //               val,
  //               index
  //             ) {
  //               let arr1: any = val.x.split(/[- :]/);
  //               let time1A = new Date(
  //                 arr1[0],
  //                 arr1[1] - 1,
  //                 arr1[2],
  //                 arr1[3],
  //                 arr1[4],
  //                 arr1[5]
  //               );
  //               let x = time1A;
  //               let y = val.y;
  //               return { x, y };
  //             });
  //             let pointVibration3 = updateSensorChartDataZ.map(function (
  //               val,
  //               index
  //             ) {
  //               let arr1: any = val.x.split(/[- :]/);
  //               let time1A = new Date(
  //                 arr1[0],
  //                 arr1[1] - 1,
  //                 arr1[2],
  //                 arr1[3],
  //                 arr1[4],
  //                 arr1[5]
  //               );
  //               let x = time1A;
  //               let y = val.y;
  //               return { x, y };
  //             });
  //             let lastUpdatedTime: any = new Date(
  //               new Date(
  //                 this.velocityDataPoints1[this.velocityDataPoints1.length - 1][
  //                   "x"
  //                 ]
  //               )
  //             );
  //             let newUpdatedTime: any = new Date(
  //               new Date(pointVibration1[pointVibration1.length - 1]["x"])
  //             );
  //             if (lastUpdatedTime < newUpdatedTime) {
  //               this.velocityDataPoints1.push(...pointVibration1);
  //               this.velocityDataPoints2.push(...pointVibration2);
  //               this.velocityDataPoints3.push(...pointVibration3);
  //               this.velocityChart.render();
  //               this.returnVelocityObj = JSON.parse(
  //                 JSON.stringify(res)
  //               ).data.body.returnobj;
  //             } else {
  //             }
  //           } else {
  //           }
  //         } else {
  //         }
  //       });
  //     this.updateIntervalBool2 = false;
  //   }
  // }

  /********************************************
   * Update - Temperature Trend (°C)
   ********************************************/
  // updateTemperatureChart() {
  //   if (this.updateIntervalBool3 === false) {
  //     this.updateIntervalBool3 = true;
  //     this.service
  //       .postData(this.SENSOR_UPDATE_INFO, this.returnTempObj)
  //       .then((res) => {
  //         if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
  //         } else if (
  //           JSON.parse(JSON.stringify(res)).data.status === "success"
  //         ) {
  //           if (
  //             JSON.parse(JSON.stringify(res)).data.body.chartXdata !== null &&
  //             JSON.parse(JSON.stringify(res)).data.body.chartXdata !== undefined
  //           ) {
  //             this.dataTemperaturePoints1.pop();
  //             this.dataTemperaturePoints2.pop();
  //             this.dataTemperaturePoints3.pop();
  //             let updateTempChartDataX = JSON.parse(JSON.stringify(res)).data
  //               .body.chartXdata;
  //             let updateTempChartDataY = JSON.parse(JSON.stringify(res)).data
  //               .body.chartYdata;
  //             let updateTempChartDataZ = JSON.parse(JSON.stringify(res)).data
  //               .body.chartZdata;
  //             let lastChartTime: any = new Date(
  //               new Date(
  //                 updateTempChartDataX[updateTempChartDataX.length - 1]["x"]
  //               )
  //             );
  //             lastChartTime.setMinutes(lastChartTime.getMinutes() + 30);
  //             let format1 = "YYYY-MM-DD HH:mm:ss";
  //             let addedDate = new Date(lastChartTime);
  //             let newDateBe = moment(addedDate).format(format1);
  //             updateTempChartDataX.push({ x: newDateBe, y: null });
  //             updateTempChartDataY.push({ x: newDateBe, y: null });
  //             updateTempChartDataZ.push({ x: newDateBe, y: null });
  //             let TemperaturePoints1 = updateTempChartDataX.map(function (
  //               val,
  //               index
  //             ) {
  //               let arr1: any = val.x.split(/[- :]/);
  //               let time1A = new Date(
  //                 arr1[0],
  //                 arr1[1] - 1,
  //                 arr1[2],
  //                 arr1[3],
  //                 arr1[4],
  //                 arr1[5]
  //               );
  //               let x = time1A;
  //               let y = val.y;
  //               return { x, y };
  //             });
  //             let TemperaturePoints2 = updateTempChartDataY.map(function (
  //               val,
  //               index
  //             ) {
  //               let arr1: any = val.x.split(/[- :]/);
  //               let time1A = new Date(
  //                 arr1[0],
  //                 arr1[1] - 1,
  //                 arr1[2],
  //                 arr1[3],
  //                 arr1[4],
  //                 arr1[5]
  //               );
  //               let x = time1A;
  //               let y = val.y;
  //               return { x, y };
  //             });
  //             let TemperaturePoints3 = updateTempChartDataZ.map(function (
  //               val,
  //               index
  //             ) {
  //               let arr1: any = val.x.split(/[- :]/);
  //               let time1A = new Date(
  //                 arr1[0],
  //                 arr1[1] - 1,
  //                 arr1[2],
  //                 arr1[3],
  //                 arr1[4],
  //                 arr1[5]
  //               );
  //               let x = time1A;
  //               let y = val.y;
  //               return { x, y };
  //             });
  //             let lastUpdatedTime: any = new Date(
  //               new Date(
  //                 this.dataTemperaturePoints1[
  //                   this.dataTemperaturePoints1.length - 1
  //                 ]["x"]
  //               )
  //             );
  //             let newUpdatedTime: any = new Date(
  //               new Date(TemperaturePoints1[TemperaturePoints1.length - 1]["x"])
  //             );
  //             if (lastUpdatedTime < newUpdatedTime) {
  //               this.dataTemperaturePoints1.push(...TemperaturePoints1);
  //               this.dataTemperaturePoints2.push(...TemperaturePoints2);
  //               this.dataTemperaturePoints3.push(...TemperaturePoints3);
  //               this.temperatureChart.render();
  //               this.returnTempObj = JSON.parse(
  //                 JSON.stringify(res)
  //               ).data.body.returnobj;
  //             } else {
  //             }
  //           } else {
  //           }
  //         } else {
  //         }
  //         this.updateIntervalBool3 = false;
  //       });
  //   }
  // }
  //electrical signature dropdown

  getElectricalDropDown() {
    this.service
      .getDataWithQuery(
        this.electricalDropDown +
          "/" +
          this.userID +
          "/" +
          this.deviceId +
          "/" +
          this.assetId
      )
      .then((res) => {
        let response = JSON.parse(JSON.stringify(res)).data;
        if (response.body.message != "No Data found for Given Params") {
          if (response.status === "fail") {
            // this.service.showError('No Data found for Given Params');
          } else if (response.status === "success") {
            if (response.body.length != 0) {
              this.ESADisabled = false;
              this.electricalDropDownList = response.body.body.map((val) => {
                let obj = {
                  id: val.id,
                  devicerawMatricId: val.device_raw_matric_id,
                  batch_id: val.batch_id,
                  time: val.updated_at,
                };
                return obj;
              });
              // this.electricalDropDownList=response.body.body;
              this.device_raw_matric_id =
                this.electricalDropDownList[0].devicerawMatricId;
              // this.electricalLabelVal = new ConvertDatetimePipe().convertDateTime(this.electricalDropDownList[0].time);
              this.getElectricalChart();
              this.getCurrentAcceleration();
            } else {
              this.ESADisabled = true;
            }
          }
        } else {
          this.ESADisabled = true;
          // this.service.showwaiting('No Data found for Given Params');
          this.getElectricalChart();
          this.getCurrentAcceleration();
        }
      });
  }
  selectRawMatricId(val) {
    this.device_raw_matric_id = val;
    const selectedVal = this.electricalDropDownList.filter(
      (key) => key.devicerawMatricId == val
    );
    // this.electricalLabelVal = new ConvertDatetimePipe().convertDateTime(selectedVal[0].time);
    this.getElectricalChart();
    this.getCurrentAcceleration();
  }

  //end
  // getFftList() {
  //   let response: any;
  //   console.log(this.deviceId,this.assetId)
  //   this.service
  //     .getDataWithQuery(
  //       this.Fft_List +
  //         "/" +
  //         this.deviceId +
  //         "/" +
  //         this.assetId +
  //         "?userid=" +
  //         this.userID +
  //         "&role=" +
  //         localStorage.getItem("role") +
  //         "&asset_type=" +
  //         this.assetType
  //     )
  //     .then((res) => {
  //       this.chartBoxVisibility = true;
  //       response = JSON.parse(JSON.stringify(res)).data;
  //       if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
  //         this.downloadDisabled = true;
  //         this.msgDownload =
  //           "FFT values are currently unavailable. Please initiate an on-demand spectrum to generate the asset health report.";
  //         this.chartBoxVisibility = false;
  //         const msgErr = response.body.message;
  //         this.service.showError(msgErr);
  //       } else if (response.status === "success") {
  //         if (response.body.length !== 0) {
  //           if (this.onoffStatus == 2) {
  //             this.msgDownload = "Asset is offline.";
  //           }
  //           let self = this;
  //           self.trendAnalysDataPeriodic = [];
  //           self.trendAnalysDataAnomaly = [];
  //           self.fftMarkers = [];
  //           //Add this line for DiagnosticsArray without date format.
  //           this.DiagnosticsArray = response.body;
  //           this.trendAnalysData = response.body.map(function (val, index) {
  //             self.fftMarkers.push({
  //               label: val.label,
  //               fft_time: val.fft_time,
  //               fftId: val.value,
  //             });
  //             // this.forSAonDemandLabel= val.label;
  //             const ffttestDateUtc = moment.utc(val.fft_time);
  //             const localDatefft = ffttestDateUtc.local();
  //             const fftTIME = new ConvertDatetimePipe().convertDateTime(
  //               localDatefft
  //             );
  //             const nObj = {
  //               key: index,
  //               SAname: val.label,
  //               label: fftTIME,
  //               fft_time: val.fft_time,
  //               line_freq: val.line_freq,
  //               rated_rpm: val.rated_rpm,
  //               actual_rpm: val.actual_rpm,
  //               value: val.value,
  //               error: val.error,
  //               observe: val.observe,
  //               op_freq: val.op_freq,
  //               p_actual_rpm: val.p_actual_rpm,
  //               p_rated_rpm: val.p_rated_rpm,
  //             };
  //             if (val.label.includes("Periodic")) {
  //               self.trendAnalysDataPeriodic.push(nObj);
  //             } else {
  //               self.trendAnalysDataAnomaly.push(nObj);
  //             }
  //             return nObj;
  //           });

  //           // this.fftLabelValue = this.trendAnalysData[0].label;
  //           let _timeFft;
  //           const timeFFTNew = this.trendAnalysData.filter(
  //             (v) =>
  //               parseInt(v.value) === parseInt(this.trendAnalysData[0].value)
  //           );
  //           _timeFft = timeFFTNew;
  //           this._fftDate = _timeFft[0].label;
  //           this._rated_rpm = _timeFft[0].rated_rpm;
  //           this._line_frequency =
  //             _timeFft[0].line_freq == null
  //               ? null
  //               : _timeFft[0].line_freq.toFixed(1);
  //           this._actualrpm = _timeFft[0].actual_rpm.toFixed(0);

  //           this.OperatingLineFrequency = _timeFft[0].op_freq.toFixed(1);
  //           // this._ffteError = _timeFft[0].error;
  //           this._observe_value = _timeFft[0].observe;
  //           this.selectedFFTUID = _timeFft[0].value;
  //           this.pinion_gear_rated_rpm = _timeFft[0].p_rated_rpm;
  //           this.outer_gear_rated_rpm = _timeFft[0].rated_rpm;
  //           this.pinionActualForDiagnosticslabel = Math.ceil(
  //             _timeFft[0].p_actual_rpm
  //           );

  //           this.outerActualForDiagnosticslabel = Math.ceil(
  //             _timeFft[0].actual_rpm.toFixed(0)
  //           );
  //           if (self.trendAnalysDataPeriodic.length === 0) {
  //             this.loadFftData(null, "periodic");
  //           } else {
  //             this.loadFftData(this.selectedFFTUID, "periodic");
  //           }
  //         } else {
  //           this.downloadDisabled = true;
  //           this.msgDownload =
  //             "FFT values are currently unavailable. Please initiate an on-demand spectrum to generate the asset health report.";
  //           this.pinion_gear_rated_rpm = "N/A";
  //           this.outer_gear_rated_rpm = "N/A";
  //         }
  //       }
  //     });
  // }

  getDeviceReport() {
    // this.onoffStatus=
    this.hideDownloadBtn = false;
    this.showReportMsg = "Preparing, Please wait...";
    let body: any = {
      creater_id: localStorage.getItem("user_id"),
      asset_id: this.assetId,
      inventory_id: this.deviceId,
      fft_value: this.selectedFFTUID,
      fftIdAdvance: this.fftIdforAdvance || 0
    };
    if (localStorage.getItem("role") === "ADMIN") {
      body.user_id = localStorage.getItem("admin_client_id");
    } else if (localStorage.getItem("role") === "CLIENT") {
      body.user_id = localStorage.getItem("user_id");
    } else if (localStorage.getItem("role") === "USER") {
      body.user_id = localStorage.getItem("associated_clientid");
    } else {
      body.user_id = localStorage.getItem("admin_client_id");
    }

    this.service.postAssetReport(this.device_report_api, body).then((res) => {
      if (JSON.parse(JSON.stringify(res)).status === 200) {
        if (JSON.parse(JSON.stringify(res)).message === "Missing FFT Value!") {
          this.service.showError("Missing FFT Value.");
        } else {
          this.hideDownloadBtn = true;
          this.showReportMsg = "";
          this.service.showSuccess("Report created successfully.");
        }
      } else {
        this.hideDownloadBtn = true;
        this.showReportMsg = "";
        this.service.showError("Error while preparing your report.");
      }
    });
  }

  ForcedSpectralAnalysis() {
    let response: any;
    const body = {
      deviceid: this.deviceId,
      assetid: this.assetId,
      api_type: "fft_force",
    };
    this.service
      .getDataWithQuery(
        this.base_diagnostics + "fftforce" +
          "/" +
          this.deviceId +
          "/" +
          this.assetId +
          "?userid=" +
          this.userID +
          "&asset_type=" +
          this.assetType
      )
      .then((res) => {
        response = JSON.parse(JSON.stringify(res)).data;
        if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
          this.loaderAddClass = "";
          const msgErr = response.body.message;
          this.service.showError(msgErr);
        } else if (response.status === "success") {
          this.loaderAddClass = "";
          this._spectralLoader = false;
          // this.getFftList();
          this.getDiagnosticsFFTList();
          this.fetchRPMDetails();
          if (this.activeTabID === 1) {
            this.insideTabChange("innertab-1");
          } else if (this.activeTabID === 2) {
            this.insideTabChange("innertab-2");
          } else if (this.activeTabID === 3) {
            this.insideTabChange("innertab-3");
          } else if (this.activeTabID === 4) {
            this.insideTabChange("innertab-4");
          } else if (this.activeTabID === 5) {
            this.insideTabChange("innertab-5");
          }
        }
      });
    this.getMachineDiagnosticsDone();
  }

  loadFftData(value, type) {
    this.loader = true;
    this.anomalyType = type;
    this.forSAonDemandLabel = type;
    if (type === "periodic") {
      this.selectedFFTUIDPeriodic = value;
      this.selectedFFTUIDAnomaly = null;
    } else {
      this.selectedFFTUIDPeriodic = null;
      this.selectedFFTUIDAnomaly = value;
    }
    const event_val = this.trendAnalysData.filter(
      (e) => JSON.parse(e.value) == JSON.parse(value)
    );
    // this.fftLabelValue = event_val[0].label;
    //this.predominentFreq(this.deviceId, event_val[0].value);
    //this.getFrequentDetail(event_val[0].value);
    if (event_val.length != 0) {
      this.selectedFFTUID = event_val[0].value;

      this.pinion_gear_rated_rpm = event_val[0].p_rated_rpm;
      this.pinionActualForDiagnosticslabel = Math.ceil(
        event_val[0].p_actual_rpm
      );

      this.outer_gear_rated_rpm = event_val[0].rated_rpm;
      this.outerActualForDiagnosticslabel = Math.ceil(event_val[0].actual_rpm);
      this._fftDate = event_val[0].label;
      this._rated_rpm = event_val[0].rated_rpm;
      this._line_frequency =
        event_val[0].line_freq == null
          ? "N/A"
          : event_val[0].line_freq.toFixed(1);
      this._actualrpm = event_val[0].actual_rpm.toFixed(0);
      this.opr_rpm = event_val[0].actual_rpm.toFixed(0);
      // this._ffteError = event_val[0].error;
      this._observe_value = event_val[0].observe;
      this.OperatingLineFrequency = event_val[0].op_freq.toFixed(1);
      this.spectrumAnalysisCase = event_val[0].SAname === "On-Demand SA : "
        ? "SA On-demand Spectrum Analysed at:- "
        : event_val[0].SAname === "Periodic SA : "
        ? "Periodic Spectrum Analysed at:- "
        : "Anomaly Spectrum Analysed at:- ";
    }
    //this.faultDetails();
    //this.conditionDetails();
    // this.diagnosticsSummary(this.selectedFFTUID, this.fftIdforAdvance, true);
    if(this.selectedFFTUID !== undefined) {
      this.getDiagnosticsSummary(this.selectedFFTUID, this.fftIdforAdvance, true);
    }
    this.callDiagnosticsSummary = true;
    // this.setFaults();
  }
  getFrequentDetail(val) {
    this.getFrequentChart(val, this.xAxisScaleTypeGlobal);
    this.getfftSensorDetail();
  }

  getfftSensorDetail() {
    if (this.selectedFFTUID !== undefined) {
      this.service
        .getDataWithQuery(
          this.sensorFFTINFO +
            "/" +
            this.selectedFFTUID +
            "/" +
            [1, 2, 3, 25, 26, 27] +
            "/" +
            this.assetId +
            "?userid=" +
            this.userID +
            "&asset_type=" +
            this.assetType
        )
        .then((res) => {
          if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
          } else if (
            JSON.parse(JSON.stringify(res)).data.status === "success"
          ) {
            let sensorData =
              JSON.parse(JSON.stringify(res)).data.body.sensor === undefined
                ? []
                : JSON.parse(JSON.stringify(res)).data.body.sensor.sensor;
            let resultBody = JSON.parse(JSON.stringify(res)).data.body;
            this.mySensFFTVelocity = [];
            this.mySensFFTTemperature = [];
            this.mySensFFTOrientation = [];
            this.mySensFFTAcceleration = [];
            let newFFTTempArray = [];
            if (sensorData.length !== 0) {
              for (var i = 0; i < sensorData.length; i++) {
                if (sensorData[i].mgroup === "temperature") {
                  sensorData[i].value = sensorData[i].value.toFixed(2);
                  sensorData[i].max_range = resultBody.range_temperature.temp_2;
                  newFFTTempArray.push(sensorData[i]);
                } else if (sensorData[i].mgroup === "orientation") {
                  sensorData[i].value = sensorData[i].value.toFixed(2);
                  sensorData[i].max_range =
                    resultBody.range_acceleration.acceleration_2;
                  this.mySensFFTOrientation.push(sensorData[i]);
                } else if (sensorData[i].mgroup === "velocity") {
                  sensorData[i].value = sensorData[i].value.toFixed(2);
                  sensorData[i].max_range = resultBody.velocity.yellow;
                  this.mySensFFTVelocity.push(sensorData[i]);
                }
              }
              let tempA = [];
              for (let ft = 0; ft < newFFTTempArray.length; ft++) {
                if (ft < 3) {
                  newFFTTempArray[ft]["name"] = newFFTTempArray[ft].label;
                  tempA.push(newFFTTempArray[ft]);
                  if (tempA.length >= 3) {
                    this.mySensFFTTemperature = this.imposeRtdOrdering(tempA);
                  }
                }
              }
              this.mySensFFTAcceleration = this.meterShownResult.map(function (
                val,
                index
              ) {
                let accObj = {
                  label: val.name,
                  value: val.centralLabel,
                  max_range: resultBody.range_acceleration.acceleration_3,
                };
                return accObj;
              });
            }
          }
        });
    }
  }

  // bearingDetail(rawid) {
  //   if (rawid !== undefined) {
  //     this.service
  //       .getDataWithQuery(
  //         this.bearing_url_detail +
  //         "/" +
  //         rawid +
  //         "?userid=" +
  //         this.userID +
  //         "&asset_type=" +
  //         this.assetType
  //       )
  //       .then((res) => {
  //         if (JSON.parse(JSON.stringify(res)).data.status === "success") {
  //           let result = JSON.parse(JSON.stringify(res)).data;
  //           if (result.code === 200) {
  //             this.bearingFaults = [];
  //             for (let ber = 0; ber < result.body.length; ber++) {
  //               let body = {
  //                 label: result.body[ber].value[2],
  //                 values: result.body[ber].value.slice(
  //                   result.body[ber].value.length - 4,
  //                   result.body[ber].value.length
  //                 ),
  //               };
  //               this.bearingFaults.push(body);
  //               this.bearingFaults.values;
  //             }
  //           }
  //         } else {
  //         }
  //       });
  //   }
  // }
  getBearingFreq() {
    if (
      this.assetType === "MOTOR" ||
      this.assetType === "FAN_BLOWER" ||
      this.assetType === "PUMP" ||
      this.assetType === "COMPRESSOR" ||
      this.assetType === "JOURNAL_BEARING"
    ) {
      var rpmToSend = this._actualrpm === 0 ? this._rated_rpm : this._actualrpm;
      rpmToSend = rpmToSend == undefined ? 1 : rpmToSend;
      this.service
        .getData(
          // `${this.getBearingFrequency}/${this.assetId}/${this.mac_address}?speed=${rpmToSend}&gearbox=false&type=null`
          `${this.diagnosticsBearingFrequencyAPI}/${this.assetId}/${this.mac_address}?speed=${rpmToSend}&gearbox=false&type=null`
        )
        .then((res) => {
          if (JSON.parse(JSON.stringify(res)).data.status == "success") {
            let result = Object.values(
              JSON.parse(JSON.stringify(res)).data.body
            );
            this.bearingFreqVal = [];
            if (result[0][0].ORF != "NaN" && result[0][0].ORF != null) {
              for (let i = 0; i < result.length; i++) {
                let body = {
                  label: result[i][0].label,
                  values: Object.values(result[i][0]).slice(0, 4),
                };
                this.bearingFreqVal.push(body);
              }
            } else {
              this.bearingFreqVal = [];
            }
          } else {
            this.bearingFreqVal = [];
          }
        });
    } else if (this.assetType == "GEAR") {
      this.bearingFreqVal = [];
      var rpmToSend01 =
        this.pinionActualForDiagnosticslabel === 0
          ? this.pinion_gear_rated_rpm
          : this.pinionActualForDiagnosticslabel;
      rpmToSend01 = rpmToSend01 == undefined ? 1 : rpmToSend01;

      this.service
        .getData(
          // `${this.getBearingFrequency}/${this.assetId}/${this.mac_address}?speed=${rpmToSend01}&gearbox=true&type=Pinion`
          `${this.diagnosticsBearingFrequencyAPI}/${this.assetId}/${this.mac_address}?speed=${rpmToSend01}&gearbox=true&type=Pinion`
        )
        .then((res) => {
          if (JSON.parse(JSON.stringify(res)).data.status == "success") {
            let result = Object.values(
              JSON.parse(JSON.stringify(res)).data.body
            );
            if (result[0][0].ORF != null && result[0][0].ORF != "NaN") {
              for (let i = 0; i < result.length; i++) {
                let body = {
                  label: result[i][0].label,
                  values: Object.values(result[i][0]).slice(0, 4),
                };
                this.bearingFreqVal.push(body);
              }
            } else {
              this.bearingFreqVal = [];
            }
          } else {
            this.bearingFreqVal = [];
          }
        });

      var rpmToSend02 =
        this.outerActualForDiagnosticslabel === 0
          ? this.outer_gear_rated_rpm
          : this.outerActualForDiagnosticslabel;
      rpmToSend02 = rpmToSend02 == undefined ? 1 : rpmToSend02;
      this.service
        .getData(
          // `${this.getBearingFrequency}/${this.assetId}/${this.mac_address}?speed=${rpmToSend02}&gearbox=true&type=Output`
          `${this.diagnosticsBearingFrequencyAPI}/${this.assetId}/${this.mac_address}?speed=${rpmToSend02}&gearbox=true&type=Output`
        )
        .then((res) => {
          if (JSON.parse(JSON.stringify(res)).data.status == "success") {
            let result = Object.values(
              JSON.parse(JSON.stringify(res)).data.body
            );
            if (result[0][0].ORF != null && result[0][0].ORF != "NaN") {
              for (let i = 0; i < result.length; i++) {
                let body = {
                  label: result[i][0].label,
                  values: Object.values(result[i][0]).slice(0, 4),
                };
                this.bearingFreqVal.push(body);
              }
            } else {
              this.bearingFreqVal = [];
            }
          } else {
            this.bearingFreqVal = [];
          }
        });
    }
  }
  // getFrequentChart(value: any, scaleType: Number) {
  //   // console.log("function initialized");
  //   this.datafrequentPoints1 = [];
  //   this.datafrequentPoints2 = [];
  //   this.datafrequentPoints3 = [];
  //   let self = this;
  //   if (value !== undefined) {
  //     //got here
  //     this.service
  //       .getDataWithQuery(
  //         // this.Spectral_Analysis_Data +
  //         //   "/" +
  //         //   this.deviceId +
  //         //   "/" +
  //         //   this.assetId +
  //         //   "/" +
  //         //   value +
  //         //   "?type=" +
  //         //   this.diagChartType +
  //         //   "&userid=" +
  //         //   this.userID +
  //         //   "&asset_type=" +
  //         //   this.assetType +
  //         //   "&axis=" +
  //         //   this.sensor_mounting_axis_option
  //         this.diagnosticsFFTGraphAPI +
  //           this.deviceId +
  //           "/" +
  //           this.assetId +
  //           "/" +
  //           value +
  //           "?type=" +
  //           this.diagChartType +
  //           "&userId=" +
  //           this.userID +
  //           "&asset_type=" +
  //           this.assetType +
  //           "&axis=" +
  //           this.sensor_mounting_axis_option
  //       )
  //       .then((res) => {
  //         if (JSON.parse(JSON.stringify(res)).success === false) {
  //           this.showFFTDataChartEmpty = true;
  //         } else if (
  //           JSON.parse(JSON.stringify(res)).data.status === "success"
  //         ) {
  //           if (JSON.parse(JSON.stringify(res)).data.body.chartdata !== null) {
  //             this.showFFTDataChartEmpty = false;
  //             let lableFreqX = JSON.parse(JSON.stringify(res)).data.body.labelx;
  //             let lableFreqY = JSON.parse(JSON.stringify(res)).data.body.labely;
  //             let lableFreqZ = JSON.parse(JSON.stringify(res)).data.body.labelz;
  //             this.datafrequentPoints1 = JSON.parse(
  //               JSON.stringify(res)
  //             ).data.body.chartXdata;
  //             this.datafrequentPoints2 = JSON.parse(
  //               JSON.stringify(res)
  //             ).data.body.chartYdata;
  //             this.datafrequentPoints3 = JSON.parse(
  //               JSON.stringify(res)
  //             ).data.body.chartZdata;
  //             this.spectrumResolutionFactor = (this.datafrequentPoints1[1].x - this.datafrequentPoints1[0].x).toFixed(2);
  //             this.listFrequencyChartData();
  //             if (document.getElementById("freqNewChartContainer") !== null) {

  //               let fftChartObj: any = [];

  //               let rpmvalue: any = "";
  //               let RPMGraphValueUpto8x: any = [];

  //               //Calcular Vertical Lines at Trend Graph based on RPM value.
  //               if (this.assetType == "GEAR") {
  //                 if (
  //                   this.pinion_gear_actual_rpm != undefined &&
  //                   this.pinion_gear_actual_rpm > 0
  //                 ) {
  //                   //rpmvalue = this.pinionrpmshowgaudge[0].needleValue;
  //                   rpmvalue = this.pinion_gear_actual_rpm;
  //                 }
  //               } else {
  //                 rpmvalue = this._actualrpm;
  //               }

  //               console.log(this.assetType, 'this.assetType')
  //               console.log(rpmvalue, 'rpmvalue')

  //               if (rpmvalue !== undefined && rpmvalue >= 0) {
  //                 RPMGraphValueUpto8x[0] = parseFloat((rpmvalue / 60).toFixed(2));
  //               }
  //               console.log(RPMGraphValueUpto8x[0], 'RPMGraphValueUpto8x[0]')

  //               if (RPMGraphValueUpto8x[0] !== undefined) {
  //                 RPMGraphValueUpto8x[1] = parseFloat((RPMGraphValueUpto8x[0] * 2).toFixed(2));
  //                 RPMGraphValueUpto8x[2] = parseFloat((RPMGraphValueUpto8x[0] * 3).toFixed(2));
  //                 RPMGraphValueUpto8x[3] = parseFloat((RPMGraphValueUpto8x[0] * 4).toFixed(2));
  //                 RPMGraphValueUpto8x[4] = parseFloat((RPMGraphValueUpto8x[0] * 5).toFixed(2));
  //                 RPMGraphValueUpto8x[5] = parseFloat((RPMGraphValueUpto8x[0] * 6).toFixed(2));
  //                 RPMGraphValueUpto8x[6] = parseFloat((RPMGraphValueUpto8x[0] * 7).toFixed(2));
  //               }
  //               fftChartObj = cloneDeep(fftChartObject);
  //               document.getElementById
  //               let feedDataToArray = [];
  //               feedDataToArray.push({
  //                 data: this.datafrequentPoints1,
  //                 lineDashType: "",
  //                 label: lableFreqX,
  //                 legendMarkerType: "none",
  //                 key: lableFreqX.trim(),
  //               });
  //               feedDataToArray.push({
  //                 data: this.datafrequentPoints2,
  //                 lineDashType: "",
  //                 label: lableFreqY,
  //                 legendMarkerType: "none",
  //                 key: lableFreqY.trim(),
  //               });
  //               feedDataToArray.push({
  //                 data: this.datafrequentPoints3,
  //                 lineDashType: "",
  //                 label: lableFreqZ,
  //                 legendMarkerType: "none",
  //                 key: lableFreqZ.trim(),
  //               });
  //               this.changeOrder(
  //                 ["Radial (Horizontal)", "Tangential (Vertical)", "Axial"],
  //                 feedDataToArray
  //               );
  //               fftChartObj.charts[0].data = [];
  //               fftChartObj.charts[0].unit = "";
  //               fftChartObj.charts[0].axisX.interval = 5000;
  //               fftChartObj.charts[0].axisY["minimum"] = 0;
  //               fftChartObj.charts[0].axisX["title"] = "Frequency (Hz)";
  //               fftChartObj.charts[0].myValue = this.diagChartType;
  //               fftChartObj.charts[0].data =
  //                 this.makeFFTDataForChart(feedDataToArray);
  //               fftChartObj.navigator.data =
  //                 this.makeFFTDataForChart(feedDataToArray);
  //                 // Inside the getFrequentChart function after cloning fftChartObject into fftChartObj:
  //                 fftChartObj.currentXVal = 0;
  //               fftChartObj.charts[0].toolTip.contentFormatter = function (e) {
  //                 let content = "";
  //                 if (e.chart.options.myValue === 'Acceleration') {
  //                   content = "Sample Count ";
  //                 } else if (e.chart.options.myValue === "cepstrum") {
  //                   content = "Quefrency ";
  //                 } else {
  //                   content = "Frequency ";
  //                 }

  //                 for (var i = 0; i < e.entries.length; i++) {
  //                   const originalX = e.entries[i].dataPoint.x;
  //                   let xVal, unit;

  //                   if (i === 0) {
  //                     if (scaleType === 1) {
  //                       xVal = originalX;
  //                       unit = "Hz";
  //                     } else if (scaleType === 2) {
  //                       xVal = originalX * 60;
  //                       unit = "CPM";
  //                     } else if (scaleType === 3) {
  //                       xVal = originalX / RPMGraphValueUpto8x[0];
  //                       unit = "Orders";
  //                     }
  //                     if (e.chart.options.myValue === 'Acceleration') {
  //                       content += xVal.toFixed(1) + "<br/>";
  //                     } else if (e.chart.options.myValue === 'cepstrum') {
  //                       content += xVal.toFixed(6) + " Sec" + "<br/>";
  //                     } else {
  //                       content += xVal.toFixed(1) + " " + unit + "<br/>";
  //                     }
  //                   }
  //                   // Add series name and Y value as before
  //                   if (e.chart.options.myValue === "fft" || e.chart.options.myValue === 'Acceleration') {
  //                     content +=
  //                       e.entries[i].dataSeries.name +
  //                       " " +
  //                       "<strong>" +
  //                       e.entries[i].dataPoint.y.toFixed(2) +
  //                       " m/sec<sup>2</sup></strong>";
  //                   } else if (e.chart.options.myValue === "magnetic") {
  //                     content +=
  //                       e.entries[i].dataSeries.name +
  //                       " " +
  //                       "<strong>" +
  //                       e.entries[i].dataPoint.y.toFixed(2) +
  //                       " Gs</strong>";
  //                   } else {
  //                     content +=
  //                       e.entries[i].dataSeries.name +
  //                       " " +
  //                       "<strong>" +
  //                       e.entries[i].dataPoint.y.toFixed(2) +
  //                       " mm/sec</strong>";
  //                   }
  //                   content += "<br/>";
  //                   fftChartObj.currentXVal = scaleType === 1 ? originalX : scaleType === 2 ? originalX * 60 : originalX / RPMGraphValueUpto8x[0];
  //                 }
  //                 return content;
  //               };

  //               /* STRIP LINES LOGIC */
  //               let preDominantFreqs = [];

  //               if (this.xaxisFrequency.length > 0) {
  //                 preDominantFreqs = this.xaxisFrequency.map((obj) => Number(obj.freq)); // Convert to number
  //               }

  //               this.preDominantStripLines = preDominantFreqs.map((value, i) => {
  //                 let numericValue = Number(value); // Ensure it's a number

  //                 return {
  //                   value: numericValue.toFixed(2), // Format to 2 decimal places
  //                   color: "black",
  //                   thickness: 2,
  //                   label:
  //                     scaleType === 1
  //                       ? `${numericValue.toFixed(2)} x${i + 1} PDF`
  //                       : scaleType === 2
  //                       ? `${(numericValue * 60).toFixed(2)} x${i + 1} PDF`
  //                       : RPMGraphValueUpto8x[0] && RPMGraphValueUpto8x[0] !== 0
  //                       ? `${(numericValue / Number(RPMGraphValueUpto8x[0])).toFixed(2)} x${i + 1} PDF`
  //                       : `N/A`, // Handles division by zero
  //                 };
  //               });

  //               let stripLinesUpto8x = RPMGraphValueUpto8x.map((value, index) => ({
  //                 value: parseFloat(value.toFixed(2)),
  //                 color: ["red", "yellow", "green", "orange", "gray", "black", "blue"][index],
  //                 thickness: 1,
  //                 label:
  //                   scaleType === 1
  //                     ? `${parseFloat(value.toFixed(2))} x${index + 1}x`
  //                     : scaleType === 2
  //                     ? `${parseFloat((value * 60).toFixed(2))} x${index + 1}x`
  //                     : `${parseFloat(((RPMGraphValueUpto8x[0] / RPMGraphValueUpto8x[0]) * (index + 1)).toFixed(2))} x${index + 1}x`,
  //               }));


  //               let ballCageFrequency, ballSpinFrequency, outerRace, innerRace;
  //               ballCageFrequency = scaleType === 1
  //                 ? parseFloat(this.bearingFreqVal[0]?.values[2])
  //                 : scaleType === 2
  //                 ? parseFloat(this.bearingFreqVal[0]?.values[2]) * 60
  //                 : parseFloat(this.bearingFreqVal[0]?.values[2]) / RPMGraphValueUpto8x[0];

  //               ballSpinFrequency = scaleType === 1
  //                 ? parseFloat(this.bearingFreqVal[0]?.values[3])
  //                 : scaleType === 2
  //                 ? parseFloat(this.bearingFreqVal[0]?.values[3]) * 60
  //                 : parseFloat(this.bearingFreqVal[0]?.values[3]) / RPMGraphValueUpto8x[0];

  //               outerRace = scaleType === 1
  //                 ? parseFloat(this.bearingFreqVal[0]?.values[0])
  //                 : scaleType === 2
  //                 ? parseFloat(this.bearingFreqVal[0]?.values[0]) * 60
  //                 : parseFloat(this.bearingFreqVal[0]?.values[0]) / RPMGraphValueUpto8x[0];

  //               innerRace = scaleType === 1
  //                 ? parseFloat(this.bearingFreqVal[0]?.values[1])
  //                 : scaleType === 2
  //                 ? parseFloat(this.bearingFreqVal[0]?.values[1]) * 60
  //                 : parseFloat(this.bearingFreqVal[0]?.values[1]) / RPMGraphValueUpto8x[0];

  //               this.bearingFrequencyStripLines = [
  //                 {
  //                   value: ballCageFrequency,
  //                   color: "purple",
  //                   thickness: 2,
  //                   label: ballCageFrequency.toFixed(2) + " (Ball Cage)",
  //                 },
  //                 {
  //                   value: ballSpinFrequency,
  //                   color: "cyan",
  //                   thickness: 2,
  //                   label: ballSpinFrequency.toFixed(2) + " (Ball Spin)",
  //                 },
  //                 {
  //                   value: outerRace,
  //                   color: "orange",
  //                   thickness: 2,
  //                   label: outerRace.toFixed(2) + " (Outer Race)",
  //                 },
  //                 {
  //                   value: innerRace,
  //                   color: "blue",
  //                   thickness: 2,
  //                   label: innerRace.toFixed(2) + " (Inner Race)",
  //                 }
  //               ]
  //               if (this.assetType === "GEAR") {
  //                 let gmf = [];
  //                 gmf[0] = parseFloat(this.gmf_frequency);
  //                 gmf[1] = gmf[0] * 2;
  //                 gmf[2] = gmf[0] * 3;

  //                 const colors = ["red", "yellow", "green"];

  //                 this.gearMeshFrequencyStripLines = gmf.map((value, index) => ({
  //                   value: value.toFixed(2),
  //                   color: colors[index] || "blue",
  //                   thickness: 2,
  //                   label:
  //                     scaleType === 1
  //                       ? `${value.toFixed(2)} x${index + 1} GMF`
  //                       : scaleType === 2
  //                       ? `${(value * 60).toFixed(2)} x${index + 1} GMF`
  //                       : RPMGraphValueUpto8x[0] && RPMGraphValueUpto8x[0] !== 0
  //                       ? `${((value / RPMGraphValueUpto8x[0]) * (index + 1)).toFixed(2)} x${index + 1} GMF`
  //                       : `N/A x${index + 1} GMF`,
  //                 }));
  //               }

  //               fftChartObj.navigator.axisX = {
  //                 labelFormatter: (e) => {
  //                   let val = Math.floor(e.value);
  //                   switch (scaleType) {
  //                     case 2:
  //                       val = Math.floor(e.value * 60);
  //                       return `${val}`;
  //                     case 3:
  //                       val = Math.floor(e.value / RPMGraphValueUpto8x[0]);
  //                       return `${val}`;
  //                     default:
  //                       return `${val}`;
  //                   }
  //                 },

  //               };


  //               fftChartObj.charts[0].axisX.title = scaleType === 1 ? "Frequency (Hz)" : scaleType === 2 ? "CPM" : "Orders"


  //               let selectedStripLines = [];

  //               if (this.rmptoggle) {
  //                 selectedStripLines = [...selectedStripLines, ...stripLinesUpto8x];
  //               }

  //               if (this.pFreqtoggleVelocity) {
  //                 selectedStripLines = [...selectedStripLines, ...this.preDominantStripLines];
  //               }

  //               if (this.bearingFrequencyCheckboxBoolean) {
  //                 selectedStripLines = [...selectedStripLines, ...this.bearingFrequencyStripLines];
  //               }

  //               if(this.gearMeshFrequencyCheckboxBoolean) {
  //                 selectedStripLines = [...selectedStripLines, ...this.gearMeshFrequencyStripLines];
  //                 console.log(selectedStripLines)
  //               }
  //               fftChartObj.charts[0].axisX.stripLines = selectedStripLines;
  //               fftChartObj.charts[0].axisX.scaleBreaks.autoCalculate = true;

  //               this.frequentChart = new CanvasJS.StockChart(
  //                 "freqNewChartContainer",
  //                 fftChartObj
  //               );
  //               // console.log("aiming for demo function");
  //               this.demoFunction(fftChartObj, scaleType, RPMGraphValueUpto8x[0]);
  //               setTimeout(() => {
  //                 console.log('Rendering Acceleration spectra')
  //               if(this.frequentChart) this.frequentChart.render();

  //               }, 1000);
  //             }
  //           } else {
  //             this.showFFTDataChartEmpty = true;
  //           }
  //         } else {
  //           this.showFFTDataChartEmpty = true;
  //         }
  //       });
  //   } else {
  //     this.showFFTDataChartEmpty = true;
  //   }
  //   this.getNewAccFrequentChart(this.selectedFFTUID);
  // }
  // Fixed version of your getFrequentChart method
getFrequentChart(value: any, scaleType: Number) {
  this.datafrequentPoints1 = [];
  this.datafrequentPoints2 = [];
  this.datafrequentPoints3 = [];
  let self = this;

  if (value !== undefined) {
    this.service
      .getDataWithQuery(
        this.diagnosticsFFTGraphAPI +
          this.deviceId +
          "/" +
          this.assetId +
          "/" +
          value +
          "?type=" +
          this.diagChartType +
          "&userId=" +
          this.userID +
          "&asset_type=" +
          this.assetType +
          "&axis=" +
          this.sensor_mounting_axis_option
      )
      .then((res) => {
        if (JSON.parse(JSON.stringify(res)).success === false) {
          this.showFFTDataChartEmpty = true;
          return;
        }

        if (JSON.parse(JSON.stringify(res)).data.status !== "success") {
          this.showFFTDataChartEmpty = true;
          return;
        }

        if (JSON.parse(JSON.stringify(res)).data.body.chartdata === null) {
          this.showFFTDataChartEmpty = true;
          return;
        }

        // Data is available, proceed with chart creation
        this.showFFTDataChartEmpty = false;

        let lableFreqX = JSON.parse(JSON.stringify(res)).data.body.labelx;
        let lableFreqY = JSON.parse(JSON.stringify(res)).data.body.labely;
        let lableFreqZ = JSON.parse(JSON.stringify(res)).data.body.labelz;

        this.datafrequentPoints1 = JSON.parse(JSON.stringify(res)).data.body.chartXdata;
        this.datafrequentPoints2 = JSON.parse(JSON.stringify(res)).data.body.chartYdata;
        this.datafrequentPoints3 = JSON.parse(JSON.stringify(res)).data.body.chartZdata;

        // Validate data arrays are not empty
        if (!this.datafrequentPoints1?.length ||
            !this.datafrequentPoints2?.length ||
            !this.datafrequentPoints3?.length) {
          this.showFFTDataChartEmpty = true;
          return;
        }

        this.spectrumResolutionFactor = (this.datafrequentPoints1[1].x - this.datafrequentPoints1[0].x).toFixed(2);
        this.listFrequencyChartData();

        // Use setTimeout to ensure DOM is ready and give Angular time to update the view
        setTimeout(() => {
          this.renderChart(lableFreqX, lableFreqY, lableFreqZ, scaleType);
        }, 100);
      })
      .catch((error) => {
        console.error('Error fetching chart data:', error);
        this.showFFTDataChartEmpty = true;
      });
  } else {
    this.showFFTDataChartEmpty = true;
  }

  this.getNewAccFrequentChart(this.selectedFFTUID);
}

private renderChart(lableFreqX: string, lableFreqY: string, lableFreqZ: string, scaleType: Number) {
  const containerElement = document.getElementById("freqNewChartContainer");

  // Check if container exists and is visible
  if (!containerElement) {
    console.error('Chart container not found');
    return;
  }

  // Check container dimensions
  const containerRect = containerElement.getBoundingClientRect();
  if (containerRect.width === 0 || containerRect.height === 0) {
    console.warn('Container has zero dimensions, retrying...');
    // Retry after a longer delay
    setTimeout(() => {
      this.renderChart(lableFreqX, lableFreqY, lableFreqZ, scaleType);
    }, 500);
    return;
  }

  try {
    // Destroy existing chart if it exists
    if (this.frequentChart) {
      this.frequentChart.destroy();
      this.frequentChart = null;
    }

    let fftChartObj: any = [];
    let rpmvalue: any = "";
    let RPMGraphValueUpto8x: any = [];

    // Calculate Vertical Lines at Trend Graph based on RPM value
    if (this.assetType == "GEAR") {
      if (this.pinion_gear_actual_rpm != undefined && this.pinion_gear_actual_rpm > 0) {
        rpmvalue = this.pinion_gear_actual_rpm;
      }
    } else {
      rpmvalue = this._actualrpm;
    }

    if (rpmvalue !== undefined && rpmvalue >= 0) {
      RPMGraphValueUpto8x[0] = parseFloat((rpmvalue / 60).toFixed(2));
    }

    if (RPMGraphValueUpto8x[0] !== undefined) {
      for (let i = 1; i <= 6; i++) {
        RPMGraphValueUpto8x[i] = parseFloat((RPMGraphValueUpto8x[0] * (i + 1)).toFixed(2));
      }
    }

    fftChartObj = cloneDeep(fftChartObject);

    let feedDataToArray = [];
    feedDataToArray.push({
      data: this.datafrequentPoints1,
      lineDashType: "",
      label: lableFreqX,
      legendMarkerType: "none",
      key: lableFreqX.trim(),
    });
    feedDataToArray.push({
      data: this.datafrequentPoints2,
      lineDashType: "",
      label: lableFreqY,
      legendMarkerType: "none",
      key: lableFreqY.trim(),
    });
    feedDataToArray.push({
      data: this.datafrequentPoints3,
      lineDashType: "",
      label: lableFreqZ,
      legendMarkerType: "none",
      key: lableFreqZ.trim(),
    });

    this.changeOrder(
      ["Radial (Horizontal)", "Tangential (Vertical)", "Axial"],
      feedDataToArray
    );

    // Configure chart object
    fftChartObj.charts[0].data = [];
    fftChartObj.charts[0].unit = "";
    fftChartObj.charts[0].axisX.interval = 5000;
    fftChartObj.charts[0].axisY["minimum"] = 0;
    fftChartObj.charts[0].axisX["title"] = "Frequency (Hz)";
    fftChartObj.charts[0].myValue = this.diagChartType;
    fftChartObj.charts[0].data = this.makeFFTDataForChart(feedDataToArray);
    fftChartObj.navigator.data = this.makeFFTDataForChart(feedDataToArray);
    fftChartObj.currentXVal = 0;

    // Ensure chart has valid dimensions
    fftChartObj.width = Math.max(containerRect.width, 300);
    fftChartObj.height = Math.max(containerRect.height, 200);

    // Set up tooltip formatter
    fftChartObj.charts[0].toolTip.contentFormatter = function (e) {
      let content = "";
      if (e.chart.options.myValue === 'Acceleration') {
        content = "Sample Count ";
      } else if (e.chart.options.myValue === "cepstrum") {
        content = "Quefrency ";
      } else {
        content = "Frequency ";
      }

      for (var i = 0; i < e.entries.length; i++) {
        const originalX = e.entries[i].dataPoint.x;
        let xVal, unit;

        if (i === 0) {
          if (scaleType === 1) {
            xVal = originalX;
            unit = "Hz";
          } else if (scaleType === 2) {
            xVal = originalX * 60;
            unit = "CPM";
          } else if (scaleType === 3) {
            xVal = originalX / RPMGraphValueUpto8x[0];
            unit = "Orders";
          }

          if (e.chart.options.myValue === 'Acceleration') {
            content += xVal.toFixed(1) + "<br/>";
          } else if (e.chart.options.myValue === 'cepstrum') {
            content += xVal.toFixed(6) + " Sec" + "<br/>";
          } else {
            content += xVal.toFixed(1) + " " + unit + "<br/>";
          }
        }

        // Add series name and Y value
        if (e.chart.options.myValue === "fft" || e.chart.options.myValue === 'Acceleration') {
          content +=
            e.entries[i].dataSeries.name +
            " " +
            "<strong>" +
            e.entries[i].dataPoint.y.toFixed(2) +
            " m/sec<sup>2</sup></strong>";
        } else if (e.chart.options.myValue === "magnetic") {
          content +=
            e.entries[i].dataSeries.name +
            " " +
            "<strong>" +
            e.entries[i].dataPoint.y.toFixed(2) +
            " Gs</strong>";
        } else {
          content +=
            e.entries[i].dataSeries.name +
            " " +
            "<strong>" +
            e.entries[i].dataPoint.y.toFixed(2) +
            " mm/sec</strong>";
        }
        content += "<br/>";
        fftChartObj.currentXVal = scaleType === 1 ? originalX : scaleType === 2 ? originalX * 60 : originalX / RPMGraphValueUpto8x[0];
      }
      return content;
    };

    // Configure strip lines and other chart properties
    this.configureStripLines(fftChartObj, scaleType, RPMGraphValueUpto8x);

    // Create and render the chart
    this.frequentChart = new CanvasJS.StockChart("freqNewChartContainer", fftChartObj);

    // Add error handling for chart rendering
    try {
      console.log('Rendering chart with dimensions:', containerRect.width, 'x', containerRect.height);
      this.frequentChart.render();
      this.demoFunction(fftChartObj, scaleType, RPMGraphValueUpto8x[0]);
    } catch (renderError) {
      console.error('Error rendering chart:', renderError);
      this.showFFTDataChartEmpty = true;
    }

  } catch (error) {
    console.error('Error creating chart:', error);
    this.showFFTDataChartEmpty = true;
  }
}

private configureStripLines(fftChartObj: any, scaleType: Number, RPMGraphValueUpto8x: any[]) {
  // Strip lines logic
  let preDominantFreqs = [];
  if (this.xaxisFrequency.length > 0) {
    preDominantFreqs = this.xaxisFrequency.map((obj) => Number(obj.freq));
  }

  this.preDominantStripLines = preDominantFreqs.map((value, i) => {
    let numericValue = Number(value);
    return {
      value: numericValue.toFixed(2),
      color: "black",
      thickness: 2,
      label:
        scaleType === 1
          ? `${numericValue.toFixed(2)} x${i + 1} PDF`
          : scaleType === 2
          ? `${(numericValue * 60).toFixed(2)} x${i + 1} PDF`
          : RPMGraphValueUpto8x[0] && RPMGraphValueUpto8x[0] !== 0
          ? `${(numericValue / Number(RPMGraphValueUpto8x[0])).toFixed(2)} x${i + 1} PDF`
          : `N/A`,
    };
  });

  let stripLinesUpto8x = RPMGraphValueUpto8x.map((value, index) => ({
    value: parseFloat(value.toFixed(2)),
    color: ["red", "yellow", "green", "orange", "gray", "black", "blue"][index],
    thickness: 1,
    label:
      scaleType === 1
        ? `${parseFloat(value.toFixed(2))} x${index + 1}x`
        : scaleType === 2
        ? `${parseFloat((value * 60).toFixed(2))} x${index + 1}x`
        : `${parseFloat(((RPMGraphValueUpto8x[0] / RPMGraphValueUpto8x[0]) * (index + 1)).toFixed(2))} x${index + 1}x`,
  }));

  // Configure bearing frequency strip lines
  this.configureBearingFrequencyStripLines(scaleType, RPMGraphValueUpto8x);

  // Configure gear mesh frequency strip lines if applicable
  if (this.assetType === "GEAR") {
    this.configureGearMeshFrequencyStripLines(scaleType, RPMGraphValueUpto8x);
  }

  // Configure navigator axis
  fftChartObj.navigator.axisX = {
    labelFormatter: (e) => {
      let val = Math.floor(e.value);
      switch (scaleType) {
        case 2:
          val = Math.floor(e.value * 60);
          return `${val}`;
        case 3:
          val = Math.floor(e.value / RPMGraphValueUpto8x[0]);
          return `${val}`;
        default:
          return `${val}`;
      }
    },
  };

  fftChartObj.charts[0].axisX.title = scaleType === 1 ? "Frequency (Hz)" : scaleType === 2 ? "CPM" : "Orders";

  // Combine selected strip lines
  let selectedStripLines = [];
  if (this.rmptoggle) {
    selectedStripLines = [...selectedStripLines, ...stripLinesUpto8x];
  }
  if (this.pFreqtoggleVelocity) {
    selectedStripLines = [...selectedStripLines, ...this.preDominantStripLines];
  }
  if (this.bearingFrequencyCheckboxBoolean) {
    selectedStripLines = [...selectedStripLines, ...this.bearingFrequencyStripLines];
  }
  if (this.gearMeshFrequencyCheckboxBoolean) {
    selectedStripLines = [...selectedStripLines, ...this.gearMeshFrequencyStripLines];
  }

  fftChartObj.charts[0].axisX.stripLines = selectedStripLines;
  fftChartObj.charts[0].axisX.scaleBreaks.autoCalculate = true;
}

private configureBearingFrequencyStripLines(scaleType: Number, RPMGraphValueUpto8x: any[]) {
  if (!this.bearingFreqVal || !this.bearingFreqVal[0]) return;

  let ballCageFrequency = scaleType === 1
    ? parseFloat(this.bearingFreqVal[0]?.values[2])
    : scaleType === 2
    ? parseFloat(this.bearingFreqVal[0]?.values[2]) * 60
    : parseFloat(this.bearingFreqVal[0]?.values[2]) / RPMGraphValueUpto8x[0];

  let ballSpinFrequency = scaleType === 1
    ? parseFloat(this.bearingFreqVal[0]?.values[3])
    : scaleType === 2
    ? parseFloat(this.bearingFreqVal[0]?.values[3]) * 60
    : parseFloat(this.bearingFreqVal[0]?.values[3]) / RPMGraphValueUpto8x[0];

  let outerRace = scaleType === 1
    ? parseFloat(this.bearingFreqVal[0]?.values[0])
    : scaleType === 2
    ? parseFloat(this.bearingFreqVal[0]?.values[0]) * 60
    : parseFloat(this.bearingFreqVal[0]?.values[0]) / RPMGraphValueUpto8x[0];

  let innerRace = scaleType === 1
    ? parseFloat(this.bearingFreqVal[0]?.values[1])
    : scaleType === 2
    ? parseFloat(this.bearingFreqVal[0]?.values[1]) * 60
    : parseFloat(this.bearingFreqVal[0]?.values[1]) / RPMGraphValueUpto8x[0];

  this.bearingFrequencyStripLines = [
    {
      value: ballCageFrequency,
      color: "purple",
      thickness: 2,
      label: ballCageFrequency.toFixed(2) + " (Ball Cage)",
    },
    {
      value: ballSpinFrequency,
      color: "cyan",
      thickness: 2,
      label: ballSpinFrequency.toFixed(2) + " (Ball Spin)",
    },
    {
      value: outerRace,
      color: "orange",
      thickness: 2,
      label: outerRace.toFixed(2) + " (Outer Race)",
    },
    {
      value: innerRace,
      color: "blue",
      thickness: 2,
      label: innerRace.toFixed(2) + " (Inner Race)",
    }
  ];
}

private configureGearMeshFrequencyStripLines(scaleType: Number, RPMGraphValueUpto8x: any[]) {
  let gmf = [];
  gmf[0] = parseFloat(this.gmf_frequency);
  gmf[1] = gmf[0] * 2;
  gmf[2] = gmf[0] * 3;

  const colors = ["red", "yellow", "green"];

  this.gearMeshFrequencyStripLines = gmf.map((value, index) => ({
    value: value.toFixed(2),
    color: colors[index] || "blue",
    thickness: 2,
    label:
      scaleType === 1
        ? `${value.toFixed(2)} x${index + 1} GMF`
        : scaleType === 2
        ? `${(value * 60).toFixed(2)} x${index + 1} GMF`
        : RPMGraphValueUpto8x[0] && RPMGraphValueUpto8x[0] !== 0
        ? `${((value / RPMGraphValueUpto8x[0]) * (index + 1)).toFixed(2)} x${index + 1} GMF`
        : `N/A x${index + 1} GMF`,
  }));
}

  demoFunction(chartInstance: any, scaleType, firstX: number) {
    const chartContainer = document.getElementById('freqNewChartContainer');

    const handleClick = (e: Event) => {
      const target = e.target as HTMLElement;

      if (target && target.classList.contains('canvasjs-chart-canvas')) {
        const chart = chartInstance.charts?.[0];

        if (!chart || !chart.axisX?.stripLines) {
          console.warn('Chart or axisX.stripLines not found');
          return;
        }

        // Remove existing stripLines with labels containing 'y'
        chart.axisX.stripLines = chart.axisX.stripLines.filter(
          (line: any) => !line.label?.includes('y')
        );

        // Add new stripLines
        for (let i = 1; i <= 8; i++) {
          let computedValue: number;
          let unit = "";

          switch (scaleType) {
            case 1:
              computedValue = chartInstance.currentXVal * i;
              unit = "Hz";
              break;
            case 2:
              computedValue = (chartInstance.currentXVal * i) / 60;
              unit = "CPM";
              break;
            case 3:
              computedValue = chartInstance.currentXVal * i * firstX;
              unit = "Orders";
              break;
            default:
              console.warn("Unknown scaleType");
              return;
          }

          const label = `${computedValue.toFixed(2)} ${unit} (${i}y)`;

          chart.axisX.stripLines.push({
            value: computedValue,
            color: i % 2 === 0 ? "#00FF00" : "#FF0000",
            thickness: 3,
            label: label
          });
        }

        // chartInstance.render?.(); // ✅ Call render only if it exists
        // console.log(chartInstance);
        // this.cd.detectChanges();
        this.frequentChart.render();
      }
    };

    // Attach or remove click event
    if (this.yChecksMultipleBoolean) {
      console.log("Setting event listener");
      chartContainer?.addEventListener('click', handleClick);
    } else {
      chartContainer?.removeEventListener('click', handleClick);
    }
  }




  bFreqShowHideVelocity() {
    //set strip line to on/off as per bearingFreq value
    this.pFreqtoggleVelocity = !this.pFreqtoggleVelocity;
    this.getFrequentChart(this.selectedFFTUID, this.xAxisScaleTypeGlobal);
  }

  rmpValueShowHide() {
    this.getFrequentChart(this.selectedFFTUID, this.xAxisScaleTypeGlobal);
    this.rmptoggle = !this.rmptoggle;
    // Perform additional actions here
  }
  handleXAxisScaleChange(scale: Number) {
    this.xAxisScaleTypeGlobal = scale;
    this.getFrequentChart(this.selectedFFTUID, this.xAxisScaleTypeGlobal)
  }
  updateBearingFrequencyStripLines() {
    this.bearingFrequencyCheckboxBoolean = !this.bearingFrequencyCheckboxBoolean;
    // console.log("updateBearingFrequencyStripLines", this.bearingFrequencyCheckboxBoolean);
    this.getFrequentChart(this.selectedFFTUID, this.xAxisScaleTypeGlobal);
  }

  updateGearMeshFrequencyStripLines() {
    this.gearMeshFrequencyCheckboxBoolean = !this.gearMeshFrequencyCheckboxBoolean;
    this.getFrequentChart(this.selectedFFTUID, this.xAxisScaleTypeGlobal)
  }
  updateYChecksMultipleStripLines() {
    this.yChecksMultipleBoolean = !this.yChecksMultipleBoolean;
    this.getFrequentChart(this.selectedFFTUID, this.xAxisScaleTypeGlobal)
  }
  rmpValueShowHideEnvelop() {
    this.rmptoggleEnvelop = !this.rmptoggleEnvelop;
    this.getdiagKurtChart(this.fftIdforAdvance);
  }
  bFreqValueShowHideEnvelop() {
    this.bFreqtoggleEnvelop = !this.bFreqtoggleEnvelop;
    this.getdiagKurtChart(this.fftIdforAdvance);
  }

  getNewAccFrequentChart(uuid) {
    let self = this;
    if (uuid !== undefined) {
      this.service
        .getDataWithQuery(
          // this.new_fft_chart_end +
          //   "/" +
          //   uuid +
          //   "/" +
          //   this.userID +
          //   "/" +
          //   this.sensor_mounting_axis_option
          this.diagnosticsFFTChartAPI +
            uuid +
            "/" +
            this.userID +
            "/" +
            this.sensor_mounting_axis_option
        )
        .then((res) => {
          if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
            // this.vibrationNoDataMsg =
            //   "Frequency api facing issue while retriving data.";
            this.showFFTDataChartEmpty_Vibration = true;
          } else if (
            JSON.parse(JSON.stringify(res)).data.status === "success"
          ) {
            if (
              JSON.parse(JSON.stringify(res)).data.body.message !== "404" &&
              JSON.parse(JSON.stringify(res)).data.body.message !== "403"
            ) {
              if (
                JSON.parse(JSON.stringify(res)).data.body.chartdata !== null
              ) {
                this.showFFTDataChartEmpty_Vibration = false;
                let lableFreqX = JSON.parse(JSON.stringify(res)).data.body
                  .labelx;
                let lableFreqY = JSON.parse(JSON.stringify(res)).data.body
                  .labely;
                let lableFreqZ = JSON.parse(JSON.stringify(res)).data.body
                  .labelz;

                this.dataNewfrequentPoints1 = JSON.parse(
                  JSON.stringify(res)
                ).data.body.chartXdata;
                this.dataNewfrequentPoints2 = JSON.parse(
                  JSON.stringify(res)
                ).data.body.chartYdata;
                this.dataNewfrequentPoints3 = JSON.parse(
                  JSON.stringify(res)
                ).data.body.chartZdata;
                this.listFrequencyChartData();
                if (
                  document.getElementById("freqAccNewChartContainer") !== null
                ) {
                  let fftChartObj = cloneDeep(fftChartObject);
                  let feedDataToArray = [];
                  feedDataToArray.push({
                    data: this.dataNewfrequentPoints1,
                    lineDashType: "",
                    label: lableFreqX,
                    legendMarkerType: "none",
                    key: lableFreqX.trim(),
                  });
                  feedDataToArray.push({
                    data: this.dataNewfrequentPoints2,
                    lineDashType: "",
                    label: lableFreqY,
                    legendMarkerType: "none",
                    key: lableFreqY.trim(),
                  });
                  feedDataToArray.push({
                    data: this.dataNewfrequentPoints3,
                    lineDashType: "",
                    label: lableFreqZ,
                    legendMarkerType: "none",
                    key: lableFreqZ.trim(),
                  });
                  this.changeOrder(
                    ["Radial (Horizontal)", "Tangential (Vertical)", "Axial"],
                    feedDataToArray
                  );
                  fftChartObj.charts[0].data = [];
                  fftChartObj.charts[0].unit = "";
                  fftChartObj.charts[0].axisX.interval = 500;
                  fftChartObj.charts[0].myValue = "Acceleration";
                  fftChartObj.charts[0].data =
                    this.makeFFTDataForChart(feedDataToArray);
                  fftChartObj.navigator.data =
                    this.makeFFTDataForChart(feedDataToArray);
                  this.frequentNewAccChart = new CanvasJS.StockChart(
                    "freqAccNewChartContainer",
                    fftChartObj
                  );
                  setTimeout(() => {
                    console.log('Rendering Vibration - Acceleration (m/sec2)')
                    if(this.frequentNewAccChart) this.frequentNewAccChart.render();
                  }, 1000);
                }
              } else {
                this.showFFTDataChartEmpty_Vibration = true;
                this.vibrationNoDataMsg = "No data available.";
              }
            } else {
              this.showFFTDataChartEmpty_Vibration = true;
              this.vibrationNoDataMsg = "Error while fetching data.";
            }
          } else {
            this.showFFTDataChartEmpty_Vibration = true;
            this.vibrationNoDataMsg = "Something went wrong.";
          }
        });
    } else {
      this.showFFTDataChartEmpty_Vibration = true;
      this.vibrationNoDataMsg = "No data available.";
    }
  }

  isObjEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  getMagnetiFieldSpectraChart(uuid) {
    let self = this;
    let tempArray = [];
    if (uuid !== undefined) {
      this.service
        .getDataWithQuery(
          // this.new_fft_chart_end +
          //   "/v1/magnetometer" +
          //   "/" +
          //   uuid +
          //   "/" +
          //   this.userID +
          //   "?axis=" +
          //   this.sensor_mounting_axis_option
          this.diagnosticsFFTMagnetoMeterAPI +
            uuid +
            "/" +
            this.userID +
            "?axis=" +
            this.sensor_mounting_axis_option
        )
        .then((res) => {
          console.log(res);
          console.log("Surya--------------")
          if (JSON.parse(JSON.stringify(res)).success === false) {
            this.showMagnetFieldChartEmpty = true;
          } else if (
            JSON.parse(JSON.stringify(res)).data.status === "success"
          ) {
            if (JSON.parse(JSON.stringify(res)).data.body.message !== "404") {
              if (
                !this.isObjEmpty(
                  JSON.parse(JSON.stringify(res)).data.body.chartXdata
                )
              ) {
                let valueOne = JSON.parse(
                  JSON.stringify(res)
                ).data.body.chartXdata.find(
                  (item) =>
                    item.y ===
                    Math.max.apply(
                      Math,
                      JSON.parse(JSON.stringify(res)).data.body.chartXdata.map(
                        function (o) {
                          return o.y;
                        }
                      )
                    )
                );
                let valueTwo = JSON.parse(
                  JSON.stringify(res)
                ).data.body.chartYdata.find(
                  (item) =>
                    item.y ===
                    Math.max.apply(
                      Math,
                      JSON.parse(JSON.stringify(res)).data.body.chartYdata.map(
                        function (o) {
                          return o.y;
                        }
                      )
                    )
                );
                let valueThree = JSON.parse(
                  JSON.stringify(res)
                ).data.body.chartZdata.find(
                  (item) =>
                    item.y ===
                    Math.max.apply(
                      Math,
                      JSON.parse(JSON.stringify(res)).data.body.chartZdata.map(
                        function (o) {
                          return o.y;
                        }
                      )
                    )
                );

                tempArray.push(valueOne);
                tempArray.push(valueTwo);
                tempArray.push(valueThree);
                let valueHigh = tempArray.find(
                  (item) =>
                    item.y ===
                    Math.max.apply(
                      Math,
                      tempArray.map(function (o) {
                        return o.y;
                      })
                    )
                );
                this.showMagnetFieldChartEmpty = false;
                let lableFreqX = JSON.parse(JSON.stringify(res)).data.body
                  .labelx;
                let lableFreqY = JSON.parse(JSON.stringify(res)).data.body
                  .labely;
                let lableFreqZ = JSON.parse(JSON.stringify(res)).data.body
                  .labelz;
                this.magneticPredFreq = JSON.parse(
                  JSON.stringify(res)
                ).data.body.preDominantFreq.map(function (value, index) {
                  if (!isNaN(value.freq)) {
                    value["freq"] = value.freq.toFixed(1);
                  }
                  if (!isNaN(value.X)) {
                    value["X"] = value.X.toFixed(2);
                  }
                  if (!isNaN(value.Y)) {
                    value["Y"] = value.Y.toFixed(2);
                  }
                  if (!isNaN(value.Z)) {
                    value["Z"] = value.Z.toFixed(2);
                  }
                  return value;
                });
                this.dataMagneticFieldPoints1 = JSON.parse(
                  JSON.stringify(res)
                ).data.body.chartXdata;
                this.dataMagneticFieldPoints2 = JSON.parse(
                  JSON.stringify(res)
                ).data.body.chartYdata;
                this.dataMagneticFieldPoints3 = JSON.parse(
                  JSON.stringify(res)
                ).data.body.chartZdata;

                if (
                  document.getElementById(
                    "magnetiFieldSpectraChartContainer"
                  ) !== null
                ) {
                  let fftChartObj = cloneDeep(fftChartObject);
                  let feedDataToArray = [];
                  feedDataToArray.push({
                    data: this.dataMagneticFieldPoints1,
                    lineDashType: "",
                    label: lableFreqX,
                    legendMarkerType: "none",
                  });
                  feedDataToArray.push({
                    data: this.dataMagneticFieldPoints2,
                    lineDashType: "",
                    label: lableFreqY,
                    legendMarkerType: "none",
                  });
                  feedDataToArray.push({
                    data: this.dataMagneticFieldPoints3,
                    lineDashType: "",
                    label: lableFreqZ,
                    legendMarkerType: "none",
                  });
                  fftChartObj.charts[0].axisX.interval = 500;
                  fftChartObj.charts[0].axisY["minimum"] = 0;
                  fftChartObj.charts[0].axisX["title"] = "Frequency (Hz)";
                  fftChartObj.charts[0].data = [];
                  fftChartObj.charts[0].unit = "";
                  fftChartObj.charts[0].myValue = "magnetic";
                  fftChartObj.charts[0].data =
                    this.makeFFTDataForChart(feedDataToArray);
                  fftChartObj.navigator.data =
                    this.makeFFTDataForChart(feedDataToArray);
                    const container = document.getElementById("magnetiFieldSpectraChartContainer");
                    if (container) {
                      console.log("Adjusting height");
                    container.style.width  = "1336px";  // or "100%" or whatever you need
                    container.style.height = "312px";  // px, vh, etc.
                    }
                    fftChartObj.width  = 1336;  // px
                    fftChartObj.height = 312;  // px
                  this.magneticFieldSpecChart = new CanvasJS.StockChart(
                    "magnetiFieldSpectraChartContainer",
                    fftChartObj
                  );
                  // this.magneticFieldSpecChart.render();
                  setTimeout(() => {
                    this.magneticFieldSpecChart.render();
                  }, 500);
                }
              } else {
                this.showMagnetFieldChartEmpty = true;
                this.magnetFieldNoDataMsg = "No data available.";
              }
            } else {
              this.showMagnetFieldChartEmpty = true;
              this.magnetFieldNoDataMsg = "404 Error while fetching data.";
            }
          } else {
            this.showMagnetFieldChartEmpty = true;
            this.magnetFieldNoDataMsg = "Something went wrong.";
          }
        });
    } else {
      this.showMagnetFieldChartEmpty = true;
      this.magnetFieldNoDataMsg = "No data available.";
    }
  }

  getUltrasoundFFTChart(uuid) {
    let self = this;
    if (uuid !== undefined) {
      this.service
        .getDataWithQuery(
          // this.new_fft_chart_end +
          //   "/v1/ultrasound" +
          //   "/" +
          //   uuid +
          //   "/" +
          //   this.userID +
          //   "?axis=" +
          //   this.sensor_mounting_axis_option
          this.diagnosticsFFTUltrasoundAPI +
            uuid +
            "/" +
            this.userID +
            "?axis=" +
            this.sensor_mounting_axis_option
        )
        .then((res) => {
          if (JSON.parse(JSON.stringify(res)).success === false) {
            // this.vibrationNoDataMsg =
            //   "Frequency api facing issue while retriving data.";
            this.showUltrasoundChartEmpty_Vibration = true;
          } else if (
            JSON.parse(JSON.stringify(res)).data.status === "success"
          ) {
            if (JSON.parse(JSON.stringify(res)).data.body.message !== "404") {
              if (
                JSON.parse(JSON.stringify(res)).data.body !== null ||
                JSON.parse(JSON.stringify(res)).data.body !== ""
              ) {
                this.showUltrasoundChartEmpty_Vibration = false;
                let lableFreqX = "";

                this.predUltraSoundFrq = JSON.parse(
                  JSON.stringify(res)
                ).data.body.preDominantFreq.map(function (value, index) {
                  value.val = parseFloat(value.val) + 132;
                  value["sno"] = JSON.parse(value.sno).toFixed(1);
                  value["val"] = JSON.parse(value.val).toFixed(2);
                  return value;
                });

                this.datafftUltrasoundfrequentPoints1.push({
                  sno: null,
                  val: null,
                });
                this.datafftUltrasoundfrequentPoints1.push({
                  sno: null,
                  val: null,
                });
                this.datafftUltrasoundfrequentPoints1.push({
                  sno: null,
                  val: null,
                });
                this.datafftUltrasoundfrequentPoints1 = JSON.parse(
                  JSON.stringify(res)
                ).data.body.res.map(function (val, index) {
                  val.val = parseFloat(val.val) + 132;
                  let obj = {
                    x: JSON.parse(val.sno),
                    y: JSON.parse(val.val),
                  };
                  return obj;
                });
                if (
                  document.getElementById("ultrasoundFFTChartContainer") !==
                  null
                ) {
                  let fftChartObj = cloneDeep(fft_ultrasound_chart);
                  let feedDataToArray = [];
                  feedDataToArray.push({
                    data: this.datafftUltrasoundfrequentPoints1,
                    lineDashType: "",
                    label: lableFreqX,
                    legendMarkerType: "none",
                  });
                  fftChartObj.charts[0].data = [];
                  fftChartObj.charts[0].unit = "dB-A";
                  fftChartObj.charts[0].axisX["title"] = "Frequency (Hz)";
                  fftChartObj.charts[0].axisX.interval = 5000;
                  fftChartObj.charts[0].myValue = "";
                  fftChartObj.charts[0].data =
                    this.makeFFTDataForChart(feedDataToArray);
                  fftChartObj.navigator.data =
                    this.makeFFTDataForChart(feedDataToArray);

                    const container = document.getElementById("ultrasoundFFTChartContainer");
                    if (container) {
                    container.style.width  = "1336px";  // or "100%" or whatever you need
                    container.style.height = "312px";  // px, vh, etc.
                    }
                    fftChartObj.width  = 1336;  // px
                    fftChartObj.height = 312;  // px
                  this.fftUltrsoundChart = new CanvasJS.StockChart(
                    "ultrasoundFFTChartContainer",
                    fftChartObj
                  );
                setTimeout(() => {
                  this.fftUltrsoundChart.render();
                }, 500);

                }
              } else {
                this.showUltrasoundChartEmpty_Vibration = true;
                this.vibrationNoDataMsg = "No data available.";
              }
            } else {
              this.showUltrasoundChartEmpty_Vibration = true;
              this.vibrationNoDataMsg = "404 Error while fetching data.";
            }
          } else {
            this.showUltrasoundChartEmpty_Vibration = true;
            this.vibrationNoDataMsg = "Something went wrong.";
          }
        });
    } else {
      this.showUltrasoundChartEmpty_Vibration = true;
      this.vibrationNoDataMsg = "No data available.";
    }
    this.cd.detectChanges();
  }

  openModal(id: string) {
    this.modalService.open(id);
  }

  closeModal(id: string) {
    this.modalService.close(id);
  }

  toggleHighlight(newValue: number) {
    if (this.highlightedDiv === newValue) {
      this.highlightedDiv = 0;
    } else {
      this.highlightedDiv = newValue;
    }
  }

  async getMisalignedCharts() {
    this.dataMisalignedPoints1 = [];
    this.dataMisalignedPoints2 = [];
    this.dataMisalignedPredPoints1 = [];
    this.dataMisalignedPredPoints2 = [];
    let dataDoughnut = [];
    this.service
      .getDataWithQuery(
        this.trendData +
          "/" +
          parseInt(this.deviceId) +
          "/" +
          parseInt(this.assetId) +
          "/" +
          "amc" +
          "?userid=" +
          this.userID +
          "&filter=" +
          this.valueTypeTrend +
          "&asset_type=" +
          this.assetType
      )
      .then((res) => {
        if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
        } else if (JSON.parse(JSON.stringify(res)).data.status === "success") {
          if (
            JSON.parse(JSON.stringify(res)).data.body.chartdata.length !== 0
          ) {
            dataDoughnut = JSON.parse(JSON.stringify(res)).data.body
              .doughnutData;
            let abPer = JSON.parse(JSON.stringify(res)).data.body
              .absolute_percentage;
            if (abPer != undefined) {
              this.absolutePercentageDoughnuts1 = abPer;
            } else {
              this.absolutePercentageDoughnuts1 = 0;
            }
            if (document.getElementById("chartDoughnutContainer") !== null) {
              let chartObject = cloneDeep(individualChartObject);
              chartObject.data[0].dataPoints = dataDoughnut;
              this.dataAMCDoughnut = new CanvasJS.Chart(
                "chartDoughnutContainer",
                chartObject
              );
              this.dataAMCDoughnut.render();
              this.misalignImageUrl = $(
                "#chartDoughnutContainer .canvasjs-chart-canvas"
              )
                .get(0)
                .toDataURL();
            }
          }
        }
      });
  }

  async getNonDriveCharts() {
    this.dataNonDrivePoints1 = [];
    this.dataNonDrivePoints2 = [];
    this.dataNonDrivePoints3 = [];
    this.dataNonDrivePredPoints1 = [];
    this.dataNonDrivePredPoints2 = [];
    this.dataNonDrivePredPoints3 = [];
    this.service
      .getDataWithQuery(
        this.trendData +
          "/" +
          parseInt(this.deviceId) +
          "/" +
          parseInt(this.assetId) +
          "/" +
          "ndebc" +
          "?userid=" +
          this.userID +
          "&filter=" +
          this.valueTypeTrend +
          "&asset_type=" +
          this.assetType
      )
      .then((res) => {
        if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
        } else if (JSON.parse(JSON.stringify(res)).data.status === "success") {
          if (
            JSON.parse(JSON.stringify(res)).data.body.chartdata.length !== 0
          ) {
            this.dataNonDrivePoints1 = JSON.parse(
              JSON.stringify(res)
            ).data.body.chartXdata.map(function (val, index) {
              let arr1: any = val.x.split(/[- :]/);
              let time1A = new Date(
                arr1[0],
                arr1[1] - 1,
                arr1[2],
                arr1[3],
                arr1[4],
                arr1[5]
              );
              let x = time1A;
              let y = val.y;
              return { x, y };
            });

            this.dataNonDrivePoints2 = JSON.parse(
              JSON.stringify(res)
            ).data.body.chartYdata.map(function (val, index) {
              let arr1: any = val.x.split(/[- :]/);
              let time1A = new Date(
                arr1[0],
                arr1[1] - 1,
                arr1[2],
                arr1[3],
                arr1[4],
                arr1[5]
              );
              let x = time1A;
              let y = val.y;
              return { x, y };
            });

            this.dataNonDrivePoints3 = JSON.parse(
              JSON.stringify(res)
            ).data.body.chartZdata.map(function (val, index) {
              let arr1: any = val.x.split(/[- :]/);
              let time1A = new Date(
                arr1[0],
                arr1[1] - 1,
                arr1[2],
                arr1[3],
                arr1[4],
                arr1[5]
              );
              let x = time1A;
              let y = val.y;
              return { x, y };
            });
            let statusPredValues = JSON.parse(JSON.stringify(res)).data.body
              .status_for_prediction;
            if (statusPredValues) {
              this.dataNonDrivePredPoints1 = null;
              this.dataNonDrivePredPoints2 = null;
              this.dataNonDrivePredPoints3 = null;
            } else {
              this.dataNonDrivePredPoints1 = JSON.parse(
                JSON.stringify(res)
              ).data.body.nChartArrX.map(function (val, index) {
                let arr1: any = val.x.split(/[- :]/);
                let time1A = new Date(
                  arr1[0],
                  arr1[1] - 1,
                  arr1[2],
                  arr1[3],
                  arr1[4],
                  arr1[5]
                );
                let x = time1A;
                let y = val.y;
                return { x, y };
              });

              this.dataNonDrivePredPoints2 = JSON.parse(
                JSON.stringify(res)
              ).data.body.nChartArrY.map(function (val, index) {
                let arr1: any = val.x.split(/[- :]/);
                let time1A = new Date(
                  arr1[0],
                  arr1[1] - 1,
                  arr1[2],
                  arr1[3],
                  arr1[4],
                  arr1[5]
                );
                let x = time1A;
                let y = val.y;
                return { x, y };
              });

              this.dataNonDrivePredPoints3 = JSON.parse(
                JSON.stringify(res)
              ).data.body.nChartArrZ.map(function (val, index) {
                let arr1: any = val.x.split(/[- :]/);
                let time1A = new Date(
                  arr1[0],
                  arr1[1] - 1,
                  arr1[2],
                  arr1[3],
                  arr1[4],
                  arr1[5]
                );
                let x = time1A;
                let y = val.y;
                return { x, y };
              });
            }
            if (document.getElementById("NonDriveChartContainer") !== null) {
              this.NonDriveChart = new CanvasJS.Chart(
                "NonDriveChartContainer",
                {
                  zoomEnabled: true,
                  title: {
                    text: "mm/s",
                    horizontalAlign: "left",
                    fontSize: 12,
                    fontColor: "#444",
                    FontFamily: "Roboto-Regular",
                    margin: 15,
                  },
                  axisX: {
                    title: "",
                    titleFontSize: 11,
                    titleFontColor: "#777",
                    titleFontFamily: "Roboto-Regular",
                    labelFontFamily: "Roboto-Regular",
                    labelFontColor: "#444",
                    labelFontSize: 12,
                    margin: 10,
                    tickLength: 15,
                    tickColor: "transparent",
                  },
                  axisY: {
                    maximum: 3,
                    minimum: 0,
                    prefix: "",
                    includeZero: false,
                    gridThickness: 0,
                    gridColor: "#e8e8e8",
                    labelFontFamily: "Roboto-Regular",
                    labelFontColor: "#444",
                    labelFontSize: 12,
                    lineThickness: 0,
                    tickLength: 10,
                    tickColor: "transparent",
                  },
                  toolTip: {
                    shared: false,
                    contentFormatter: function (e) {
                      var content =
                        new Date(e.entries[0].dataPoint.x).toLocaleString() +
                        "<br/>";
                      for (var i = 0; i < e.entries.length; i++) {
                        if (!isNaN(e.entries[i].dataPoint.y)) {
                          content +=
                            "Value" +
                            " " +
                            "<strong>" +
                            e.entries[i].dataPoint.y.toFixed(2) +
                            "</strong>";
                          content += "<br/>";
                        }
                      }
                      return content;
                    },
                  },
                  legend: {
                    verticalAlign: "top",
                    horizontalAlign: "center",
                    fontSize: 12,
                    fontColor: "#191919",
                    fontWeight: "normal",
                    markerMargin: 10,
                    fontFamily: "Roboto-Regular",
                    cursor: "pointer",
                    itemclick: function (e) {
                      if (
                        typeof e.dataSeries.visible === "undefined" ||
                        e.dataSeries.visible
                      ) {
                        e.dataSeries.visible = false;
                      } else {
                        e.dataSeries.visible = true;
                      }
                      e.chart.render();
                    },
                  },
                  data: [
                    {
                      type: "line",
                      xValueType: "dateTime",
                      yValueFormatString: "",
                      xValueFormatString: "hh:mm:ss TT",
                      showInLegend: false,
                      name: "",
                      dataPoints: this.dataNonDrivePoints1,
                    },
                    {
                      type: "line",
                      xValueType: "dateTime",
                      yValueFormatString: "",
                      showInLegend: false,
                      name: "",
                      dataPoints: this.dataNonDrivePoints2,
                    },
                    {
                      type: "line",
                      xValueType: "dateTime",
                      yValueFormatString: "",
                      showInLegend: false,
                      name: "",
                      dataPoints: this.dataNonDrivePoints3,
                    },
                    {
                      type: "line",
                      lineDashType: "dot",
                      xValueType: "dateTime",
                      yValueFormatString: "",
                      showInLegend: false,
                      name: "",
                      dataPoints: this.dataNonDrivePredPoints1,
                    },
                    {
                      type: "line",
                      lineDashType: "dot",
                      xValueType: "dateTime",
                      yValueFormatString: "",
                      showInLegend: false,
                      name: "",
                      dataPoints: this.dataNonDrivePredPoints2,
                    },
                    {
                      type: "line",
                      lineDashType: "dot",
                      xValueType: "dateTime",
                      yValueFormatString: "",
                      showInLegend: false,
                      name: "",
                      dataPoints: this.dataNonDrivePredPoints3,
                    },
                  ],
                }
              );
              this.NonDriveChart.options.data[0].legendText = JSON.parse(
                JSON.stringify(res)
              ).data.body.chartdata[0][1];
              this.NonDriveChart.options.data[1].legendText = JSON.parse(
                JSON.stringify(res)
              ).data.body.chartdata[0][2];
              this.NonDriveChart.options.data[2].legendText = JSON.parse(
                JSON.stringify(res)
              ).data.body.chartdata[0][3];
              this.NonDriveChart.render();
              this.NonDriveChart.axisY[0].addTo("stripLines", {
                startValue: 0,
                endValue: 1,
                color: "rgb(212, 237, 218)",
              });
              this.NonDriveChart.axisY[0].addTo("stripLines", {
                value: 1,
                label: 1,
                color: "rgb(212, 237, 218)",
                labelFontColor: "#000000",
              });
              this.NonDriveChart.axisY[0].addTo("stripLines", {
                startValue: 1,
                endValue: 2,
                color: "rgb(255, 250, 196)",
              });
              this.NonDriveChart.axisY[0].addTo("stripLines", {
                value: 2,
                label: 2,
                color: "rgb(255, 250, 196)",
                labelFontColor: "#000000",
              });
              this.NonDriveChart.axisY[0].addTo("stripLines", {
                startValue: 2,
                endValue: 3,
                color: "rgb(255, 230, 230)",
              });
              this.NonDriveChart.axisY[0].addTo("stripLines", {
                value: 3,
                label: 3,
                color: "rgb(255, 230, 230)",
                labelFontColor: "#000000",
              });

              this.nonDriveImageUrl = $(
                "#NonDriveChartContainer .canvasjs-chart-canvas"
              )
                .get(0)
                .toDataURL();
            }
          }
        }
      });
  }

  async getJBearingWearCharts() {
    this.dataJBearingWearPoints1 = [];
    this.dataJBearingWearPoints2 = [];
    this.dataJBearingWearPoints3 = [];
    this.dataJBearingWearPoints4 = [];
    this.dataJBearingWearPoints5 = [];
    let dataXBISSUEDoughnut = [];
    this.service
      .getDataWithQuery(
        this.trendData +
          "/" +
          parseInt(this.deviceId) +
          "/" +
          parseInt(this.assetId) +
          "/" +
          "xbissue" +
          "?userid=" +
          this.userID +
          "&filter=" +
          this.valueTypeTrend +
          "&asset_type=" +
          this.assetType
      )
      .then((res) => {
        if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
        } else if (JSON.parse(JSON.stringify(res)).data.status === "success") {
          if (
            JSON.parse(JSON.stringify(res)).data.body.chartdata.length !== 0
          ) {
            let abPer = JSON.parse(JSON.stringify(res)).data.body
              .absolute_percentage;
            if (abPer != undefined) {
              this.absolutePercentageDoughnuts6 = abPer;
            } else {
              this.absolutePercentageDoughnuts6 = 0;
            }
            dataXBISSUEDoughnut = JSON.parse(JSON.stringify(res)).data.body
              .doughnutData;
            if (
              document.getElementById("JBearingDoughnutWearChartContainer") !==
              null
            ) {
              let chartObject = cloneDeep(individualChartObject);
              chartObject.data[0].dataPoints = dataXBISSUEDoughnut;
              this.dataXBISSUEDChartDoughnut = new CanvasJS.Chart(
                "JBearingDoughnutWearChartContainer",
                chartObject
              );
              this.dataXBISSUEDChartDoughnut.render();
              this.JBearingImageUrl = $(
                "#JBearingDoughnutWearChartContainer .canvasjs-chart-canvas"
              )
                .get(0)
                .toDataURL();
            }
          }
        }
      });
  }

  predominentFreq(id, val) {
    let response: any;
    let _fftTime = val;
    if (_fftTime !== undefined) {
      if (this.diagChartType == "kurtosis") {
        this.diagChartType = "velocity";
        this.service
          .getDataWithQuery(this.Predominent_Freq_kurtosis + _fftTime)
          .then((res) => {
            this.chartBoxVisibility = true;
            response = JSON.parse(JSON.stringify(res));
            if (JSON.parse(JSON.stringify(res)).status === "fail") {
              this.chartBoxVisibility = false;
              this.errmsg = "No data available";
              //this.service.showError(this.errmsg);
            } else if (response.status === "success") {
              this.xaxisFrequency = response.data;
              if (
                JSON.parse(JSON.stringify(res)).message ==
                "Kurtosis Runner service is under development"
              ) {
                this.chartBoxVisibility = false;
                this.errmsg = "No data available";
              }
              //got here
              else if (response.data.length !== 0) {
                for (let i = 0; i < response.data.length; i++) {
                  if (typeof response.data[i].frequency === "number") {
                    response.data[i].frequency =
                      response.data[i].frequency.toFixed(1);
                  }
                  if (typeof response.data[i]["x"] === "number") {
                    response.data[i]["x"] = response.data[i]["x"].toFixed(2);
                  }
                  if (typeof response.data[i]["y"] === "number") {
                    response.data[i]["y"] = response.data[i]["y"].toFixed(2);
                  }
                  if (typeof response.data[i]["z"] === "number") {
                    response.data[i]["z"] = response.data[i]["z"].toFixed(2);
                  }
                }
              }
            }
          });
      } else {
        this.predominantFrequencyLoader = true;
        this.service
          .getDataWithQuery(
            // this.Predominent_Freq +
            //   "/" +
            //   [16, 17, 18] +
            //   "/" +
            //   _fftTime +
            //   "?type=" +
            //   this.diagChartType +
            //   "&userid=" +
            //   this.userID +
            //   "&asset_type=" +
            //   this.assetType
            this.diagnosticsFFTPredominantFrequencyAPI +
              [16, 17, 18] +
              "/" +
              _fftTime +
              "?type=" +
              this.diagChartType +
              "&userId=" +
              this.userID +
              "&assetType=" +
              this.assetType
          )
          .then((res) => {
            this.chartBoxVisibility = true;

            response = JSON.parse(JSON.stringify(res)).data;
            if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
              const msgErr = response.body.message;
              this.service.showError(msgErr);
            } else if (response.status === "success") {
              //got here
              this.xaxisFrequency = response.body;

              if (response.body.length !== 0) {
                for (let i = 0; i < response.body.length; i++) {
                  if (typeof response.body[i].freq === "number") {
                    response.body[i].freq = response.body[i].freq.toFixed(1);
                  }
                  if (
                    typeof response.body[i]["Acceleration 1 X"] === "number"
                  ) {
                    response.body[i]["Acceleration 1 X"] =
                      response.body[i]["Acceleration 1 X"].toFixed(2);
                  }
                  if (
                    typeof response.body[i]["Acceleration 1 Y"] === "number"
                  ) {
                    response.body[i]["Acceleration 1 Y"] =
                      response.body[i]["Acceleration 1 Y"].toFixed(2);
                  }
                  if (
                    typeof response.body[i]["Acceleration 1 Z"] === "number"
                  ) {
                    response.body[i]["Acceleration 1 Z"] =
                      response.body[i]["Acceleration 1 Z"].toFixed(2);
                  }
                }
              }
            }
          });

        this.diagChartType = "velocity";
        this.predominantFrequencyLoader = false;
      }
    } else {
      this.chartBoxVisibility = false;
      this.errmsg = "No data available.";
    }
  }

  getPredictiveTempChart() {
    if (document.getElementById("predictiveChartContainer") !== null) {
      document.getElementById("predictiveChartContainer").innerHTML="";
    }
    this.predictiveChartContainerOnOff = true;
    this.emptyMsgAlert2 = true;

    this.service
      .getDataWithQuery(
        this.accelsensorData +
          "/" +
          parseInt(this.deviceId) +
          "/" +
          parseInt(this.assetId) +
          "/" +
          [1, 2, 3] +
          "/" +
          this.valueTypeTrend +
          "?type=" +
          1 +
          "&userid=" +
          this.userID +
          "&asset_type=" +
          this.assetType
      )
      .then((res) => {
        this.emptyMsgAlert2 = false;
        if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
          this.showPredictiveChartEmpty = true;
        } else if (JSON.parse(JSON.stringify(res)).data.status === "success") {
          if (JSON.parse(JSON.stringify(res)).data.body.chartXdata !== null) {
            let tempArr = [];
            this.showPredictiveChartEmpty = false;
            tempArr.push({
              name: JSON.parse(JSON.stringify(res)).data.body.labelx,
            });
            tempArr.push({
              name: JSON.parse(JSON.stringify(res)).data.body.labely,
            });
            tempArr.push({
              name: JSON.parse(JSON.stringify(res)).data.body.labelz,
            });
            let labels = this.imposeRtdOrdering(tempArr);
            let lablePreTempX = labels[0].name;
            let lablePreTempY = labels[1].name;
            let lablePreTempZ = labels[2].name;
            let chartOneResponse = JSON.parse(JSON.stringify(res));
            let nChartArrX = chartOneResponse.data.body.nChartArrX;
            // for (let i = 0; i < nChartArrX.length; i++) {
            //   let testDateUtc = moment.utc(nChartArrX[i].x).toDate();
            //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
            //   nChartArrX[i].x = timeUpdatedAt;
            // }
            let nChartArrY = chartOneResponse.data.body.nChartArrY;
            // for (let i = 0; i < nChartArrY.length; i++) {
            //       let testDateUtc = moment.utc(nChartArrY[i].x).toDate();
            //       let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
            //   nChartArrY[i].x = timeUpdatedAt;
            //     }
            let nChartArrZ = chartOneResponse.data.body.nChartArrZ;
            // for (let i = 0; i < nChartArrZ.length; i++) {
            //       let testDateUtc = moment.utc(nChartArrZ[i].x).toDate();
            //       let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
            //   nChartArrZ[i].x = timeUpdatedAt;
            //     }
            let chartXdata = chartOneResponse.data.body.chartXdata;
            // for (let i = 0; i < chartXdata.length; i++) {
            //       let testDateUtc = moment.utc(chartXdata[i].x).toDate();
            //       let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
            //       chartXdata[i].x = timeUpdatedAt;
            //     }
            let chartYdata = chartOneResponse.data.body.chartYdata;
            // for (let i = 0; i < chartYdata.length; i++) {
            //       let testDateUtc = moment.utc(chartYdata[i].x).toDate();
            //       let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
            //   chartYdata[i].x = timeUpdatedAt;
            //     }
            let chartZdata = chartOneResponse.data.body.chartZdata;
            // for (let i = 0; i < chartZdata.length; i++) {
            //       let testDateUtc = moment.utc(chartZdata[i].x).toDate();
            //       let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
            //   chartZdata[i].x = timeUpdatedAt;
            //     }

            this.absolutePercentageTemp = JSON.parse(
              JSON.stringify(res)
            ).data.body.absolute_percentage;
            this.statusTempPredictionValues = JSON.parse(
              JSON.stringify(res)
            ).data.body.status_for_prediction;

            if (this.statusTempPredictionValues) {
              this.dataPreTempPointsNew1 = null;
              this.dataPreTempPointsNew2 = null;
              this.dataPreTempPointsNew3 = null;
            } else {
              this.dataPreTempPointsNew1 = nChartArrX.map(function (
                val,
                index
              ) {
                let arr1: any = val.x.split(/[- :]/);
                let time1A = new Date(
                  arr1[0],
                  arr1[1] - 1,
                  arr1[2],
                  arr1[3],
                  arr1[4],
                  arr1[5]
                );
                let x = time1A;
                let y = val.y;
                return { x, y };
              });
              this.dataPreTempPointsNew2 = nChartArrY.map(function (
                val,
                index
              ) {
                let arr1: any = val.x.split(/[- :]/);
                let time1A = new Date(
                  arr1[0],
                  arr1[1] - 1,
                  arr1[2],
                  arr1[3],
                  arr1[4],
                  arr1[5]
                );
                let x = time1A;
                let y = val.y;
                return { x, y };
              });
              this.dataPreTempPointsNew3 = nChartArrZ.map(function (
                val,
                index
              ) {
                let arr1: any = val.x.split(/[- :]/);
                let time1A = new Date(
                  arr1[0],
                  arr1[1] - 1,
                  arr1[2],
                  arr1[3],
                  arr1[4],
                  arr1[5]
                );
                let x = time1A;
                let y = val.y;
                return { x, y };
              });
            }
            this.dataPreTempPoints1 = chartXdata.map(function (val, index) {
              let arr1: any = val.x.split(/[- :]/);
              let time1A = new Date(
                arr1[0],
                arr1[1] - 1,
                arr1[2],
                arr1[3],
                arr1[4],
                arr1[5]
              );
              let x = time1A;
              let y = val.y;
              return { x, y };
            });
            this.dataPreTempPoints2 = chartYdata.map(function (val, index) {
              let arr1: any = val.x.split(/[- :]/);
              let time2A = new Date(
                arr1[0],
                arr1[1] - 1,
                arr1[2],
                arr1[3],
                arr1[4],
                arr1[5]
              );
              let x = time2A;
              let y = val.y;
              return { x, y };
            });
            this.dataPreTempPoints3 = chartZdata.map(function (val, index) {
              let arr1: any = val.x.split(/[- :]/);
              let time3A = new Date(
                arr1[0],
                arr1[1] - 1,
                arr1[2],
                arr1[3],
                arr1[4],
                arr1[5]
              );
              let x = time3A;
              let y = val.y;
              return { x, y };
            });
            this.dataPreTPoints1 = JSON.parse(
              JSON.stringify(res)
            ).data.body.plineX.map(function (val, index) {
              let time4A = new Date(val.x);
              let x = time4A;
              let y = val.y;
              return { x, y };
            });
            this.dataPreTPoints2 = JSON.parse(
              JSON.stringify(res)
            ).data.body.plineY.map(function (val, index) {
              let time5A = new Date(val.x);
              let x = time5A;
              let y = val.y;
              return { x, y };
            });
            this.dataPreTPoints3 = JSON.parse(
              JSON.stringify(res)
            ).data.body.plineZ.map(function (val, index) {
              let time6A = new Date(val.x);
              let x = time6A;
              let y = val.y;
              return { x, y };
            });
            this.returnPreTempObj = JSON.parse(
              JSON.stringify(res)
            ).data.body.returnobj;
            this.min_g = JSON.parse(JSON.stringify(res)).data.body.min || 0;
            this.max_g = JSON.parse(JSON.stringify(res)).data.body.green;
            this.max_y = JSON.parse(JSON.stringify(res)).data.body.yellow;
            this.max_r = JSON.parse(JSON.stringify(res)).data.body.red;
            this.trendTempanalysis = {
              xmin: JSON.parse(JSON.stringify(res)).data.body.x_min.toFixed(1),
              xavg: JSON.parse(JSON.stringify(res)).data.body.x_avg.toFixed(1),
              xmax: JSON.parse(JSON.stringify(res)).data.body.x_max.toFixed(1),
              ymin: JSON.parse(JSON.stringify(res)).data.body.y_min.toFixed(1),
              yavg: JSON.parse(JSON.stringify(res)).data.body.y_avg.toFixed(1),
              ymax: JSON.parse(JSON.stringify(res)).data.body.y_max.toFixed(1),
              zmin: JSON.parse(JSON.stringify(res)).data.body.z_min.toFixed(1),
              zavg: JSON.parse(JSON.stringify(res)).data.body.z_avg.toFixed(1),
              zmax: JSON.parse(JSON.stringify(res)).data.body.z_max.toFixed(1),
              range:
                0 + " - " + JSON.parse(JSON.stringify(res)).data.body.yellow,
            };
            let acceptableTempRange = JSON.parse(JSON.stringify(res)).data.body
              .yellow;
            if (this.trendTempanalysis.xavg < acceptableTempRange) {
              this.trendTempanalysis.messagex = "No Action Needed";
            } else if (this.trendTempanalysis.xavg <= acceptableTempRange) {
              this.trendTempanalysis.messagex = "Attention Reqiured";
            } else {
              this.trendTempanalysis.messagex = "Immediate Action Required";
            }
            if (this.trendTempanalysis.yavg < acceptableTempRange) {
              this.trendTempanalysis.messagey = "No Action Needed";
            } else if (this.trendTempanalysis.yavg <= acceptableTempRange) {
              this.trendTempanalysis.messagey = "Attention Reqiured";
            } else {
              this.trendTempanalysis.messagey = "Immediate Action Required";
            }
            if (this.trendTempanalysis.zavg < acceptableTempRange) {
              this.trendTempanalysis.messagez = "No Action Needed";
            } else if (this.trendTempanalysis.zavg <= acceptableTempRange) {
              this.trendTempanalysis.messagez = "Attention Reqiured";
            } else {
              this.trendTempanalysis.messagez = "Immediate Action Required";
            }
            this.listPreTempChartData(
              this.dataPreTempPoints1,
              this.dataPreTempPoints2,
              this.dataPreTempPoints3,
              this.dataPreTempPointsNew1,
              this.dataPreTempPointsNew2,
              this.dataPreTempPointsNew3
            );
            this.showOverAllStatusSummary();
            let self = this;
            if (document.getElementById("predictiveChartContainer") !== null) {
              let predChartThree = cloneDeep(predicationChartObject);
              let feedDataToArray = [];
              feedDataToArray.push({
                data: this.dataPreTempPoints1,
                lineDashType: "",
                label: lablePreTempX,
                legendMarkerType: "none",
              });
              feedDataToArray.push({
                data: this.dataPreTempPoints2,
                lineDashType: "",
                label: lablePreTempY,
                legendMarkerType: "none",
              });
              feedDataToArray.push({
                data: this.dataPreTempPoints3,
                lineDashType: "",
                label: lablePreTempZ,
                legendMarkerType: "none",
              });
              feedDataToArray.push({
                data: this.dataPreTempPointsNew1,
                lineDashType: "dot",
                label: lablePreTempX,
                legendMarkerType: "circle",
              });
              feedDataToArray.push({
                data: this.dataPreTempPointsNew2,
                lineDashType: "dot",
                label: lablePreTempY,
                legendMarkerType: "circle",
              });
              feedDataToArray.push({
                data: this.dataPreTempPointsNew3,
                lineDashType: "dot",
                label: lablePreTempZ,
                legendMarkerType: "circle",
              });
              predChartThree.data = [];
              predChartThree.axisY.maximum = this.max_r;
              predChartThree.unit = "°C";
              (predChartThree.myValue = this.statusTempPredictionValues),
                (predChartThree.data = this.makeDataForChart(feedDataToArray));
              this.predictiveChart = new CanvasJS.Chart(
                "predictiveChartContainer",
                predChartThree
              );
              setTimeout(() => {
                if(this.predictiveChart) {
                  console.log('Rendering Temperature Trend')
                  this.predictiveChart.render();
                  this.predictiveChart.axisY[0].addTo("stripLines", {
                    startValue: this.min_g,
                    endValue: this.max_g,
                    color: "rgb(212, 237, 218)",
                  });
                  this.predictiveChart.axisY[0].addTo("stripLines", {
                    value: this.max_g,
                    label: this.max_g,
                    color: "rgb(212, 237, 218)",
                    labelFontColor: "#000000",
                  });
                  this.predictiveChart.axisY[0].addTo("stripLines", {
                    startValue: this.max_g,
                    endValue: this.max_y,
                    color: "rgb(255, 250, 196)",
                  });
                  this.predictiveChart.axisY[0].addTo("stripLines", {
                    value: this.max_y,
                    label: this.max_y,
                    color: "rgb(255, 250, 196)",
                    labelFontColor: "#000000",
                  });
                  this.predictiveChart.axisY[0].addTo("stripLines", {
                    startValue: this.max_y,
                    endValue: this.max_r,
                    color: "rgb(255, 230, 230)",
                  });
                  this.predictiveChart.axisY[0].addTo("stripLines", {
                    value: this.max_r,
                    label: this.max_r,
                    color: "rgb(255, 250, 196)",
                    labelFontColor: "#000000",
                  });
                }

              }, 1000)
            }
          } else {
            this.predictiveChartContainerOnOff = false;
            this.showPredictiveChartEmpty = true;
          }
        } else {
          this.predictiveChartContainerOnOff = false;
          this.showPredictiveChartEmpty = true;
        }
      });
  }

  addMarkerAtTrendsGraph(
    nChartArrX,
    nChartArrY,
    nChartArrZ,
    chartXdata,
    chartYdata,
    chartZdata
  ) {
    let allXValues: string[] = [];
    allXValues = allXValues.concat(
      nChartArrX.map((item) => item.x),
      nChartArrY.map((item) => item.x),
      nChartArrZ.map((item) => item.x),
      chartXdata.map((item) => item.x),
      chartYdata.map((item) => item.x),
      chartZdata.map((item) => item.x)
    );
    // Remove duplicates
    const uniqueXValues = Array.from(new Set(allXValues));
    //Save x axis value from uniqueXValues to this.markerPoints1
    this.markerPoint1 = uniqueXValues.map((x) => ({ x }));

    // Extract fft_time values from DiagnosticsArray
    const fftTimes: string[] = this.DiagnosticsArray.map(
      (item) => item.fft_time
    );
    // Create markerPoint2 array with fft_time values
    this.markerPoint2 = fftTimes.map((fft_time) => ({ x: fft_time }));

    const set1 = new Set(this.markerPoint1.map((item) => item.x));
    const set2 = new Set(this.markerPoint2.map((item) => item.x));

    // Find the intersection of sets
    if (set1.size > 0 && set2.size > 0) {
      const matchingDatetimes = Array.from(set1).filter((datetime) =>
        set2.has(datetime)
      );

      matchingDatetimes.forEach((datetime) => {
        let datetimeString = datetime as string;
        let arr1: any = datetimeString.split(/[- :]/);
        let time1A = new Date(
          arr1[0],
          arr1[1] - 1,
          arr1[2],
          arr1[3],
          arr1[4],
          arr1[5]
        );
        let x = time1A;
        this.markerPoint3.push({ x: x, y: 0 });
      });
    }

    return this.markerPoint3;
  }

  getVibrationNewTrendChart() {
    if(document.getElementById("chartContainerVelocity")!==null)document.getElementById("chartContainerVelocity").innerHTML=null;
    this.divoff = true;
    this.emptyMessageAlert = true;

    this.service
      .getDataWithQuery(
        this.accelsensorData +
          "/" +
          parseInt(this.deviceId) +
          "/" +
          parseInt(this.assetId) +
          "/" +
          [6, 7, 8] +
          "/" +
          this.valueTypeTrend +
          "?type=" +
          1 +
          "&userid=" +
          this.userID +
          "&asset_type=" +
          this.assetType
      )
      .then((res) => {
        this.emptyMessageAlert = false;
        if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
        } else if (JSON.parse(JSON.stringify(res)).data.status == "success") {
          if (JSON.parse(JSON.stringify(res)).data.body.chartXdata !== null) {
            localStorage.setItem(
              "min_g_imp1",
              JSON.parse(JSON.stringify(res)).data.body.min || 0
            );
            localStorage.setItem(
              "max_g_imp1",
              JSON.parse(JSON.stringify(res)).data.body.green
            );
            localStorage.setItem(
              "max_y_imp1",
              JSON.parse(JSON.stringify(res)).data.body.yellow
            );
            localStorage.setItem(
              "max_r_imp1",
              JSON.parse(JSON.stringify(res)).data.body.red
            );
            let lablePreVelX = JSON.parse(JSON.stringify(res)).data.body.labelx;
            let lablePreVelY = JSON.parse(JSON.stringify(res)).data.body.labely;
            let lablePreVelZ = JSON.parse(JSON.stringify(res)).data.body.labelz;
            let chartOneResponse = JSON.parse(JSON.stringify(res));
            let nChartArrX = chartOneResponse.data.body.nChartArrX;
            // for (let i = 0; i < nChartArrX.length; i++) {
            //   let testDateUtc = moment.utc(nChartArrX[i].x).toDate();
            //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
            //   nChartArrX[i].x = timeUpdatedAt;
            // }
            let nChartArrY = chartOneResponse.data.body.nChartArrY;
            // for (let i = 0; i < nChartArrY.length; i++) {
            //   let testDateUtc = moment.utc(nChartArrY[i].x).toDate();
            //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
            //   nChartArrY[i].x = timeUpdatedAt;
            // }
            let nChartArrZ = chartOneResponse.data.body.nChartArrZ;
            // for (let i = 0; i < nChartArrZ.length; i++) {
            //   let testDateUtc = moment.utc(nChartArrZ[i].x).toDate();
            //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
            //   nChartArrZ[i].x = timeUpdatedAt;
            // }
            let chartXdata = chartOneResponse.data.body.chartXdata;
            // for (let i = 0; i < chartXdata.length; i++) {
            //   let testDateUtc = moment.utc(chartXdata[i].x).toDate();
            //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
            //   chartXdata[i].x = timeUpdatedAt;
            // }
            let chartYdata = chartOneResponse.data.body.chartYdata;
            // for (let i = 0; i < chartYdata.length; i++) {
            //   let testDateUtc = moment.utc(chartYdata[i].x).toDate();
            //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
            //   chartYdata[i].x = timeUpdatedAt;
            // }
            let chartZdata = chartOneResponse.data.body.chartZdata;
            // for (let i = 0; i < chartZdata.length; i++) {
            //   let testDateUtc = moment.utc(chartZdata[i].x).toDate();
            //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
            //   chartZdata[i].x = timeUpdatedAt;
            // }
            this.absolutePercentageVibration = JSON.parse(
              JSON.stringify(res)
            ).data.body.absolute_percentage;
            this.statusVibrationPredictionValues = JSON.parse(
              JSON.stringify(res)
            ).data.body.status_for_prediction;
            if (this.statusVibrationPredictionValues) {
              this.dataPreVibrationPointsNew1 = null;
              this.dataPreVibrationPointsNew2 = null;
              this.dataPreVibrationPointsNew3 = null;
            } else {
              this.dataPreVibrationPointsNew1 = nChartArrX.map(function (
                val,
                index
              ) {
                let arr1: any = val.x.split(/[- :]/);
                let time1A = new Date(
                  arr1[0],
                  arr1[1] - 1,
                  arr1[2],
                  arr1[3],
                  arr1[4],
                  arr1[5]
                );
                let x = time1A;
                let y = val.y;
                return { x, y };
              });
              this.dataPreVibrationPointsNew2 = nChartArrY.map(function (
                val,
                index
              ) {
                let arr1: any = val.x.split(/[- :]/);
                let time1A = new Date(
                  arr1[0],
                  arr1[1] - 1,
                  arr1[2],
                  arr1[3],
                  arr1[4],
                  arr1[5]
                );
                let x = time1A;
                let y = val.y;
                return { x, y };
              });
              this.dataPreVibrationPointsNew3 = nChartArrZ.map(function (
                val,
                index
              ) {
                let arr1: any = val.x.split(/[- :]/);
                let time1A = new Date(
                  arr1[0],
                  arr1[1] - 1,
                  arr1[2],
                  arr1[3],
                  arr1[4],
                  arr1[5]
                );
                let x = time1A;
                let y = val.y;
                return { x, y };
              });
            }
            this.dataVibPredPoints1 = chartXdata.map(function (val, index) {
              let arr1: any = val.x.split(/[- :]/);
              let time1A = new Date(
                arr1[0],
                arr1[1] - 1,
                arr1[2],
                arr1[3],
                arr1[4],
                arr1[5]
              );
              let x = time1A;
              let y = val.y;
              return { x, y };
            });
            this.dataVibPredPoints2 = chartYdata.map(function (val, index) {
              let arr1: any = val.x.split(/[- :]/);
              let time1A = new Date(
                arr1[0],
                arr1[1] - 1,
                arr1[2],
                arr1[3],
                arr1[4],
                arr1[5]
              );
              let x = time1A;
              let y = val.y;
              return { x, y };
            });
            this.dataVibPredPoints3 = chartZdata.map(function (val, index) {
              let arr1: any = val.x.split(/[- :]/);
              let time1A = new Date(
                arr1[0],
                arr1[1] - 1,
                arr1[2],
                arr1[3],
                arr1[4],
                arr1[5]
              );
              let x = time1A;
              let y = val.y;
              return { x, y };
            });

            this.returnPreVibObj = JSON.parse(
              JSON.stringify(res)
            ).data.body.returnobj;
            this.min_g_vib = JSON.parse(JSON.stringify(res)).data.body.min || 0;
            this.max_g_vib = JSON.parse(JSON.stringify(res)).data.body.green;
            this.max_y_vib = JSON.parse(JSON.stringify(res)).data.body.yellow;
            this.max_r_vib = JSON.parse(JSON.stringify(res)).data.body.red;
            this.trend_analysis_acc_new = {
              xmin: JSON.parse(JSON.stringify(res)).data.body.x_min.toFixed(1),
              xavg: JSON.parse(JSON.stringify(res)).data.body.x_avg.toFixed(1),
              xmax: JSON.parse(JSON.stringify(res)).data.body.x_max.toFixed(1),
              ymin: JSON.parse(JSON.stringify(res)).data.body.y_min.toFixed(1),
              yavg: JSON.parse(JSON.stringify(res)).data.body.y_avg.toFixed(1),
              ymax: JSON.parse(JSON.stringify(res)).data.body.y_max.toFixed(1),
              zmin: JSON.parse(JSON.stringify(res)).data.body.z_min.toFixed(1),
              zavg: JSON.parse(JSON.stringify(res)).data.body.z_avg.toFixed(1),
              zmax: JSON.parse(JSON.stringify(res)).data.body.z_max.toFixed(1),
              range:
                0 +
                " - " +
                JSON.parse(JSON.stringify(res)).data.body.yellow.toFixed(1),
            };

            let acceptableRange = JSON.parse(JSON.stringify(res)).data.body
              .yellow;
            if (this.trend_analysis_acc_new.xavg < acceptableRange) {
              this.trend_analysis_acc_new.messagex = "No Action Needed";
            } else if (this.trend_analysis_acc_new.xavg <= acceptableRange) {
              this.trend_analysis_acc_new.messagex = "Attention Reqiured";
            } else {
              this.trend_analysis_acc_new.messagex =
                "Immediate Action Required";
            }

            if (this.trend_analysis_acc_new.yavg < acceptableRange) {
              this.trend_analysis_acc_new.messagey = "No Action Needed";
            } else if (this.trend_analysis_acc_new.yavg <= acceptableRange) {
              this.trend_analysis_acc_new.messagey = "Attention Reqiured";
            } else {
              this.trend_analysis_acc_new.messagey =
                "Immediate Action Required";
            }

            if (this.trend_analysis_acc_new.zavg < acceptableRange) {
              this.trend_analysis_acc_new.messagez = "No Action Needed";
            } else if (this.trend_analysis_acc_new.zavg <= acceptableRange) {
              this.trend_analysis_acc_new.messagez = "Attention Reqiured";
            } else {
              this.trend_analysis_acc_new.messagez =
                "Immediate Action Required";
            }

            this.listSensorVibrationNewChartData(
              this.dataVibPredPoints1,
              this.dataVibPredPoints2,
              this.dataVibPredPoints3,
              this.dataPreVibrationPointsNew1,
              this.dataPreVibrationPointsNew2,
              this.dataPreVibrationPointsNew3
            );
            this.showOverAllStatusSummary();
            let self = this;
            if (document.getElementById("chartContainerVelocity") !== null) {
              /**** Add marker on Trend Graph. *****/
              this.markerPoint3 = [];
              this.markerPoint3 = this.addMarkerAtTrendsGraph(
                nChartArrX,
                nChartArrY,
                nChartArrZ,
                chartXdata,
                chartYdata,
                chartZdata
              );
              /**** Add marker on Trend Graph. *****/

              let feedDataToArray = [];
              feedDataToArray.push({
                data: this.dataVibPredPoints1,
                lineDashType: "",
                label: lablePreVelX,
                legendMarkerType: "none",
                key: lablePreVelX,
              });
              feedDataToArray.push({
                data: this.dataVibPredPoints2,
                lineDashType: "",
                label: lablePreVelY,
                legendMarkerType: "none",
                key: lablePreVelY,
              });
              feedDataToArray.push({
                data: this.dataVibPredPoints3,
                lineDashType: "",
                label: lablePreVelZ,
                legendMarkerType: "none",
                key: lablePreVelZ,
              });
              feedDataToArray.push({
                data: this.dataPreVibrationPointsNew1,
                lineDashType: "dot",
                label: lablePreVelX,
                legendMarkerType: "circle",
                key: lablePreVelX,
              });
              feedDataToArray.push({
                data: this.dataPreVibrationPointsNew2,
                lineDashType: "dot",
                label: lablePreVelY,
                legendMarkerType: "circle",
                key: lablePreVelY,
              });
              feedDataToArray.push({
                data: this.dataPreVibrationPointsNew3,
                lineDashType: "dot",
                label: lablePreVelZ,
                legendMarkerType: "circle",
                key: lablePreVelZ,
              });
              feedDataToArray = this.changeOrderPred(
                ["Radial (Horizontal)", "Tangential (Vertical)", "Axial"],
                feedDataToArray
              );
              let predChartOne = cloneDeep(predicationChartObject);
              predChartOne.data = [];
              predChartOne.axisY.maximum = this.max_r_vib;
              predChartOne.unit = "m/sec<sup>2</sup>";
              predChartOne.myValue = this.statusVibrationPredictionValues;
              predChartOne.data = this.makeDataForChart(feedDataToArray);

              if (this.markerPoint3.length > 0) {
                // markerType: "triangle", "circle", "square", "cross", "none"
                predChartOne.data.push({
                  type: "scatter",
                  xValueFormatString: "hh:mm:ss TT",
                  xValueType: "dateTime",
                  markerType: "triangle",
                  markerSize: 20,
                  dataPoints: this.markerPoint3,
                });
                predChartOne.axisY.stripLines = [
                  {
                    value: 0, // Y-axis value where you want to place the marker
                    thickness: 4,
                    color: "blue",
                    label: "", // Optional label for the marker
                  },
                ];
              }

              this.predictiveVibrationChart = new CanvasJS.Chart(
                "chartContainerVelocity",
                predChartOne
              );
              setTimeout(() => {
                console.log('Rendering predictiveVibrationChart')
                if(this.predictiveVibrationChart) {

                  this.predictiveVibrationChart.render();
                this.predictiveVibrationChart.axisY[0].addTo(
                  "stripLines",
                  this.addBackgroundColor(
                    this.min_g_vib,
                    this.max_g_vib,
                    this.greenColor
                  )
                );
                this.predictiveVibrationChart.axisY[0].addTo("stripLines", {
                  value: this.max_g_vib,
                  label: this.max_g_vib,
                  color: this.greenColor,
                  labelFontColor: "#000000",
                });
                this.predictiveVibrationChart.axisY[0].addTo(
                  "stripLines",
                  this.addBackgroundColor(
                    this.max_g_vib,
                    this.max_y_vib,
                    this.yellowColor
                  )
                );
                this.predictiveVibrationChart.axisY[0].addTo("stripLines", {
                  value: this.max_y_vib,
                  label: this.max_y_vib,
                  color: this.yellowColor,
                  labelFontColor: "#000000",
                });
                this.predictiveVibrationChart.axisY[0].addTo(
                  "stripLines",
                  this.addBackgroundColor(
                    this.max_y_vib,
                    this.max_r_vib,
                    this.redColor
                  )
                );
                this.predictiveVibrationChart.axisY[0].addTo("stripLines", {
                  value: this.max_r_vib,
                  label: this.max_r_vib,
                  color: this.redColor,
                  labelFontColor: "#000000",
                });
                }
              }, 200);
            }
          } else {
            this.divoff = false;
          }
        } else {
          this.divoff = false;
        }
      });
  }

  getPredictiveVelocityChart() {
    if (
      document.getElementById("predVelocityChartContainer") !== null
    ){
      document.getElementById("predVelocityChartContainer").innerHTML= null
    }
    this.vibrationVelocityTrendDiv = true;
    this.emptyMessageAlert3 = true;
    this.service
      .getDataWithQuery(
        this.sensorData +
          "/velocity/" +
          parseInt(this.deviceId) +
          "/" +
          parseInt(this.assetId) +
          "/" +
          [29, 30, 31] +
          "/" +
          this.valueTypeTrend +
          "?userid=" +
          this.userID +
          "&asset_type=" +
          this.assetType
      )
      .then((res) => {
        if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
          this.showPredVelocityChartEmpty = true;
        } else if (JSON.parse(JSON.stringify(res)).data.status === "success") {
          if (JSON.parse(JSON.stringify(res)).data.body.chartdata !== null) {
            this.emptyMessageAlert3 = false;
            const min: any =
              JSON.parse(JSON.stringify(res)).data.body.min / 2 || 0;
            const green: any =
              JSON.parse(JSON.stringify(res)).data.body.green / 2;
            const yellow: any =
              JSON.parse(JSON.stringify(res)).data.body.yellow / 2;
            const red: any = JSON.parse(JSON.stringify(res)).data.body.red / 2;
            localStorage.setItem("min_g_imp", min);
            localStorage.setItem("max_g_imp", green);
            localStorage.setItem("max_y_imp", yellow);
            localStorage.setItem("max_r_imp", red);
            this.showPredVelocityChartEmpty = false;
            let lablePreVelX = JSON.parse(JSON.stringify(res)).data.body.labelx;
            let lablePreVelY = JSON.parse(JSON.stringify(res)).data.body.labely;
            let lablePreVelZ = JSON.parse(JSON.stringify(res)).data.body.labelz;
            let chartOneResponse = JSON.parse(JSON.stringify(res));
            let nChartArrX = chartOneResponse.data.body.nChartArrX;
            // for (let i = 0; i < nChartArrX.length; i++) {
            //   let testDateUtc = moment.utc(nChartArrX[i].x).toDate();
            //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
            //   nChartArrX[i].x = timeUpdatedAt;
            // }
            let nChartArrY = chartOneResponse.data.body.nChartArrY;
            // for (let i = 0; i < nChartArrY.length; i++) {
            //   let testDateUtc = moment.utc(nChartArrY[i].x).toDate();
            //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
            //   nChartArrY[i].x = timeUpdatedAt;
            // }
            let nChartArrZ = chartOneResponse.data.body.nChartArrZ;
            // for (let i = 0; i < nChartArrZ.length; i++) {
            //   let testDateUtc = moment.utc(nChartArrZ[i].x).toDate();
            //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
            //   nChartArrZ[i].x = timeUpdatedAt;
            // }
            let chartXdata = chartOneResponse.data.body.chartXdata;
            // for (let i = 0; i < chartXdata.length; i++) {
            //   let testDateUtc = moment.utc(chartXdata[i].x).toDate();
            //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
            //   chartXdata[i].x = timeUpdatedAt;
            // }
            let chartYdata = chartOneResponse.data.body.chartYdata;
            // for (let i = 0; i < chartYdata.length; i++) {
            //   let testDateUtc = moment.utc(chartYdata[i].x).toDate();
            //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
            //   chartYdata[i].x = timeUpdatedAt;
            // }
            let chartZdata = chartOneResponse.data.body.chartZdata;
            // for (let i = 0; i < chartZdata.length; i++) {
            //   let testDateUtc = moment.utc(chartZdata[i].x).toDate();
            //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
            //   chartZdata[i].x = timeUpdatedAt;
            // }
            this.absolutePercentageVelocity = JSON.parse(
              JSON.stringify(res)
            ).data.body.absolute_percentage;
            this.statusVelocityPredictionValues = JSON.parse(
              JSON.stringify(res)
            ).data.body.status_for_prediction;
            if (this.statusVelocityPredictionValues) {
              this.dataPreVelPointsNew1 = null;
              this.dataPreVelPointsNew2 = null;
              this.dataPreVelPointsNew3 = null;
            } else {
              this.dataPreVelPointsNew1 = nChartArrX.map(function (val, index) {
                let arr1: any = val.x.split(/[- :]/);
                let time1A = new Date(
                  arr1[0],
                  arr1[1] - 1,
                  arr1[2],
                  arr1[3],
                  arr1[4],
                  arr1[5]
                );
                let x = time1A;
                let y = val.y;
                return { x, y };
              });
              this.dataPreVelPointsNew2 = nChartArrY.map(function (val, index) {
                let arr1: any = val.x.split(/[- :]/);
                let time1A = new Date(
                  arr1[0],
                  arr1[1] - 1,
                  arr1[2],
                  arr1[3],
                  arr1[4],
                  arr1[5]
                );
                let x = time1A;
                let y = val.y;
                return { x, y };
              });
              this.dataPreVelPointsNew3 = nChartArrZ.map(function (val, index) {
                let arr1: any = val.x.split(/[- :]/);
                let time1A = new Date(
                  arr1[0],
                  arr1[1] - 1,
                  arr1[2],
                  arr1[3],
                  arr1[4],
                  arr1[5]
                );
                let x = time1A;
                let y = val.y;
                return { x, y };
              });
            }
            this.dataPreVelPoints1 = chartXdata.map(function (val, index) {
              let arr1: any = val.x.split(/[- :]/);
              let time1A = new Date(
                arr1[0],
                arr1[1] - 1,
                arr1[2],
                arr1[3],
                arr1[4],
                arr1[5]
              );
              let x = time1A;
              let y = val.y;
              return { x, y };
            });
            this.dataPreVelPoints2 = chartYdata.map(function (val, index) {
              let arr1: any = val.x.split(/[- :]/);
              let time1A = new Date(
                arr1[0],
                arr1[1] - 1,
                arr1[2],
                arr1[3],
                arr1[4],
                arr1[5]
              );
              let x = time1A;
              let y = val.y;
              return { x, y };
            });
            this.dataPreVelPoints3 = chartZdata.map(function (val, index) {
              let arr1: any = val.x.split(/[- :]/);
              let time1A = new Date(
                arr1[0],
                arr1[1] - 1,
                arr1[2],
                arr1[3],
                arr1[4],
                arr1[5]
              );
              let x = time1A;
              let y = val.y;
              return { x, y };
            });
            this.dataPredPoints1 = JSON.parse(
              JSON.stringify(res)
            ).data.body.plineX.map(function (val, index) {
              let time1A = new Date(val.x);
              let x = time1A;
              let y = val.y;
              return { x, y };
            });
            this.dataPredPoints2 = JSON.parse(
              JSON.stringify(res)
            ).data.body.plineY.map(function (val, index) {
              let time1A = new Date(val.x);

              let x = time1A;
              let y = val.y;
              return { x, y };
            });
            this.dataPredPoints3 = JSON.parse(
              JSON.stringify(res)
            ).data.body.plineZ.map(function (val, index) {
              let time1A = new Date(val.x);
              let x = time1A;
              let y = val.y;
              return { x, y };
            });
            this.returnPreVelObj = JSON.parse(
              JSON.stringify(res)
            ).data.body.returnobj;
            this.min_g = JSON.parse(JSON.stringify(res)).data.body.min || 0;
            this.max_g = JSON.parse(JSON.stringify(res)).data.body.green;
            this.max_y = JSON.parse(JSON.stringify(res)).data.body.yellow;
            this.max_r = JSON.parse(JSON.stringify(res)).data.body.red;
            this.trend_analysis = {
              xmin: JSON.parse(JSON.stringify(res)).data.body.x_min.toFixed(1),
              xavg: JSON.parse(JSON.stringify(res)).data.body.x_avg.toFixed(1),
              xmax: JSON.parse(JSON.stringify(res)).data.body.x_max.toFixed(1),
              ymin: JSON.parse(JSON.stringify(res)).data.body.y_min.toFixed(1),
              yavg: JSON.parse(JSON.stringify(res)).data.body.y_avg.toFixed(1),
              ymax: JSON.parse(JSON.stringify(res)).data.body.y_max.toFixed(1),
              zmin: JSON.parse(JSON.stringify(res)).data.body.z_min.toFixed(1),
              zavg: JSON.parse(JSON.stringify(res)).data.body.z_avg.toFixed(1),
              zmax: JSON.parse(JSON.stringify(res)).data.body.z_max.toFixed(1),
              range:
                0 + " - " + JSON.parse(JSON.stringify(res)).data.body.yellow,
            };

            let acceptableRange = JSON.parse(JSON.stringify(res)).data.body
              .yellow;
            if (this.trend_analysis.xavg < acceptableRange) {
              this.trend_analysis.messagex = "No Action Needed";
            } else if (this.trend_analysis.xavg <= acceptableRange) {
              this.trend_analysis.messagex = "Attention Reqiured";
            } else {
              this.trend_analysis.messagex = "Immediate Action Required";
            }

            if (this.trend_analysis.yavg < acceptableRange) {
              this.trend_analysis.messagey = "No Action Needed";
            } else if (this.trend_analysis.yavg <= acceptableRange) {
              this.trend_analysis.messagey = "Attention Reqiured";
            } else {
              this.trend_analysis.messagey = "Immediate Action Required";
            }

            if (this.trend_analysis.zavg < acceptableRange) {
              this.trend_analysis.messagez = "No Action Needed";
            } else if (this.trend_analysis.zavg <= acceptableRange) {
              this.trend_analysis.messagez = "Attention Reqiured";
            } else {
              this.trend_analysis.messagez = "Immediate Action Required";
            }

            this.tableListVelocityTrend(
              this.dataPreVelPoints1,
              this.dataPreVelPoints2,
              this.dataPreVelPoints3,
              this.dataPreVelPointsNew1,
              this.dataPreVelPointsNew2,
              this.dataPreVelPointsNew3
            );

            this.showOverAllStatusSummary();
            let self = this;
            if (
              document.getElementById("predVelocityChartContainer") !== null
            ) {
              let predChartTwo = cloneDeep(predicationChartObject);
              let feedDataToArray = [];
              feedDataToArray.push({
                data: this.dataPreVelPoints1,
                lineDashType: "",
                label: lablePreVelX,
                legendMarkerType: "none",
                key: lablePreVelX,
              });
              feedDataToArray.push({
                data: this.dataPreVelPoints2,
                lineDashType: "",
                label: lablePreVelY,
                legendMarkerType: "none",
                key: lablePreVelY,
              });
              feedDataToArray.push({
                data: this.dataPreVelPoints3,
                lineDashType: "",
                label: lablePreVelZ,
                legendMarkerType: "none",
                key: lablePreVelZ,
              });
              feedDataToArray.push({
                data: this.dataPreVelPointsNew1,
                lineDashType: "dot",
                label: lablePreVelX,
                legendMarkerType: "circle",
                key: lablePreVelX,
              });
              feedDataToArray.push({
                data: this.dataPreVelPointsNew2,
                lineDashType: "dot",
                label: lablePreVelY,
                legendMarkerType: "circle",
                key: lablePreVelY,
              });
              feedDataToArray.push({
                data: this.dataPreVelPointsNew3,
                lineDashType: "dot",
                label: lablePreVelZ,
                legendMarkerType: "circle",
                key: lablePreVelZ,
              });
              feedDataToArray = this.changeOrderPred(
                ["Radial (Horizontal)", "Tangential (Vertical)", "Axial"],
                feedDataToArray
              );
              predChartTwo.data = [];
              predChartTwo.axisY.maximum = this.max_r;
              predChartTwo.unit = "mm/sec";
              predChartTwo.myValue = this.statusVelocityPredictionValues;
              predChartTwo.data = this.makeDataForChart(feedDataToArray);

              /**** Add marker on Trend Graph. *****/
              this.markerPoint3 = [];
              this.markerPoint3 = this.addMarkerAtTrendsGraph(
                nChartArrX,
                nChartArrY,
                nChartArrZ,
                chartXdata,
                chartYdata,
                chartZdata
              );
              /**** Add marker on Trend Graph. *****/

              //Add Marker at trends graph.
              if (this.markerPoint3.length > 0) {
                // markerType: "triangle", "circle", "square", "cross", "none"
                predChartTwo.data.push({
                  type: "scatter",
                  xValueFormatString: "hh:mm:ss TT",
                  xValueType: "dateTime",
                  markerType: "triangle",
                  markerSize: 20,
                  dataPoints: this.markerPoint3,
                });
                predChartTwo.axisY.stripLines = [
                  {
                    value: 0, // Y-axis value where you want to place the marker
                    thickness: 4,
                    color: "blue",
                    label: "", // Optional label for the marker
                  },
                ];
              }

              this.predictiveVelocityChart = new CanvasJS.Chart(
                "predVelocityChartContainer",
                predChartTwo
              );
              setTimeout(() => {
                console.log('Rendering predictiveVelocityChart')
                if(this.predictiveVelocityChart) {
                  this.predictiveVelocityChart.render();
                this.predictiveVelocityChart.axisY[0].addTo(
                  "stripLines",
                  this.addBackgroundColor(this.min_g, this.max_g, this.greenColor)
                );
                this.predictiveVelocityChart.axisY[0].addTo("stripLines", {
                  value: this.max_g,
                  label: this.max_g,
                  color: this.yellowColor,
                  labelFontColor: "#000000",
                });
                this.predictiveVelocityChart.axisY[0].addTo(
                  "stripLines",
                  this.addBackgroundColor(
                    this.max_g,
                    this.max_y,
                    this.yellowColor
                  )
                );
                this.predictiveVelocityChart.axisY[0].addTo("stripLines", {
                  value: this.max_y,
                  label: this.max_y,
                  color: this.yellowColor,
                  labelFontColor: "#000000",
                });
                this.predictiveVelocityChart.axisY[0].addTo(
                  "stripLines",
                  this.addBackgroundColor(this.max_y, this.max_r, this.redColor)
                );
                this.predictiveVelocityChart.axisY[0].addTo("stripLines", {
                  value: this.max_r,
                  label: this.max_r,
                  color: this.yellowColor,
                  labelFontColor: "#000000",
                });

                }
              }, 200);
            }
          } else {
            this.vibrationVelocityTrendDiv = false;
            this.emptyMessageAlert3 = false;
            this.showPredVelocityChartEmpty = true;
          }
        } else {
          this.vibrationVelocityTrendDiv = false;
          this.showPredVelocityChartEmpty = true;
          this.emptyMessageAlert3 = false;
        }
      });
  }
  taketopredominant(event) {
    let id = "tab-2";
    this.ctdTabset.select(id);
  }

  /********************************************
   * Trend Predictive Machine Acoustics (dB)
   ********************************************/
  getPredictiveMachineAcousticsChart() {
    if (
      document.getElementById("trendMachineAcousticsChart") !== null
    ){
      document.getElementById("trendMachineAcousticsChart").innerHTML = "";
    }
    this.trendMachineAcousitcsOnOff = true;
    this.emptyMessageAlertAcoustics = true;
    if (this.firstTimeChartLoad) {
      this.service
        .getDataWithQuery(
          this.sensorData +
            "/acoustics/" +
            parseInt(this.deviceId) +
            "/" +
            parseInt(this.assetId) +
            "/" +
            [35] +
            "/" +
            this.valueTypeTrend +
            "?userid=" +
            this.userID +
            "&asset_type=" +
            this.assetType
        )
        .then((res) => {
          this.emptyMessageAlertAcoustics = false;
          if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
            this.showPredAcousticsChartEmpty = true;
          } else if (
            JSON.parse(JSON.stringify(res)).data.status === "success"
          ) {
            if (JSON.parse(JSON.stringify(res)).data.body.chartXdata !== null) {
              this.emptyMessageAlertAcoustics = true;
              this.showPredAcousticsChartEmpty = false;
              let lableW = JSON.parse(JSON.stringify(res)).data.body.labelx;
              let chartOneResponse = JSON.parse(JSON.stringify(res));
              let nChartArrX = chartOneResponse.data.body.nChartArrX;
              // for (let i = 0; i < nChartArrX.length; i++) {
              //   let testDateUtc = moment.utc(nChartArrX[i].x).toDate();
              //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
              //   nChartArrX[i].x = timeUpdatedAt;
              // }

              let chartXdata = chartOneResponse.data.body.chartXdata;
              // for (let i = 0; i < chartXdata.length; i++) {
              //   let testDateUtc = moment.utc(chartXdata[i].x).toDate();
              //   let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
              //   chartXdata[i].x = timeUpdatedAt;
              // }

              this.absolutePercentageAcoustics = JSON.parse(
                JSON.stringify(res)
              ).data.body.absolute_percentage;
              this.statusAcousticsPredictionValues = JSON.parse(
                JSON.stringify(res)
              ).data.body.status_for_prediction;
              if (this.statusAcousticsPredictionValues) {
                this.dataAcousticsPred1 = null;
              } else {
                this.dataAcousticsPred1 = nChartArrX.map(function (val, index) {
                  let arr1: any = val.x.split(/[- :]/);
                  let time1A = new Date(
                    arr1[0],
                    arr1[1] - 1,
                    arr1[2],
                    arr1[3],
                    arr1[4],
                    arr1[5]
                  );
                  let x = time1A;
                  let y = val.y;
                  return { x, y };
                });
              }

              this.dataAcoustics1 = chartXdata.map(function (val, index) {
                let arr1: any = val.x.split(/[- :]/);
                let time1A = new Date(
                  arr1[0],
                  arr1[1] - 1,
                  arr1[2],
                  arr1[3],
                  arr1[4],
                  arr1[5]
                );
                let x = time1A;
                let y = val.y;
                return { x, y };
              });
              let self = this;
              this.listPreAcousticsChartData(
                this.dataAcoustics1,
                this.dataAcousticsPred1,
                [],
                [],
                [],
                []
              );
              if (
                document.getElementById("trendMachineAcousticsChart") !== null
              ) {
                let predChartFour = cloneDeep(predicationChartObject);
                let feedDataToArray = [];
                feedDataToArray.push({
                  data: this.dataAcoustics1,
                  lineDashType: "",
                  label: lableW,
                  legendMarkerType: "none",
                });
                feedDataToArray.push({
                  data: this.dataAcousticsPred1,
                  lineDashType: "dot",
                  label: lableW,
                  legendMarkerType: "circle",
                });
                predChartFour.data = [];
                predChartFour.axisY.maximum = this.max_r;
                predChartFour.unit = "dB";
                predChartFour.myValue = this.statusAcousticsPredictionValues;
                predChartFour.type = "acoustics";
                predChartFour.data = this.makeDataForChart(feedDataToArray);

                this.predictiveAcousticsChart = new CanvasJS.Chart(
                  "trendMachineAcousticsChart",
                  predChartFour
                );
                setTimeout(() => {
                console.log('Rendering predictiveAcousticsChart')
                if(this.predictiveAcousticsChart) {

                  this.predictiveAcousticsChart.render();
                this.predictiveAcousticsChart.axisY[0].addTo(
                  "stripLines",
                  this.addBackgroundColor(
                    this.min_g,
                    this.max_g,
                    this.greenColor
                  )
                );
                this.predictiveAcousticsChart.axisY[0].addTo("stripLines", {
                  value: this.max_g,
                  label: this.max_g,
                  color: this.greenColor,
                  labelFontColor: "#000000",
                });

                this.predictiveAcousticsChart.axisY[0].addTo(
                  "stripLines",
                  this.addBackgroundColor(
                    this.max_g,
                    this.max_y,
                    this.yellowColor
                  )
                );
                this.predictiveAcousticsChart.axisY[0].addTo("stripLines", {
                  value: this.max_y,
                  label: this.max_y,
                  color: this.yellowColor,
                  labelFontColor: "#000000",
                });
                this.predictiveAcousticsChart.axisY[0].addTo(
                  "stripLines",
                  this.addBackgroundColor(this.max_y, this.max_r, this.redColor)
                );
                this.predictiveAcousticsChart.axisY[0].addTo("stripLines", {
                  value: this.max_r,
                  label: this.max_r,
                  color: this.yellowColor,
                  labelFontColor: "#000000",
                });
                }
              }, 200);
              }
            } else {
              this.trendMachineAcousitcsOnOff = false;
              this.showPredAcousticsChartEmpty = true;
            }
          } else {
            this.trendMachineAcousitcsOnOff = true;
            this.emptyMessageAlertAcoustics = false;
            this.showPredAcousticsChartEmpty = true;
          }
        });
    } else {
    }
  }

  toggleWithMouse() {
    this.service
      .getDataWithQuery(
        this.sensorData +
          "/" +
          this.deviceId +
          "/" +
          this.assetId +
          "?userid=" +
          this.userID +
          "&asset_type=" +
          this.assetType
      )
      .then(async (res) => {
        let response = JSON.parse(JSON.stringify(res)).data;
        if (response.status === "fail") {
          const msgErr = response.body.message;
        } else if (response.status === "success") {
          if (response.body.length !== 0) {
            if (response.body.sensor.length !== 0) {
              this.sensorDataArr = [];
              var testDateUtc = moment.utc(response.body.issue.lastupdate);
              var localDate = testDateUtc.local();
              this._lastUpdate = new ConvertDatetimePipe().convertDateTime(
                localDate
              );
              this._rmsAccels = [];
              this._driveTemps = [];
              for (let va = 0; va < response.body.sensor.length; va++) {
                if (
                  response.body.sensor[va].value < 0 &&
                  response.body.sensor[va].key !== "OrientationX" &&
                  response.body.sensor[va].value < 0 &&
                  response.body.sensor[va].key !== "OrientationY" &&
                  response.body.sensor[va].value < 0 &&
                  response.body.sensor[va].key !== "OrientationZ"
                ) {
                  response.body.sensor[va].value = "N/A";
                }
                if (
                  response.body.sensor[va].key.includes("RMS_Accel_1_X_Axis")
                ) {
                  this.sensorDataArr.splice(0, 0, response.body.sensor[va]);
                }
                if (
                  response.body.sensor[va].key.includes("RMS_Accel_1_Y_Axis")
                ) {
                  this.sensorDataArr.splice(1, 0, response.body.sensor[va]);
                }
                if (
                  response.body.sensor[va].key.includes("RMS_Accel_1_Z_Axis")
                ) {
                  this.sensorDataArr.splice(2, 0, response.body.sensor[va]);
                }
                if (
                  response.body.sensor[va].key.includes("Winding_Temperature")
                ) {
                  this.sensorDataArr.splice(3, 0, response.body.sensor[va]);
                }
                if (
                  response.body.sensor[va].key.includes("Ambient_Temperature")
                ) {
                  this.sensorDataArr.splice(4, 0, response.body.sensor[va]);
                }
                if (
                  response.body.sensor[va].key.includes("Bearing_Temperature")
                ) {
                  this.sensorDataArr.splice(5, 0, response.body.sensor[va]);
                }
                if (
                  response.body.sensor[va].key.includes(
                    "Rate of change of useful life left"
                  )
                ) {
                  this.sensorDataArr.splice(6, 0, response.body.sensor[va]);
                }
                if (response.body.sensor[va].key.includes("OrientationX")) {
                  this.sensorDataArr.splice(7, 0, response.body.sensor[va]);
                }
                if (response.body.sensor[va].key.includes("OrientationY")) {
                  this.sensorDataArr.splice(8, 0, response.body.sensor[va]);
                }
                if (response.body.sensor[va].key.includes("OrientationZ")) {
                  this.sensorDataArr.splice(9, 0, response.body.sensor[va]);
                }
              }
              this.devicedata =
                response.body.message === "No results found"
                  ? []
                  : this.sensorDataArr;
              for (var i = 0; i < this.devicedata.length; i++) {
                if (
                  this.devicedata[i].key === "Bearing_Temperature" ||
                  this.devicedata[i].key === "Winding_Temperature" ||
                  this.devicedata[i].key === "Ambient_Temperature"
                ) {
                  this._driveTemps.push(this.devicedata[i]);
                }
                if (
                  this.devicedata[i].key === "RMS_Accel_1_X_Axis" ||
                  this.devicedata[i].key === "RMS_Accel_1_Y_Axis" ||
                  this.devicedata[i].key === "RMS_Accel_1_Z_Axis"
                ) {
                  this._rmsAccels.push(this.devicedata[i]);
                  this.velocityTangential = this._rmsAccels[0];
                }
              }
              if (
                (this._rmsAccels[0].value /
                  parseFloat(this._rmsAccels[0].rangelabel[1])) *
                  100 <
                  this._rmsAccels[0].arcDelimiters[0] &&
                (this._rmsAccels[1].value /
                  parseFloat(this._rmsAccels[1].rangelabel[1])) *
                  100 <
                  this._rmsAccels[1].arcDelimiters[0] &&
                (this._rmsAccels[2].value /
                  parseFloat(this._rmsAccels[2].rangelabel[1])) *
                  100 <
                  this._rmsAccels[2].arcDelimiters[0]
              ) {
                this._greenRmsIcon = true;
                this._yellowRmsIcon = false;
                this._redRmsIcon = false;
              }
              if (
                ((this._rmsAccels[0].value /
                  parseFloat(this._rmsAccels[0].rangelabel[1])) *
                  100 >=
                  this._rmsAccels[0].arcDelimiters[0] &&
                  (this._rmsAccels[0].value /
                    parseFloat(this._rmsAccels[0].rangelabel[1])) *
                    100 <
                    this._rmsAccels[0].arcDelimiters[1]) ||
                ((this._rmsAccels[1].value /
                  parseFloat(this._rmsAccels[1].rangelabel[1])) *
                  100 >=
                  this._rmsAccels[1].arcDelimiters[0] &&
                  (this._rmsAccels[1].value /
                    parseFloat(this._rmsAccels[1].rangelabel[1])) *
                    100 <
                    this._rmsAccels[1].arcDelimiters[1]) ||
                ((this._rmsAccels[2].value /
                  parseFloat(this._rmsAccels[2].rangelabel[1])) *
                  100 >=
                  this._rmsAccels[2].arcDelimiters[0] &&
                  (this._rmsAccels[2].value /
                    parseFloat(this._rmsAccels[2].rangelabel[1])) *
                    100 <
                    this._rmsAccels[2].arcDelimiters[1])
              ) {
                this._greenRmsIcon = false;
                this._yellowRmsIcon = true;
                this._redRmsIcon = false;
              }
              if (
                (this._rmsAccels[0].value /
                  parseFloat(this._rmsAccels[0].rangelabel[1])) *
                  100 >=
                  this._rmsAccels[0].arcDelimiters[1] ||
                (this._rmsAccels[1].value /
                  parseFloat(this._rmsAccels[1].rangelabel[1])) *
                  100 >=
                  this._rmsAccels[1].arcDelimiters[1] ||
                (this._rmsAccels[2].value /
                  parseFloat(this._rmsAccels[2].rangelabel[1])) *
                  100 >=
                  this._rmsAccels[2].arcDelimiters[1]
              ) {
                this._greenRmsIcon = false;
                this._yellowRmsIcon = false;
                this._redRmsIcon = true;
              }
            } else {
              this._rmsAccels = [];
              this._driveTemps = [];
            }
          } else {
            this._rmsAccels = [];
            this._driveTemps = [];
          }
        } else {
          this._rmsAccels = [];
          this._driveTemps = [];
        }
      });
  }

  showOverAllStatusSummary() {
    let msg;
    let reco;
    if (
      this.trend_analysis_acc_new.messagex === "Attention Reqiured" &&
      this.trend_analysis_acc_new.messagex === "Immediate Action Required"
    ) {
      msg = "Unacceptable";
      reco = "Immediate Action Required";
    } else if (this.trend_analysis_acc_new.messagex === "Attention Reqiured") {
      msg = "Satisfactory";
      reco = "Attention Reqiured";
    } else if (
      this.trend_analysis_acc_new.messagex === "Immediate Action Required"
    ) {
      msg = "Unacceptable";
      reco = "Immediate Action Required";
    } else if (
      this.trend_analysis_acc_new.messagey === "Attention Reqiured" &&
      this.trend_analysis_acc_new.messagey === "Immediate Action Required"
    ) {
      msg = "Unacceptable";
      reco = "Immediate Action Required";
    } else if (this.trend_analysis_acc_new.messagey === "Attention Reqiured") {
      msg = "Satisfactory";
      reco = "Attention Reqiured";
    } else if (
      this.trend_analysis_acc_new.messagey === "Immediate Action Required"
    ) {
      msg = "Unacceptable";
      reco = "Immediate Action Required";
    } else if (
      this.trend_analysis_acc_new.messagez === "Attention Reqiured" &&
      this.trend_analysis_acc_new.messagez === "Immediate Action Required"
    ) {
      msg = "Unacceptable";
      reco = "Immediate Action Required";
    } else if (this.trend_analysis_acc_new.messagez === "Attention Reqiured") {
      msg = "Satisfactory";
      reco = "Attention Reqiured";
    } else if (
      this.trend_analysis_acc_new.messagez === "Immediate Action Required"
    ) {
      msg = "Unacceptable";
      reco = "Immediate Action Required";
    } else if (
      this.trend_analysis.messagex === "Attention Reqiured" &&
      this.trend_analysis.messagex === "Immediate Action Required"
    ) {
      msg = "Unacceptable";
      reco = "Immediate Action Required";
    } else if (this.trend_analysis.messagex === "Attention Reqiured") {
      msg = "Satisfactory";
      reco = "Attention Reqiured";
    } else if (this.trend_analysis.messagex === "Immediate Action Required") {
      msg = "Unacceptable";
      reco = "Immediate Action Required";
    } else if (
      this.trend_analysis.messagey === "Attention Reqiured" &&
      this.trend_analysis.messagey === "Immediate Action Required"
    ) {
      msg = "Unacceptable";
      reco = "Immediate Action Required";
    } else if (this.trend_analysis.messagey === "Attention Reqiured") {
      msg = "Satisfactory";
      reco = "Attention Reqiured";
    } else if (this.trend_analysis.messagey === "Immediate Action Required") {
      msg = "Unacceptable";
      reco = "Immediate Action Required";
    } else if (
      this.trend_analysis.messagez === "Attention Reqiured" &&
      this.trend_analysis.messagez === "Immediate Action Required"
    ) {
      msg = "Unacceptable";
      reco = "Immediate Action Required";
    } else if (this.trend_analysis.messagez === "Attention Reqiured") {
      msg = "Satisfactory";
      reco = "Attention Reqiured";
    } else if (this.trend_analysis.messagez === "Immediate Action Required") {
      msg = "Unacceptable";
      reco = "Immediate Action Required";
    } else if (
      this.trendTempanalysis.messagex === "Attention Reqiured" &&
      this.trendTempanalysis.messagex === "Immediate Action Required"
    ) {
      msg = "Unacceptable";
      reco = "Immediate Action Required";
    } else if (this.trendTempanalysis.messagex === "Attention Reqiured") {
      msg = "Satisfactory";
      reco = "Attention Reqiured";
    } else if (
      this.trendTempanalysis.messagex === "Immediate Action Required"
    ) {
      msg = "Unacceptable";
      reco = "Immediate Action Required";
    } else if (
      this.trendTempanalysis.messagey === "Attention Reqiured" &&
      this.trendTempanalysis.messagey === "Immediate Action Required"
    ) {
      msg = "Unacceptable";
      reco = "Immediate Action Required";
    } else if (this.trendTempanalysis.messagey === "Attention Reqiured") {
      msg = "Satisfactory";
      reco = "Attention Reqiured";
    } else if (
      this.trendTempanalysis.messagey === "Immediate Action Required"
    ) {
      msg = "Unacceptable";
      reco = "Immediate Action Required";
    } else if (
      this.trendTempanalysis.messagez === "Attention Reqiured" &&
      this.trendTempanalysis.messagez === "Immediate Action Required"
    ) {
      msg = "Unacceptable";
      reco = "Immediate Action Required";
    } else if (this.trendTempanalysis.messagez === "Attention Reqiured") {
      msg = "Satisfactory";
      reco = "Attention Reqiured";
    } else if (
      this.trendTempanalysis.messagez === "Immediate Action Required"
    ) {
      msg = "Unacceptable";
      reco = "Immediate Action Required";
    } else if (
      this.trend_ori_analy.messagex === "Attention Reqiured" &&
      this.trend_ori_analy.messagex === "Immediate Action Required"
    ) {
      msg = "Unacceptable";
      reco = "Immediate Action Required";
    } else if (this.trend_ori_analy.messagex === "Attention Reqiured") {
      msg = "Satisfactory";
      reco = "Attention Reqiured";
    } else if (this.trend_ori_analy.messagex === "Immediate Action Required") {
      msg = "Unacceptable";
      reco = "Immediate Action Required";
    } else if (
      this.trend_ori_analy.messagey === "Attention Reqiured" &&
      this.trend_ori_analy.messagey === "Immediate Action Required"
    ) {
      msg = "Unacceptable";
      reco = "Immediate Action Required";
    } else if (this.trend_ori_analy.messagey === "Attention Reqiured") {
      msg = "Satisfactory";
      reco = "Attention Reqiured";
    } else if (this.trend_ori_analy.messagey === "Immediate Action Required") {
      msg = "Unacceptable";
      reco = "Immediate Action Required";
    } else if (
      this.trend_ori_analy.messagez === "Attention Reqiured" &&
      this.trend_ori_analy.messagez === "Immediate Action Required"
    ) {
      msg = "Unacceptable";
      reco = "Immediate Action Required";
    } else if (this.trend_ori_analy.messagez === "Attention Reqiured") {
      msg = "Satisfactory";
      reco = "Attention Reqiured";
    } else if (this.trend_ori_analy.messagez === "Immediate Action Required") {
      msg = "Unacceptable";
      reco = "Immediate Action Required";
    } else {
      msg = "Satisfactory";
      reco = "No Action Needed";
    }
    this.MachineStatus = msg;
    this.RecommendedAction = reco;
  }

  makingGearCharts(chartID, dataArray1, trendDataArray2) {
    if (dataArray1.length !== 0) {
      let canvasChartObject = new CanvasJS.Chart(chartID, {
        zoomEnabled: true,
        title: {
          text: "mm/s",
          horizontalAlign: "left",
          fontSize: 12,
          fontColor: "#444",
          FontFamily: "Roboto-Regular",
          margin: 15,
        },
        axisX: {
          title: "",
          titleFontSize: 11,
          titleFontColor: "#777",
          titleFontFamily: "Roboto-Regular",
          labelFontFamily: "Roboto-Regular",
          labelFontColor: "#444",
          labelFontSize: 12,
          margin: 10,
          tickLength: 15,
          tickColor: "transparent",
        },
        axisY: {
          maximum: 3,
          minimum: 0,
          prefix: "",
          includeZero: false,
          gridThickness: 0,
          gridColor: "#e8e8e8",
          labelFontFamily: "Roboto-Regular",
          labelFontColor: "#444",
          labelFontSize: 12,
          lineThickness: 0,
          tickLength: 10,
          tickColor: "transparent",
        },
        toolTip: {
          shared: false,
          contentFormatter: function (e) {
            var content =
              new Date(e.entries[0].dataPoint.x).toLocaleString() + "<br/>";
            for (var i = 0; i < e.entries.length; i++) {
              if (!isNaN(e.entries[i].dataPoint.y)) {
                content +=
                  "Value" +
                  " " +
                  "<strong>" +
                  e.entries[i].dataPoint.y.toFixed(2) +
                  "</strong>";
                content += "<br/>";
              }
            }
            return content;
          },
        },
        legend: {
          verticalAlign: "top",
          horizontalAlign: "center",
          fontSize: 12,
          fontColor: "#191919",
          fontWeight: "normal",
          markerMargin: 10,
          fontFamily: "Roboto-Regular",
          cursor: "pointer",
          itemclick: function (e) {
            if (
              typeof e.dataSeries.visible === "undefined" ||
              e.dataSeries.visible
            ) {
              e.dataSeries.visible = false;
            } else {
              e.dataSeries.visible = true;
            }
            e.chart.render();
          },
        },
        data: [
          {
            type: "line",
            xValueType: "dateTime",
            yValueFormatString: "",
            xValueFormatString: "hh:mm:ss TT",
            showInLegend: false,
            name: "",
            dataPoints: dataArray1,
          },
          {
            type: "line",
            lineDashType: "dot",
            xValueType: "dateTime",
            yValueFormatString: "",
            showInLegend: false,
            name: "",
            dataPoints: trendDataArray2,
          },
        ],
      });
      canvasChartObject.render();
      canvasChartObject.axisY[0].addTo("stripLines", {
        startValue: 0,
        endValue: 1,
        color: "rgb(212, 237, 218)",
      });
      canvasChartObject.axisY[0].addTo("stripLines", {
        startValue: 1,
        endValue: 2,
        color: "rgb(255, 250, 196)",
      });
      canvasChartObject.axisY[0].addTo("stripLines", {
        startValue: 2,
        endValue: 3,
        color: "rgb(255, 230, 230)",
      });
      return $(`${"#" + chartID} .canvasjs-chart-canvas`)
        .get(0)
        .toDataURL();
    }
  }

  makingMultiGearCharts(
    chartID,
    dataArray1,
    dataArray2,
    dataArray3,
    dataTrendPredArray1,
    dataTrendPredArray2,
    dataTrendPredArray3
  ) {
    if (dataArray1.length !== 0) {
      let canvasChartObject = new CanvasJS.Chart(chartID, {
        zoomEnabled: true,
        title: {
          text: "mm/s",
          horizontalAlign: "left",
          fontSize: 12,
          fontColor: "#444",
          FontFamily: "Roboto-Regular",
          margin: 15,
        },
        axisX: {
          title: "",
          titleFontSize: 11,
          titleFontColor: "#777",
          titleFontFamily: "Roboto-Regular",
          labelFontFamily: "Roboto-Regular",
          labelFontColor: "#444",
          labelFontSize: 12,
          margin: 10,
          tickLength: 15,
          tickColor: "transparent",
        },
        axisY: {
          maximum: 3,
          minimum: 0,
          prefix: "",
          includeZero: false,
          gridThickness: 0,
          gridColor: "#e8e8e8",
          labelFontFamily: "Roboto-Regular",
          labelFontColor: "#444",
          labelFontSize: 12,
          lineThickness: 0,
          tickLength: 10,
          tickColor: "transparent",
        },
        toolTip: {
          shared: false,
          contentFormatter: function (e) {
            var content =
              new Date(e.entries[0].dataPoint.x).toLocaleString() + "<br/>";
            for (var i = 0; i < e.entries.length; i++) {
              if (!isNaN(e.entries[i].dataPoint.y)) {
                content +=
                  "Value" +
                  " " +
                  "<strong>" +
                  e.entries[i].dataPoint.y.toFixed(2) +
                  "</strong>";
                content += "<br/>";
              }
            }
            return content;
          },
        },
        legend: {
          verticalAlign: "top",
          horizontalAlign: "center",
          fontSize: 12,
          fontColor: "#191919",
          fontWeight: "normal",
          markerMargin: 10,
          fontFamily: "Roboto-Regular",
          cursor: "pointer",
          itemclick: function (e) {
            if (
              typeof e.dataSeries.visible === "undefined" ||
              e.dataSeries.visible
            ) {
              e.dataSeries.visible = false;
            } else {
              e.dataSeries.visible = true;
            }
            e.chart.render();
          },
        },
        data: [
          {
            type: "line",
            xValueType: "dateTime",
            yValueFormatString: "",
            xValueFormatString: "hh:mm:ss TT",
            showInLegend: false,
            name: "",
            dataPoints: dataArray1,
          },
          {
            type: "line",
            xValueType: "dateTime",
            yValueFormatString: "",
            xValueFormatString: "hh:mm:ss TT",
            showInLegend: false,
            name: "",
            dataPoints: dataArray2,
          },
          {
            type: "line",
            xValueType: "dateTime",
            yValueFormatString: "",
            xValueFormatString: "hh:mm:ss TT",
            showInLegend: false,
            name: "",
            dataPoints: dataArray3,
          },
          {
            type: "line",
            lineDashType: "dot",
            xValueType: "dateTime",
            yValueFormatString: "",
            showInLegend: false,
            name: "",
            dataPoints: dataTrendPredArray1,
          },
          {
            type: "line",
            lineDashType: "dot",
            xValueType: "dateTime",
            yValueFormatString: "",
            showInLegend: false,
            name: "",
            dataPoints: dataTrendPredArray2,
          },
          {
            type: "line",
            lineDashType: "dot",
            xValueType: "dateTime",
            yValueFormatString: "",
            showInLegend: false,
            name: "",
            dataPoints: dataTrendPredArray3,
          },
        ],
      });
      canvasChartObject.render();
      canvasChartObject.axisY[0].addTo("stripLines", {
        startValue: 0,
        endValue: 1,
        color: "rgb(212, 237, 218)",
      });
      canvasChartObject.axisY[0].addTo("stripLines", {
        startValue: 1,
        endValue: 2,
        color: "rgb(255, 250, 196)",
      });
      canvasChartObject.axisY[0].addTo("stripLines", {
        startValue: 2,
        endValue: 3,
        color: "rgb(255, 230, 230)",
      });

      return $(`${"#" + chartID} .canvasjs-chart-canvas`)
        .get(0)
        .toDataURL();
    }
  }

  showIndicesChart() {
    this.getIndicesTrendChart();
    this.indicesChartOn = true;
    this.indicesTableOn = false;
  }

  showIndicesTable() {
    this.getIndicesTableData(
      this.dataIndicesHealth1,
      this.dataIndicesHealth2,
      this.dataIndicesHealth3,
      this.dataIndicesHealth4,
      this.dataIndicesHealthPred1,
      this.dataIndicesHealthPred2,
      this.dataIndicesHealthPred3,
      this.dataIndicesHealthPred4
    );
    this.indicesChartOn = false;
    this.indicesTableOn = true;
  }

  getIndicesTrendChart() {
    if (document.getElementById("machineHealthIndicesChart") !== null) {
      document.getElementById("machineHealthIndicesChart").innerHTML="";
    }
    this.machineHealthIndicesOnOff = true;
    this.emptyMessageAlert4 = true;
    this.service
      .getDataWithQuery(
        this.sensorData +
          "/indices/" +
          parseInt(this.deviceId) +
          "/" +
          parseInt(this.assetId) +
          "/" +
          [25, 26, 27] +
          "/" +
          this.valueTypeTrend +
          "?userid=" +
          this.userID +
          "&asset_type=" +
          this.assetType
      )
      .then((res) => {
        this.emptyMessageAlert4 = false;
        if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
          this.showPredIndicesChartEmpty = true;
        } else if (JSON.parse(JSON.stringify(res)).data.status === "success") {
          if (JSON.parse(JSON.stringify(res)).data.body.chartXdata !== null) {
            const min: any = JSON.parse(JSON.stringify(res)).data.body.min || 0;
            const green: any = JSON.parse(JSON.stringify(res)).data.body.green;
            const yellow: any = JSON.parse(JSON.stringify(res)).data.body
              .yellow;
            const red: any = JSON.parse(JSON.stringify(res)).data.body.red;
            this.showPredIndicesChartEmpty = false;
            let lableW = "Mechanical";
            let lableX = "Electrical";
            let lableY = "Bearing";
            let lableZ = "Thermal";
            let chartOneResponse = JSON.parse(JSON.stringify(res));

            let nChartArrX = chartOneResponse.data.body.nChartArrX;
            // for (let i = 0; i < nChartArrX.length; i++) {
            //       let testDateUtc = moment.utc(nChartArrX[i].x).toDate();
            //       let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
            //       nChartArrX[i].x = timeUpdatedAt;
            //     }
            let chartXdata = chartOneResponse.data.body.chartXdata;
            // for (let i = 0; i < chartXdata.length; i++) {
            //       let testDateUtc = moment.utc(chartXdata[i].x).toDate();
            //       let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(testDateUtc);
            //       chartXdata[i].x = timeUpdatedAt;
            //     }

            this.absolutePercentageIndices = JSON.parse(
              JSON.stringify(res)
            ).data.body.absolute_percentage;
            this.statusHealthIndicesPredictionValues = JSON.parse(
              JSON.stringify(res)
            ).data.body.status_for_prediction;
            if (this.statusHealthIndicesPredictionValues) {
              this.dataIndicesHealthPred1 = null;
              this.dataIndicesHealthPred2 = null;
              this.dataIndicesHealthPred3 = null;
              this.dataIndicesHealthPred4 = null;
            } else {
              this.dataIndicesHealthPred1 = JSON.parse(
                JSON.stringify(res)
              ).data.body.nChartArrX.map(function (val, index) {
                let arr1: any = val.x.split(/[- :]/);
                let time1A = new Date(
                  arr1[0],
                  arr1[1] - 1,
                  arr1[2],
                  arr1[3],
                  arr1[4],
                  arr1[5]
                );
                let x = time1A;
                let y = val.y;
                return { x, y };
              });
              this.dataIndicesHealthPred2 = JSON.parse(
                JSON.stringify(res)
              ).data.body.nChartArrY.map(function (val, index) {
                let arr1: any = val.x.split(/[- :]/);
                let time1A = new Date(
                  arr1[0],
                  arr1[1] - 1,
                  arr1[2],
                  arr1[3],
                  arr1[4],
                  arr1[5]
                );
                let x = time1A;
                let y = val.y;
                return { x, y };
              });
              this.dataIndicesHealthPred3 = JSON.parse(
                JSON.stringify(res)
              ).data.body.nChartArrZ.map(function (val, index) {
                let arr1: any = val.x.split(/[- :]/);
                let time1A = new Date(
                  arr1[0],
                  arr1[1] - 1,
                  arr1[2],
                  arr1[3],
                  arr1[4],
                  arr1[5]
                );
                let x = time1A;
                let y = val.y;
                return { x, y };
              });
              this.dataIndicesHealthPred4 = JSON.parse(
                JSON.stringify(res)
              ).data.body.nChartArrK.map(function (val, index) {
                let arr1: any = val.x.split(/[- :]/);
                let time1A = new Date(
                  arr1[0],
                  arr1[1] - 1,
                  arr1[2],
                  arr1[3],
                  arr1[4],
                  arr1[5]
                );
                let x = time1A;
                let y = val.y;
                return { x, y };
              });
            }

            this.dataIndicesHealth1 = chartXdata.map(function (val, index) {
              let arr1: any = val.x.split(/[- :]/);
              let time1A = new Date(
                arr1[0],
                arr1[1] - 1,
                arr1[2],
                arr1[3],
                arr1[4],
                arr1[5]
              );
              let x = time1A;
              let y = val.y;
              return { x, y };
            });
            this.dataIndicesHealth2 = JSON.parse(
              JSON.stringify(res)
            ).data.body.chartYdata.map(function (val, index) {
              let arr1: any = val.x.split(/[- :]/);
              let time1A = new Date(
                arr1[0],
                arr1[1] - 1,
                arr1[2],
                arr1[3],
                arr1[4],
                arr1[5]
              );
              let x = time1A;
              let y = val.y;
              return { x, y };
            });
            this.dataIndicesHealth3 = JSON.parse(
              JSON.stringify(res)
            ).data.body.chartZdata.map(function (val, index) {
              let arr1: any = val.x.split(/[- :]/);
              let time1A = new Date(
                arr1[0],
                arr1[1] - 1,
                arr1[2],
                arr1[3],
                arr1[4],
                arr1[5]
              );
              let x = time1A;
              let y = val.y;
              return { x, y };
            });

            this.dataIndicesHealth4 = JSON.parse(
              JSON.stringify(res)
            ).data.body.chartKdata.map(function (val, index) {
              let arr1: any = val.x.split(/[- :]/);
              let time1A = new Date(
                arr1[0],
                arr1[1] - 1,
                arr1[2],
                arr1[3],
                arr1[4],
                arr1[5]
              );
              let x = time1A;
              let y = val.y;
              return { x, y };
            });

            this.getIndicesTableData(
              this.dataIndicesHealth1,
              this.dataIndicesHealth2,
              this.dataIndicesHealth3,
              this.dataIndicesHealth4,
              this.dataIndicesHealthPred1,
              this.dataIndicesHealthPred2,
              this.dataIndicesHealthPred3,
              this.dataIndicesHealthPred4
            );
            let self = this;
            if (document.getElementById("machineHealthIndicesChart") !== null) {
              let predChartFour = cloneDeep(predicationChartObject);
              let feedDataToArray = [];
              feedDataToArray.push({
                data: this.dataIndicesHealth1,
                lineDashType: "",
                label: lableW,
                legendMarkerType: "none",
              });
              feedDataToArray.push({
                data: this.dataIndicesHealth2,
                lineDashType: "",
                label: lableX,
                legendMarkerType: "none",
              });
              feedDataToArray.push({
                data: this.dataIndicesHealth3,
                lineDashType: "",
                label: lableY,
                legendMarkerType: "none",
              });
              feedDataToArray.push({
                data: this.dataIndicesHealth4,
                lineDashType: "",
                label: lableZ,
                legendMarkerType: "none",
              });
              feedDataToArray.push({
                data: this.dataIndicesHealthPred1,
                lineDashType: "dot",
                label: lableW,
                legendMarkerType: "circle",
              });
              feedDataToArray.push({
                data: this.dataIndicesHealthPred2,
                lineDashType: "dot",
                label: lableX,
                legendMarkerType: "circle",
              });
              feedDataToArray.push({
                data: this.dataIndicesHealthPred3,
                lineDashType: "dot",
                label: lableY,
                legendMarkerType: "circle",
              });
              feedDataToArray.push({
                data: this.dataIndicesHealthPred4,
                lineDashType: "dot",
                label: lableZ,
                legendMarkerType: "circle",
              });
              predChartFour.data = [];
              predChartFour.axisY.maximum = green;
              predChartFour.unit = "%";
              predChartFour.myValue = this.statusHealthIndicesPredictionValues;
              predChartFour.data = this.makeDataForChart(feedDataToArray);
              this.predictiveHealthIndicesChart = new CanvasJS.Chart(
                "machineHealthIndicesChart",
                predChartFour
              );
              setTimeout(() => {
                console.log('Rendering predictiveHealthIndicesChart')
                if(this.predictiveHealthIndicesChart)
                  this.predictiveHealthIndicesChart.render();
              }, 200);
              this.predictiveHealthIndicesChart.axisY[0].addTo(
                "stripLines",
                this.addBackgroundColor(min, red, this.redColor)
              );
              this.predictiveHealthIndicesChart.axisY[0].addTo("stripLines", {
                value: red,
                label: red,
                color: this.redColor,
                labelFontColor: "#000000",
              });
              this.predictiveHealthIndicesChart.axisY[0].addTo(
                "stripLines",
                this.addBackgroundColor(red, yellow, this.yellowColor)
              );
              this.predictiveHealthIndicesChart.axisY[0].addTo("stripLines", {
                value: yellow,
                label: yellow,
                color: this.yellowColor,
                labelFontColor: "#000000",
              });
              this.predictiveHealthIndicesChart.axisY[0].addTo(
                "stripLines",
                this.addBackgroundColor(yellow, green, this.greenColor)
              );
              this.predictiveHealthIndicesChart.axisY[0].addTo("stripLines", {
                value: green,
                label: green,
                color: this.greenColor,
                labelFontColor: "#000000",
              });
              let self = this;
              if (
                document.getElementById("machineHealthIndicesChart") !== null
              ) {
                let predChartFour = cloneDeep(predicationChartObject);
                let feedDataToArray = [];
                feedDataToArray.push({
                  data: this.dataIndicesHealth1,
                  lineDashType: "",
                  label: lableW,
                  legendMarkerType: "none",
                });
                feedDataToArray.push({
                  data: this.dataIndicesHealth2,
                  lineDashType: "",
                  label: lableX,
                  legendMarkerType: "none",
                });
                feedDataToArray.push({
                  data: this.dataIndicesHealth3,
                  lineDashType: "",
                  label: lableY,
                  legendMarkerType: "none",
                });
                feedDataToArray.push({
                  data: this.dataIndicesHealth4,
                  lineDashType: "",
                  label: lableZ,
                  legendMarkerType: "none",
                });
                feedDataToArray.push({
                  data: this.dataIndicesHealthPred1,
                  lineDashType: "dot",
                  label: lableW,
                  legendMarkerType: "circle",
                });
                feedDataToArray.push({
                  data: this.dataIndicesHealthPred2,
                  lineDashType: "dot",
                  label: lableX,
                  legendMarkerType: "circle",
                });
                feedDataToArray.push({
                  data: this.dataIndicesHealthPred3,
                  lineDashType: "dot",
                  label: lableY,
                  legendMarkerType: "circle",
                });
                feedDataToArray.push({
                  data: this.dataIndicesHealthPred4,
                  lineDashType: "dot",
                  label: lableZ,
                  legendMarkerType: "circle",
                });
                predChartFour.data = [];
                predChartFour.axisY.maximum = green;
                predChartFour.unit = "%";
                predChartFour.myValue =
                  this.statusHealthIndicesPredictionValues;
                predChartFour.data = this.makeDataForChart(feedDataToArray);
                this.predictiveHealthIndicesChart = new CanvasJS.Chart(
                  "machineHealthIndicesChart",
                  predChartFour
                );
                setTimeout(() => {
                console.log('Rendering predictiveHealthIndicesChart')
                if(this.predictiveHealthIndicesChart)
                  this.predictiveHealthIndicesChart.render();
              }, 200);
                this.predictiveHealthIndicesChart.axisY[0].addTo(
                  "stripLines",
                  this.addBackgroundColor(min, red, this.redColor)
                );
                this.predictiveHealthIndicesChart.axisY[0].addTo("stripLines", {
                  value: red,
                  label: red,
                  color: this.redColor,
                  labelFontColor: "#000000",
                });

                this.predictiveHealthIndicesChart.axisY[0].addTo(
                  "stripLines",
                  this.addBackgroundColor(red, yellow, this.yellowColor)
                );
                this.predictiveHealthIndicesChart.axisY[0].addTo("stripLines", {
                  value: yellow,
                  label: yellow,
                  color: this.yellowColor,
                  labelFontColor: "#000000",
                });
                this.predictiveHealthIndicesChart.axisY[0].addTo(
                  "stripLines",
                  this.addBackgroundColor(yellow, green, this.greenColor)
                );
                this.predictiveHealthIndicesChart.axisY[0].addTo("stripLines", {
                  value: green,
                  label: green,
                  color: this.greenColor,
                  labelFontColor: "#000000",
                });
              }
            } else {
              this.showPredIndicesChartEmpty = true;
            }
          } else {
            this.machineHealthIndicesOnOff = false;
            this.showPredIndicesChartEmpty = true;
          }
        } else {
          this.machineHealthIndicesOnOff = false;
          this.showPredIndicesChartEmpty = true;
        }
      });
  }

  async getIndicesTableData(
    dataPoint1,
    dataPoint2,
    dataPoint3,
    dataPoint4,
    dataPointPred1,
    dataPointPred2,
    dataPointPred3,
    dataPointPred4
  ) {
    let self = this;
    var f_arr3;
    let f_arr = await Promise.all(
      dataPoint1.map(async function (f, fx) {
        let chartTime = self.getTimeOnly(f);
        return {
          d: chartTime,
          c1: f.y === null ? "-" : f.y.toFixed(2),
          c2: dataPoint2[fx].y === null ? "-" : dataPoint2[fx].y.toFixed(2),
          c3: dataPoint3[fx].y === null ? "-" : dataPoint3[fx].y.toFixed(2),
          c4: dataPoint4[fx].y === null ? "-" : dataPoint4[fx].y.toFixed(2),
        };
      })
    );
    if (dataPointPred1 !== null) {
      let f_arr1 = await Promise.all(
        dataPointPred1.map(async function (f, fx) {
          let chartTime = self.getTimeOnly(f);
          return {
            d: chartTime,
            c5: f.y === null ? "-" : f.y.toFixed(2),
            c6:
              dataPointPred2[fx].y === null
                ? "-"
                : dataPointPred2[fx].y.toFixed(2),
            c7:
              dataPointPred3[fx].y === null
                ? "-"
                : dataPointPred3[fx].y.toFixed(2),
            c8:
              dataPointPred3[fx].y === null
                ? "-"
                : dataPointPred3[fx].y.toFixed(2),
          };
        })
      );
      f_arr3 = [...f_arr, ...f_arr1];
    } else {
      f_arr3 = [...f_arr];
    }
    this.tableDataHealthIndices = this.mergeArray(f_arr3, "d");
  }
  stackchartvelocity() {
    this.stackData = [];
    let interval = 30;
    let bearingSelectedValue = "";
    this.service
      .getData(this.assetsUrlEdit + "/" + this.assetId + "/" + this.mac_address)
      .then((result) => {
        if (JSON.parse(JSON.stringify(result)).data.status === "success") {
          //If "Sleeve Bearing" is selected then "Diagnostics->Bearing Analysist" tab is disabled.
          //Start Code.
          bearingSelectedValue =
            JSON.parse(JSON.stringify(result)).data.body.de_bearing_number ===
            "NA"
              ? "off"
              : "on";
          //End Code.
          if (this.assetType === "GEAR") {
            if (
              JSON.parse(JSON.stringify(result)).data.body.gear_info[0]
                .gear_deb !== "NA" &&
              JSON.parse(JSON.stringify(result)).data.body.gear_info[0]
                .gear_deb !== null &&
              JSON.parse(JSON.stringify(result)).data.body.gear_info[1]
                .gear_deb !== "NA" &&
              JSON.parse(JSON.stringify(result)).data.body.gear_info[1]
                .gear_deb !== null
            ) {
              this.ballBearingOn = false;
            }
          } else if (
            this.assetType != "GEAR" &&
            JSON.parse(JSON.stringify(result)).data.body.de_bearing_number !== "NA" &&  JSON.parse(JSON.stringify(result)).data.body.de_bearing_number !== null
          ) {
            this.ballBearingOn = false;
          }
          if (
            JSON.parse(JSON.stringify(result)).data.body.data_frequency > 15
          ) {
            interval = 45;
          } else {
            interval = 30;
          }
        } else {
          interval = 30;
        }

        this.service
          .getDataWithQuery(
            `${this.bucketsensordata}/${this.userID}/${this.assetId}/${this.mac_address}/${interval}/29,30,31?lastHours=${this.lastHours[1]}`)
          .then((res) => {
            if (JSON.parse(JSON.stringify(res)).data.status == "success") {
              let resdata = JSON.parse(JSON.stringify(res)).data.body;
              // delete resdata[0];
              // console.log(resdata);

              for (let i = 1; i < resdata.length - 1; i++) {
                let testDateUtc = moment.utc(resdata[i].bucket_date).toDate();
                let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(
                  testDateUtc
                );
                // console.log(resdata[i].bucket_date +  "=>" + testDateUtc + "=>" + timeUpdatedAt);
                let dateandtime = timeUpdatedAt.split(" ");
                let date = dateandtime[0].toString();
                let time = dateandtime[1].toString();
                let velocityStatus = resdata[i].status.velocity || "N/A";
                let temperatureStatus = resdata[i].status.temperature || "N/A";
                let ultrasoundStatus = resdata[i].status.ultrasound || "N/A";
                // console.log(resdata[i].highest_val ,this.velocityG,resdata[i].highest_val < this.velocityG)
                // if (
                //   resdata[i].highest_val < this.velocityG &&
                //   resdata[i].highest_val > 0
                // ) {
                //   // console.log("INSIDE IF")
                //   this.stackData.push({
                //     type: "stackedBar",
                //     xValueFormatString: time,

                //     color: "#72FF13",
                //     dataPoints: [{ x: 0, y: 30 }],
                //   });
                // } else if (
                //   resdata[i].highest_val > this.velocityG &&
                //   resdata[i].highest_val < this.velocityY
                // ) {
                //   this.stackData.push({
                //     type: "stackedBar",
                //     indexLabelFontColor: "red",
                //     xValueFormatString: time,

                //     color: "#FAA700",
                //     dataPoints: [{ x: 0, y: 30 }],
                //   });
                // } else if (resdata[i].highest_val > this.velocityY) {
                //   this.stackData.push({
                //     type: "stackedBar",
                //     xValueFormatString: time,

                //     color: "#ff2a1b",
                //     dataPoints: [{ x: 0, y: 30 }],
                //   });
                // } else if (resdata[i].highest_val == 0) {
                //   this.stackData.push({
                //     type: "stackedBar",
                //     xValueFormatString: time,

                //     color: "#999999",
                //     dataPoints: [{ x: 0, y: 30 }],
                //   });
                // }
                switch(resdata[i].status.overall) {
                  case 'HEALTHY':
                    this.stackData.push({
                      type: "stackedBar",
                      xValueFormatString: time,
                      color: "#72FF13",
                      dataPoints: [{
                        x: 0,
                        y: 30,
                        time: time,
                        velocityStatus: velocityStatus,
                        temperatureStatus: temperatureStatus,
                        ultrasoundStatus: ultrasoundStatus
                      }],
                    })
                    break;
                  case 'WARNING':
                    this.stackData.push({
                      type: "stackedBar",
                      xValueFormatString: time,
                      color: "#FAA700",
                      dataPoints: [{
                        x: 0,
                        y: 30,
                        time: time,
                        velocityStatus: velocityStatus,
                        temperatureStatus: temperatureStatus,
                        ultrasoundStatus: ultrasoundStatus
                      }],
                    })
                    break;
                  case 'CRITICAL':
                    this.stackData.push({
                      type: "stackedBar",
                      xValueFormatString: time,
                      color: "#ff2a1b",
                      dataPoints: [{
                        x: 0,
                        y: 30,
                        time: time,
                        velocityStatus: velocityStatus,
                        temperatureStatus: temperatureStatus,
                        ultrasoundStatus: ultrasoundStatus
                      }],
                    })
                    break;
                    case 'IDLE':
                    this.stackData.push({
                      type: "stackedBar",
                      xValueFormatString: time,
                      color: "#cecece",
                      dataPoints: [{
                        x: 0,
                        y: 30,
                        time: time,
                        velocityStatus: velocityStatus,
                        temperatureStatus: temperatureStatus,
                        ultrasoundStatus: ultrasoundStatus
                      }],
                    })
                    break;
                  default:
                    this.stackData.push({
                      type: "stackedBar",
                      xValueFormatString: time,
                      color: "#999999",
                      dataPoints: [{
                        x: 0,
                        y: 30,
                        time: time,
                        velocityStatus: velocityStatus,
                        temperatureStatus: temperatureStatus,
                        ultrasoundStatus: ultrasoundStatus
                      }],
                    })
                    break;
                }
              }
              // console.log("Stack data")
              // console.log(this.stackData)
              // console.log(this.stackData.length)
              const chart11 = new CanvasJS.Chart(
                "stackvelocitychartContainer",
                {
                  axisX: {
                    valueFormatString: " ",
                    titleFontSize: 100,
                    gridThickness: 0,
                    lineThickness: 0,
                    tickThickness: 0,
                  },
                  axisY: {
                    titleFontSize: 135,
                    valueFormatString: " ",
                    gridThickness: 0,
                    lineThickness: 0,
                    tickThickness: 0,
                  },
                  toolTip: {
                    contentFormatter: function(e) {
                      const dataPoint = e.entries[0].dataPoint;

                      // Helper function to get status color
                      function getStatusColor(status) {
                        switch(status) {
                          case 'HEALTHY': return "#72FF13"; // Green
                          case 'WARNING': return "#FAA700"; // Orange/Amber
                          case 'CRITICAL': return "#ff2a1b"; // Red
                          case 'IDLE': return "#cecece"; // idle
                          default: return "#999999";         // Gray for unknown/undefined
                        }
                      }

                      // Color formatting for each status
                      const velocityColor = getStatusColor(dataPoint.velocityStatus);
                      const temperatureColor = getStatusColor(dataPoint.temperatureStatus);
                      const ultrasoundColor = getStatusColor(dataPoint.ultrasoundStatus);

                      return `<div style="padding: 5px;">
                        <b>Time:</b> ${dataPoint.time}<br/>
                        <b>Velocity:</b> <span style="color:${velocityColor}; font-weight:bold">${dataPoint.velocityStatus}</span><br/>
                        <b>Temperature:</b> <span style="color:${temperatureColor}; font-weight:bold">${dataPoint.temperatureStatus}</span><br/>
                        <b>Ultrasound:</b> <span style="color:${ultrasoundColor}; font-weight:bold">${dataPoint.ultrasoundStatus}</span>
                      </div>`;
                    },
                    shared: false,
                  },
                  dataPointWidth: 65,

                  data: this.stackData,
                  afterRender: function () {
                    this.stackvelocitychartLoader = false;
                  },
                }
              );
              setTimeout(() => {
                console.log('rendering chart...')
                if(chart11) chart11.render();
              }, 200);
              // chart11.render();
              this.stackvelocitychartLoader = false;
            } else {
            }
          });
      });
  }
  // batterystatusgraph(){
  //   const batterystatusDialogRef = this.dialog.open(
  //     DialogOverviewExampleDialogComponent,
  //     {
  //       width: "1220px",
  //       maxWidth: "100%",
  //       disableClose: false,
  //       data: {
  //         type: "BAtterystatusgraph",
  //         mac_address:this.mac_address
  //       },
  //     }
  //   );

  // }
  downloadIndicesCsv() {
    this.getIndicesTableData(
      this.dataIndicesHealth1,
      this.dataIndicesHealth2,
      this.dataIndicesHealth3,
      this.dataIndicesHealth4,
      this.dataIndicesHealthPred1,
      this.dataIndicesHealthPred2,
      this.dataIndicesHealthPred3,
      this.dataIndicesHealthPred4
    );
    let csvArray = [];
    for (let time of this.tableDataHealthIndices) {
      let obj = {
        time: time.d,
        "Mechanical Health": time.c1 === undefined ? "-" : time.c1,
        "Electrical Health": time.c2 === undefined ? "-" : time.c2,
        "Bearings Health": time.c3 === undefined ? "-" : time.c3,
        "Thermal Health": time.c4 === undefined ? "-" : time.c4,
        PredictionW: time.c5 === undefined ? "-" : time.c5,
        PredictionX: time.c6 === undefined ? "-" : time.c6,
        PredictionY: time.c7 === undefined ? "-" : time.c7,
        PredictionZ: time.c8 === undefined ? "-" : time.c8,
      };
      csvArray.push(obj);
    }
    new AngularCsv(
      csvArray,
      this.mac_address + "-Health Indices Trend",
      this.csvOptionsIndices
    );
  }

  taketopredominantalert(event, raw_matric_id) {
    this.selectedFFTUID = raw_matric_id;
    let id = "tab-2";
    this.ctdTabset.select(id);
    this.loadFftData(this.selectedFFTUID, "pre");
  }
  takeselectedEnvelopAnalysis(event, raw_matric_id) {
    this.fftIdforAdvance = raw_matric_id;
    this.innerTab = 'diagSummary';
    this.loadFftData(this.selectedFFTUID, "pre");
  }

  public selectIndividualFilter(value: string) {
    switch (value) {
      case "Mechanical":
        this.tabTwoColor1 = "active";
        this.tabTwoColor2 = "";
        this.tabTwoColor3 = "";
        this.tabTwoColor4 = "";
        this.tabTwoColor5 = "";
        this.tabTwoColor6 = "";
        this.tabTwoColor7 = "";
        this.faultFilterName = value;
        this.individualFaultCharts(this.assetType, this.faultFilterName);
        break;
      case "Electrical Stator":
        this.tabTwoColor1 = "";
        this.tabTwoColor2 = "active";
        this.tabTwoColor3 = "";
        this.tabTwoColor4 = "";
        this.tabTwoColor5 = "";
        this.tabTwoColor6 = "";
        this.tabTwoColor7 = "";
        this.faultFilterName = value;
        this.individualFaultCharts(this.assetType, this.faultFilterName);
        break;
      case "Electrical Rotor":
        this.tabTwoColor1 = "";
        this.tabTwoColor2 = "";
        this.tabTwoColor3 = "active";
        this.tabTwoColor4 = "";
        this.tabTwoColor5 = "";
        this.tabTwoColor6 = "";
        this.tabTwoColor7 = "";
        this.faultFilterName = value;
        this.individualFaultCharts(this.assetType, this.faultFilterName);
        break;
      case "Belt System":
        this.tabTwoColor1 = "";
        this.tabTwoColor2 = "";
        this.tabTwoColor3 = "";
        this.tabTwoColor4 = "active";
        this.tabTwoColor5 = "";
        this.tabTwoColor6 = "";
        this.tabTwoColor7 = "";
        this.faultFilterName = value;
        this.individualFaultCharts(this.assetType, this.faultFilterName);
        break;
      case "Bearing":
        this.tabTwoColor1 = "";
        this.tabTwoColor2 = "";
        this.tabTwoColor3 = "";
        this.tabTwoColor4 = "";
        this.tabTwoColor5 = "active";
        this.tabTwoColor6 = "";
        this.tabTwoColor7 = "";
        this.faultFilterName = value;
        this.individualFaultCharts(this.assetType, this.faultFilterName);
        break;
      case "Gear":
        this.tabTwoColor1 = "";
        this.tabTwoColor2 = "";
        this.tabTwoColor3 = "";
        this.tabTwoColor4 = "";
        this.tabTwoColor5 = "";
        this.tabTwoColor6 = "active";
        this.tabTwoColor7 = "";
        this.faultFilterName = value;
        this.individualFaultCharts(this.assetType, this.faultFilterName);
        break;
      case "Journal Bearing":
        this.tabTwoColor1 = "";
        this.tabTwoColor2 = "";
        this.tabTwoColor3 = "";
        this.tabTwoColor4 = "";
        this.tabTwoColor5 = "";
        this.tabTwoColor6 = "";
        this.tabTwoColor7 = "active";
        this.faultFilterName = value;
        this.individualFaultCharts(this.assetType, this.faultFilterName);
        break;
    }
  }

  async individualFaultCharts(type, group) {
    this.mainChartIndiArr = [];
    let returnItem = [];
    this.service
      .getDataWithQuery(`${this.getIndividualFaults}/v1/${type}/${group}`)
      .then(async (res) => {
        let result = JSON.parse(JSON.stringify(res));
        this.emptyIndivisualCharts = false;
        if (result.length != 0) {
          let self = this;
          (async function loop() {
            for (let k = 0; k < result.length; k++) {
              if (!self.stopLoopForIndi) {
                break;
              }
              self.mainChartIndiArr.push({
                chartID: `chart${result[k].id}`,
                imgUrl: "",
                absolute_percentage: "",
                fault_group: "",
                modal: `custom-modal-${k}`,
                empty: true,
              });
              await new Promise((resolve) => {
                let dataUnbalancedDoughnut = [];
                let index = k;
                let id = result[k].id;
                let fault_type = result[k].fault_type;
                let fault_name = result[k].fault_name;
                if (fault_type != undefined && fault_type != "") {
                  self.service
                    .getDataWithQuery(
                      self.trendData +
                        "/" +
                        parseInt(self.deviceId) +
                        "/" +
                        parseInt(self.assetId) +
                        "/" +
                        fault_type +
                        "?userid=" +
                        self.userID +
                        "&filter=" +
                        self.valueTypeTrend +
                        "&asset_type=" +
                        self.assetType
                    )
                    .then(async (res) => {
                      if (
                        JSON.parse(JSON.stringify(res)).data.status === "fail"
                      ) {
                        self.service.showError("Error in chart service!");
                      } else if (
                        JSON.parse(JSON.stringify(res)).data.status ===
                        "success"
                      ) {
                        setTimeout(resolve, Math.random() * 1000);
                        dataUnbalancedDoughnut = await JSON.parse(
                          JSON.stringify(res)
                        ).data.body.doughnutData;
                        let abPer = JSON.parse(JSON.stringify(res)).data.body
                          .absolute_percentage;
                        if (dataUnbalancedDoughnut.length !== 0) {
                          if (abPer != undefined) {
                            self.absolutePercentageDoughnuts = abPer;
                          } else {
                            self.absolutePercentageDoughnuts = 0;
                          }
                          if (document.getElementById(`chart${id}`) !== null) {
                            let chartObject = cloneDeep(individualChartObject);
                            chartObject.data[0].dataPoints =
                              dataUnbalancedDoughnut;
                            self.dataMUCDoughnut = new CanvasJS.Chart(
                              `chart${id}`,
                              chartObject
                            );
                            self.dataMUCDoughnut.render();
                            if (self.mainChartIndiArr[index] !== undefined) {
                              self.mainChartIndiArr[index].imgUrl = $(
                                `#chart${id} .canvasjs-chart-canvas`
                              )
                                .get(0)
                                .toDataURL();
                              self.mainChartIndiArr[index].absolute_percentage =
                                self.absolutePercentageDoughnuts;
                              self.mainChartIndiArr[index].fault_group =
                                fault_name;
                              self.mainChartIndiArr[index].empty = true;
                            }
                          }
                        } else {
                          if (self.mainChartIndiArr[index] != undefined) {
                            self.mainChartIndiArr[index].empty = false;
                          }
                        }
                      }
                    });
                } else {
                  if (self.mainChartIndiArr[index] != undefined) {
                    self.mainChartIndiArr[index].empty = false;
                  }
                }
              });
            }
          })();
        } else {
          this.emptyIndivisualCharts = true;
        }
      });
  }

  getSmallFaultChart(index, id, fault_type, fault_name) {
    return new Promise((resolve) => {
      if (fault_type != undefined && fault_type != "") {
        this.service
          .getDataWithQuery(
            this.trendData +
              "/" +
              parseInt(this.deviceId) +
              "/" +
              parseInt(this.assetId) +
              "/" +
              fault_type +
              "?userid=" +
              this.userID +
              "&filter=" +
              this.valueTypeTrend +
              "&asset_type=" +
              this.assetType
          )
          .then(async (res) => {
            if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
              this.service.showError("Error in chart service!");
            } else if (
              JSON.parse(JSON.stringify(res)).data.status === "success"
            ) {
              return resolve(JSON.parse(JSON.stringify(res)).data.body);
            }
          });
      }
    });
  }

  makeFFTDataForChart(data) {
    let chartData = data.map(function (val, index) {
      let obj = {
        type: "line",
        yValueFormatString: "",
        showInLegend: true,
        name: val.label,
        dataPoints: val.data,
      };
      return obj;
    });

    return chartData;
  }

  makeDataForChart(data) {
    let chartData = data.map(function (val, index) {
      let obj = {
        lineDashType: val.lineDashType,
        type: "line",
        legendMarkerType: val.legendMarkerType,
        xValueType: "dateTime",
        yValueFormatString: "",
        xValueFormatString: "hh:mm:ss TT",
        showInLegend: true,
        name: val.label,
        dataPoints: val.data,
      };
      return obj;
    });
    return chartData;
  }

  addBackgroundColor(min, max, color) {
    let Obj = {
      startValue: min,
      endValue: max,
      color: color,
    };
    return Obj;
  }

  async editAssets() {
    if(this.isOutOfService){
      // this.service.showError("Asset is out for service!")
      return;
    }
    // this.pageName="Detail"
    const assetInfoObj = this.assetDataObject.data.body[0];
    console.log(assetInfoObj,'assetinfo')
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        assets_id: assetInfoObj.id,
        online_status: assetInfoObj.live_status,
        deviceid: this.deviceId,
        label: this.label,
        assetStatus: this.onoffStatus,
        sensorType: this.sensorType,
        serial_no: this.serial_no,
        pageRef: this.pageName,
        asset_master_info: JSON.stringify(this.assetMasterInfo),
        asset_type: this.assetType,
        state: "monitor_edit",
        macaddress: this.mac_address, // JULIO
        firmware: this.firmware_version,
        overall_powertrain_status:this.overall_powertrain_live_status,
        overallStatus:this.overallStatus,
      },
      state: {
        orientation: this.orientation
      }
    };
    console.log(navigationExtras);
    this.router.navigate(["/clients-add-assets"], navigationExtras);
  }

  viewAsset() {
    if(this.isOutOfService){
      // this.service.showError("Asset is out for service!")
      return;
    }
    const assetInfoObj = this.assetDataObject.data.body[0];
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: "1100px",
      maxWidth: "85vw",
      data: {
        type: "sensorNewDialogBox",
        client_asset_id: assetInfoObj.id,
        asset_type: assetInfoObj.asset_type,
        online_status: assetInfoObj.live_status,
        clientId: this.userID,
        inventory_id: assetInfoObj.inventory_id,
        asset_status: this.onoffStatus,
        asset_obj: assetInfoObj,
        showKurtosis: this.AdvanceDiagnosticsDisabled,
        kurt_freq: localStorage.getItem("kurt_freq")
          ? localStorage.getItem("kurt_freq")
          : this.kurt_freq,
        kurt_threshold: localStorage.getItem("kurt_threshold")
          ? localStorage.getItem("kurt_threshold")
          : this.kurt_threshold,
        kurt_anomaly_counter: localStorage.getItem("kurt_anomaly_counter")
          ? localStorage.getItem("kurt_anomaly_counter")
          : this.kurt_anomaly_counter,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      // console.log("Results");
      // console.log(result.graphToReload.audible);
      if(result.graphToReload.acceleration){
        // console.log("reloading accel chart");
        document.getElementById("chartContainer").innerHTML?document.getElementById("chartContainer").innerHTML =
        null:""
        this.getSensorCharts();
        this.getGaugeDataByID(true,false,false);
        this.monitoringGaugeData(true,false,false);
      }
      if(result.graphToReload.audible==true){
        // console.log("Relaoding audible chart");
        document.getElementById("audibleChartId").innerHTML? document.getElementById("audibleChartId").innerHTML=null:""
        // document.getElementById("audibleChartId").innerHTML =
        // null;
        if([2,3].includes(this.master_product_type)){
          this.getAudibleChart();
        }
        this.getGaugeDataByID(false,false,true);
        this.monitoringGaugeData(false,false,true);
      }
      if(result.graphToReload.sound){
        document.getElementById("monitoringMachineAcousticsChart").innerHTML?document.getElementById("monitoringMachineAcousticsChart").innerHTML =
        null:""
        if([2,3].includes(this.master_product_type))
          this.getMachineAcousticsChart();
        this.getGaugeDataByID(false,false,true);
        this.monitoringGaugeData(false,false,true);

      }
      if(result.graphToReload.temperature){
        document.getElementById("tempChartContainer").innerHTML?document.getElementById("tempChartContainer").innerHTML =
        null:""
        this.getGaugeDataByID(false,true,false);
        this.monitoringGaugeData(false,true,false);
        this.getSensorTempCharts();
      }
      if (result.isChanged) {
        document.getElementById("predictiveKurtChartContainer").innerHTML?document.getElementById("predictiveKurtChartContainer").innerHTML =
        null:""
        this.getPredictiveKurtChart();
      }
      if(result.graphToReload.kwrating3){
        document.getElementById("monitoringVelocityChartContainer").innerHTML?document.getElementById("monitoringVelocityChartContainer").innerHTML=null:""
        this.getVelocityChart();
        this.getGaugeDataByID(true,false,false);
        this.monitoringGaugeData(true,false,false);
      }
    });
    // localStorage.setItem("kurt_threshold",String(this.kurt_threshold))
  }

  getDeviceInfo() {
    this.service
      .getData(this.assetsUrlEdit + "/" + this.assetId + "/" + this.mac_address)
      .then((result) => {
        if (JSON.parse(JSON.stringify(result)).data.status === "success") {
          const dialogRef = this.dialog.open(
            DialogOverviewExampleDialogComponent,
            {
              width: "410px",
              height: "auto",
              data: {
                type: "motorPlateDialogBox",
                asset_id: this.assetId,
                deviceStatus: result,
                lastUpdate: this._lastUpdate,
              },
            }
          );
          dialogRef.afterClosed().subscribe((result) => {
            if (result !== undefined) {
            }
          });
        } else {
          this.service.showError("Something went wrong.");
        }
      });
  }

  async serviceBookOpen() {
    if(this.isOutOfService){
      // this.service.showError("Asset is out for service");
      return;
    }
    this.service
      .getData(
        this.assetServiceUrl + "/" + this.assetId + "/" + this.mac_address
      )
      .then((res) => {
        this.changeService.loader(false);
        if (JSON.parse(JSON.stringify(res)).data.status === "success") {
          if (
            JSON.parse(JSON.stringify(res)).data.body.last_service_date ===
            undefined
          ) {
            this.fromDate = this.calendar.getToday();
          } else {
            var datelastSerobj = new Date(
              JSON.parse(JSON.stringify(res)).data.body.last_service_date
            );
            var last_month = datelastSerobj.getMonth() + 1;
            var last_day = datelastSerobj.getDate();
            var last_year = datelastSerobj.getFullYear();
            this.fromDate = new NgbDate(last_year, last_month, last_day);
          }
          if (
            JSON.parse(JSON.stringify(res)).data.body.next_service_date ===
            undefined
          ) {
            this.toDate = this.calendar.getNext(
              this.calendar.getToday(),
              "d",
              360
            );
          } else {
            var dateNextSerobj = new Date(
              JSON.parse(JSON.stringify(res)).data.body.next_service_date
            );
            var next_month = dateNextSerobj.getMonth() + 1;
            var next_day = dateNextSerobj.getDate();
            var next_year = dateNextSerobj.getFullYear();
            this.toDate = new NgbDate(next_year, next_month, next_day);
          }
          const dialogRef = this.dialog.open(
            DialogOverviewExampleDialogComponent,
            {
              width: "400px",
              maxWidth: "85vw",
              data: {
                type: "ServiceBookOpen",
                data: {
                  service_category:
                    JSON.parse(JSON.stringify(res)).data.body
                      .service_category === null
                      ? "Planned Repair/Service"
                      : JSON.parse(JSON.stringify(res)).data.body
                          .service_category,
                  id: JSON.parse(JSON.stringify(res)).data.body.id,
                  service_detail: JSON.parse(JSON.stringify(res)).data.body
                    .service_detail,
                  asset_id: JSON.parse(JSON.stringify(res)).data.body.asset_id,
                  last_service_date: this.fromDate,
                  last_service_performed: JSON.parse(JSON.stringify(res)).data
                    .body.last_service_performed,
                  service_details: "",
                  service_performed_by: JSON.parse(JSON.stringify(res)).data
                    .body.service_performed_by,
                  next_service_date: this.toDate,
                },
                client_asset_id: this.assetId,
                clientId: this.userID,
              },
            }
          );
          dialogRef.afterClosed().subscribe((result) => {
            if (result !== undefined) {
              if (result.type === "ServiceBookOpen") {
                if (result.data.last_service_date === undefined) {
                  this.service.showError("Last service date can't be empty!");
                } else if (result.data.last_service_performed === undefined) {
                  this.service.showError(
                    "Last service performed date can't be empty!"
                  );
                } else if (result.data.service_performed_by === undefined) {
                  this.service.showError(
                    "service performed by date can't be empty!"
                  );
                } else {
                  const monthNames = [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December",
                  ];
                  let last_service_date =
                    result.data.last_service_date.day +
                    " " +
                    monthNames[result.data.last_service_date.month - 1] +
                    " " +
                    result.data.last_service_date.year;
                  let next_service_date =
                    result.data.next_service_date.day +
                    " " +
                    monthNames[result.data.next_service_date.month - 1] +
                    " " +
                    result.data.next_service_date.year;
                  if (result.data.id === undefined) {
                    let resultObj = {
                      asset_id: result.client_asset_id,
                      inventory_id: this.deviceId,
                      last_service_date:
                        moment(last_service_date).format("YYYY-MM-DD"),
                      next_service_date:
                        moment(next_service_date).format("YYYY-MM-DD"),
                      service_detail: result.data.service_detail,
                      last_service_performed:
                        result.data.last_service_performed,
                      service_performed_by: result.data.service_performed_by,
                      user_id: localStorage.getItem("user_id"),
                      service_category: result.data.service_category,
                    };
                    this.service
                      .postData(this.assetServiceUrl, resultObj)
                      .then((res) => {
                        if (
                          JSON.parse(JSON.stringify(res)).data.status ===
                          "success"
                        ) {
                          this.service.showSuccess(
                            JSON.parse(JSON.stringify(res)).data.message
                          );
                        } else {
                          this.service.showError("Something went wrong");
                        }
                      });
                  } else {
                    let body = {
                      asset_id: result.client_asset_id,
                      inventory_id: this.deviceId,
                      last_service_date:
                        moment(last_service_date).format("YYYY-MM-DD"),
                      next_service_date:
                        moment(next_service_date).format("YYYY-MM-DD"),
                      service_detail: result.data.service_detail,
                      last_service_performed:
                        result.data.last_service_performed,
                      service_performed_by: result.data.service_performed_by,
                      user_id: localStorage.getItem("user_id"),
                      service_category: result.data.service_category,
                    };
                    this.service
                      .putData(
                        this.assetServiceUrl +
                          "/" +
                          result.data.id +
                          "/" +
                          this.mac_address,
                        body
                      )
                      .then((res) => {
                        this.changeService.loader(false);
                        if (
                          JSON.parse(JSON.stringify(res)).data.status ===
                          "success"
                        ) {
                          this.service.showSuccess(
                            JSON.parse(JSON.stringify(res)).data.message
                          );
                          this.getMonitoringInfo();
                        } else {
                          this.service.showError("Something went wrong");
                        }
                      });
                  }
                }
              }
            }
          });
        }
      });
  }

  public alertSettings(): void {
    if(this.isOutOfService){
      // this.service.showError("Asset is out for service")
      return;
    }
    const alertDialogRef = this.dialog.open(
      DialogOverviewExampleDialogComponent,
      {
        width: "1220px",
        maxWidth: "100%",
        disableClose: true,
        data: {
          type: "NotifyAlertStstem",
          assetId: this.assetId,
          clientId: this.userID,
          deviceId: this.deviceId,
          asset_obj: this.assetDataObject.data.body[0],
        },
      }
    );
  }

  showDeleteAlert() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: "400px",
      height: "auto",
      data: {
        type: "delete-dialog-open-with-childs",
        typeOf: "asset",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined) {
      }
    });
  }

  showDeleteDialog() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: "400px",
      height: "auto",
      data: {
        type: "delete-asset-dialog",
        typeOf: "asset",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        this.deleteAssets(this.assetId, this.deviceId);
      }
    });
  }
  UpdateHealthIndices() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: "410px",
      height: "auto",
      data: {
        type: "Update Weightage",
        assetid: this.assetId,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined) {
      }
    });
  }

  deleteAssets(id, inventory_id) {
    this.service
      .deleteInfo(this.assetDeleteUrl + "/" + id + "/" + inventory_id)
      .then((res) => {
        this.service
          .deleteInfo(this.assetServiceUrl + "/" + id + "/" + this.mac_address)
          .then((res2) => {
            if (JSON.parse(JSON.stringify(res)).data) {
              if (JSON.parse(JSON.stringify(res2)).data) {
                this.service
                  .putData(
                    this.deviceStatusURL +
                      "inventory/make/usage/status/" +
                      inventory_id,
                    { device_status: "FREE" }
                  )
                  .then((res2) => {
                    this.service.showSuccess("Successfully deleted.");
                    if (localStorage.getItem("role") === "ADMIN") {
                      if(this.route_path === "boiler-configurator"){
                        const navigationExtras ={
                          // skipLocationChange: true,
                          // queryParams:{
                          //   subsystem_id: localStorage.getItem('subsystem_id'),
                          //   boilerName: localStorage.getItem('boiler_name'),
                          //   site_name: localStorage.getItem('boiler_site_name'),
                          //   application_name: localStorage.getItem('boiler_application_name'),
                          //   tabName: this.tabName,
                          //   tab1: true,
                          //   tab2 :this.productTab2,
                          //   tab3 :this.productTab2,
                          //   tab4 :this.productTab2,


                          // }
                        }
                        this.router.navigate([this.route_path], navigationExtras);
                      }else{
                        if(this.fromPowerTrain){
                          //delete powertrain sensor from json
                          this.service.putData(`${this.powertrain_delete_one_url}${this.powertrainSubsystemId}/${inventory_id}`,'').then(response=>{
                            console.log(response)
                          }).catch(err=>{
                            this.service.showError("Failed to delete from powertrain")
                            console.log(err)
                          })
                        }
                        this.router.navigate([this.route_path]);
                      }
                    } else {
                     if(this.route_path === "boiler-configurator"){
                        const navigationExtras ={
                          skipLocationChange: true,
                          queryParams:{
                            subsystem_id: localStorage.getItem('subsystem_id'),
                            boilerName: localStorage.getItem('boiler_name'),
                            site_name: localStorage.getItem('boiler_site_name'),
                            application_name: localStorage.getItem('boiler_application_name'),
                            tabName: this.tabName,
                            tab1: true,
                            tab2 :this.productTab2,
                            tab3 :this.productTab2,
                            tab4 :this.productTab2,
                          }
                        }
                        this.router.navigate([this.route_path], navigationExtras);
                      }else{
                        const navigationExtras ={
                          // skipLocationChange: true,
                          // queryParams:{
                          //   subsystem_id: localStorage.getItem('subsystem_id'),
                          //   boilerName: localStorage.getItem('boiler_name'),
                          //   site_name: localStorage.getItem('boiler_site_name'),
                          //   application_name: localStorage.getItem('boiler_application_name'),
                          //   tabName: this.tabName,
                          //   tab1: true,
                          //   tab2 :this.productTab2,
                          //   tab3 :this.productTab2,
                          //   tab4 :this.productTab2,
                          // }
                        }
                        if(this.fromPowerTrain){
                          //delete powertrain sensor from json
                          this.service.putData(`${this.powertrain_delete_one_url}${this.powertrainSubsystemId}/${inventory_id}`,'').then(response=>{
                            console.log(response)
                          }).catch(err=>{
                            this.service.showError("Failed to delete from powertrain")
                            console.log(err)
                          })
                        }
                        this.router.navigate([this.route_path],navigationExtras);
                      }
                    }
                  });
              } else {
                this.service.showSuccess("Something went wrong.");
              }
            } else {
              this.service.showSuccess("Something went wrong.");
            }
          });
      });
  }
  downloadChartData2(val) {
    switch (val) {
      case "magnetic":
        this.maglistLayout();
        this.dtDataForCSVARRAY2 = [];
        for (let table2 = 0; table2 < this.listMagData1.length; table2++) {
          let obj = {
            frequency: this.listMagData1[table2].x,
            x: this.listMagData1[table2].y,
            y: this.listMagData2[table2].y,
            z: this.listMagData3[table2].y,
          };
          this.dtDataForCSVARRAY2.push(obj);
        }
        new AngularCsv(
          this.dtDataForCSVARRAY2,
          this.mac_address + "-Magnetic Spectra",
          this.magCsvOption
        );
        break;
      case "ultrasonic":
        this.ultralistLayout();
        this.dtDataForCSVARRAY2 = [];
        for (let i = 0; i < this.listUltraData.length; i++) {
          let obj = {
            frequency: this.listUltraData[i].x,
            dB: this.listUltraData[i].y,
          };
          this.dtDataForCSVARRAY2.push(obj);
        }
        new AngularCsv(
          this.dtDataForCSVARRAY2,
          this.mac_address + "-Ultrasonic Spectra",
          this.ultraCsvOption
        );
        break;
      case "vibration":
        this.listFrequencyChartData();
        this.dtDataForCSVARRAY2 = [];
        for (let table2 = 0; table2 < this.listFreqData1.length; table2++) {
          let obj = {
            frequency: this.listFreqData1[table2].x,
            tangential: this.listFreqData1[table2].y,
            axial: this.listFreqData2[table2].y,
            Radial: this.listFreqData3[table2].y,
          };
          this.dtDataForCSVARRAY2.push(obj);
        }
        new AngularCsv(
          this.dtDataForCSVARRAY2,
          this.mac_address + "-Velocity-Amplitude",
          this.csvOptions2
        );
        break;
      case "vibration&acceleration":
        this.listAccelerationChartData();
        this.dtDataForCSVARRAY2 = [];
        for (let table2 = 0; table2 < this.listAccData1.length; table2++) {
          let obj = {
            "Sample Count": this.listAccData1[table2].x,
            tangential: this.listAccData1[table2].y,
            axial: this.listAccData2[table2].y,
            Radial: this.listAccData3[table2].y,
          };
          this.dtDataForCSVARRAY2.push(obj);
        }
        new AngularCsv(
          this.dtDataForCSVARRAY2,
          this.mac_address + "-Velocity-Vibration - Acceleration",
          this.csvVibOptions2
        );
        break;
      case "acceleration":
        this.listFrequencyChartData();
        this.dtDataForCSVARRAY2 = [];
        for (let table2 = 0; table2 < this.listFreqData1.length; table2++) {
          let obj = {
            frequency: this.listFreqData1[table2].x,
            tangential: this.listFreqData1[table2].y,
            axial: this.listFreqData2[table2].y,
            Radial: this.listFreqData3[table2].y,
          };
          this.dtDataForCSVARRAY2.push(obj);
        }
        new AngularCsv(
          this.dtDataForCSVARRAY2,
          this.mac_address + "-Acceleration-Amplitude",
          this.csvOptions3
        );
        break;
      case "cepstrum":
        this.cepstrumListLayout();
        this.dtDataForCSVARRAY2 = [];
        for (let table2 = 0; table2 < this.cepListData1.length; table2++) {
          let obj = {
            Quefrency: this.cepListData1[table2].x,
            tangential: this.cepListData1[table2].y,
            axial: this.cepListData2[table2].y,
            Radial: this.cepListData3[table2].y,
          };
          this.dtDataForCSVARRAY2.push(obj);
        }
        new AngularCsv(
          this.dtDataForCSVARRAY2,
          this.mac_address + "-Cepstrum_Spectra_Data",
          this.cepstrumOptions3
        );
        break;
      case "Kurtosis":
        this.dtDataForCSVARRAY2 = [];
        for (
          let table2 = 0;
          table2 < this.datadiagKurtPoints1.length;
          table2++
        ) {
          let obj = {
            Quefrency: this.datadiagKurtPoints1[table2].x,
            tangential: this.datadiagKurtPoints1[table2].y,
            axial: this.datadiagKurtPoints2[table2].y,
            Radial: this.datadiagKurtPoints3[table2].y,
          };
          this.dtDataForCSVARRAY2.push(obj);
        }
        new AngularCsv(
          this.dtDataForCSVARRAY2,
          this.mac_address + "-Envelop_Analysis_Data",
          this.kurtosisEnv
        );
        break;
      case "electricalData":
        this.electricalLayout();
        this.dtDataForCSVARRAY2 = [];
        for (let i = 0; i < this.listElectricalData.length; i++) {
          let obj = {
            frequency: this.listElectricalData[i].x,
            mA: this.listElectricalData[i].y,
          };
          this.dtDataForCSVARRAY2.push(obj);
        }
        new AngularCsv(
          this.dtDataForCSVARRAY2,
          this.mac_address + "-Electrical Singnature Analysis(Amplitude)",
          this.electricalCsvOption
        );
        break;
      case "currentData":
        this.dtDataForCSVARRAY2 = [];
        for (
          let table2 = 0;
          table2 < this.dataCurrentPoints1.length;
          table2++
        ) {
          let obj = {
            "Sample Count": this.dataCurrentPoints1[table2].x,
            tangential: this.dataCurrentPoints1[table2].y,
            axial: this.dataCurrentPoints2[table2].y,
            Radial: this.dataCurrentPoints3[table2].y,
          };
          this.dtDataForCSVARRAY2.push(obj);
        }
        new AngularCsv(
          this.dtDataForCSVARRAY2,
          this.mac_address + "-Electrical Current",
          this.electricalCurrentCsvOption
        );
        break;
    }
  }
  electricalAnalysis() {
    this.getElectricalChart();
    this.electricalChartViewOn = true;
    this.electricalChartViewOff = false;
  }
  getElectricalChart() {
    this.electricalChartViewOn = true;
    this.electricalChartLoader = false;
    if (this.device_raw_matric_id != undefined) {
      this.service
        .getDataWithQuery(
          this.ElectricalSignaturefft +
            "/" +
            this.userID +
            "/" +
            this.deviceId +
            "/" +
            this.assetId +
            "/" +
            this.device_raw_matric_id
        )
        .then((res) => {
          if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
            this.electricalChartLoader = true;
            this.electricalMessage = false;
          } else if (
            JSON.parse(JSON.stringify(res)).data.status === "success"
          ) {
            if (
              JSON.parse(JSON.stringify(res)).data.body !== null ||
              JSON.parse(JSON.stringify(res)).data.body !== ""
            ) {
              if (
                JSON.parse(JSON.stringify(res)).data.body.body.chartXdata
                  .length != 0
              ) {
                this.electricalChartViewOn = true;
                this.electricalChartLoader = true;
                this.electricalMessage = false;

                let lableFreqX = "";

                this.predElectricalFrq = JSON.parse(
                  JSON.stringify(res)
                ).data.body.body.predominantData.map(function (value, index) {
                  value["frequency"] = JSON.parse(value.frequency).toFixed(1);
                  value["magnitude"] = JSON.parse(value.magnitude).toFixed(2);
                  return value;
                });

                this.dataElectricalfrequentPoints1.push({
                  frequency: null,
                  magnitude: null,
                });
                this.dataElectricalfrequentPoints1 = JSON.parse(
                  JSON.stringify(res)
                ).data.body.body.chartXdata.map(function (val, index) {
                  let obj = {
                    x: JSON.parse(val.frequency),
                    y: JSON.parse(val.magnitude),
                  };
                  return obj;
                });
                if (
                  document.getElementById("electricalChartContainer") !== null
                ) {
                  let electricalChartObj = cloneDeep(fft_ultrasound_chart);
                  let feedDataToArray = [];
                  feedDataToArray.push({
                    data: this.dataElectricalfrequentPoints1,
                    lineDashType: "",
                    label: lableFreqX,
                    legendMarkerType: "none",
                  });
                  electricalChartObj.charts[0].data = [];
                  electricalChartObj.charts[0].unit = " ";
                  electricalChartObj.charts[0].axisX["title"] = "Frequency";
                  electricalChartObj.charts[0].axisX.interval = 5000;
                  electricalChartObj.charts[0].myValue = "electrical";
                  electricalChartObj.charts[0].data =
                    this.makeFFTDataForChart(feedDataToArray);
                  electricalChartObj.navigator.data =
                    this.makeFFTDataForChart(feedDataToArray);
                  this.fftUltrsoundChart = new CanvasJS.StockChart(
                    "electricalChartContainer",
                    electricalChartObj
                  );
                  this.fftUltrsoundChart.render();
                }
              } else {
                this.electricalChartLoader = true;
                this.electricalMessage = true;
              }
            } else {
              this.electricalChartLoader = true;
              this.electricalMessage = true;
            }
          }
        });
    } else {
      this.electricalChartLoader = true;
      this.electricalMessage = true;
    }
  }

  getCurrentAcceleration() {
    let currentDataPoints1 = [];
    this.currentChartLoader = false;
    this.vibrationNoDataMsg = "No data available.";
    if (this.device_raw_matric_id != undefined) {
      let self = this;
      this.service
        .getDataWithQuery(
          this.currentSignature +
            "/" +
            this.userID +
            "/" +
            this.deviceId +
            "/" +
            this.assetId +
            "/" +
            this.device_raw_matric_id
        )
        .then((res) => {
          if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
          } else if (
            JSON.parse(JSON.stringify(res)).data.status === "success"
          ) {
            if (
              JSON.parse(JSON.stringify(res)).data.body.message !== "404" &&
              JSON.parse(JSON.stringify(res)).data.body.message !== "403"
            ) {
              if (JSON.parse(JSON.stringify(res)).data.body.body.length !== 0) {
                this.currentChartLoader = true;
                this.vibrationNoDataMsg = "No data available.";
                let lableFreqX = "x";
                let lableFreqY = "Y";
                let lableFreqZ = "Z";

                this.dataCurrentPoints1 = JSON.parse(
                  JSON.stringify(res)
                ).data.body.body;
                this.dataCurrentPoints2 = JSON.parse(
                  JSON.stringify(res)
                ).data.body.body;
                this.dataCurrentPoints3 = JSON.parse(
                  JSON.stringify(res)
                ).data.body.body;
                this.listFrequencyChartData();
                if (document.getElementById("currentVibrationChart") !== null) {
                  let fftChartObj = cloneDeep(fftChartObject);
                  let feedDataToArray = [];
                  feedDataToArray.push({
                    data: this.dataCurrentPoints1,
                    lineDashType: "",
                    label: lableFreqX,
                    legendMarkerType: "none",
                    key: lableFreqX,
                  });
                  feedDataToArray.push({
                    data: this.dataCurrentPoints2,
                    lineDashType: "",
                    label: lableFreqY,
                    legendMarkerType: "none",
                    key: lableFreqY,
                  });
                  feedDataToArray.push({
                    data: this.dataCurrentPoints3,
                    lineDashType: "",
                    label: lableFreqZ,
                    legendMarkerType: "none",
                    key: lableFreqZ,
                  });
                  // this.changeOrder(
                  //   ["Radial (Horizontal)", "Tangential (Vertical)", "Axial"],
                  //   feedDataToArray
                  // );
                  fftChartObj.charts[0].data = [];
                  fftChartObj.charts[0].unit = "";
                  fftChartObj.charts[0].axisX.interval = 500;
                  fftChartObj.charts[0].myValue = "Acceleration";
                  fftChartObj.charts[0].data =
                    this.makeFFTDataForChart(feedDataToArray);
                  fftChartObj.navigator.data =
                    this.makeFFTDataForChart(feedDataToArray);
                  this.frequentNewAccChart = new CanvasJS.StockChart(
                    "currentVibrationChart",
                    fftChartObj
                  );
                  // this.frequentNewAccChart.render();
                  setTimeout(() => {
                    console.log('Rendering Vibration - Acceleration (m/sec2)')
                    if(this.frequentNewAccChart) this.frequentNewAccChart.render();
                  }, 1000);
                }
              } else {
                this.currentChartLoader = true;
                this.vibrationNoDataMsg = "No data available.";
              }
            } else {
              this.currentChartLoader = true;
              this.vibrationNoDataMsg = "Error while fetching data.";
            }
          } else {
            this.currentChartLoader = true;
            this.vibrationNoDataMsg = "Something went wrong.";
          }
        });
    } else {
      this.currentChartLoader = true;
      this.vibrationNoDataMsg = "No data available.";
    }
  }
  electricalLayout() {
    this.electricalChartViewOff = true;
    this.electricalChartViewOn = false;
    this.listElectricalData = [];
    this.listElectricalData = this.dataElectricalfrequentPoints1.map(function (
      val,
      index
    ) {
      return { key: index, x: val.x.toFixed(1), y: val.y.toFixed(2) };
    });
  }
  replaceUnderscoresWithSpacesAndCapitalize(str: string): string {
    return str
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  getAnomalyStatus(){
    this.anomalyLoader=true;
    let endpoint=`${this.anomaly_api}${this.assetId}/${this.deviceId}?userId=${this.userID}`
    this.service.getDataV2(endpoint)
    .then(res=>{
      let anomalyResponse=JSON.parse(JSON.stringify(res));
      if(anomalyResponse.data){
        const {overall_health}=anomalyResponse.data.body;
        const {status,updated_at}=overall_health;
        if(updated_at==null){
          this.overAllService = 'N/A';
          this.overall_health_status="N/A"
        }
        else{
          let testDateUtc = moment.utc(updated_at);
          let localDate = testDateUtc.local();
          let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(localDate);
          this.overAllService = timeUpdatedAt;
          switch(status){
            case 'HEALTHY':
                    this.overall_health_status='Good';
                    this.recommened_action='No Action Required'
                    break;
            case 'ERROR':
                    this.overall_health_status='Unacceptable';
                    this.recommened_action='Immediate Action Required'
                    break;
            case 'UNHEALTHY':
                    this.overall_health_status='Unsatisfactory';
                    this.recommened_action='Attention Required'
                    break;
            default:
                    this.overall_health_status='N/A';
                    this.recommened_action='N/A';

                  }
                }
        this.anomalyLoader=false;
      }else{
        this.anomalyLoader=false;
        this.overall_health_status='N/A';
        this.recommened_action='N/A';
        this.overAllService = 'N/A';
      }
    })
    .catch(err=>{
      console.log(err)
      this.anomalyLoader=false;
      this.overall_health_status='N/A';
      this.recommened_action='N/A';
      this.overAllService = 'N/A';
      console.log("Error Fetching Anomaly status")
    })
  }

  checkSensorDataExitsOnInit(){
    let endpoint=`${this.checkSensorHistoricalDataExists}${this.assetId}/${this.deviceId}?userId=${this.userID}`;
    this.service.getDataV2(endpoint)
    .then(res=>{
      let checkDataExitsRes=JSON.parse(JSON.stringify(res));
      if(checkDataExitsRes.data){
        const {deviceSensorHistoricalData}=checkDataExitsRes.data.body;
        if(deviceSensorHistoricalData) this.historicalDataExists=true;
        else {
          this.historicalDataExists=false;
          const dialogRef=this.dialog.open(DialogOverviewExampleDialogComponent, {
            width: "800px",
            maxWidth: "55vw",
            data: {
              type: "checkSensorDataExits",
              data:"reqObj"
            },
          });
          dialogRef.afterClosed().subscribe(result=>{
            if(this.userRoll=='CLIENT' || this.userRoll=='USER')
                this.router.navigate(['/device-reports'])
           else if(this.userRoll=='ADMIN'){
                this.router.navigate(['/device-report-new'])
          }
        })
        }
      }else{
      this.historicalDataExists=false;
      const dialogRef=this.dialog.open(DialogOverviewExampleDialogComponent, {
        width: "800px",
        maxWidth: "55vw",
        data: {
          type: "checkSensorDataExits",
          data:"reqObj"
        },
      });
      dialogRef.afterClosed().subscribe(result=>{
        if(this.userRoll=='CLIENT' || this.userRoll=='USER')
            this.router.navigate(['/device-reports'])
        else if(this.userRoll=='ADMIN'){
            this.router.navigate(['/device-report-new'])
    }
    })
    }
  })
  .catch(err=>{
    console.log("Error Fetching checkSensorHistoricalDataExists");
    this.historicalDataExists=false;
    })

  }

  getMachineOperatingParameters() {
    let selected_asset_id;
    let selected_inventory_id;
    if(this.assetMasterInfo.asset_status === 1){
       selected_asset_id = this.assetMasterInfo.id
       selected_inventory_id = this.assetMasterInfo.inventory_id;
    }else{
       selected_asset_id = this.assetId
       selected_inventory_id = this.deviceId;
    }
    
    this.machineOperatngParametersLoader = true;
    // console.log(selected_asset_id, this.assetMasterInfo.id , this.assetId,this.assetMasterInfo.inventory_id, this.deviceId)
    let endpoint;
    if(this.assetType !== "GEAR") endpoint = `${this.machineOperatingParametersAPI}${selected_asset_id}/${selected_inventory_id}?userId=${this.userID}&assetType=${this.assetType}`;
    else endpoint = endpoint = `${this.machineOperatingParametersAPI}${this.assetId}/${this.deviceId}?userId=${this.userID}&assetType=${this.assetType}`;
    this.service.getDataV2(endpoint)
      .then((response) => {
        try {
          this.machineOperatngParametersLoader = false;
          const machineOperatingAPIResponse = JSON.parse(JSON.stringify(response));
          if (machineOperatingAPIResponse.data) {
            const machineOperatingParameters = machineOperatingAPIResponse.data.body.data;
            if(this.assetType !== 'GEAR') {

              const operatingLF = machineOperatingParameters.operatingLF || 0;
              // const operatingSyncRPM = machineOperatingParameters.operatingSyncRPM || 0; // earlier this key was used
              const operatingSyncRPM = machineOperatingParameters.syncRPM || 0; // upadted on 3rd oct 2025 as per discussion with jatin,amit,bobby sir 
              const actual_rpm = machineOperatingParameters.actual_rpm || 0;
              const operating_ph_line_current = machineOperatingParameters.operating_ph_line_current || 0;

              this.monitoring_operatingLF = this.formatValue(operatingLF, 1);
              this.monitoring_operatingSyncRPM = this.formatValue(operatingSyncRPM, 1, true);
              this.monitoring_actual_rpm = this.formatValue(actual_rpm, 1);
              this.monitoring_operating_ph_line_current = this.formatValue(operating_ph_line_current, 2);
            }
            else {
              this.monitoring_gear_rated_power = machineOperatingParameters.rated_power;
              this.monitoring_number_of_stages = machineOperatingParameters.number_of_stages;
              machineOperatingParameters.rpm.forEach(element => {
                if(element.gear_type === 'PINION') this.monitoring_pinion_gear_rpm = element.gear_rpm;
                else if(element.gear_type === 'OUTER') this.monitoring_output_gear_rpm = element.gear_rpm;
              });
            }
            if (this.onoffStatus === 0 || this.onoffStatus === 2) {
              this.resetMonitoringParameters();
            }
          } else {
            this.resetMonitoringParameters();
          }
        } catch (error) {
          this.machineOperatngParametersLoader = false;
          console.error("Error processing API response: ", error);
          this.resetMonitoringParameters();
        }
      })
      .catch((err) => {
        this.machineOperatngParametersLoader = false;
        console.error("Error fetching Machine Operating Parameters: ", err);
        this.resetMonitoringParameters();
      });
  }

  formatValue(value: number, decimals: number, integerOnly = false): number {
    console
    if (value === 0) return 0;
    return integerOnly ? ~~value : parseFloat(value.toFixed(decimals));
  }

  formatValueWithDecimals(value: number, decimals: number): string {
    if (value === 0) return `0.${'0'.repeat(decimals)}`;
    return value.toFixed(decimals);
  }

  resetMonitoringParameters(): void {
    this.monitoring_operatingLF = 0;
    this.monitoring_operatingSyncRPM = 0;
    this.monitoring_actual_rpm = 0;
    this.monitoring_operating_ph_line_current = 0;
  }

  getMachineHealthIndexValues() {
    this.monitoringIndicesLoader = true;
    const endpoint = `${this.machineHealthIndexAPI}${this.assetId}/${this.deviceId}?userId=${this.userID}&assetType=${this.assetType}`;
    this.service.getDataV2(endpoint)
      .then((response) => {
        try {
          this.monitoringIndicesLoader = false;
          const machineHealthIndexAPIResponse = JSON.parse(JSON.stringify(response));
          if (machineHealthIndexAPIResponse.data) {
            this.monitoringIndicesValues = machineHealthIndexAPIResponse.data.body.deviceHealthResponse;
            this.monitoringOverallHealthIndex = Math.round(machineHealthIndexAPIResponse.data.body.overallHealthIndex.overallHealthIndex);
            this.monitoringOverallHealthIndexColor = machineHealthIndexAPIResponse.data.body.overallHealthIndex.overallHealthIndexColor;
          }
        } catch (error) {
          console.error("Error processing API response: ", error);
        }
      })
      .catch((err) => {
        this.monitoringIndicesLoader = false;
        console.error("Error fetching Machine Operating Parameters: ", err);
      });
  }

  getMonitoringDeviceDetails() {
    const endpoint = `${this.monitoringDeviceDetailsAPI}${this.assetId}?userId=${this.userID}&assetType=${this.assetType}`;
    this.monitoringDeviceDetailsLoader = true;
    this.service.getDataV2(endpoint)
     .then((response) => {
        try {
          this.monitoringDeviceDetailsLoader = false;
          const monitoringDeviceDetailsAPIResponse = JSON.parse(JSON.stringify(response));
          if (monitoringDeviceDetailsAPIResponse.data) {
            this.monitoringDeviceDetails = monitoringDeviceDetailsAPIResponse.data.body;
          }
        } catch (error) {
          this.monitoringDeviceDetailsLoader = false;
          console.error("Error processing API response: ", error);
        }
      })
     .catch((err) => {
      this.monitoringDeviceDetailsLoader = false;
        console.error("Error fetching Monitoring Device Details: ", err);
      });
  }
  getMonitoringMachineUtilization() {
    let macAddress = this.deviceSerialNo !== 1 ? this.assetMasterInfo.mac_address : this.mac_address;
    const endpoint = `${this.monitoringMachineUtilizationAPI}${macAddress}/${this.userID}/1`;
      this.service.getDataV2(endpoint)
      .then((response) => {
         try {
           this.monitoringMachineUtlizationLoader = false;
           const monitoringMachineUtilizationAPIResponse = JSON.parse(JSON.stringify(response));
           if (monitoringMachineUtilizationAPIResponse.data) {
             this.monitoringMachineUtilization = monitoringMachineUtilizationAPIResponse.data.body.machineUtilization;
             this.monitoringDeviceStops = this.monitoringMachineUtilization.device.no_of_stops;
             this.monitoringAssetStops = this.monitoringMachineUtilization.asset.no_of_stops;
             this.monitoringDeviceUtilization = isNaN(this.monitoringMachineUtilization.device?.device_utilization) ? 0 : this.monitoringMachineUtilization.device.device_utilization.toFixed(2);
             this.monitoringAssetUtilization = isNaN(this.monitoringMachineUtilization.asset?.asset_utilization) ? 0 : this.monitoringMachineUtilization.asset.asset_utilization.toFixed(2);
             this.monitoringDeviceAverageRun = this.monitoringMachineUtilization.device.avg_run;
             this.monitoringAssetAverageRun = this.monitoringMachineUtilization.asset.avg_run;


             const fullTimestamp = this.monitoringMachineUtilization.device.weekly_running_status;

            //  console.log(fullTimestamp )
             if (!fullTimestamp || fullTimestamp === 'N/A') {

               this.monitoringDeviceWeeklyRunningStatus = fullTimestamp;
             } else {
               const [hours, minutes] = fullTimestamp.split(':');
               this.monitoringDeviceWeeklyRunningStatus = `${hours} H ${minutes} M`;
             }

           }
         } catch (error) {
           this.monitoringMachineUtlizationLoader = false;
           console.error("Error processing API response: ", error);
         }
       })
      .catch((err) => {
       this.monitoringMachineUtlizationLoader = false;
         console.error("Error fetching Monitoring Machine Utilization: ", err);
       });
  }

  getDiagnosticsSummary(fftId, bearingId, fetchFaults) {
    this.diagnosticsSummaryLoader = true;

    const endpoint = `${this.diagnosticsSummaryAPI}${this.userID}/${this.deviceId}/${this.assetId}?type=${this.assetType}&fft_id=${fftId}&bearing_id=${bearingId}`;

    this.service.getDataV2(endpoint)
      .then((response) => {
        try {
          const data = JSON.parse(JSON.stringify(response))?.body;
          if (!data) throw new Error("No data in API response.");

          const vibrationFaults = data.vibrationfaults || {};
          const earlyStageBallBearing = data.earlyStageBallBearing || {};
          const esaFaults = data.esaFaults || {};

          const convertDateTime = (dateString) =>
            dateString ? new ConvertDatetimePipe().convertDateTime(moment.utc(dateString).toDate()) : "N/A";

          this.diagosticsCreateAtFFT = convertDateTime(vibrationFaults.updated_at);
          this.diagosticsTimeFFT = fftId !== undefined ? convertDateTime(vibrationFaults.updated_at) : "N/A";
          this.diagnosticsMechanicalFaultPredominantError = vibrationFaults.mechanicalFaults?.predominantError || "N/A";
          this.diagnosticsMechanicalFaultObservableError = vibrationFaults.mechanicalFaults?.observeableError || "N/A";
          this.diagnosticsElectricalFaultPredominantError = vibrationFaults.electricalFaults?.predominantError || "N/A";
          this.diagnosticsElectricalFaultObservableError = vibrationFaults.electricalFaults?.observeableError || "N/A";
          this.diagnosticsBearingFaultPredominantError = vibrationFaults.bearingFaults?.predominantError || "N/A";
          this.diagnosticsBearingFaultObservableError = vibrationFaults.bearingFaults?.observeableError || "N/A";
          this.diagnosticsCepstrumError = vibrationFaults.cepstrum_mssg || "N/A";
          this.diagnosticsEarlyStageBallBearingUpdatedAt = convertDateTime(earlyStageBallBearing.updated_at);
          this.diagnosticsBallBearingErrorMessage = earlyStageBallBearing.ballBearingErrorMessage || "N/A";
          if (fetchFaults) this.setFaults();
          if (!esaFaults.updated_at?.includes("Not Applicable")) {
            this.diagnosticsEsaFaultsUpdatedAt = convertDateTime(esaFaults.updated_at);
          } else {
            this.diagnosticsEsaFaultsUpdatedAt = esaFaults.updated_at || "N/A";
          }
          this.diagnosticsEsaFaultsErrorMessage = esaFaults.esaMessage || "N/A";
          this.diagnosticsSummaryLoader = false;
        } catch (error) {
          console.error("Error processing API response: ", error);
        } finally {
          this.diagnosticsSummaryLoader = false;
        }
      })
      .catch((error) => {
        // this.diagnosticsSummaryLoader = false;
        console.error("Error fetching diagnostics summary: ", error);
      });
  }

  getDiagnosticsFFTList() {
    console.log('getDiagnosticsFFTList');
    this.diagnoticsFFTListLoader = true;
    const role = localStorage.getItem("role");
    const endpoint = `${this.diagnosticsFFTListAPI}${this.deviceId}/${this.assetId}?userId=${this.userID}&role=${role}&assetType=${this.assetType}`;

    this.service.getDataV2(endpoint)
      .then((response) => {
        try {
          const diagnosticsFFTListResponse = JSON.parse(JSON.stringify(response));
          // Handle cases with no data or empty body
          if (!diagnosticsFFTListResponse?.data || !diagnosticsFFTListResponse?.data?.body?.length) {
            console.log('--------------------------------------------------------------------------------')
            this.downloadDisabled = true;
            this.is_sa_on_demand_done = false;
            this.msgDownload = "FFT values are currently unavailable. Please initiate an on-demand spectrum to generate the asset health report.";
          }
          else {
            this.is_sa_on_demand_done =true;
            this.downloadDisabled = false;
            if(diagnosticsFFTListResponse.data.body.length !== 0) {

              // Reset necessary data containers
              this.trendAnalysDataPeriodic = [];
              this.trendAnalysDataAnomaly = [];
              this.fftMarkers = [];

              // Map FFT data
              this.trendAnalysData = diagnosticsFFTListResponse.data.body.map((item, index) => {
                this.fftLists.push({id:item.value,time:item.fft_time})
                this.fftMarkers.push({
                  label: item.label,
                  fft_time: item.fft_time,
                  fftId: item.value,
                });
                this.fftMarkersTemp = this.fftMarkers;
                // Convert FFT time
                const ffttestDateUtc = moment.utc(item.fft_time);
                const localDatefft = ffttestDateUtc.local();
                const fftTIME = new ConvertDatetimePipe().convertDateTime(localDatefft);

                // Create trend data object
                const trendData = {
                  key: index,
                  SAname: item.label,
                  label: fftTIME,
                  fft_time: item.fft_time,
                  line_freq: item.line_freq,
                  rated_rpm: item.rated_rpm,
                  actual_rpm: item.actual_rpm,
                  value: item.value,
                  error: item.error,
                  observe: item.observe,
                  op_freq: item.op_freq,
                  p_actual_rpm: item.p_actual_rpm,
                  p_rated_rpm: item.p_rated_rpm,
                };

                // Categorize into Periodic or Anomaly
                // if (item.label.includes("Periodic")) {
                //   this.trendAnalysDataPeriodic.push(trendData);
                // } else {
                //   this.trendAnalysDataAnomaly.push(trendData);
                // }
                this.trendAnalysDataAnomaly.push(trendData);

                return trendData;
              });
              // const currentTime = new Date();
              // const twentyFourHoursAgo = new Date(currentTime.getTime() - 24 * 60 * 60 * 1000);
              // this.trendAnalysDataAnomaly = this.trendAnalysDataAnomaly.filter((item) => {
              //   const itemDate = new Date(item.fft_time);
              //   return itemDate >= twentyFourHoursAgo && itemDate <= currentTime;
              // });
              this.trendAnalysDataAnomaly = this.trendAnalysDataAnomaly.slice(0, this.countLatestNValues - 1);
              if (this.trendAnalysDataAnomaly.length > 0) {
                this.selectedFFTUIDAnomaly = this.trendAnalysDataAnomaly[0].value;
              }

              // Set additional properties based on filtered data
              // console.log("trendAnalysDataAnomaly: ", this.trendAnalysDataAnomaly);
              // console.log("trendAnalysDataPeriodic: ", this.trendAnalysDataPeriodic);
              const firstTrendData = this.trendAnalysData[0];
              if (firstTrendData) {
                const filteredData = this.trendAnalysData.filter(
                  (v) => parseInt(v.value) === parseInt(firstTrendData.value)
                );

                const selectedData = filteredData[0];
                this._fftDate = selectedData.label;
                this._rated_rpm = selectedData.rated_rpm;
                this._line_frequency = selectedData.line_freq?.toFixed(1) || null;
                this._actualrpm = selectedData.actual_rpm?.toFixed(0);
                this.OperatingLineFrequency = selectedData.op_freq?.toFixed(1);
                this._observe_value = selectedData.observe;
                this.selectedFFTUID = selectedData.value;
                this.pinion_gear_rated_rpm = selectedData.p_rated_rpm;
                this.outer_gear_rated_rpm = selectedData.rated_rpm;
                this.pinionActualForDiagnosticslabel = Math.ceil(selectedData.p_actual_rpm);
                this.outerActualForDiagnosticslabel = Math.ceil(selectedData.actual_rpm?.toFixed(0));
              }
              // Handle periodic data loading
              // if (this.trendAnalysDataPeriodic.length === 0) {
              //   this.loadFftData(null, "periodic");
              // } else {
              //   this.loadFftData(this.selectedFFTUID, "periodic");
              // }
              if(!this.fromPowerTrain || !this.powertrainSelectedFFT_id){
                this.loadFftData(this.selectedFFTUID, "anomaly");
              }else{
                this.loadFftData(this.powertrainSelectedFFT_id, "anomaly");
              }
            }
          }
        }
        catch (error) {
          console.error("Error processing API response: ", error);
        }
        finally {
          this.diagnoticsFFTListLoader = false;
        }
      })
      .catch((err) => {
        // this.diagnoticsFFTListLoader = false;
        console.error("Error fetching Diagnostics FFT List API: ", err);
      })
      .finally(() => {
        this.getBearingFreq()
      })
  }

  getMachineDiagnosticsDone() {
    console.log('fftlist');
    this.machineDiagnosticsLoader = true;
    const role = localStorage.getItem("role");
    const endpoint = `${this.diagnosticsFFTListAPI}${this.deviceId}/${this.assetId}?userId=${this.userID}&role=${role}&assetType=${this.assetType}`;

    this.service.getDataV2(endpoint)
      .then((response) => {
        try {
          const diagnosticsFFTListResponse = JSON.parse(JSON.stringify(response));
          if(diagnosticsFFTListResponse?.data && diagnosticsFFTListResponse?.data?.body) this.isMachineDiagnosticsAnalysisDone = diagnosticsFFTListResponse?.data?.body?.length > 0 ? true : false;
          else this.isMachineDiagnosticsAnalysisDone = false;
          this.machineDiagnosticsLoader = false;
        }
        catch (error) {
          console.error("Error processing API response: ", error);
        }
        finally {
          this.machineDiagnosticsLoader = false;
        }
      })
      .catch((err) => {
        // this.diagnoticsFFTListLoader = false;
        console.error("Error fetching Diagnostics FFT List API: ", err);
      });
  }

  async getGearMeshFrequency() {
    try {
      const endpoint = `${this.assetsUrlEdit}/${this.assetId}/${this.mac_address}`;
      const response = await this.service.getDataV2(endpoint);

      if ((response as any)?.data?.status === "success" && (response as any)?.data?.code === 200) {
        console.log((response as any).data.body.orientation)
        this.orientation = (response as any)?.data?.body?.orientation;
        const gearInfo = (response as any)?.data?.body?.gear_info;
        const tempfxMax = (response as any)?.data?.body?.odr;
        switch(tempfxMax) {
          case "NORMAL":
            this.fxMax = 1700;
            break;
          case "HIGH":
            this.fxMax = 3400
            break;
          case "LOW":
            this.fxMax = 200;
            break;
          case "EXTRALOW":
            this.fxMax = 100;
            break;
          case "EXTRAEXTRALOW":
            this.fxMax = 50;
            break;
          default:
            this.fxMax = 0
        }

        if (gearInfo?.length > 0 && gearInfo[0]?.gmf_data) {
          let gmfDataArray;

          try {
            gmfDataArray = JSON.parse(gearInfo[0]?.gmf_data);
          } catch (err) {
            console.error("Error parsing gmf_data:", err);
            gmfDataArray = null;
          }

          if (Array.isArray(gmfDataArray) && gmfDataArray.length > 0) {
            const gmfName = gmfDataArray[0]?.gmfName;
            if (gmfName) {
              this.gmf_frequency = gmfName;
              console.log("GMF Frequency:", this.gmf_frequency);
            } else {
              console.warn("GMF Name is undefined or empty");
            }
          } else {
            console.warn("Parsed GMF Data is empty or not an array");
          }
        }
        else {
          console.warn("GMF Data is missing or null in response");
        }
      } else {
        console.warn("Invalid response status or code", response);
      }
    } catch (error) {
      console.error("Error fetching GMF frequency:", error);
    }
  }
  downloadChart(idPassed) {
    this.downloadChartLoader = true;
    const chartElement = document.getElementById(idPassed);
    if (chartElement) {
      html2canvas(chartElement).then(canvas => {
        const image = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.href = image;
        link.download = 'chart.png';
        link.click();

        this.downloadChartLoader = false;
      }).catch(() => {
        this.downloadChartLoader = false;
        alert("Failed to download chart");
      });
    } else {
      this.downloadChartLoader = false;
      alert("Chart not found");
    }
  }

  onStartDateChange(event: any) {
    this.startDateTrendChart = formatDate(event, 'yyyy-MM-dd', 'en');
  }

  onEndDateChange(event: any) {
    this.endDateTrendChart = formatDate(event, 'yyyy-MM-dd', 'en');
    if(this.startDateTrendChart && this.endDateTrendChart) {
      this.time_span = "range";
      this.gridLayout();
    }
  }

  openChartPopup() {
    // console.log(this.fftLists);
    const dialogRef = this.dialog.open(WaterfallPlotComponent, {
      width: '90vw',
      height: '90vh',
      data: {
        userId: this.userID,
        fftCollection: this.fftLists,
        assetId: this.assetId,
        inventoryId: this.deviceId
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Dialog closed:', result);
    });
  }

  checkSubscriptionController(event: MouseEvent, type: 'diagnostics' | 'predictive') {
    if(!this.softwareStatusMap['diagnostics'] || !this.softwareStatusMap['predictive']) {
      event.preventDefault();
      event.stopPropagation();
      if(type === 'diagnostics') {
        if(!this.ON_PREM) {
          this.modalTitle = 'Diagnostics Access Required';
          if(this.isMailReceived) {
            this.modalMessage = "You have already requested a token. Please check your email for the token. If you haven't received it, please contact your administrator."
          }
          else {
            this.modalMessage = 'Diagnostics feature require a valid subscription token. Once you request, a notification will be sent to the administrator, and they will add the token to enable these features for your account.'
          }
        }
        else {
          this.modalTitle = 'Diagnostics Access Required';
          this.modalMessage = 'Diagnostics feature requires a valid subscription token. Please contact your administrator or email development@enertics.ca to enable or add a token for your account.';
        }
      }
      else if(type === 'predictive') {
        if(!this.ON_PREM) {
          this.modalTitle = 'Predictive Access Required';
          if(this.isMailReceived) {
            this.modalMessage = "You have already requested a token. Please check your email for the token. If you haven't received it, please contact your administrator.";
          }
          else {
            this.modalMessage = 'Trending & Predictive Maintenance feature require a valid subscription token. Once you request, a notification will be sent to the administrator, and they will add the token to enable these features for your account.';
          }
        }
        else {
          this.modalTitle = 'Predictive Access Required';
          this.modalMessage = 'Trending & Predictive Maintenance feature require a valid subscription token. Please contact your administrator or email development@enertics.ca to enable or add a token for your account.';
        }
      }
      this.showRequestTokenModal = !this.showRequestTokenModal;
    }
  }

  async requestTokenFromAdmin() {
    console.log('Requesting token...');
    if (this.sendingRequestToken) return;
    this.sendingRequestToken = true;
    try {
      const response: any = await this.service.postData(BaseUrlConstantsService.REQUEST_TOKEN_URL, { clientId: this.userID});
      console.log('Response from request token:', response);
      if(response.status === 'success') {
        this.modalMessage = response.message || "Token request successful. Please check your email for the token.";
      }
      else {
        this.modalMessage = response.message || "Failed to request token. Please try again later.";
      }
    }
    catch (error) {
      console.error('Error requesting token:', error);
    }
    finally {
      this.sendingRequestToken = false;
    }
  }

  closeRequestTokenModal() {
    this.showRequestTokenModal = false;
    this.beforeChange({ nextId: "tab-1"});

  }

}


function toFixed(arg0: number) {
  throw new Error("Function not implemented.");
}
